import type { ArticleIdentity } from "./article-loader";

/** Exact pilot mapping. Drafts do not authorize public routes or search entries. */
export const ARTICLE_IDENTITIES: readonly ArticleIdentity[] = [
{
  "id": "article.national-mathematical-olympiad",
  "englishSourcePath": "content/posts/National-Mathematical-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/National-Mathematical-Olympiad",
      "sourcePath": "content/posts/National-Mathematical-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "bfa6a4163eea4e8a2cf19084ed671516cea3bcebcbd187d68527bb40fa174c3c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/National-Mathematical-Olympiad",
      "sourcePath": "content/translations/zh-Hans/National-Mathematical-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "bfa6a4163eea4e8a2cf19084ed671516cea3bcebcbd187d68527bb40fa174c3c"
    }
  ]
},
{
  "id": "article.what-if-my-school-does-not-participate-in-competitions-singapore",
  "englishSourcePath": "content/posts/What-If-My-School-Does-Not-Participate-in-Competitions-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/What-If-My-School-Does-Not-Participate-in-Competitions-Singapore",
      "sourcePath": "content/posts/What-If-My-School-Does-Not-Participate-in-Competitions-Singapore.mdx",
      "status": "published",
      "sourceSha256": "196845baa62add443fd3cc284c917d2f965fcf3bab1b70cec409f9f720d2b351"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/What-If-My-School-Does-Not-Participate-in-Competitions-Singapore",
      "sourcePath": "content/translations/zh-Hans/What-If-My-School-Does-Not-Participate-in-Competitions-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "196845baa62add443fd3cc284c917d2f965fcf3bab1b70cec409f9f720d2b351"
    }
  ]
},
{
  "id": "article.raffles-mathematical-olympiad",
  "englishSourcePath": "content/posts/Raffles-Mathematical-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Raffles-Mathematical-Olympiad",
      "sourcePath": "content/posts/Raffles-Mathematical-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "7398a8287b7617a9a6d2b91205c48f06c3796ac77eab709e2b4925dfb4374dfe"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Raffles-Mathematical-Olympiad",
      "sourcePath": "content/translations/zh-Hans/Raffles-Mathematical-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "7398a8287b7617a9a6d2b91205c48f06c3796ac77eab709e2b4925dfb4374dfe"
    }
  ]
},
{
  "id": "article.apmops-results-2026-when-how-to-check",
  "englishSourcePath": "content/posts/APMOPS-Results-2026-When-How-to-Check.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/APMOPS-Results-2026-When-How-to-Check",
      "sourcePath": "content/posts/APMOPS-Results-2026-When-How-to-Check.mdx",
      "status": "published",
      "sourceSha256": "a3fc605ea1d9596c071e6c012a45275282573911182a3df7dd511e1c7742b865"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/APMOPS-Results-2026-When-How-to-Check",
      "sourcePath": "content/translations/zh-Hans/APMOPS-Results-2026-When-How-to-Check.mdx",
      "status": "draft",
      "sourceSha256": "a3fc605ea1d9596c071e6c012a45275282573911182a3df7dd511e1c7742b865"
    }
  ]
},
{
  "id": "article.best-math-olympiad-books-resources-singapore",
  "englishSourcePath": "content/posts/Best-Math-Olympiad-Books-Resources-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Best-Math-Olympiad-Books-Resources-Singapore",
      "sourcePath": "content/posts/Best-Math-Olympiad-Books-Resources-Singapore.mdx",
      "status": "published",
      "sourceSha256": "20cf00729ced52ec33f4a15f29a31fd58e47403a6d1aa7582ef4054d195d8637"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Best-Math-Olympiad-Books-Resources-Singapore",
      "sourcePath": "content/translations/zh-Hans/Best-Math-Olympiad-Books-Resources-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "20cf00729ced52ec33f4a15f29a31fd58e47403a6d1aa7582ef4054d195d8637"
    }
  ]
},
{
  "id": "article.asia-pacific-mathematical-olympiad-for-primary-schools-apmops",
  "englishSourcePath": "content/posts/Asia-Pacific-Mathematical-Olympiad-for-Primary-Schools-APMOPS.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Asia-Pacific-Mathematical-Olympiad-for-Primary-Schools-APMOPS",
      "sourcePath": "content/posts/Asia-Pacific-Mathematical-Olympiad-for-Primary-Schools-APMOPS.mdx",
      "status": "published",
      "sourceSha256": "f86ae51eacb77f1c1fb2bfea19ac3432ffe719d6017acd877ac79bd1f53e62cc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Asia-Pacific-Mathematical-Olympiad-for-Primary-Schools-APMOPS",
      "sourcePath": "content/translations/zh-Hans/Asia-Pacific-Mathematical-Olympiad-for-Primary-Schools-APMOPS.mdx",
      "status": "draft",
      "sourceSha256": "f86ae51eacb77f1c1fb2bfea19ac3432ffe719d6017acd877ac79bd1f53e62cc"
    }
  ]
},
{
  "id": "article.american-mathematics-competitions",
  "englishSourcePath": "content/posts/American-Mathematics-Competitions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/American-Mathematics-Competitions",
      "sourcePath": "content/posts/American-Mathematics-Competitions.mdx",
      "status": "published",
      "sourceSha256": "007e913a1ccb674b08e542f6c0ace5a54008d9dd333b63d200fcf3f9955bde00"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/American-Mathematics-Competitions",
      "sourcePath": "content/translations/zh-Hans/American-Mathematics-Competitions.mdx",
      "status": "draft",
      "sourceSha256": "007e913a1ccb674b08e542f6c0ace5a54008d9dd333b63d200fcf3f9955bde00"
    }
  ]
},
{
  "id": "article.ip-maths-names-explained-singapore-2026",
  "englishSourcePath": "content/posts/IP-Maths-Names-Explained-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-maths-tuition/IP-Maths-Names-Explained-Singapore-2026",
      "sourcePath": "content/posts/IP-Maths-Names-Explained-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "493cc90472a6622ada552d7f00022d03765f1a01abfb1363f49ab23984b212b6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-maths-tuition/IP-Maths-Names-Explained-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/IP-Maths-Names-Explained-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "493cc90472a6622ada552d7f00022d03765f1a01abfb1363f49ab23984b212b6"
    }
  ]
},
{
  "id": "article.raffles-institution-dsa-math-guide",
  "englishSourcePath": "content/posts/Raffles-Institution-DSA-Math-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Raffles-Institution-DSA-Math-Guide",
      "sourcePath": "content/posts/Raffles-Institution-DSA-Math-Guide.mdx",
      "status": "published",
      "sourceSha256": "5d5da12b9889b9604a7cca99d2440023a7b2327f5b21c41174803a000bc2f9e5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Raffles-Institution-DSA-Math-Guide",
      "sourcePath": "content/translations/zh-Hans/Raffles-Institution-DSA-Math-Guide.mdx",
      "status": "draft",
      "sourceSha256": "5d5da12b9889b9604a7cca99d2440023a7b2327f5b21c41174803a000bc2f9e5"
    }
  ]
},
{
  "id": "article.primary-school-maths-science-competitions-singapore",
  "englishSourcePath": "content/posts/Primary-School-Maths-Science-Competitions-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Primary-School-Maths-Science-Competitions-Singapore",
      "sourcePath": "content/posts/Primary-School-Maths-Science-Competitions-Singapore.mdx",
      "status": "published",
      "sourceSha256": "17527778da6de858c0ea73fe7a3ae71661a929b9d951799e2ac993f23ccfadc2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Primary-School-Maths-Science-Competitions-Singapore",
      "sourcePath": "content/translations/zh-Hans/Primary-School-Maths-Science-Competitions-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "17527778da6de858c0ea73fe7a3ae71661a929b9d951799e2ac993f23ccfadc2"
    }
  ]
},
{
  "id": "article.singapore-maths-olympiad-pathway-nmos-smo-apmo-imo",
  "englishSourcePath": "content/posts/Singapore-Maths-Olympiad-Pathway-NMOS-SMO-APMO-IMO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Maths-Olympiad-Pathway-NMOS-SMO-APMO-IMO",
      "sourcePath": "content/posts/Singapore-Maths-Olympiad-Pathway-NMOS-SMO-APMO-IMO.mdx",
      "status": "published",
      "sourceSha256": "595a037e7cfdc1a108255184c944b19dbdeac299059aeaeb60fdf9ca45de7a30"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Maths-Olympiad-Pathway-NMOS-SMO-APMO-IMO",
      "sourcePath": "content/translations/zh-Hans/Singapore-Maths-Olympiad-Pathway-NMOS-SMO-APMO-IMO.mdx",
      "status": "draft",
      "sourceSha256": "595a037e7cfdc1a108255184c944b19dbdeac299059aeaeb60fdf9ca45de7a30"
    }
  ]
},
{
  "id": "article.hwa-chong-institution-dsa-math-guide",
  "englishSourcePath": "content/posts/Hwa-Chong-Institution-DSA-Math-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Hwa-Chong-Institution-DSA-Math-Guide",
      "sourcePath": "content/posts/Hwa-Chong-Institution-DSA-Math-Guide.mdx",
      "status": "published",
      "sourceSha256": "9d5e426ec5c5bd093fcc87cd7fcfc5a35c09861b9e6ef33c9740c8b7da5bc989"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Hwa-Chong-Institution-DSA-Math-Guide",
      "sourcePath": "content/translations/zh-Hans/Hwa-Chong-Institution-DSA-Math-Guide.mdx",
      "status": "draft",
      "sourceSha256": "9d5e426ec5c5bd093fcc87cd7fcfc5a35c09861b9e6ef33c9740c8b7da5bc989"
    }
  ]
},
{
  "id": "article.junior-informatics-olympiad-ijio-2025-2026-guide-for-ip-maths-and-physics-students",
  "englishSourcePath": "content/posts/Junior-Informatics-Olympiad-IJIO-2025-2026-Guide-for-IP-Maths-and-Physics-Students.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Junior-Informatics-Olympiad-IJIO-2025-2026-Guide-for-IP-Maths-and-Physics-Students",
      "sourcePath": "content/posts/Junior-Informatics-Olympiad-IJIO-2025-2026-Guide-for-IP-Maths-and-Physics-Students.mdx",
      "status": "published",
      "sourceSha256": "2211fddf8e3ada9915c54377be96caa7f50ad1493de9906a9db91049f4073f40"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Junior-Informatics-Olympiad-IJIO-2025-2026-Guide-for-IP-Maths-and-Physics-Students",
      "sourcePath": "content/translations/zh-Hans/Junior-Informatics-Olympiad-IJIO-2025-2026-Guide-for-IP-Maths-and-Physics-Students.mdx",
      "status": "draft",
      "sourceSha256": "2211fddf8e3ada9915c54377be96caa7f50ad1493de9906a9db91049f4073f40"
    }
  ]
},
{
  "id": "article.jc1-to-jc2-h2-maths-roadmap-for-consistent-a-level-results-2026",
  "englishSourcePath": "content/posts/JC1-to-JC2-H2-Maths-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-maths-tuition/JC1-to-JC2-H2-Maths-Roadmap-for-Consistent-A-Level-Results-2026",
      "sourcePath": "content/posts/JC1-to-JC2-H2-Maths-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
      "status": "published",
      "sourceSha256": "d80460fdfb0a73e143100e44975910959df031c5bd6eb2b14053da35f2666f0f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-maths-tuition/JC1-to-JC2-H2-Maths-Roadmap-for-Consistent-A-Level-Results-2026",
      "sourcePath": "content/translations/zh-Hans/JC1-to-JC2-H2-Maths-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
      "status": "draft",
      "sourceSha256": "d80460fdfb0a73e143100e44975910959df031c5bd6eb2b14053da35f2666f0f"
    }
  ]
},
{
  "id": "article.graphical-transformations-for-ipy3y4-math",
  "englishSourcePath": "content/posts/Graphical-Transformations-for-IPY3Y4-Math.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-maths-tuition/Graphical-Transformations-for-IPY3Y4-Math",
      "sourcePath": "content/posts/Graphical-Transformations-for-IPY3Y4-Math.mdx",
      "status": "published",
      "sourceSha256": "0a9575d436d0bd54720d9eb6b37431247e47700145ed0affebe63033a2246b4c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-maths-tuition/Graphical-Transformations-for-IPY3Y4-Math",
      "sourcePath": "content/translations/zh-Hans/Graphical-Transformations-for-IPY3Y4-Math.mdx",
      "status": "draft",
      "sourceSha256": "0a9575d436d0bd54720d9eb6b37431247e47700145ed0affebe63033a2246b4c"
    }
  ]
},
{
  "id": "article.proof-of-funds-japan-vs-korea-student-routes-singapore-guide-2026",
  "englishSourcePath": "content/posts/Proof-of-Funds-Japan-vs-Korea-Student-Routes-Singapore-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/scholarships/Proof-of-Funds-Japan-vs-Korea-Student-Routes-Singapore-Guide-2026",
      "sourcePath": "content/posts/Proof-of-Funds-Japan-vs-Korea-Student-Routes-Singapore-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "52ee7327108743fe5a89e044119176d430d88ac97badb6d04d1e76cf541ff281"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/scholarships/Proof-of-Funds-Japan-vs-Korea-Student-Routes-Singapore-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Proof-of-Funds-Japan-vs-Korea-Student-Routes-Singapore-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "52ee7327108743fe5a89e044119176d430d88ac97badb6d04d1e76cf541ff281"
    }
  ]
},
{
  "id": "article.housing-in-japan-vs-korea-singapore-students-dorms-deposits-questions-guide-2026",
  "englishSourcePath": "content/posts/Housing-in-Japan-vs-Korea-Singapore-Students-Dorms-Deposits-Questions-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/scholarships/Housing-in-Japan-vs-Korea-Singapore-Students-Dorms-Deposits-Questions-Guide-2026",
      "sourcePath": "content/posts/Housing-in-Japan-vs-Korea-Singapore-Students-Dorms-Deposits-Questions-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "3cf42e2253bd29a1b6b932e197dea53d23ff0050381597706d2df264f08a7957"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/scholarships/Housing-in-Japan-vs-Korea-Singapore-Students-Dorms-Deposits-Questions-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Housing-in-Japan-vs-Korea-Singapore-Students-Dorms-Deposits-Questions-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "3cf42e2253bd29a1b6b932e197dea53d23ff0050381597706d2df264f08a7957"
    }
  ]
},
{
  "id": "article.where-to-study-in-japan-singapore-students-47-prefectures-guide-2026",
  "englishSourcePath": "content/posts/Where-to-Study-in-Japan-Singapore-Students-47-Prefectures-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Where-to-Study-in-Japan-Singapore-Students-47-Prefectures-Guide-2026",
      "sourcePath": "content/posts/Where-to-Study-in-Japan-Singapore-Students-47-Prefectures-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "1ac78c2ab0d1fe3dc24abf6e672f4e3b90041a470c7902f2fac126661642e8db"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Where-to-Study-in-Japan-Singapore-Students-47-Prefectures-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Where-to-Study-in-Japan-Singapore-Students-47-Prefectures-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "1ac78c2ab0d1fe3dc24abf6e672f4e3b90041a470c7902f2fac126661642e8db"
    }
  ]
},
{
  "id": "article.where-to-study-in-korea-singapore-students-official-regions-guide-2026",
  "englishSourcePath": "content/posts/Where-to-Study-in-Korea-Singapore-Students-Official-Regions-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Where-to-Study-in-Korea-Singapore-Students-Official-Regions-Guide-2026",
      "sourcePath": "content/posts/Where-to-Study-in-Korea-Singapore-Students-Official-Regions-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "de38841c29c38c43bcfdb1b74bd762e976483e1d2e75b92012ce9c84b2234f15"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Where-to-Study-in-Korea-Singapore-Students-Official-Regions-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Where-to-Study-in-Korea-Singapore-Students-Official-Regions-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "de38841c29c38c43bcfdb1b74bd762e976483e1d2e75b92012ce9c84b2234f15"
    }
  ]
},
{
  "id": "article.living-in-japan-support-systems-singapore-students-official-help-guide-2026",
  "englishSourcePath": "content/posts/Living-in-Japan-Support-Systems-Singapore-Students-Official-Help-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Living-in-Japan-Support-Systems-Singapore-Students-Official-Help-Guide-2026",
      "sourcePath": "content/posts/Living-in-Japan-Support-Systems-Singapore-Students-Official-Help-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "24bd65e2b0a078ac080de92ccdaf9eae71eb00f3c9fce061fab5a37d7a3840ba"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Living-in-Japan-Support-Systems-Singapore-Students-Official-Help-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Living-in-Japan-Support-Systems-Singapore-Students-Official-Help-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "24bd65e2b0a078ac080de92ccdaf9eae71eb00f3c9fce061fab5a37d7a3840ba"
    }
  ]
},
{
  "id": "article.living-in-korea-international-student-singapore-official-living-law-checklist-guide-2026",
  "englishSourcePath": "content/posts/Living-in-Korea-International-Student-Singapore-Official-Living-Law-Checklist-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Living-in-Korea-International-Student-Singapore-Official-Living-Law-Checklist-Guide-2026",
      "sourcePath": "content/posts/Living-in-Korea-International-Student-Singapore-Official-Living-Law-Checklist-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "882be7db10e4c6fd76dca50b46a3a326b9eb122cad97c77fe38e1058354fd4aa"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Living-in-Korea-International-Student-Singapore-Official-Living-Law-Checklist-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Living-in-Korea-International-Student-Singapore-Official-Living-Law-Checklist-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "882be7db10e4c6fd76dca50b46a3a326b9eb122cad97c77fe38e1058354fd4aa"
    }
  ]
},
{
  "id": "article.japan-vs-korea-student-budget-singapore-practical-cost-checklist-guide-2026",
  "englishSourcePath": "content/posts/Japan-vs-Korea-Student-Budget-Singapore-Practical-Cost-Checklist-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/scholarships/Japan-vs-Korea-Student-Budget-Singapore-Practical-Cost-Checklist-Guide-2026",
      "sourcePath": "content/posts/Japan-vs-Korea-Student-Budget-Singapore-Practical-Cost-Checklist-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "9bb3d74c724f8a6441ab90374348aa08d0309973687e619fe097bc8417d73759"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/scholarships/Japan-vs-Korea-Student-Budget-Singapore-Practical-Cost-Checklist-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Japan-vs-Korea-Student-Budget-Singapore-Practical-Cost-Checklist-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "9bb3d74c724f8a6441ab90374348aa08d0309973687e619fe097bc8417d73759"
    }
  ]
},
{
  "id": "article.korea-cost-planning-singapore-students-abroad-expenses-living-expense-guide-2026",
  "englishSourcePath": "content/posts/Korea-Cost-Planning-Singapore-Students-Abroad-Expenses-Living-Expense-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Korea-Cost-Planning-Singapore-Students-Abroad-Expenses-Living-Expense-Guide-2026",
      "sourcePath": "content/posts/Korea-Cost-Planning-Singapore-Students-Abroad-Expenses-Living-Expense-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "4d5c3372b7c8469a31df2c2594d4ebda23ac2690005dd456a6a0492d892e23b4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Korea-Cost-Planning-Singapore-Students-Abroad-Expenses-Living-Expense-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Korea-Cost-Planning-Singapore-Students-Abroad-Expenses-Living-Expense-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "4d5c3372b7c8469a31df2c2594d4ebda23ac2690005dd456a6a0492d892e23b4"
    }
  ]
},
{
  "id": "article.recommendation-letters-for-mext-gks-and-japan-korea-admissions-singapore-guide-2026",
  "englishSourcePath": "content/posts/Recommendation-Letters-for-MEXT-GKS-and-Japan-Korea-Admissions-Singapore-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/scholarships/Recommendation-Letters-for-MEXT-GKS-and-Japan-Korea-Admissions-Singapore-Guide-2026",
      "sourcePath": "content/posts/Recommendation-Letters-for-MEXT-GKS-and-Japan-Korea-Admissions-Singapore-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "802316daceb8d1c68e448505b0c3e9e4eaeb35ed30bd9ff3eeed41ba76270548"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/scholarships/Recommendation-Letters-for-MEXT-GKS-and-Japan-Korea-Admissions-Singapore-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Recommendation-Letters-for-MEXT-GKS-and-Japan-Korea-Admissions-Singapore-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "802316daceb8d1c68e448505b0c3e9e4eaeb35ed30bd9ff3eeed41ba76270548"
    }
  ]
},
{
  "id": "article.mext-vs-gks-singapore-which-scholarship-fits-you-compare-guide-2026",
  "englishSourcePath": "content/posts/MEXT-vs-GKS-Singapore-Which-Scholarship-Fits-You-Compare-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/scholarships/MEXT-vs-GKS-Singapore-Which-Scholarship-Fits-You-Compare-Guide-2026",
      "sourcePath": "content/posts/MEXT-vs-GKS-Singapore-Which-Scholarship-Fits-You-Compare-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "2750661ed3aea098ca24f429b05eb5d31ce0118bc04a1446e2a1d1e8537a7a44"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/scholarships/MEXT-vs-GKS-Singapore-Which-Scholarship-Fits-You-Compare-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/MEXT-vs-GKS-Singapore-Which-Scholarship-Fits-You-Compare-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "2750661ed3aea098ca24f429b05eb5d31ce0118bc04a1446e2a1d1e8537a7a44"
    }
  ]
},
{
  "id": "article.mext-vs-gks-medical-forms-singapore-health-check-timing-guide-2026",
  "englishSourcePath": "content/posts/MEXT-vs-GKS-Medical-Forms-Singapore-Health-Check-Timing-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/scholarships/MEXT-vs-GKS-Medical-Forms-Singapore-Health-Check-Timing-Guide-2026",
      "sourcePath": "content/posts/MEXT-vs-GKS-Medical-Forms-Singapore-Health-Check-Timing-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "fad71693815a417580e992a34620d873744b27a50ba7148200251746b56e5577"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/scholarships/MEXT-vs-GKS-Medical-Forms-Singapore-Health-Check-Timing-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/MEXT-vs-GKS-Medical-Forms-Singapore-Health-Check-Timing-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "fad71693815a417580e992a34620d873744b27a50ba7148200251746b56e5577"
    }
  ]
},
{
  "id": "article.korea-scholarships-beyond-gks-official-notices-shortlist-workflow-guide-2026",
  "englishSourcePath": "content/posts/Korea-Scholarships-Beyond-GKS-Official-Notices-Shortlist-Workflow-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Korea-Scholarships-Beyond-GKS-Official-Notices-Shortlist-Workflow-Guide-2026",
      "sourcePath": "content/posts/Korea-Scholarships-Beyond-GKS-Official-Notices-Shortlist-Workflow-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "4abc81a6162250bd04ef03e3183fdf24578091e7f4e1f7fbac4fef80577a3992"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Korea-Scholarships-Beyond-GKS-Official-Notices-Shortlist-Workflow-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Korea-Scholarships-Beyond-GKS-Official-Notices-Shortlist-Workflow-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "4abc81a6162250bd04ef03e3183fdf24578091e7f4e1f7fbac4fef80577a3992"
    }
  ]
},
{
  "id": "article.global-korea-scholarship-gks-korea-japan-programme-2026-profile",
  "englishSourcePath": "content/posts/Global-Korea-Scholarship-GKS-Korea-Japan-Programme-2026-Profile.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Global-Korea-Scholarship-GKS-Korea-Japan-Programme-2026-Profile",
      "sourcePath": "content/posts/Global-Korea-Scholarship-GKS-Korea-Japan-Programme-2026-Profile.mdx",
      "status": "published",
      "sourceSha256": "f75ff28de8da3c50cbf1221ff5480c3614aa84a50a34c0a88d7ae03ce7ddad88"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Global-Korea-Scholarship-GKS-Korea-Japan-Programme-2026-Profile",
      "sourcePath": "content/translations/zh-Hans/Global-Korea-Scholarship-GKS-Korea-Japan-Programme-2026-Profile.mdx",
      "status": "draft",
      "sourceSha256": "f75ff28de8da3c50cbf1221ff5480c3614aa84a50a34c0a88d7ae03ce7ddad88"
    }
  ]
},
{
  "id": "article.adb-japan-scholarship-postgraduate-profile",
  "englishSourcePath": "content/posts/ADB-Japan-Scholarship-Postgraduate-Profile.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/ADB-Japan-Scholarship-Postgraduate-Profile",
      "sourcePath": "content/posts/ADB-Japan-Scholarship-Postgraduate-Profile.mdx",
      "status": "published",
      "sourceSha256": "4249dd1f1a3a53be507d1a0f912cbb5cab9ca6d39ff093f449fd27da19020748"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/ADB-Japan-Scholarship-Postgraduate-Profile",
      "sourcePath": "content/translations/zh-Hans/ADB-Japan-Scholarship-Postgraduate-Profile.mdx",
      "status": "draft",
      "sourceSha256": "4249dd1f1a3a53be507d1a0f912cbb5cab9ca6d39ff093f449fd27da19020748"
    }
  ]
},
{
  "id": "article.japan-vocational-schools-singapore-students-specialized-training-colleges-guide-2026",
  "englishSourcePath": "content/posts/Japan-Vocational-Schools-Singapore-Students-Specialized-Training-Colleges-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Japan-Vocational-Schools-Singapore-Students-Specialized-Training-Colleges-Guide-2026",
      "sourcePath": "content/posts/Japan-Vocational-Schools-Singapore-Students-Specialized-Training-Colleges-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "36d79f057b1da390100da70489d70c52eb295f174afff2c903b6a3eeb3d78cd0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Japan-Vocational-Schools-Singapore-Students-Specialized-Training-Colleges-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Japan-Vocational-Schools-Singapore-Students-Specialized-Training-Colleges-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "36d79f057b1da390100da70489d70c52eb295f174afff2c903b6a3eeb3d78cd0"
    }
  ]
},
{
  "id": "article.japan-graduate-schools-singapore-students-coursework-vs-research-planning-guide-2026",
  "englishSourcePath": "content/posts/Japan-Graduate-Schools-Singapore-Students-Coursework-vs-Research-Planning-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Japan-Graduate-Schools-Singapore-Students-Coursework-vs-Research-Planning-Guide-2026",
      "sourcePath": "content/posts/Japan-Graduate-Schools-Singapore-Students-Coursework-vs-Research-Planning-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "39a8581a32cbda765cd8972c0e7a560a726cf2da81c9f470e1222f8cf110818a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Japan-Graduate-Schools-Singapore-Students-Coursework-vs-Research-Planning-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Japan-Graduate-Schools-Singapore-Students-Coursework-vs-Research-Planning-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "39a8581a32cbda765cd8972c0e7a560a726cf2da81c9f470e1222f8cf110818a"
    }
  ]
},
{
  "id": "article.japan-colleges-of-technology-kosen-singapore-students-guide-2026",
  "englishSourcePath": "content/posts/Japan-Colleges-of-Technology-Kosen-Singapore-Students-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Japan-Colleges-of-Technology-Kosen-Singapore-Students-Guide-2026",
      "sourcePath": "content/posts/Japan-Colleges-of-Technology-Kosen-Singapore-Students-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "54b6f1de9d4c1a503d00b993c18bcc6f10e4fed461630d98573182e2c89a8885"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Japan-Colleges-of-Technology-Kosen-Singapore-Students-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Japan-Colleges-of-Technology-Kosen-Singapore-Students-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "54b6f1de9d4c1a503d00b993c18bcc6f10e4fed461630d98573182e2c89a8885"
    }
  ]
},
{
  "id": "article.how-to-use-study-in-korea-download-university-information-singapore-shortlisting-guide-2026",
  "englishSourcePath": "content/posts/How-to-Use-Study-in-Korea-Download-University-Information-Singapore-Shortlisting-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/How-to-Use-Study-in-Korea-Download-University-Information-Singapore-Shortlisting-Guide-2026",
      "sourcePath": "content/posts/How-to-Use-Study-in-Korea-Download-University-Information-Singapore-Shortlisting-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "49ebe337a5c129383d2555d2a145993b02618017da49015f55a602d89df3e992"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/How-to-Use-Study-in-Korea-Download-University-Information-Singapore-Shortlisting-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/How-to-Use-Study-in-Korea-Download-University-Information-Singapore-Shortlisting-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "49ebe337a5c129383d2555d2a145993b02618017da49015f55a602d89df3e992"
    }
  ]
},
{
  "id": "article.how-to-verify-a-korean-university-singapore-students-certified-university-list-guide-2026",
  "englishSourcePath": "content/posts/How-to-Verify-a-Korean-University-Singapore-Students-Certified-University-List-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/How-to-Verify-a-Korean-University-Singapore-Students-Certified-University-List-Guide-2026",
      "sourcePath": "content/posts/How-to-Verify-a-Korean-University-Singapore-Students-Certified-University-List-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "be8954ea3dff7ce5bde5808db87591706cb8c7d4f0d84298a4b8269f2706b0a8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/How-to-Verify-a-Korean-University-Singapore-Students-Certified-University-List-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/How-to-Verify-a-Korean-University-Singapore-Students-Certified-University-List-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "be8954ea3dff7ce5bde5808db87591706cb8c7d4f0d84298a4b8269f2706b0a8"
    }
  ]
},
{
  "id": "article.gks-2026-singapore-embassy-vs-university-track-university-shortlist-guide",
  "englishSourcePath": "content/posts/GKS-2026-Singapore-Embassy-vs-University-Track-University-Shortlist-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/GKS-2026-Singapore-Embassy-vs-University-Track-University-Shortlist-Guide",
      "sourcePath": "content/posts/GKS-2026-Singapore-Embassy-vs-University-Track-University-Shortlist-Guide.mdx",
      "status": "published",
      "sourceSha256": "81957652da8534a866e986552ec4d521aa393a4f85142586a3911dcdec355226"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/GKS-2026-Singapore-Embassy-vs-University-Track-University-Shortlist-Guide",
      "sourcePath": "content/translations/zh-Hans/GKS-2026-Singapore-Embassy-vs-University-Track-University-Shortlist-Guide.mdx",
      "status": "draft",
      "sourceSha256": "81957652da8534a866e986552ec4d521aa393a4f85142586a3911dcdec355226"
    }
  ]
},
{
  "id": "article.gks-scholarship-singapore-interview-prep-guide-2026",
  "englishSourcePath": "content/posts/GKS-Scholarship-Singapore-Interview-Prep-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/GKS-Scholarship-Singapore-Interview-Prep-Guide-2026",
      "sourcePath": "content/posts/GKS-Scholarship-Singapore-Interview-Prep-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "e144ed8d208903bfa8073026881ec836b4fcc561e19e5efefeda796069d980c6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/GKS-Scholarship-Singapore-Interview-Prep-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/GKS-Scholarship-Singapore-Interview-Prep-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "e144ed8d208903bfa8073026881ec836b4fcc561e19e5efefeda796069d980c6"
    }
  ]
},
{
  "id": "article.gks-2026-singapore-personal-statement-and-study-plan-writing-guide",
  "englishSourcePath": "content/posts/GKS-2026-Singapore-Personal-Statement-and-Study-Plan-Writing-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/GKS-2026-Singapore-Personal-Statement-and-Study-Plan-Writing-Guide",
      "sourcePath": "content/posts/GKS-2026-Singapore-Personal-Statement-and-Study-Plan-Writing-Guide.mdx",
      "status": "published",
      "sourceSha256": "4d4a9358c252e1535143408f8fd616f3d084d4a529efc70be963413d13d60870"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/GKS-2026-Singapore-Personal-Statement-and-Study-Plan-Writing-Guide",
      "sourcePath": "content/translations/zh-Hans/GKS-2026-Singapore-Personal-Statement-and-Study-Plan-Writing-Guide.mdx",
      "status": "draft",
      "sourceSha256": "4d4a9358c252e1535143408f8fd616f3d084d4a529efc70be963413d13d60870"
    }
  ]
},
{
  "id": "article.japanese-language-schools-singapore-students-how-to-choose-safely-pivot-to-degree-guide-2026",
  "englishSourcePath": "content/posts/Japanese-Language-Schools-Singapore-Students-How-to-Choose-Safely-Pivot-to-Degree-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Japanese-Language-Schools-Singapore-Students-How-to-Choose-Safely-Pivot-to-Degree-Guide-2026",
      "sourcePath": "content/posts/Japanese-Language-Schools-Singapore-Students-How-to-Choose-Safely-Pivot-to-Degree-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "b763953b4a25bff262a3f35f9bb8fef6a92b54ae54f2ca9ccfcd19dfd0cac140"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Japanese-Language-Schools-Singapore-Students-How-to-Choose-Safely-Pivot-to-Degree-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Japanese-Language-Schools-Singapore-Students-How-to-Choose-Safely-Pivot-to-Degree-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "b763953b4a25bff262a3f35f9bb8fef6a92b54ae54f2ca9ccfcd19dfd0cac140"
    }
  ]
},
{
  "id": "article.arriving-in-korea-as-a-student-singapore-first-week-admin-checklist-2026",
  "englishSourcePath": "content/posts/Arriving-in-Korea-as-a-Student-Singapore-First-Week-Admin-Checklist-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Arriving-in-Korea-as-a-Student-Singapore-First-Week-Admin-Checklist-2026",
      "sourcePath": "content/posts/Arriving-in-Korea-as-a-Student-Singapore-First-Week-Admin-Checklist-2026.mdx",
      "status": "published",
      "sourceSha256": "6445f99ea1493630ebf1560b9236d43ac102a8c99783c748229dcaf50043ac7e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Arriving-in-Korea-as-a-Student-Singapore-First-Week-Admin-Checklist-2026",
      "sourcePath": "content/translations/zh-Hans/Arriving-in-Korea-as-a-Student-Singapore-First-Week-Admin-Checklist-2026.mdx",
      "status": "draft",
      "sourceSha256": "6445f99ea1493630ebf1560b9236d43ac102a8c99783c748229dcaf50043ac7e"
    }
  ]
},
{
  "id": "article.arriving-in-japan-as-a-student-singapore-first-week-admin-checklist-2026",
  "englishSourcePath": "content/posts/Arriving-in-Japan-as-a-Student-Singapore-First-Week-Admin-Checklist-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Arriving-in-Japan-as-a-Student-Singapore-First-Week-Admin-Checklist-2026",
      "sourcePath": "content/posts/Arriving-in-Japan-as-a-Student-Singapore-First-Week-Admin-Checklist-2026.mdx",
      "status": "published",
      "sourceSha256": "ce2426d12266a0d00d50d55f735aa633d5ac978ccd2dc647868e463d6a5b7921"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Arriving-in-Japan-as-a-Student-Singapore-First-Week-Admin-Checklist-2026",
      "sourcePath": "content/translations/zh-Hans/Arriving-in-Japan-as-a-Student-Singapore-First-Week-Admin-Checklist-2026.mdx",
      "status": "draft",
      "sourceSha256": "ce2426d12266a0d00d50d55f735aa633d5ac978ccd2dc647868e463d6a5b7921"
    }
  ]
},
{
  "id": "article.japan-student-visa-singapore-coe-to-visa-arrival-checklist-guide-2026",
  "englishSourcePath": "content/posts/Japan-Student-Visa-Singapore-COE-to-Visa-Arrival-Checklist-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Japan-Student-Visa-Singapore-COE-to-Visa-Arrival-Checklist-Guide-2026",
      "sourcePath": "content/posts/Japan-Student-Visa-Singapore-COE-to-Visa-Arrival-Checklist-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "295160c7ec1ade3d8928f240f86a3ee4fa2d7e79169135c7285a51b207f648dd"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Japan-Student-Visa-Singapore-COE-to-Visa-Arrival-Checklist-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Japan-Student-Visa-Singapore-COE-to-Visa-Arrival-Checklist-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "295160c7ec1ade3d8928f240f86a3ee4fa2d7e79169135c7285a51b207f648dd"
    }
  ]
},
{
  "id": "article.japan-university-fees-explained-singapore-students-tuition-vs-entrance-fees-guide-2026",
  "englishSourcePath": "content/posts/Japan-University-Fees-Explained-Singapore-Students-Tuition-vs-Entrance-Fees-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Japan-University-Fees-Explained-Singapore-Students-Tuition-vs-Entrance-Fees-Guide-2026",
      "sourcePath": "content/posts/Japan-University-Fees-Explained-Singapore-Students-Tuition-vs-Entrance-Fees-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "ea53b4f9ac60bc8bda1dec17033a410ae34a494bc2a6b718e8ad5e2bda62e104"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Japan-University-Fees-Explained-Singapore-Students-Tuition-vs-Entrance-Fees-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Japan-University-Fees-Explained-Singapore-Students-Tuition-vs-Entrance-Fees-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "ea53b4f9ac60bc8bda1dec17033a410ae34a494bc2a6b718e8ad5e2bda62e104"
    }
  ]
},
{
  "id": "article.japan-university-intakes-singapore-students-april-vs-september-october-planning-guide-2026",
  "englishSourcePath": "content/posts/Japan-University-Intakes-Singapore-Students-April-vs-September-October-Planning-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/Japan-University-Intakes-Singapore-Students-April-vs-September-October-Planning-Guide-2026",
      "sourcePath": "content/posts/Japan-University-Intakes-Singapore-Students-April-vs-September-October-Planning-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "9a054b49e177b3630a2a5258df434920cc70625032d3e91166f86acf5777ba3e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/Japan-University-Intakes-Singapore-Students-April-vs-September-October-Planning-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Japan-University-Intakes-Singapore-Students-April-vs-September-October-Planning-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "9a054b49e177b3630a2a5258df434920cc70625032d3e91166f86acf5777ba3e"
    }
  ]
},
{
  "id": "article.english-taught-degrees-in-japan-singapore-programme-search-shortlist-guide-2026",
  "englishSourcePath": "content/posts/English-Taught-Degrees-in-Japan-Singapore-Programme-Search-Shortlist-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/japan-scholarships/English-Taught-Degrees-in-Japan-Singapore-Programme-Search-Shortlist-Guide-2026",
      "sourcePath": "content/posts/English-Taught-Degrees-in-Japan-Singapore-Programme-Search-Shortlist-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "c466cd90080c286416d0592e7cefe6f2a00b2769b8397454ae98c3f6ef6c8c70"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/japan-scholarships/English-Taught-Degrees-in-Japan-Singapore-Programme-Search-Shortlist-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/English-Taught-Degrees-in-Japan-Singapore-Programme-Search-Shortlist-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "c466cd90080c286416d0592e7cefe6f2a00b2769b8397454ae98c3f6ef6c8c70"
    }
  ]
},
{
  "id": "article.english-taught-degrees-in-korea-singapore-programme-discovery-shortlist-guide-2026",
  "englishSourcePath": "content/posts/English-Taught-Degrees-in-Korea-Singapore-Programme-Discovery-Shortlist-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/English-Taught-Degrees-in-Korea-Singapore-Programme-Discovery-Shortlist-Guide-2026",
      "sourcePath": "content/posts/English-Taught-Degrees-in-Korea-Singapore-Programme-Discovery-Shortlist-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "04b8ea42c7f248006eafd812a5dcda937cfd5647b1a609c5522765091a4bd8f1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/English-Taught-Degrees-in-Korea-Singapore-Programme-Discovery-Shortlist-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/English-Taught-Degrees-in-Korea-Singapore-Programme-Discovery-Shortlist-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "04b8ea42c7f248006eafd812a5dcda937cfd5647b1a609c5522765091a4bd8f1"
    }
  ]
},
{
  "id": "article.korean-language-institutes-singapore-students-topik-visa-progression-checklist-2026",
  "englishSourcePath": "content/posts/Korean-Language-Institutes-Singapore-Students-TOPIK-Visa-Progression-Checklist-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Korean-Language-Institutes-Singapore-Students-TOPIK-Visa-Progression-Checklist-2026",
      "sourcePath": "content/posts/Korean-Language-Institutes-Singapore-Students-TOPIK-Visa-Progression-Checklist-2026.mdx",
      "status": "published",
      "sourceSha256": "458c5dfd311d68eff205dd5fe794f70d5f67f06d3687c8ab83de77b31577ac63"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Korean-Language-Institutes-Singapore-Students-TOPIK-Visa-Progression-Checklist-2026",
      "sourcePath": "content/translations/zh-Hans/Korean-Language-Institutes-Singapore-Students-TOPIK-Visa-Progression-Checklist-2026.mdx",
      "status": "draft",
      "sourceSha256": "458c5dfd311d68eff205dd5fe794f70d5f67f06d3687c8ab83de77b31577ac63"
    }
  ]
},
{
  "id": "article.korea-university-intakes-singapore-students-march-vs-september-planning-guide-2026",
  "englishSourcePath": "content/posts/Korea-University-Intakes-Singapore-Students-March-vs-September-Planning-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Korea-University-Intakes-Singapore-Students-March-vs-September-Planning-Guide-2026",
      "sourcePath": "content/posts/Korea-University-Intakes-Singapore-Students-March-vs-September-Planning-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "6bf81ea5d14cb4875940e62a061df147cfdf0a3fcfe28dbbd015c066abf05271"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Korea-University-Intakes-Singapore-Students-March-vs-September-Planning-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Korea-University-Intakes-Singapore-Students-March-vs-September-Planning-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "6bf81ea5d14cb4875940e62a061df147cfdf0a3fcfe28dbbd015c066abf05271"
    }
  ]
},
{
  "id": "article.korea-student-visas-singapore-d2-vs-d4-1-degree-vs-language-guide-2026",
  "englishSourcePath": "content/posts/Korea-Student-Visas-Singapore-D2-vs-D4-1-Degree-vs-Language-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/Korea-Student-Visas-Singapore-D2-vs-D4-1-Degree-vs-Language-Guide-2026",
      "sourcePath": "content/posts/Korea-Student-Visas-Singapore-D2-vs-D4-1-Degree-vs-Language-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "a8844bcc8cacd1221abaf9ca19ceae9c77debe7f6aaac1947f4994a27abdc8be"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/Korea-Student-Visas-Singapore-D2-vs-D4-1-Degree-vs-Language-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Korea-Student-Visas-Singapore-D2-vs-D4-1-Degree-vs-Language-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "a8844bcc8cacd1221abaf9ca19ceae9c77debe7f6aaac1947f4994a27abdc8be"
    }
  ]
},
  {
  "id": "article.gks-scholarship-singapore-embassy-guide-2026",
  "englishSourcePath": "content/posts/GKS-Scholarship-Singapore-Embassy-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/korea-scholarships/GKS-Scholarship-Singapore-Embassy-Guide-2026",
      "sourcePath": "content/posts/GKS-Scholarship-Singapore-Embassy-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "81b95768e8e13154671b6fe04d1a5400c4be75418e4251d9fcc85bbe7bcc2481"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/korea-scholarships/GKS-Scholarship-Singapore-Embassy-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/GKS-Scholarship-Singapore-Embassy-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "81b95768e8e13154671b6fe04d1a5400c4be75418e4251d9fcc85bbe7bcc2481"
    }
  ]
},
  {
    id: "article.global-korea-scholarship-gks-undergraduate-2026-profile",
    englishSourcePath:
      "content/posts/Global-Korea-Scholarship-GKS-Undergraduate-2026-Profile.mdx",
    versions: [
      {
        locale: "en",
        publicPath:
          "/blog/korea-scholarships/Global-Korea-Scholarship-GKS-Undergraduate-2026-Profile",
        sourcePath:
          "content/posts/Global-Korea-Scholarship-GKS-Undergraduate-2026-Profile.mdx",
        status: "published",
        sourceSha256:
          "fffeb082dce2c5b1bcb355b7fe2783605faeccbeb9c8854aca431a12f8b831fc",
      },
      {
        locale: "zh-Hans",
        publicPath:
          "/zh/blog/korea-scholarships/Global-Korea-Scholarship-GKS-Undergraduate-2026-Profile",
        sourcePath:
          "content/translations/zh-Hans/Global-Korea-Scholarship-GKS-Undergraduate-2026-Profile.mdx",
        status: "draft",
        sourceSha256:
          "fffeb082dce2c5b1bcb355b7fe2783605faeccbeb9c8854aca431a12f8b831fc",
      },
    ],
  },
  {
    id: "article.japan-scholarships-beyond-mext-jasso-tuition-reduction-search-workflow-guide-2026",
    englishSourcePath:
      "content/posts/Japan-Scholarships-Beyond-MEXT-JASSO-Tuition-Reduction-Search-Workflow-Guide-2026.mdx",
    versions: [
      {
        locale: "en",
        publicPath:
          "/blog/japan-scholarships/Japan-Scholarships-Beyond-MEXT-JASSO-Tuition-Reduction-Search-Workflow-Guide-2026",
        sourcePath:
          "content/posts/Japan-Scholarships-Beyond-MEXT-JASSO-Tuition-Reduction-Search-Workflow-Guide-2026.mdx",
        status: "published",
        sourceSha256:
          "e8351ed51cf58895e74c94bda18c76bacec43adf21086c28d223aabce74667c6",
      },
      {
        locale: "zh-Hans",
        publicPath:
          "/zh/blog/japan-scholarships/Japan-Scholarships-Beyond-MEXT-JASSO-Tuition-Reduction-Search-Workflow-Guide-2026",
        sourcePath:
          "content/translations/zh-Hans/Japan-Scholarships-Beyond-MEXT-JASSO-Tuition-Reduction-Search-Workflow-Guide-2026.mdx",
        status: "draft",
        sourceSha256:
          "e8351ed51cf58895e74c94bda18c76bacec43adf21086c28d223aabce74667c6",
      },
    ],
  },
  {
    id: "article.mext-written-tests-singapore-official-sample-questions-guide-2026",
    englishSourcePath:
      "content/posts/MEXT-Written-Tests-Singapore-Official-Sample-Questions-Guide-2026.mdx",
    versions: [
      {
        locale: "en",
        publicPath:
          "/blog/japan-scholarships/MEXT-Written-Tests-Singapore-Official-Sample-Questions-Guide-2026",
        sourcePath:
          "content/posts/MEXT-Written-Tests-Singapore-Official-Sample-Questions-Guide-2026.mdx",
        status: "published",
        sourceSha256:
          "4c183804b2f9297da8d9a4f354e7e2e380a66915eb5d63c330e5ac08a2d9eaa2",
      },
      {
        locale: "zh-Hans",
        publicPath:
          "/zh/blog/japan-scholarships/MEXT-Written-Tests-Singapore-Official-Sample-Questions-Guide-2026",
        sourcePath:
          "content/translations/zh-Hans/MEXT-Written-Tests-Singapore-Official-Sample-Questions-Guide-2026.mdx",
        status: "draft",
        sourceSha256:
          "4c183804b2f9297da8d9a4f354e7e2e380a66915eb5d63c330e5ac08a2d9eaa2",
      },
    ],
  },
  {
    id: "article.mext-scholarship-singapore-interview-prep-guide-2026",
    englishSourcePath:
      "content/posts/MEXT-Scholarship-Singapore-Interview-Prep-Guide-2026.mdx",
    versions: [
      {
        locale: "en",
        publicPath:
          "/blog/japan-scholarships/MEXT-Scholarship-Singapore-Interview-Prep-Guide-2026",
        sourcePath:
          "content/posts/MEXT-Scholarship-Singapore-Interview-Prep-Guide-2026.mdx",
        status: "published",
        sourceSha256:
          "f7d80fe75cd889ac1b6dbde273b98af1abc2fac4628637538aa39e281082ed84",
      },
      {
        locale: "zh-Hans",
        publicPath:
          "/zh/blog/japan-scholarships/MEXT-Scholarship-Singapore-Interview-Prep-Guide-2026",
        sourcePath:
          "content/translations/zh-Hans/MEXT-Scholarship-Singapore-Interview-Prep-Guide-2026.mdx",
        status: "draft",
        sourceSha256:
          "f7d80fe75cd889ac1b6dbde273b98af1abc2fac4628637538aa39e281082ed84",
      },
    ],
  },
  {
    id: "article.mext-scholarship-singapore-embassy-guide-2026",
    englishSourcePath:
      "content/posts/MEXT-Scholarship-Singapore-Embassy-Guide-2026.mdx",
    versions: [
      {
        locale: "en",
        publicPath:
          "/blog/japan-scholarships/MEXT-Scholarship-Singapore-Embassy-Guide-2026",
        sourcePath:
          "content/posts/MEXT-Scholarship-Singapore-Embassy-Guide-2026.mdx",
        status: "published",
        sourceSha256:
          "b0d39dc14653353c09ca277264a03d4cd63176b6c06f8222cb9d3b5c90aae219",
      },
      {
        locale: "zh-Hans",
        publicPath:
          "/zh/blog/japan-scholarships/MEXT-Scholarship-Singapore-Embassy-Guide-2026",
        sourcePath:
          "content/translations/zh-Hans/MEXT-Scholarship-Singapore-Embassy-Guide-2026.mdx",
        status: "draft",
        sourceSha256:
          "b0d39dc14653353c09ca277264a03d4cd63176b6c06f8222cb9d3b5c90aae219",
      },
    ],
  },
  {
    id: "article.study-abroad-japan-vs-south-korea-checklist",
    englishSourcePath:
      "content/posts/Study-Abroad-Japan-vs-South-Korea-Checklist.mdx",
    versions: [
      {
        locale: "en",
        publicPath: "/blog/Study-Abroad-Japan-vs-South-Korea-Checklist",
        sourcePath:
          "content/posts/Study-Abroad-Japan-vs-South-Korea-Checklist.mdx",
        status: "published",
        sourceSha256:
          "1c982991f4903d832bb429b0ff731f3a8e31c65f69618a1fa251b34b1f573892",
      },
      {
        locale: "zh-Hans",
        publicPath: "/zh/blog/Study-Abroad-Japan-vs-South-Korea-Checklist",
        sourcePath:
          "content/translations/zh-Hans/Study-Abroad-Japan-vs-South-Korea-Checklist.mdx",
        status: "draft",
        sourceSha256:
          "1c982991f4903d832bb429b0ff731f3a8e31c65f69618a1fa251b34b1f573892",
      },
    ],
  },
  {
    id: "article.o-level-practical-revision-plan-8-weeks",
    englishSourcePath:
      "content/posts/O-Level-Practical-Revision-Plan-8-Weeks.mdx",
    versions: [
      {
        locale: "en",
        publicPath: "/blog/O-Level-Practical-Revision-Plan-8-Weeks",
        sourcePath: "content/posts/O-Level-Practical-Revision-Plan-8-Weeks.mdx",
        status: "published",
        sourceSha256:
          "5cde19876798fe3d28c982659efd5ed6b6b257213e05ac4a23a7bae569729237",
      },
      {
        locale: "zh-Hans",
        publicPath: "/zh/blog/O-Level-Practical-Revision-Plan-8-Weeks",
        sourcePath:
          "content/translations/zh-Hans/O-Level-Practical-Revision-Plan-8-Weeks.mdx",
        status: "draft",
        sourceSha256:
          "5cde19876798fe3d28c982659efd5ed6b6b257213e05ac4a23a7bae569729237",
      },
    ],
  },
{
  "id": "article.singapore-and-asian-schools-math-olympiad-sasmo",
  "englishSourcePath": "content/posts/Singapore-and-Asian-Schools-Math-Olympiad-SASMO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-and-Asian-Schools-Math-Olympiad-SASMO",
      "sourcePath": "content/posts/Singapore-and-Asian-Schools-Math-Olympiad-SASMO.mdx",
      "status": "published",
      "sourceSha256": "f819653f5f6c21bfb622f0d0cf5143a6101036b015d8b4a28008cb3bd9441ff7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-and-Asian-Schools-Math-Olympiad-SASMO",
      "sourcePath": "content/translations/zh-Hans/Singapore-and-Asian-Schools-Math-Olympiad-SASMO.mdx",
      "status": "draft",
      "sourceSha256": "f819653f5f6c21bfb622f0d0cf5143a6101036b015d8b4a28008cb3bd9441ff7"
    }
  ]
},
{
  "id": "article.sasmo-results-2026-when-how-to-check",
  "englishSourcePath": "content/posts/SASMO-Results-2026-When-How-to-Check.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/SASMO-Results-2026-When-How-to-Check",
      "sourcePath": "content/posts/SASMO-Results-2026-When-How-to-Check.mdx",
      "status": "published",
      "sourceSha256": "525ceb048f569aa4c0580c3c48ee6b05ba997b73be1a5627a5d6bb4b2a679578"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/SASMO-Results-2026-When-How-to-Check",
      "sourcePath": "content/translations/zh-Hans/SASMO-Results-2026-When-How-to-Check.mdx",
      "status": "draft",
      "sourceSha256": "525ceb048f569aa4c0580c3c48ee6b05ba997b73be1a5627a5d6bb4b2a679578"
    }
  ]
},
{
  "id": "article.singapore-mathematical-olympiad-smo",
  "englishSourcePath": "content/posts/Singapore-Mathematical-Olympiad-SMO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Mathematical-Olympiad-SMO",
      "sourcePath": "content/posts/Singapore-Mathematical-Olympiad-SMO.mdx",
      "status": "published",
      "sourceSha256": "0a5bc2c31f60261cb684ac34b985297bc0608e5b55dd4b2f6c8d89e9a2ac65ae"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Mathematical-Olympiad-SMO",
      "sourcePath": "content/translations/zh-Hans/Singapore-Mathematical-Olympiad-SMO.mdx",
      "status": "draft",
      "sourceSha256": "0a5bc2c31f60261cb684ac34b985297bc0608e5b55dd4b2f6c8d89e9a2ac65ae"
    }
  ]
},
{
  "id": "article.singapore-math-kangaroo-contest",
  "englishSourcePath": "content/posts/Singapore-Math-Kangaroo-Contest.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Math-Kangaroo-Contest",
      "sourcePath": "content/posts/Singapore-Math-Kangaroo-Contest.mdx",
      "status": "published",
      "sourceSha256": "47c1d51baf1847753bdbdbab2e4fdf19054687319af23ed9544bee0bf4decf70"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Math-Kangaroo-Contest",
      "sourcePath": "content/translations/zh-Hans/Singapore-Math-Kangaroo-Contest.mdx",
      "status": "draft",
      "sourceSha256": "47c1d51baf1847753bdbdbab2e4fdf19054687319af23ed9544bee0bf4decf70"
    }
  ]
},
{
  "id": "article.singapore-math-challenge",
  "englishSourcePath": "content/posts/Singapore-Math-Challenge.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Math-Challenge",
      "sourcePath": "content/posts/Singapore-Math-Challenge.mdx",
      "status": "published",
      "sourceSha256": "160c1746066e406d1e70aa7e4b97871a430167880b6ef3c7b5176351c41db817"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Math-Challenge",
      "sourcePath": "content/translations/zh-Hans/Singapore-Math-Challenge.mdx",
      "status": "draft",
      "sourceSha256": "160c1746066e406d1e70aa7e4b97871a430167880b6ef3c7b5176351c41db817"
    }
  ]
},
{
  "id": "article.singapore-junior-physics-olympiad",
  "englishSourcePath": "content/posts/Singapore-Junior-Physics-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Junior-Physics-Olympiad",
      "sourcePath": "content/posts/Singapore-Junior-Physics-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "83d422f3de1b638cff9c1404351447e17d658947230e38f22c0d9402303310ea"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Junior-Physics-Olympiad",
      "sourcePath": "content/translations/zh-Hans/Singapore-Junior-Physics-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "83d422f3de1b638cff9c1404351447e17d658947230e38f22c0d9402303310ea"
    }
  ]
},
{
  "id": "article.singapore-junior-chemistry-olympiad-sjcho",
  "englishSourcePath": "content/posts/Singapore-Junior-Chemistry-Olympiad-SJChO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Junior-Chemistry-Olympiad-SJChO",
      "sourcePath": "content/posts/Singapore-Junior-Chemistry-Olympiad-SJChO.mdx",
      "status": "published",
      "sourceSha256": "349ac007f44764a814302a4a6b527bf734a97e650f21b135df6ed2ecc29959bc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Junior-Chemistry-Olympiad-SJChO",
      "sourcePath": "content/translations/zh-Hans/Singapore-Junior-Chemistry-Olympiad-SJChO.mdx",
      "status": "draft",
      "sourceSha256": "349ac007f44764a814302a4a6b527bf734a97e650f21b135df6ed2ecc29959bc"
    }
  ]
},
{
  "id": "article.singapore-junior-biology-olympiad-sjbo",
  "englishSourcePath": "content/posts/Singapore-Junior-Biology-Olympiad-SJBO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Junior-Biology-Olympiad-SJBO",
      "sourcePath": "content/posts/Singapore-Junior-Biology-Olympiad-SJBO.mdx",
      "status": "published",
      "sourceSha256": "a807e566ae30b4e061d47bbc7e27a33c2c6666f6810b16cd4720f84d783db787"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Junior-Biology-Olympiad-SJBO",
      "sourcePath": "content/translations/zh-Hans/Singapore-Junior-Biology-Olympiad-SJBO.mdx",
      "status": "draft",
      "sourceSha256": "a807e566ae30b4e061d47bbc7e27a33c2c6666f6810b16cd4720f84d783db787"
    }
  ]
},
{
  "id": "article.singapore-biology-olympiad-sbo",
  "englishSourcePath": "content/posts/Singapore-Biology-Olympiad-SBO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Biology-Olympiad-SBO",
      "sourcePath": "content/posts/Singapore-Biology-Olympiad-SBO.mdx",
      "status": "published",
      "sourceSha256": "069f06b272a0f70adb483afe1b411d818d02b376404450e7f55e7c22f8d42ae9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Biology-Olympiad-SBO",
      "sourcePath": "content/translations/zh-Hans/Singapore-Biology-Olympiad-SBO.mdx",
      "status": "draft",
      "sourceSha256": "069f06b272a0f70adb483afe1b411d818d02b376404450e7f55e7c22f8d42ae9"
    }
  ]
},
{
  "id": "article.singapore-chemistry-olympiad-scho",
  "englishSourcePath": "content/posts/Singapore-Chemistry-Olympiad-SChO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Chemistry-Olympiad-SChO",
      "sourcePath": "content/posts/Singapore-Chemistry-Olympiad-SChO.mdx",
      "status": "published",
      "sourceSha256": "6d16040185382fed7dbd21f7b4a458354a8a8eade7ff7bd32c1a693d1cb7bc30"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Chemistry-Olympiad-SChO",
      "sourcePath": "content/translations/zh-Hans/Singapore-Chemistry-Olympiad-SChO.mdx",
      "status": "draft",
      "sourceSha256": "6d16040185382fed7dbd21f7b4a458354a8a8eade7ff7bd32c1a693d1cb7bc30"
    }
  ]
},
{
  "id": "article.singapore-physics-olympiad-spho",
  "englishSourcePath": "content/posts/Singapore-Physics-Olympiad-SPhO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Physics-Olympiad-SPhO",
      "sourcePath": "content/posts/Singapore-Physics-Olympiad-SPhO.mdx",
      "status": "published",
      "sourceSha256": "b2f7f1c8208dfa769dcdcc0312ac8a598e873ff3b6c9f5978738249183bd1ac7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Physics-Olympiad-SPhO",
      "sourcePath": "content/translations/zh-Hans/Singapore-Physics-Olympiad-SPhO.mdx",
      "status": "draft",
      "sourceSha256": "b2f7f1c8208dfa769dcdcc0312ac8a598e873ff3b6c9f5978738249183bd1ac7"
    }
  ]
},
{
  "id": "article.space-settlement-design-competition",
  "englishSourcePath": "content/posts/Space-Settlement-Design-Competition.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Space-Settlement-Design-Competition",
      "sourcePath": "content/posts/Space-Settlement-Design-Competition.mdx",
      "status": "published",
      "sourceSha256": "e8ee9b50648e4a53c06879999c496bc955eeeb2bf0cb760fbad42ce0f4ce041e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Space-Settlement-Design-Competition",
      "sourcePath": "content/translations/zh-Hans/Space-Settlement-Design-Competition.mdx",
      "status": "draft",
      "sourceSha256": "e8ee9b50648e4a53c06879999c496bc955eeeb2bf0cb760fbad42ce0f4ce041e"
    }
  ]
},
{
  "id": "article.international-linguistics-olympiad",
  "englishSourcePath": "content/posts/International-Linguistics-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Linguistics-Olympiad",
      "sourcePath": "content/posts/International-Linguistics-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "7446d3cf8874f60fdbb561ddb32772a8508fe80db99444c070594bf210091953"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Linguistics-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Linguistics-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "7446d3cf8874f60fdbb561ddb32772a8508fe80db99444c070594bf210091953"
    }
  ]
},
{
  "id": "article.international-research-olympiad",
  "englishSourcePath": "content/posts/International-Research-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Research-Olympiad",
      "sourcePath": "content/posts/International-Research-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "9b8a0ed3ac66be4004f4cc0b49a570ca40dbf61ccfa1372594f25eb4acf09b74"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Research-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Research-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "9b8a0ed3ac66be4004f4cc0b49a570ca40dbf61ccfa1372594f25eb4acf09b74"
    }
  ]
},
{
  "id": "article.stem-racing-the-revamped-f1-in-schools-challenge",
  "englishSourcePath": "content/posts/STEM-Racing-The-Revamped-F1-in-Schools-Challenge.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/STEM-Racing-The-Revamped-F1-in-Schools-Challenge",
      "sourcePath": "content/posts/STEM-Racing-The-Revamped-F1-in-Schools-Challenge.mdx",
      "status": "published",
      "sourceSha256": "be24c14e1b775d043a014b7db5bec9d40e92e85aae5656b95b67972d99645829"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/STEM-Racing-The-Revamped-F1-in-Schools-Challenge",
      "sourcePath": "content/translations/zh-Hans/STEM-Racing-The-Revamped-F1-in-Schools-Challenge.mdx",
      "status": "draft",
      "sourceSha256": "be24c14e1b775d043a014b7db5bec9d40e92e85aae5656b95b67972d99645829"
    }
  ]
},
{
  "id": "article.international-biology-olympiad",
  "englishSourcePath": "content/posts/International-Biology-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Biology-Olympiad",
      "sourcePath": "content/posts/International-Biology-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "70bba4f1f102559f1c813f495d07168831dba5d8f723eb2f91743cff7a0ea7ff"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Biology-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Biology-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "70bba4f1f102559f1c813f495d07168831dba5d8f723eb2f91743cff7a0ea7ff"
    }
  ]
},
{
  "id": "article.international-economics-olympiad",
  "englishSourcePath": "content/posts/International-Economics-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Economics-Olympiad",
      "sourcePath": "content/posts/International-Economics-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "7f24a48c4aed2bc43779810ac015aff6fb81df2c3c7a53437d4c235b5eba2d9e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Economics-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Economics-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "7f24a48c4aed2bc43779810ac015aff6fb81df2c3c7a53437d4c235b5eba2d9e"
    }
  ]
},
{
  "id": "article.international-earth-science-olympiad",
  "englishSourcePath": "content/posts/International-Earth-Science-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Earth-Science-Olympiad",
      "sourcePath": "content/posts/International-Earth-Science-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "f9989e73841fc9a6654c08696d2136aa4c8b829e7419c09579124345a04d9884"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Earth-Science-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Earth-Science-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "f9989e73841fc9a6654c08696d2136aa4c8b829e7419c09579124345a04d9884"
    }
  ]
},
{
  "id": "article.international-geography-olympiad",
  "englishSourcePath": "content/posts/International-Geography-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Geography-Olympiad",
      "sourcePath": "content/posts/International-Geography-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "1b6d8288d83de91035baf5c3b8022993c2f0f91feac392163b2446c156f4f0fb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Geography-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Geography-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "1b6d8288d83de91035baf5c3b8022993c2f0f91feac392163b2446c156f4f0fb"
    }
  ]
},
{
  "id": "article.international-olympiad-in-informatics",
  "englishSourcePath": "content/posts/International-Olympiad-in-Informatics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Olympiad-in-Informatics",
      "sourcePath": "content/posts/International-Olympiad-in-Informatics.mdx",
      "status": "published",
      "sourceSha256": "9a0bc74a11a14936b47e3470cef22083d429b60de223bde0258a5075c5d3aa10"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Olympiad-in-Informatics",
      "sourcePath": "content/translations/zh-Hans/International-Olympiad-in-Informatics.mdx",
      "status": "draft",
      "sourceSha256": "9a0bc74a11a14936b47e3470cef22083d429b60de223bde0258a5075c5d3aa10"
    }
  ]
},
{
  "id": "article.international-philosophy-olympiad",
  "englishSourcePath": "content/posts/International-Philosophy-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Philosophy-Olympiad",
      "sourcePath": "content/posts/International-Philosophy-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "bd3bc07688dc4eeaf05da3d3537c3b28310af5641e349915ffb154f2a2046aa5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Philosophy-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Philosophy-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "bd3bc07688dc4eeaf05da3d3537c3b28310af5641e349915ffb154f2a2046aa5"
    }
  ]
},
{
  "id": "article.international-medicine-and-disease-olympiad",
  "englishSourcePath": "content/posts/International-Medicine-and-Disease-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Medicine-and-Disease-Olympiad",
      "sourcePath": "content/posts/International-Medicine-and-Disease-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "6c3125e26b8ee06180d23f41aea5af7e93fed9ef420b77d30b974f87106ff2c3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Medicine-and-Disease-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Medicine-and-Disease-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "6c3125e26b8ee06180d23f41aea5af7e93fed9ef420b77d30b974f87106ff2c3"
    }
  ]
},
{
  "id": "article.hong-kong-international-science-olympiad",
  "englishSourcePath": "content/posts/Hong-Kong-International-Science-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Hong-Kong-International-Science-Olympiad",
      "sourcePath": "content/posts/Hong-Kong-International-Science-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "d3d9e72515d40d8b727ebf8ee51d8c15432b7bd82958958d70fbf50a94131379"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Hong-Kong-International-Science-Olympiad",
      "sourcePath": "content/translations/zh-Hans/Hong-Kong-International-Science-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "d3d9e72515d40d8b727ebf8ee51d8c15432b7bd82958958d70fbf50a94131379"
    }
  ]
},
{
  "id": "article.international-physics-olympiad",
  "englishSourcePath": "content/posts/International-Physics-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Physics-Olympiad",
      "sourcePath": "content/posts/International-Physics-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "25b683b69d9e1c4768b775030aaa2e5d47cc69e8f0edb1a031acc8f4aecb4e4c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Physics-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Physics-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "25b683b69d9e1c4768b775030aaa2e5d47cc69e8f0edb1a031acc8f4aecb4e4c"
    }
  ]
},
{
  "id": "article.asian-physics-olympiad",
  "englishSourcePath": "content/posts/Asian-Physics-Olympiad-Apho-What-IP-Parents-and-Students-Should-Know.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Asian-Physics-Olympiad-Apho-What-IP-Parents-and-Students-Should-Know",
      "sourcePath": "content/posts/Asian-Physics-Olympiad-Apho-What-IP-Parents-and-Students-Should-Know.mdx",
      "status": "published",
      "sourceSha256": "b542cad61e989ecbfeef5ea433163e1068240a1b6f30106af5440ff3a139a6e9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Asian-Physics-Olympiad-Apho-What-IP-Parents-and-Students-Should-Know",
      "sourcePath": "content/translations/zh-Hans/Asian-Physics-Olympiad-Apho-What-IP-Parents-and-Students-Should-Know.mdx",
      "status": "draft",
      "sourceSha256": "b542cad61e989ecbfeef5ea433163e1068240a1b6f30106af5440ff3a139a6e9"
    }
  ]
},
{
  "id": "article.ioaa-singapore-guide",
  "englishSourcePath": "content/posts/IOAA-Astronomy-Astrophysics-Olympiad-Singapore-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/IOAA-Astronomy-Astrophysics-Olympiad-Singapore-Guide",
      "sourcePath": "content/posts/IOAA-Astronomy-Astrophysics-Olympiad-Singapore-Guide.mdx",
      "status": "published",
      "sourceSha256": "63a4d1698f18d1ffd6a64592d0c8159e9234130b1f16753e2f299e73184d2496"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/IOAA-Astronomy-Astrophysics-Olympiad-Singapore-Guide",
      "sourcePath": "content/translations/zh-Hans/IOAA-Astronomy-Astrophysics-Olympiad-Singapore-Guide.mdx",
      "status": "draft",
      "sourceSha256": "63a4d1698f18d1ffd6a64592d0c8159e9234130b1f16753e2f299e73184d2496"
    }
  ]
},
{
  "id": "article.international-mathematical-olympiad",
  "englishSourcePath": "content/posts/International-Mathematical-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Mathematical-Olympiad",
      "sourcePath": "content/posts/International-Mathematical-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "46eb425f91d8050c0fb5b010e580f33404784f05c64d551aa939c503bd2c916f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Mathematical-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Mathematical-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "46eb425f91d8050c0fb5b010e580f33404784f05c64d551aa939c503bd2c916f"
    }
  ]
},
{
  "id": "article.ioai-singapore-2027",
  "englishSourcePath": "content/posts/International-Olympiad-in-Artificial-Intelligence-IOAI-Singapore-2027.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Olympiad-in-Artificial-Intelligence-IOAI-Singapore-2027",
      "sourcePath": "content/posts/International-Olympiad-in-Artificial-Intelligence-IOAI-Singapore-2027.mdx",
      "status": "published",
      "sourceSha256": "662811b70372118f123a1d55328a5ad15c57d0a560461c32744188ae6f2ccb4d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Olympiad-in-Artificial-Intelligence-IOAI-Singapore-2027",
      "sourcePath": "content/translations/zh-Hans/International-Olympiad-in-Artificial-Intelligence-IOAI-Singapore-2027.mdx",
      "status": "draft",
      "sourceSha256": "662811b70372118f123a1d55328a5ad15c57d0a560461c32744188ae6f2ccb4d"
    }
  ]
},
{
  "id": "article.international-junior-cybersecurity-olympiad",
  "englishSourcePath": "content/posts/International-Junior-Cybersecurity-Olympiad-IP-Friendly-Guide-for-Maths-and-Physics-Students.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Junior-Cybersecurity-Olympiad-IP-Friendly-Guide-for-Maths-and-Physics-Students",
      "sourcePath": "content/posts/International-Junior-Cybersecurity-Olympiad-IP-Friendly-Guide-for-Maths-and-Physics-Students.mdx",
      "status": "published",
      "sourceSha256": "a9a8a37223828eb3f840ada1d65e37038aff8a2e249f1ee4940ac0edd1706c47"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Junior-Cybersecurity-Olympiad-IP-Friendly-Guide-for-Maths-and-Physics-Students",
      "sourcePath": "content/translations/zh-Hans/International-Junior-Cybersecurity-Olympiad-IP-Friendly-Guide-for-Maths-and-Physics-Students.mdx",
      "status": "draft",
      "sourceSha256": "a9a8a37223828eb3f840ada1d65e37038aff8a2e249f1ee4940ac0edd1706c47"
    }
  ]
},
{
  "id": "article.singapore-physics-olympiad-pathway",
  "englishSourcePath": "content/posts/Singapore-Physics-Olympiad-Pathway-SJPO-SPhO-APhO-IPhO.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Physics-Olympiad-Pathway-SJPO-SPhO-APhO-IPhO",
      "sourcePath": "content/posts/Singapore-Physics-Olympiad-Pathway-SJPO-SPhO-APhO-IPhO.mdx",
      "status": "published",
      "sourceSha256": "94ad04f6c8e38641f0be4373ad194c3e2c855e26723da4fb7fe596ff0042368a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Physics-Olympiad-Pathway-SJPO-SPhO-APhO-IPhO",
      "sourcePath": "content/translations/zh-Hans/Singapore-Physics-Olympiad-Pathway-SJPO-SPhO-APhO-IPhO.mdx",
      "status": "draft",
      "sourceSha256": "94ad04f6c8e38641f0be4373ad194c3e2c855e26723da4fb7fe596ff0042368a"
    }
  ]
},
{
  "id": "article.physics-olympiad-practical-guide",
  "englishSourcePath": "content/posts/Physics-Olympiad-Practical-Round-Guide-SPhO-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Physics-Olympiad-Practical-Round-Guide-SPhO-Singapore",
      "sourcePath": "content/posts/Physics-Olympiad-Practical-Round-Guide-SPhO-Singapore.mdx",
      "status": "published",
      "sourceSha256": "626df6b177506069b42b55b07e91ba5b3eadd19390647ee1b5ef6e13bd2d41b7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Physics-Olympiad-Practical-Round-Guide-SPhO-Singapore",
      "sourcePath": "content/translations/zh-Hans/Physics-Olympiad-Practical-Round-Guide-SPhO-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "626df6b177506069b42b55b07e91ba5b3eadd19390647ee1b5ef6e13bd2d41b7"
    }
  ]
},
{
  "id": "article.singapore-primary-science-olympiad",
  "englishSourcePath": "content/posts/Singapore-Primary-Science-Olympiad-2025-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Primary-Science-Olympiad-2025-2026",
      "sourcePath": "content/posts/Singapore-Primary-Science-Olympiad-2025-2026.mdx",
      "status": "published",
      "sourceSha256": "5b887c90feb774b4b83b69a422ab358b4b989abd66f820e616b724bb6f123ce5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Primary-Science-Olympiad-2025-2026",
      "sourcePath": "content/translations/zh-Hans/Singapore-Primary-Science-Olympiad-2025-2026.mdx",
      "status": "draft",
      "sourceSha256": "5b887c90feb774b4b83b69a422ab358b4b989abd66f820e616b724bb6f123ce5"
    }
  ]
},
{
  "id": "article.spho-results-2026",
  "englishSourcePath": "content/posts/SPhO-Results-2026-When-How-to-Check.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/SPhO-Results-2026-When-How-to-Check",
      "sourcePath": "content/posts/SPhO-Results-2026-When-How-to-Check.mdx",
      "status": "published",
      "sourceSha256": "84f2602a8e2f76c0259e407b6d6ee997f239d3549bf7d714e80c673501e04af2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/SPhO-Results-2026-When-How-to-Check",
      "sourcePath": "content/translations/zh-Hans/SPhO-Results-2026-When-How-to-Check.mdx",
      "status": "draft",
      "sourceSha256": "84f2602a8e2f76c0259e407b6d6ee997f239d3549bf7d714e80c673501e04af2"
    }
  ]
},
{
  "id": "article.international-chemistry-olympiad",
  "englishSourcePath": "content/posts/International-Chemistry-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Chemistry-Olympiad",
      "sourcePath": "content/posts/International-Chemistry-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "c035d89c66fbcc513a3a2531f37d0e1f05e6ef3305ab113976fe41920a05a5f2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Chemistry-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Chemistry-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "c035d89c66fbcc513a3a2531f37d0e1f05e6ef3305ab113976fe41920a05a5f2"
    }
  ]
},
{
  "id": "article.math-olympiad-worth-it",
  "englishSourcePath": "content/posts/Is-Math-Olympiad-Worth-It-Singapore-Parent-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Is-Math-Olympiad-Worth-It-Singapore-Parent-Guide",
      "sourcePath": "content/posts/Is-Math-Olympiad-Worth-It-Singapore-Parent-Guide.mdx",
      "status": "published",
      "sourceSha256": "d2d991fef57dff355aab2bb380c77c8ef83b5af9ceb6d3243b8df635505c94b9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Is-Math-Olympiad-Worth-It-Singapore-Parent-Guide",
      "sourcePath": "content/translations/zh-Hans/Is-Math-Olympiad-Worth-It-Singapore-Parent-Guide.mdx",
      "status": "draft",
      "sourceSha256": "d2d991fef57dff355aab2bb380c77c8ef83b5af9ceb6d3243b8df635505c94b9"
    }
  ]
},
{
  "id": "article.spso-practical-guide",
  "englishSourcePath": "content/posts/SPSO-Practical-Round-Preparation-Guide-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/SPSO-Practical-Round-Preparation-Guide-Singapore",
      "sourcePath": "content/posts/SPSO-Practical-Round-Preparation-Guide-Singapore.mdx",
      "status": "published",
      "sourceSha256": "feaa35f972c13c832d3302470f80849ff29d40198f2e2fa814f3bc3552d48ea0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/SPSO-Practical-Round-Preparation-Guide-Singapore",
      "sourcePath": "content/translations/zh-Hans/SPSO-Practical-Round-Preparation-Guide-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "feaa35f972c13c832d3302470f80849ff29d40198f2e2fa814f3bc3552d48ea0"
    }
  ]
},
{
  "id": "article.physics-olympiad-resources",
  "englishSourcePath": "content/posts/Best-Physics-Olympiad-Books-Resources-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Best-Physics-Olympiad-Books-Resources-Singapore",
      "sourcePath": "content/posts/Best-Physics-Olympiad-Books-Resources-Singapore.mdx",
      "status": "published",
      "sourceSha256": "e8690f5eb376ce454772d7c600d47a81d6d9266c81b05dc363556c44b2387113"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Best-Physics-Olympiad-Books-Resources-Singapore",
      "sourcePath": "content/translations/zh-Hans/Best-Physics-Olympiad-Books-Resources-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "e8690f5eb376ce454772d7c600d47a81d6d9266c81b05dc363556c44b2387113"
    }
  ]
},
{
  "id": "article.math-olympiad-dsa-evidence",
  "englishSourcePath": "content/posts/How-Math-Olympiad-Awards-Boost-DSA-Applications-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/How-Math-Olympiad-Awards-Boost-DSA-Applications-Singapore",
      "sourcePath": "content/posts/How-Math-Olympiad-Awards-Boost-DSA-Applications-Singapore.mdx",
      "status": "published",
      "sourceSha256": "5d1b892a9414ab8caaae7325aa74233f009fe6c94d7e44218e6d8ee55b05460a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/How-Math-Olympiad-Awards-Boost-DSA-Applications-Singapore",
      "sourcePath": "content/translations/zh-Hans/How-Math-Olympiad-Awards-Boost-DSA-Applications-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "5d1b892a9414ab8caaae7325aa74233f009fe6c94d7e44218e6d8ee55b05460a"
    }
  ]
},
{
  "id": "article.math-olympiad-starting-guide",
  "englishSourcePath": "content/posts/When-to-Start-Math-Olympiad-Training-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/When-to-Start-Math-Olympiad-Training-Singapore",
      "sourcePath": "content/posts/When-to-Start-Math-Olympiad-Training-Singapore.mdx",
      "status": "published",
      "sourceSha256": "317d27c67f2787f877b20d6aa67b9ad3aff2b4bd7ac2d8a7b4fa23ed26188b55"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/When-to-Start-Math-Olympiad-Training-Singapore",
      "sourcePath": "content/translations/zh-Hans/When-to-Start-Math-Olympiad-Training-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "317d27c67f2787f877b20d6aa67b9ad3aff2b4bd7ac2d8a7b4fa23ed26188b55"
    }
  ]
},
{
  "id": "article.math-olympiad-tuition-guide",
  "englishSourcePath": "content/posts/Do-You-Need-Tuition-for-Math-Olympiad-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Do-You-Need-Tuition-for-Math-Olympiad-Singapore",
      "sourcePath": "content/posts/Do-You-Need-Tuition-for-Math-Olympiad-Singapore.mdx",
      "status": "published",
      "sourceSha256": "d36c1c7821c2e72601e21874990d14d40f8dd8e1eae4ab7e9e5aa31a5e42ce57"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Do-You-Need-Tuition-for-Math-Olympiad-Singapore",
      "sourcePath": "content/translations/zh-Hans/Do-You-Need-Tuition-for-Math-Olympiad-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "d36c1c7821c2e72601e21874990d14d40f8dd8e1eae4ab7e9e5aa31a5e42ce57"
    }
  ]
},
{
  "id": "article.math-competition-six-way-comparison",
  "englishSourcePath": "content/posts/Which-Math-Olympiad-Singapore-NMOS-RMO-SASMO-Compared.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Which-Math-Olympiad-Singapore-NMOS-RMO-SASMO-Compared",
      "sourcePath": "content/posts/Which-Math-Olympiad-Singapore-NMOS-RMO-SASMO-Compared.mdx",
      "status": "published",
      "sourceSha256": "dcca430bfdf07cd565ea0a3d2d9ace8e60f647be36dd7deee43b031a83886ac8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Which-Math-Olympiad-Singapore-NMOS-RMO-SASMO-Compared",
      "sourcePath": "content/translations/zh-Hans/Which-Math-Olympiad-Singapore-NMOS-RMO-SASMO-Compared.mdx",
      "status": "draft",
      "sourceSha256": "dcca430bfdf07cd565ea0a3d2d9ace8e60f647be36dd7deee43b031a83886ac8"
    }
  ]
},
{
  "id": "article.math-competition-choice-guide",
  "englishSourcePath": "content/posts/Which-Math-Olympiad-Should-Your-Child-Join-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Which-Math-Olympiad-Should-Your-Child-Join-Singapore",
      "sourcePath": "content/posts/Which-Math-Olympiad-Should-Your-Child-Join-Singapore.mdx",
      "status": "published",
      "sourceSha256": "e49b90c12a8a81312d379cec562867bc755e0030babb729feb0529a9d159e548"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Which-Math-Olympiad-Should-Your-Child-Join-Singapore",
      "sourcePath": "content/translations/zh-Hans/Which-Math-Olympiad-Should-Your-Child-Join-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "e49b90c12a8a81312d379cec562867bc755e0030babb729feb0529a9d159e548"
    }
  ]
},
{
  "id": "article.international-astronomy-astrophysics-olympiad",
  "englishSourcePath": "content/posts/International-Astronomy-and-Astrophysics-Olympiad.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Astronomy-and-Astrophysics-Olympiad",
      "sourcePath": "content/posts/International-Astronomy-and-Astrophysics-Olympiad.mdx",
      "status": "published",
      "sourceSha256": "9691bdaaef6f5e40bc9ccdd049d9a05bb02a7628ebbfe557142ac26c5c6346d2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Astronomy-and-Astrophysics-Olympiad",
      "sourcePath": "content/translations/zh-Hans/International-Astronomy-and-Astrophysics-Olympiad.mdx",
      "status": "draft",
      "sourceSha256": "9691bdaaef6f5e40bc9ccdd049d9a05bb02a7628ebbfe557142ac26c5c6346d2"
    }
  ]
},
{
  "id": "article.competition-break-guide",
  "englishSourcePath": "content/posts/Signs-Your-Child-Should-Take-a-Break-from-Competitions-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Signs-Your-Child-Should-Take-a-Break-from-Competitions-Singapore",
      "sourcePath": "content/posts/Signs-Your-Child-Should-Take-a-Break-from-Competitions-Singapore.mdx",
      "status": "published",
      "sourceSha256": "7bf45ef4ced2b04c2de0400bd1b7b3b69e17c5bd071ced100cbbfa4a2a3f78f0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Signs-Your-Child-Should-Take-a-Break-from-Competitions-Singapore",
      "sourcePath": "content/translations/zh-Hans/Signs-Your-Child-Should-Take-a-Break-from-Competitions-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "7bf45ef4ced2b04c2de0400bd1b7b3b69e17c5bd071ced100cbbfa4a2a3f78f0"
    }
  ]
},
{
  "id": "article.ismc-guide",
  "englishSourcePath": "content/posts/International-Singapore-Mathematics-Competition.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/International-Singapore-Mathematics-Competition",
      "sourcePath": "content/posts/International-Singapore-Mathematics-Competition.mdx",
      "status": "published",
      "sourceSha256": "b9dfb894555cadce0de8c53828ce4f02ed595ba3adfa45bd77da0c1d09edea19"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/International-Singapore-Mathematics-Competition",
      "sourcePath": "content/translations/zh-Hans/International-Singapore-Mathematics-Competition.mdx",
      "status": "draft",
      "sourceSha256": "b9dfb894555cadce0de8c53828ce4f02ed595ba3adfa45bd77da0c1d09edea19"
    }
  ]
},
{
  "id": "article.vanda-science-guide",
  "englishSourcePath": "content/posts/Vanda-Science-International-Competition.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Vanda-Science-International-Competition",
      "sourcePath": "content/posts/Vanda-Science-International-Competition.mdx",
      "status": "published",
      "sourceSha256": "2d671ba54005b8f87e2b036c792a97668029dc847a1a4afff9ac2e9879b41600"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Vanda-Science-International-Competition",
      "sourcePath": "content/translations/zh-Hans/Vanda-Science-International-Competition.mdx",
      "status": "draft",
      "sourceSha256": "2d671ba54005b8f87e2b036c792a97668029dc847a1a4afff9ac2e9879b41600"
    }
  ]
},
{
  "id": "article.free-competition-resources",
  "englishSourcePath": "content/posts/Free-Low-Cost-Math-Science-Competition-Prep-Resources-Singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Free-Low-Cost-Math-Science-Competition-Prep-Resources-Singapore",
      "sourcePath": "content/posts/Free-Low-Cost-Math-Science-Competition-Prep-Resources-Singapore.mdx",
      "status": "published",
      "sourceSha256": "f377e52fd839fbe3f7426c18a2c25855491d94f9044d589eef11c09b0a5c76f3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Free-Low-Cost-Math-Science-Competition-Prep-Resources-Singapore",
      "sourcePath": "content/translations/zh-Hans/Free-Low-Cost-Math-Science-Competition-Prep-Resources-Singapore.mdx",
      "status": "draft",
      "sourceSha256": "f377e52fd839fbe3f7426c18a2c25855491d94f9044d589eef11c09b0a5c76f3"
    }
  ]
},
{
  "id": "article.nrc-guide",
  "englishSourcePath": "content/posts/National-Robotics-Competition.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/National-Robotics-Competition",
      "sourcePath": "content/posts/National-Robotics-Competition.mdx",
      "status": "published",
      "sourceSha256": "759b8c60ca6340a5020b5ccf210dddc38776fd7db63923401381fa986c5dcf15"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/National-Robotics-Competition",
      "sourcePath": "content/translations/zh-Hans/National-Robotics-Competition.mdx",
      "status": "draft",
      "sourceSha256": "759b8c60ca6340a5020b5ccf210dddc38776fd7db63923401381fa986c5dcf15"
    }
  ]
},
{
  "id": "article.vex-robotics-guide",
  "englishSourcePath": "content/posts/Vex-Robotics-Competitions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Vex-Robotics-Competitions",
      "sourcePath": "content/posts/Vex-Robotics-Competitions.mdx",
      "status": "published",
      "sourceSha256": "cf93955f2ce6efbfaad05f6e039349c5cebc53b37a798bb9b048a3e9fc75b9a1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Vex-Robotics-Competitions",
      "sourcePath": "content/translations/zh-Hans/Vex-Robotics-Competitions.mdx",
      "status": "draft",
      "sourceSha256": "cf93955f2ce6efbfaad05f6e039349c5cebc53b37a798bb9b048a3e9fc75b9a1"
    }
  ]
},
{
  "id": "article.igem-high-school-guide",
  "englishSourcePath": "content/posts/iGEM-High-School-Competition.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/iGEM-High-School-Competition",
      "sourcePath": "content/posts/iGEM-High-School-Competition.mdx",
      "status": "published",
      "sourceSha256": "0f116a83e20417615baeb4bd42aeef377afdf74707d0e74533fff020d73f1bad"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/iGEM-High-School-Competition",
      "sourcePath": "content/translations/zh-Hans/iGEM-High-School-Competition.mdx",
      "status": "draft",
      "sourceSha256": "0f116a83e20417615baeb4bd42aeef377afdf74707d0e74533fff020d73f1bad"
    }
  ]
},
{
  "id": "article.competition-calendar-2026",
  "englishSourcePath": "content/posts/Singapore-Maths-Science-Competition-Calendar-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Maths-Science-Competition-Calendar-2026",
      "sourcePath": "content/posts/Singapore-Maths-Science-Competition-Calendar-2026.mdx",
      "status": "published",
      "sourceSha256": "9fe03ddbf877f307ed9b95318d2c1c3e5ddad95a797c103da3ef5873597d05a2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Maths-Science-Competition-Calendar-2026",
      "sourcePath": "content/translations/zh-Hans/Singapore-Maths-Science-Competition-Calendar-2026.mdx",
      "status": "draft",
      "sourceSha256": "9fe03ddbf877f307ed9b95318d2c1c3e5ddad95a797c103da3ef5873597d05a2"
    }
  ]
},
{
  "id": "article.h2-biology-budget-guide",
  "englishSourcePath": "content/posts/H2-Biology-Tuition-Fees-Planning-Guide-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-biology-tuition/H2-Biology-Tuition-Fees-Planning-Guide-Singapore-2026",
      "sourcePath": "content/posts/H2-Biology-Tuition-Fees-Planning-Guide-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "fcef29f0bf38751c83396c6fe1e702555c7c94abad1174a24aa16bd7ffff8137"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-biology-tuition/H2-Biology-Tuition-Fees-Planning-Guide-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Tuition-Fees-Planning-Guide-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "fcef29f0bf38751c83396c6fe1e702555c7c94abad1174a24aa16bd7ffff8137"
    }
  ]
},
{
  "id": "article.h2-biology-fee-formats-guide",
  "englishSourcePath": "content/posts/H2-Biology-Tuition-Fees-and-Class-Formats-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-biology-tuition/H2-Biology-Tuition-Fees-and-Class-Formats-Singapore-2026",
      "sourcePath": "content/posts/H2-Biology-Tuition-Fees-and-Class-Formats-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "5636afe6dce020b4217046ef79b56d7f9e6724bd80fd4ea6ea2da82bc88c0457"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-biology-tuition/H2-Biology-Tuition-Fees-and-Class-Formats-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Tuition-Fees-and-Class-Formats-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "5636afe6dce020b4217046ef79b56d7f9e6724bd80fd4ea6ea2da82bc88c0457"
    }
  ]
},
{
  "id": "article.h2-biology-selection-checklist",
  "englishSourcePath": "content/posts/How-to-Choose-H2-Biology-Tuition-Singapore-2026-Checklist.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-biology-tuition/How-to-Choose-H2-Biology-Tuition-Singapore-2026-Checklist",
      "sourcePath": "content/posts/How-to-Choose-H2-Biology-Tuition-Singapore-2026-Checklist.mdx",
      "status": "published",
      "sourceSha256": "72e69cd86a77ecb9bb836f4ed49513f1fff7b58c2fe620bb84cbd4330ca3bcf3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-biology-tuition/How-to-Choose-H2-Biology-Tuition-Singapore-2026-Checklist",
      "sourcePath": "content/translations/zh-Hans/How-to-Choose-H2-Biology-Tuition-Singapore-2026-Checklist.mdx",
      "status": "draft",
      "sourceSha256": "72e69cd86a77ecb9bb836f4ed49513f1fff7b58c2fe620bb84cbd4330ca3bcf3"
    }
  ]
},
{
  "id": "article.h2-biology-comparison-guide",
  "englishSourcePath": "content/posts/Best-H2-Biology-Tuition-Singapore-Comparison-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-biology-tuition/Best-H2-Biology-Tuition-Singapore-Comparison-Guide-2026",
      "sourcePath": "content/posts/Best-H2-Biology-Tuition-Singapore-Comparison-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "fb85228040da5598b1549535a4a9d07308b1992b385a0f3338a0bbcfaf8edfa4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-biology-tuition/Best-H2-Biology-Tuition-Singapore-Comparison-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Best-H2-Biology-Tuition-Singapore-Comparison-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "fb85228040da5598b1549535a4a9d07308b1992b385a0f3338a0bbcfaf8edfa4"
    }
  ]
},
{
  "id": "article.h2-biology-class-formats-guide",
  "englishSourcePath": "content/posts/H2-Biology-Tuition-Class-Formats-Small-Group-vs-Intensive-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-biology-tuition/H2-Biology-Tuition-Class-Formats-Small-Group-vs-Intensive-2026",
      "sourcePath": "content/posts/H2-Biology-Tuition-Class-Formats-Small-Group-vs-Intensive-2026.mdx",
      "status": "published",
      "sourceSha256": "546ec2cea406acd2361d8d3df8b8681e57d1c260335a07a2bd5af5cff10c9483"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-biology-tuition/H2-Biology-Tuition-Class-Formats-Small-Group-vs-Intensive-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Tuition-Class-Formats-Small-Group-vs-Intensive-2026.mdx",
      "status": "draft",
      "sourceSha256": "546ec2cea406acd2361d8d3df8b8681e57d1c260335a07a2bd5af5cff10c9483"
    }
  ]
},
{
  "id": "article.h2-biology-study-plan",
  "englishSourcePath": "content/posts/JC1-JC2-H2-Biology-Tuition-Study-Plan-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-biology-tuition/JC1-JC2-H2-Biology-Tuition-Study-Plan-2026",
      "sourcePath": "content/posts/JC1-JC2-H2-Biology-Tuition-Study-Plan-2026.mdx",
      "status": "published",
      "sourceSha256": "f5b88eabaa0465fab631855c74aed787c44bbc595f1891b52676eb4bec5ec61d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-biology-tuition/JC1-JC2-H2-Biology-Tuition-Study-Plan-2026",
      "sourcePath": "content/translations/zh-Hans/JC1-JC2-H2-Biology-Tuition-Study-Plan-2026.mdx",
      "status": "draft",
      "sourceSha256": "f5b88eabaa0465fab631855c74aed787c44bbc595f1891b52676eb4bec5ec61d"
    }
  ]
},
{
  "id": "article.h2-biology-paper4-prep-plan",
  "englishSourcePath": "content/posts/H2-Biology-Paper-4-Practical-Prep-Plan-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-biology-tuition/H2-Biology-Paper-4-Practical-Prep-Plan-2026",
      "sourcePath": "content/posts/H2-Biology-Paper-4-Practical-Prep-Plan-2026.mdx",
      "status": "published",
      "sourceSha256": "783eaa2b572acdca6d5383e39c557c71de0fe3c5f41fadce29eb95d12a9723e8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-biology-tuition/H2-Biology-Paper-4-Practical-Prep-Plan-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Paper-4-Practical-Prep-Plan-2026.mdx",
      "status": "draft",
      "sourceSha256": "783eaa2b572acdca6d5383e39c557c71de0fe3c5f41fadce29eb95d12a9723e8"
    }
  ]
},
{
  "id": "article.h2-biology-lab-mastery-guide",
  "englishSourcePath": "content/posts/H2-Biology-Practical-2026-Lab-Mastery-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Practical-2026-Lab-Mastery-Guide",
      "sourcePath": "content/posts/H2-Biology-Practical-2026-Lab-Mastery-Guide.mdx",
      "status": "published",
      "sourceSha256": "e08e2c39633e117e5dd9a72e43b044e7162d43c32c9ec6494ac652e3411e1c59"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Practical-2026-Lab-Mastery-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Practical-2026-Lab-Mastery-Guide.mdx",
      "status": "draft",
      "sourceSha256": "e08e2c39633e117e5dd9a72e43b044e7162d43c32c9ec6494ac652e3411e1c59"
    }
  ]
},
{
  "id": "article.h2-biology-private-candidate-practical-guide",
  "englishSourcePath": "content/posts/H2-Biology-Practical-Private-Candidate-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Practical-Private-Candidate-Guide-2026",
      "sourcePath": "content/posts/H2-Biology-Practical-Private-Candidate-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "c9648076df6a80de8cb6ab8f52f8dd0ca0156b0e3c91072ea971acdf0b39810b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Practical-Private-Candidate-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Practical-Private-Candidate-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "c9648076df6a80de8cb6ab8f52f8dd0ca0156b0e3c91072ea971acdf0b39810b"
    }
  ]
},
{
  "id": "article.h2-biology-jc-roadmap",
  "englishSourcePath": "content/posts/JC1-to-JC2-H2-Biology-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-biology-tuition/JC1-to-JC2-H2-Biology-Roadmap-for-Consistent-A-Level-Results-2026",
      "sourcePath": "content/posts/JC1-to-JC2-H2-Biology-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
      "status": "published",
      "sourceSha256": "6bad4b7a3b9abf7880bc7bfe7b79aecda498f679b62fab1a9798f60322f4959a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-biology-tuition/JC1-to-JC2-H2-Biology-Roadmap-for-Consistent-A-Level-Results-2026",
      "sourcePath": "content/translations/zh-Hans/JC1-to-JC2-H2-Biology-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
      "status": "draft",
      "sourceSha256": "6bad4b7a3b9abf7880bc7bfe7b79aecda498f679b62fab1a9798f60322f4959a"
    }
  ]
},
{
  "id": "article.h2-biology-essay-mark-guide",
  "englishSourcePath": "content/posts/H2-Biology-Essay-Writing-Guide-6-8-12-Mark-Questions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Essay-Writing-Guide-6-8-12-Mark-Questions",
      "sourcePath": "content/posts/H2-Biology-Essay-Writing-Guide-6-8-12-Mark-Questions.mdx",
      "status": "published",
      "sourceSha256": "7d9a41201ee7f505065c2a1704f7a63b95020e0675582d5ede9a7bf31da50edc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Essay-Writing-Guide-6-8-12-Mark-Questions",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Essay-Writing-Guide-6-8-12-Mark-Questions.mdx",
      "status": "draft",
      "sourceSha256": "7d9a41201ee7f505065c2a1704f7a63b95020e0675582d5ede9a7bf31da50edc"
    }
  ]
},
{
  "id": "article.h2-biology-paper1-mcq-guide",
  "englishSourcePath": "content/posts/H2-Biology-Exam-Paper-1-MCQ-Playbook.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Exam-Paper-1-MCQ-Playbook",
      "sourcePath": "content/posts/H2-Biology-Exam-Paper-1-MCQ-Playbook.mdx",
      "status": "published",
      "sourceSha256": "d16b22a5fad6d977542259182eb709dd01b5c31cf1d4f787d4e9e547c4e670d7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Exam-Paper-1-MCQ-Playbook",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Exam-Paper-1-MCQ-Playbook.mdx",
      "status": "draft",
      "sourceSha256": "d16b22a5fad6d977542259182eb709dd01b5c31cf1d4f787d4e9e547c4e670d7"
    }
  ]
},
{
  "id": "article.h2-biology-paper2-structured-guide",
  "englishSourcePath": "content/posts/H2-Biology-Exam-Paper-2-Structured-Strategy.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Exam-Paper-2-Structured-Strategy",
      "sourcePath": "content/posts/H2-Biology-Exam-Paper-2-Structured-Strategy.mdx",
      "status": "published",
      "sourceSha256": "a0568152b81db76ec8507b532a72ac89d231aeb0ff77c09932ed35f6ef15c151"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Exam-Paper-2-Structured-Strategy",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Exam-Paper-2-Structured-Strategy.mdx",
      "status": "draft",
      "sourceSha256": "a0568152b81db76ec8507b532a72ac89d231aeb0ff77c09932ed35f6ef15c151"
    }
  ]
},
{
  "id": "article.h2-biology-paper3-free-response-guide",
  "englishSourcePath": "content/posts/H2-Biology-Exam-Paper-3-Free-Response-Mastery.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Exam-Paper-3-Free-Response-Mastery",
      "sourcePath": "content/posts/H2-Biology-Exam-Paper-3-Free-Response-Mastery.mdx",
      "status": "published",
      "sourceSha256": "4683bca4e9cd552073820aa93821987da6ecbc1178890703631547d79ec7b809"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Exam-Paper-3-Free-Response-Mastery",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Exam-Paper-3-Free-Response-Mastery.mdx",
      "status": "draft",
      "sourceSha256": "4683bca4e9cd552073820aa93821987da6ecbc1178890703631547d79ec7b809"
    }
  ]
},
{
  "id": "article.h2-biology-paper4-performance-guide",
  "englishSourcePath": "content/posts/H2-Biology-Exam-Paper-4-Practical-Performance.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Exam-Paper-4-Practical-Performance",
      "sourcePath": "content/posts/H2-Biology-Exam-Paper-4-Practical-Performance.mdx",
      "status": "published",
      "sourceSha256": "2abb5a13adf4e0c7581c8bf82868a46d0ae3b71709cb7b77fc7dfe802a851317"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Exam-Paper-4-Practical-Performance",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Exam-Paper-4-Practical-Performance.mdx",
      "status": "draft",
      "sourceSha256": "2abb5a13adf4e0c7581c8bf82868a46d0ae3b71709cb7b77fc7dfe802a851317"
    }
  ]
},
{
  "id": "article.h2-science-subject-choice-guide",
  "englishSourcePath": "content/posts/H2-Chemistry-vs-H2-Biology-JC-Subject-Choice.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/H2-Chemistry-vs-H2-Biology-JC-Subject-Choice",
      "sourcePath": "content/posts/H2-Chemistry-vs-H2-Biology-JC-Subject-Choice.mdx",
      "status": "published",
      "sourceSha256": "36671890bf59812a1b7b40454a0209affc04b65dc7a7defd82b480e06c03a343"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/H2-Chemistry-vs-H2-Biology-JC-Subject-Choice",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-vs-H2-Biology-JC-Subject-Choice.mdx",
      "status": "draft",
      "sourceSha256": "36671890bf59812a1b7b40454a0209affc04b65dc7a7defd82b480e06c03a343"
    }
  ]
},
{
  "id": "article.h2-biology-specimen-prep-guide",
  "englishSourcePath": "content/posts/H2-Biology-Specimen-Paper-Exam-Prep-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Specimen-Paper-Exam-Prep-Guide",
      "sourcePath": "content/posts/H2-Biology-Specimen-Paper-Exam-Prep-Guide.mdx",
      "status": "published",
      "sourceSha256": "0c381485ab2e87f3548a8c13a9e4da4b1b36f599999e0ced85d9d2339d205827"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Specimen-Paper-Exam-Prep-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Specimen-Paper-Exam-Prep-Guide.mdx",
      "status": "draft",
      "sourceSha256": "0c381485ab2e87f3548a8c13a9e4da4b1b36f599999e0ced85d9d2339d205827"
    }
  ]
},
{
  "id": "article.h2-biology-ace-evaluation-guide",
  "englishSourcePath": "content/posts/H2-Biology-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-ACE-Qualitative-to-Quantitative-Paper-4",
      "sourcePath": "content/posts/H2-Biology-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "902be4086c5d11a4707fc38898e3da05d483ea953917dab07767bbcd34c5cb99"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-ACE-Qualitative-to-Quantitative-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "902be4086c5d11a4707fc38898e3da05d483ea953917dab07767bbcd34c5cb99"
    }
  ]
},
{
  "id": "article.h2-biology-syllabus-overview",
  "englishSourcePath": "content/posts/H2-Biology-Syllabus-2026-27.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Syllabus-2026-27",
      "sourcePath": "content/posts/H2-Biology-Syllabus-2026-27.mdx",
      "status": "published",
      "sourceSha256": "32847b7530a1e5c64f713ff871d7afd55b017dcae09adbf2d482c9bd19c57993"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Syllabus-2026-27",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Syllabus-2026-27.mdx",
      "status": "draft",
      "sourceSha256": "32847b7530a1e5c64f713ff871d7afd55b017dcae09adbf2d482c9bd19c57993"
    }
  ]
},
{
  "id": "article.h2-biology-paper3-essay-writing-guide",
  "englishSourcePath": "content/posts/H2-Biology-Paper-3-Essay-Writing-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Paper-3-Essay-Writing-Guide-2026",
      "sourcePath": "content/posts/H2-Biology-Paper-3-Essay-Writing-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "e8ada0a6f8c7777f042042c9743df48f6fbef8a76de0d8cbfb701a99b7bec4a5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Paper-3-Essay-Writing-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Paper-3-Essay-Writing-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "e8ada0a6f8c7777f042042c9743df48f6fbef8a76de0d8cbfb701a99b7bec4a5"
    }
  ]
},
{
  "id": "article.h2-biology-microscope-guide",
  "englishSourcePath": "content/posts/H2-Biology-Optical-Microscope-Mastery-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Optical-Microscope-Mastery-Guide",
      "sourcePath": "content/posts/H2-Biology-Optical-Microscope-Mastery-Guide.mdx",
      "status": "published",
      "sourceSha256": "0cb161e2e579ea6308401bf373adeb7eab8b293544681e63edea8c46b3001f71"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Optical-Microscope-Mastery-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Optical-Microscope-Mastery-Guide.mdx",
      "status": "draft",
      "sourceSha256": "0cb161e2e579ea6308401bf373adeb7eab8b293544681e63edea8c46b3001f71"
    }
  ]
},
{
  "id": "article.h2-biology-core1-cell-biomolecules",
  "englishSourcePath": "content/posts/H2-Biology-Core-1-Cell-and-Biomolecules.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Core-1-Cell-and-Biomolecules",
      "sourcePath": "content/posts/H2-Biology-Core-1-Cell-and-Biomolecules.mdx",
      "status": "published",
      "sourceSha256": "0cc36d3e949e727a216aa9ad2d9555975c0242f1c34b6a562be04a89d896763a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Core-1-Cell-and-Biomolecules",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Core-1-Cell-and-Biomolecules.mdx",
      "status": "draft",
      "sourceSha256": "0cc36d3e949e727a216aa9ad2d9555975c0242f1c34b6a562be04a89d896763a"
    }
  ]
},
{
  "id": "article.h2-biology-core2-genetics-inheritance",
  "englishSourcePath": "content/posts/H2-Biology-Core-2-Genetics-and-Inheritance.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Core-2-Genetics-and-Inheritance",
      "sourcePath": "content/posts/H2-Biology-Core-2-Genetics-and-Inheritance.mdx",
      "status": "published",
      "sourceSha256": "47884ea989def0a772f57097edcef36c349f00f95600aaa2cf6a1d0e912b121f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Core-2-Genetics-and-Inheritance",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Core-2-Genetics-and-Inheritance.mdx",
      "status": "draft",
      "sourceSha256": "47884ea989def0a772f57097edcef36c349f00f95600aaa2cf6a1d0e912b121f"
    }
  ]
},
{
  "id": "article.h2-biology-core3-energy-equilibrium",
  "englishSourcePath": "content/posts/H2-Biology-Core-3-Energy-and-Equilibrium.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Core-3-Energy-and-Equilibrium",
      "sourcePath": "content/posts/H2-Biology-Core-3-Energy-and-Equilibrium.mdx",
      "status": "published",
      "sourceSha256": "6e6f134b5c984e198bffc002cba9e596ed21033ecc3517176ce09a903e62b5bd"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Core-3-Energy-and-Equilibrium",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Core-3-Energy-and-Equilibrium.mdx",
      "status": "draft",
      "sourceSha256": "6e6f134b5c984e198bffc002cba9e596ed21033ecc3517176ce09a903e62b5bd"
    }
  ]
},
{
  "id": "article.h2-biology-core4-biological-evolution",
  "englishSourcePath": "content/posts/H2-Biology-Core-4-Biological-Evolution.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Core-4-Biological-Evolution",
      "sourcePath": "content/posts/H2-Biology-Core-4-Biological-Evolution.mdx",
      "status": "published",
      "sourceSha256": "1eb343480cc848358c0737a544695a06ce1238711bc46e7b353ccbedb1175d4d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Core-4-Biological-Evolution",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Core-4-Biological-Evolution.mdx",
      "status": "draft",
      "sourceSha256": "1eb343480cc848358c0737a544695a06ce1238711bc46e7b353ccbedb1175d4d"
    }
  ]
},
{
  "id": "article.h2-biology-extension-a-infectious-diseases",
  "englishSourcePath": "content/posts/H2-Biology-Extension-A-Infectious-Diseases.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Extension-A-Infectious-Diseases",
      "sourcePath": "content/posts/H2-Biology-Extension-A-Infectious-Diseases.mdx",
      "status": "published",
      "sourceSha256": "a61c7e0633c86d6363ec9c964e698b170ae3afb2545b53ef3e228d581114f104"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Extension-A-Infectious-Diseases",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Extension-A-Infectious-Diseases.mdx",
      "status": "draft",
      "sourceSha256": "a61c7e0633c86d6363ec9c964e698b170ae3afb2545b53ef3e228d581114f104"
    }
  ]
},
{
  "id": "article.h2-biology-extension-b-climate-change",
  "englishSourcePath": "content/posts/H2-Biology-Extension-B-Impact-of-Climate-Change-on-Animals-and-Plants.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Extension-B-Impact-of-Climate-Change-on-Animals-and-Plants",
      "sourcePath": "content/posts/H2-Biology-Extension-B-Impact-of-Climate-Change-on-Animals-and-Plants.mdx",
      "status": "published",
      "sourceSha256": "e3232e48ff52361dc56717baab95346310ce0af668bacfa11713222fbb47409a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Extension-B-Impact-of-Climate-Change-on-Animals-and-Plants",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Extension-B-Impact-of-Climate-Change-on-Animals-and-Plants.mdx",
      "status": "draft",
      "sourceSha256": "e3232e48ff52361dc56717baab95346310ce0af668bacfa11713222fbb47409a"
    }
  ]
},
{
    id: "article.h2-biology-enzyme-kinetics",
    englishSourcePath:
      "content/posts/H2-Biology-Enzyme-Kinetics-Regulation-Inhibition-Notes-2026.mdx",
    versions: [
      {
        locale: "en",
        publicPath:
          "/blog/h2-biology-notes/H2-Biology-Enzyme-Kinetics-Regulation-Inhibition-Notes-2026",
        sourcePath:
          "content/posts/H2-Biology-Enzyme-Kinetics-Regulation-Inhibition-Notes-2026.mdx",
        status: "published",
        sourceSha256:
          "1279a90a03bb78efe38e3f25234ce2bd2baedf2aa9f14d41a062120a2c12d8ec",
      },
      {
        locale: "zh-Hans",
        publicPath:
          "/zh/blog/h2-biology-notes/H2-Biology-Enzyme-Kinetics-Regulation-Inhibition-Notes-2026",
        sourcePath:
          "content/translations/zh-Hans/H2-Biology-Enzyme-Kinetics-Regulation-Inhibition-Notes-2026.mdx",
        status: "draft",
        sourceSha256:
          "1279a90a03bb78efe38e3f25234ce2bd2baedf2aa9f14d41a062120a2c12d8ec",
      },
    ],
  },
{
  "id": "article.h2-biology-aerobic-respiration",
  "englishSourcePath": "content/posts/H2-Biology-Aerobic-Respiration-Glycolysis-Krebs-Cycle-Notes-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Aerobic-Respiration-Glycolysis-Krebs-Cycle-Notes-2026",
      "sourcePath": "content/posts/H2-Biology-Aerobic-Respiration-Glycolysis-Krebs-Cycle-Notes-2026.mdx",
      "status": "published",
      "sourceSha256": "4df877c8b4f94f40c37dc4e777bfbca8427f0503b84cd81be01d1cc4a5ae06be"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Aerobic-Respiration-Glycolysis-Krebs-Cycle-Notes-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Aerobic-Respiration-Glycolysis-Krebs-Cycle-Notes-2026.mdx",
      "status": "draft",
      "sourceSha256": "4df877c8b4f94f40c37dc4e777bfbca8427f0503b84cd81be01d1cc4a5ae06be"
    }
  ]
},
{
    id: "article.h2-biology-antibiotics-resistance",
    englishSourcePath:
      "content/posts/H2-Biology-Antibiotics-Resistance-Mechanisms-Notes-2026.mdx",
    versions: [
      {
        locale: "en",
        publicPath:
          "/blog/h2-biology-notes/H2-Biology-Antibiotics-Resistance-Mechanisms-Notes-2026",
        sourcePath:
          "content/posts/H2-Biology-Antibiotics-Resistance-Mechanisms-Notes-2026.mdx",
        status: "published",
        sourceSha256:
          "6d74f6564a0802b8d872ac5c53655b077f1ef3f65c5aec640e503af0ebef3dd1",
      },
      {
        locale: "zh-Hans",
        publicPath:
          "/zh/blog/h2-biology-notes/H2-Biology-Antibiotics-Resistance-Mechanisms-Notes-2026",
        sourcePath:
          "content/translations/zh-Hans/H2-Biology-Antibiotics-Resistance-Mechanisms-Notes-2026.mdx",
        status: "draft",
        sourceSha256:
          "6d74f6564a0802b8d872ac5c53655b077f1ef3f65c5aec640e503af0ebef3dd1",
      },
    ],
  },
{
  "id": "article.h2-biology-dcpip",
  "englishSourcePath": "content/posts/DCPIP-Indicator-Assay-H2-Biology-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/DCPIP-Indicator-Assay-H2-Biology-Practical",
      "sourcePath": "content/posts/DCPIP-Indicator-Assay-H2-Biology-Practical.mdx",
      "status": "published",
      "sourceSha256": "3bbd0e6939d38b836a179f331b8728805895ecb96871fc04745ee3fae08dbe5a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/DCPIP-Indicator-Assay-H2-Biology-Practical",
      "sourcePath": "content/translations/zh-Hans/DCPIP-Indicator-Assay-H2-Biology-Practical.mdx",
      "status": "draft",
      "sourceSha256": "3bbd0e6939d38b836a179f331b8728805895ecb96871fc04745ee3fae08dbe5a"
    }
  ]
},
{
  "id": "article.h2-biology-aseptic-technique",
  "englishSourcePath": "content/posts/H2-Biology-Aseptic-Technique-Microbial-Culture-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Aseptic-Technique-Microbial-Culture-Practical",
      "sourcePath": "content/posts/H2-Biology-Aseptic-Technique-Microbial-Culture-Practical.mdx",
      "status": "published",
      "sourceSha256": "59a169882d005e80111248b76eda3179ee6f668f60006ab00ad67bfad9e8f25d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Aseptic-Technique-Microbial-Culture-Practical",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Aseptic-Technique-Microbial-Culture-Practical.mdx",
      "status": "draft",
      "sourceSha256": "59a169882d005e80111248b76eda3179ee6f668f60006ab00ad67bfad9e8f25d"
    }
  ]
},
{
  "id": "article.h2-biology-biuret-ninhydrin",
  "englishSourcePath": "content/posts/H2-Biology-Biuret-Ninhydrin-Protein-Tests.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Biuret-Ninhydrin-Protein-Tests",
      "sourcePath": "content/posts/H2-Biology-Biuret-Ninhydrin-Protein-Tests.mdx",
      "status": "published",
      "sourceSha256": "e48871075682b602493b1d8dccac1e288a6be36a87654e7cd0e265fcf3c0c3e9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Biuret-Ninhydrin-Protein-Tests",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Biuret-Ninhydrin-Protein-Tests.mdx",
      "status": "draft",
      "sourceSha256": "e48871075682b602493b1d8dccac1e288a6be36a87654e7cd0e265fcf3c0c3e9"
    }
  ]
},
{
  "id": "article.h2-biology-cell-division",
  "englishSourcePath": "content/posts/H2-Biology-Cell-Division-Mitosis-Meiosis-Notes-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Cell-Division-Mitosis-Meiosis-Notes-2026",
      "sourcePath": "content/posts/H2-Biology-Cell-Division-Mitosis-Meiosis-Notes-2026.mdx",
      "status": "published",
      "sourceSha256": "f210d3ae0707700ee12b7d73cab322f7a5017ecd47fea2b8914488e7c1da3b05"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Cell-Division-Mitosis-Meiosis-Notes-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Cell-Division-Mitosis-Meiosis-Notes-2026.mdx",
      "status": "draft",
      "sourceSha256": "f210d3ae0707700ee12b7d73cab322f7a5017ecd47fea2b8914488e7c1da3b05"
    }
  ]
},
{
  "id": "article.h2-biology-dna-gene-expression",
  "englishSourcePath": "content/posts/H2-Biology-DNA-Replication-Transcription-Translation-Notes-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-DNA-Replication-Transcription-Translation-Notes-2026",
      "sourcePath": "content/posts/H2-Biology-DNA-Replication-Transcription-Translation-Notes-2026.mdx",
      "status": "published",
      "sourceSha256": "cf0771095dcd91600de0ccddfce5275583c967427ba3f5ac72e7cf4f10d07db5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-DNA-Replication-Transcription-Translation-Notes-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-DNA-Replication-Transcription-Translation-Notes-2026.mdx",
      "status": "draft",
      "sourceSha256": "cf0771095dcd91600de0ccddfce5275583c967427ba3f5ac72e7cf4f10d07db5"
    }
  ]
},
{
  "id": "article.h2-biology-ecology-conservation",
  "englishSourcePath": "content/posts/H2-Biology-Ecology-Conservation-Notes-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Ecology-Conservation-Notes-2026",
      "sourcePath": "content/posts/H2-Biology-Ecology-Conservation-Notes-2026.mdx",
      "status": "published",
      "sourceSha256": "bd04fad057162eb0c5346bdafa526b35a8c251c1d32e9d53ee2dcf93b694c9c1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Ecology-Conservation-Notes-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Ecology-Conservation-Notes-2026.mdx",
      "status": "draft",
      "sourceSha256": "bd04fad057162eb0c5346bdafa526b35a8c251c1d32e9d53ee2dcf93b694c9c1"
    }
  ]
},
{
  "id": "article.h2-biology-ecology-fieldwork",
  "englishSourcePath": "content/posts/H2-Biology-Ecology-Fieldwork-Practical-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Ecology-Fieldwork-Practical-Guide",
      "sourcePath": "content/posts/H2-Biology-Ecology-Fieldwork-Practical-Guide.mdx",
      "status": "published",
      "sourceSha256": "3e2fec4fc69f69e91cf1d267507afbd03d0185a177f03dd6ad68991bf89fdd65"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Ecology-Fieldwork-Practical-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Ecology-Fieldwork-Practical-Guide.mdx",
      "status": "draft",
      "sourceSha256": "3e2fec4fc69f69e91cf1d267507afbd03d0185a177f03dd6ad68991bf89fdd65"
    }
  ]
},
{
  "id": "article.h2-biology-catalase-kinetics",
  "englishSourcePath": "content/posts/H2-Biology-Enzyme-Kinetics-Catalase-Practical-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Enzyme-Kinetics-Catalase-Practical-Guide",
      "sourcePath": "content/posts/H2-Biology-Enzyme-Kinetics-Catalase-Practical-Guide.mdx",
      "status": "published",
      "sourceSha256": "996fb1fdebb6eb61c502f83a7b254895c6a55c9012b31286566ef2ee8f12bd5d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Enzyme-Kinetics-Catalase-Practical-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Enzyme-Kinetics-Catalase-Practical-Guide.mdx",
      "status": "draft",
      "sourceSha256": "996fb1fdebb6eb61c502f83a7b254895c6a55c9012b31286566ef2ee8f12bd5d"
    }
  ]
},
{
  "id": "article.h2-biology-gel-electrophoresis",
  "englishSourcePath": "content/posts/H2-Biology-Gel-Electrophoresis-Micropipetting-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Gel-Electrophoresis-Micropipetting-Practical",
      "sourcePath": "content/posts/H2-Biology-Gel-Electrophoresis-Micropipetting-Practical.mdx",
      "status": "published",
      "sourceSha256": "78a983b7d3b1b8a345afdaa5660851278fb8ff4352d48f50f62433e30b7dc903"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Gel-Electrophoresis-Micropipetting-Practical",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Gel-Electrophoresis-Micropipetting-Practical.mdx",
      "status": "draft",
      "sourceSha256": "78a983b7d3b1b8a345afdaa5660851278fb8ff4352d48f50f62433e30b7dc903"
    }
  ]
},
{
  "id": "article.h2-biology-genetic-disease",
  "englishSourcePath": "content/posts/H2-Biology-Genetic-Basis-of-Disease-Notes-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Genetic-Basis-of-Disease-Notes-2026",
      "sourcePath": "content/posts/H2-Biology-Genetic-Basis-of-Disease-Notes-2026.mdx",
      "status": "published",
      "sourceSha256": "34a44b628fd070311fc4db74d012094ed5f319c12af584cec75da566bc4806a4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Genetic-Basis-of-Disease-Notes-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Genetic-Basis-of-Disease-Notes-2026.mdx",
      "status": "draft",
      "sourceSha256": "34a44b628fd070311fc4db74d012094ed5f319c12af584cec75da566bc4806a4"
    }
  ]
},
{
  "id": "article.h2-biology-hydrogencarbonate",
  "englishSourcePath": "content/posts/H2-Biology-Hydrogencarbonate-Indicator-Photosynthesis-Respiration-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Hydrogencarbonate-Indicator-Photosynthesis-Respiration-Practical",
      "sourcePath": "content/posts/H2-Biology-Hydrogencarbonate-Indicator-Photosynthesis-Respiration-Practical.mdx",
      "status": "published",
      "sourceSha256": "7c6d63f18c79a764501e20c84025b5a3d566c53da5c5d17c9a7757beb1e04870"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Hydrogencarbonate-Indicator-Photosynthesis-Respiration-Practical",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Hydrogencarbonate-Indicator-Photosynthesis-Respiration-Practical.mdx",
      "status": "draft",
      "sourceSha256": "7c6d63f18c79a764501e20c84025b5a3d566c53da5c5d17c9a7757beb1e04870"
    }
  ]
},
{
  "id": "article.h2-biology-stomatal-density",
  "englishSourcePath": "content/posts/H2-Biology-Stomatal-Density-Leaf-Peel-Graticule-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Stomatal-Density-Leaf-Peel-Graticule-Practical",
      "sourcePath": "content/posts/H2-Biology-Stomatal-Density-Leaf-Peel-Graticule-Practical.mdx",
      "status": "published",
      "sourceSha256": "139b7fca072c69643b7a271fce8f74e4b4f75a1caf53e841c2483ccdc2dc15ee"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Stomatal-Density-Leaf-Peel-Graticule-Practical",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Stomatal-Density-Leaf-Peel-Graticule-Practical.mdx",
      "status": "draft",
      "sourceSha256": "139b7fca072c69643b7a271fce8f74e4b4f75a1caf53e841c2483ccdc2dc15ee"
    }
  ]
},
{
  "id": "article.h2-biology-visking-tubing",
  "englishSourcePath": "content/posts/H2-Biology-Visking-Tubing-Dialysis-Membrane-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Visking-Tubing-Dialysis-Membrane-Practical",
      "sourcePath": "content/posts/H2-Biology-Visking-Tubing-Dialysis-Membrane-Practical.mdx",
      "status": "published",
      "sourceSha256": "aba550000e4b103f4fdcfa4c0a722a30685d9762e3be720c3cb3720e93bef3db"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Visking-Tubing-Dialysis-Membrane-Practical",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Visking-Tubing-Dialysis-Membrane-Practical.mdx",
      "status": "draft",
      "sourceSha256": "aba550000e4b103f4fdcfa4c0a722a30685d9762e3be720c3cb3720e93bef3db"
    }
  ]
},
{
  "id": "article.h2-biology-osmosis-diffusion",
  "englishSourcePath": "content/posts/H2-Biology-Osmosis-and-Diffusion-Practicals-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Osmosis-and-Diffusion-Practicals-Guide",
      "sourcePath": "content/posts/H2-Biology-Osmosis-and-Diffusion-Practicals-Guide.mdx",
      "status": "published",
      "sourceSha256": "be0050c4cb2833fed3494aa18770f20a87b198bace1cb4f8d8e518efa20d648b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Osmosis-and-Diffusion-Practicals-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Osmosis-and-Diffusion-Practicals-Guide.mdx",
      "status": "draft",
      "sourceSha256": "be0050c4cb2833fed3494aa18770f20a87b198bace1cb4f8d8e518efa20d648b"
    }
  ]
},
{
  "id": "article.h2-biology-photosynthesis-respiration-rate",
  "englishSourcePath": "content/posts/H2-Biology-Photosynthesis-and-Respiration-Rate-Practical-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Photosynthesis-and-Respiration-Rate-Practical-Guide",
      "sourcePath": "content/posts/H2-Biology-Photosynthesis-and-Respiration-Rate-Practical-Guide.mdx",
      "status": "published",
      "sourceSha256": "0c62cf7d10fac40f2dbd7611f1ca4e716741fd55f72f8778f57de6f1e38af076"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Photosynthesis-and-Respiration-Rate-Practical-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Photosynthesis-and-Respiration-Rate-Practical-Guide.mdx",
      "status": "draft",
      "sourceSha256": "0c62cf7d10fac40f2dbd7611f1ca4e716741fd55f72f8778f57de6f1e38af076"
    }
  ]
},
{
  "id": "article.h2-biology-planning-evaluation",
  "englishSourcePath": "content/posts/H2-Biology-Planning-Evaluation-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-experiments/H2-Biology-Planning-Evaluation-Paper-4",
      "sourcePath": "content/posts/H2-Biology-Planning-Evaluation-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "0791d951147819519e4b0b03789254a7577ae40e489383610bad77cd319ae97a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-experiments/H2-Biology-Planning-Evaluation-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Planning-Evaluation-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "0791d951147819519e4b0b03789254a7577ae40e489383610bad77cd319ae97a"
    }
  ]
},
{
  "id": "article.h2-biology-immunology",
  "englishSourcePath": "content/posts/H2-Biology-Immunology-Notes.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Immunology-Notes",
      "sourcePath": "content/posts/H2-Biology-Immunology-Notes.mdx",
      "status": "published",
      "sourceSha256": "e937da811c25dbf45887062a12636d990503c2900c654c3d96c31730ab411cb5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Immunology-Notes",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Immunology-Notes.mdx",
      "status": "draft",
      "sourceSha256": "e937da811c25dbf45887062a12636d990503c2900c654c3d96c31730ab411cb5"
    }
  ]
},
{
  "id": "article.h2-biology-photosynthesis",
  "englishSourcePath": "content/posts/H2-Biology-Photosynthesis-Light-Reactions-Calvin-Cycle-Notes-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-biology-notes/H2-Biology-Photosynthesis-Light-Reactions-Calvin-Cycle-Notes-2026",
      "sourcePath": "content/posts/H2-Biology-Photosynthesis-Light-Reactions-Calvin-Cycle-Notes-2026.mdx",
      "status": "published",
      "sourceSha256": "6d3d654f411af163e22e7aeddfb3f7a7ddbdf3817a62af8a5a9d377b5181f7d2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-biology-notes/H2-Biology-Photosynthesis-Light-Reactions-Calvin-Cycle-Notes-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Biology-Photosynthesis-Light-Reactions-Calvin-Cycle-Notes-2026.mdx",
      "status": "draft",
      "sourceSha256": "6d3d654f411af163e22e7aeddfb3f7a7ddbdf3817a62af8a5a9d377b5181f7d2"
    }
  ]
},
{
  "id": "article.h2-chemistry-back-titration",
  "englishSourcePath": "content/posts/H2-Chemistry-Back-Titration-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Back-Titration-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-Back-Titration-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "da16820b5fcefe6def448538ab8f0018319d01623b6585a354cd005521e4b497"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Back-Titration-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Back-Titration-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "da16820b5fcefe6def448538ab8f0018319d01623b6585a354cd005521e4b497"
    }
  ]
},
{
  "id": "article.h2-chemistry-standard-solution",
  "englishSourcePath": "content/posts/H2-Chemistry-Standard-Solution-Preparation-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Standard-Solution-Preparation-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-Standard-Solution-Preparation-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "78b8da08efdae3855731562a9f962475fddd8f6ea743a4a329bbf976a3a95fb5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Standard-Solution-Preparation-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Standard-Solution-Preparation-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "78b8da08efdae3855731562a9f962475fddd8f6ea743a4a329bbf976a3a95fb5"
    }
  ]
},
{
  "id": "article.h2-chemistry-gas-volume",
  "englishSourcePath": "content/posts/H2-Chemistry-Gas-Volume-Stoichiometry-Investigations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Gas-Volume-Stoichiometry-Investigations",
      "sourcePath": "content/posts/H2-Chemistry-Gas-Volume-Stoichiometry-Investigations.mdx",
      "status": "published",
      "sourceSha256": "436707fac2824f57a10ae6e4943857698c322a055cb482602e3a27062bed20ac"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Gas-Volume-Stoichiometry-Investigations",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Gas-Volume-Stoichiometry-Investigations.mdx",
      "status": "draft",
      "sourceSha256": "436707fac2824f57a10ae6e4943857698c322a055cb482602e3a27062bed20ac"
    }
  ]
},
{
  "id": "article.h2-chemistry-gas-collection",
  "englishSourcePath": "content/posts/H2-Chemistry-Gas-Collection-Planning-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Gas-Collection-Planning-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-Gas-Collection-Planning-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "09009f6db1c2c1fe20c372c85b49a4813156b3a56a97f4dedc73dba277586df0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Gas-Collection-Planning-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Gas-Collection-Planning-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "09009f6db1c2c1fe20c372c85b49a4813156b3a56a97f4dedc73dba277586df0"
    }
  ]
},
{
  "id": "article.h2-chemistry-iodine-titration",
  "englishSourcePath": "content/posts/H2-Chemistry-Iodometric-Iodimetric-Titration-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Iodometric-Iodimetric-Titration-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-Iodometric-Iodimetric-Titration-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "2385225b4cc6aabcb807cb8136767ecd3ee06d03c46208fbfa5aa9443f281db9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Iodometric-Iodimetric-Titration-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Iodometric-Iodimetric-Titration-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "2385225b4cc6aabcb807cb8136767ecd3ee06d03c46208fbfa5aa9443f281db9"
    }
  ]
},
{
  "id": "article.h2-chemistry-gravimetry",
  "englishSourcePath": "content/posts/H2-Chemistry-Gravimetric-Analysis-Volatilisation-Constant-Mass-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Gravimetric-Analysis-Volatilisation-Constant-Mass-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-Gravimetric-Analysis-Volatilisation-Constant-Mass-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "7f9245016be43fdd4007ccee3798e1883e9539d16a82fe03e75414062d856890"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Gravimetric-Analysis-Volatilisation-Constant-Mass-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Gravimetric-Analysis-Volatilisation-Constant-Mass-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "7f9245016be43fdd4007ccee3798e1883e9539d16a82fe03e75414062d856890"
    }
  ]
},
{
  "id": "article.h2-chemistry-thermometric-titration",
  "englishSourcePath": "content/posts/H2-Chemistry-Thermometric-Titration-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Thermometric-Titration-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-Thermometric-Titration-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "d98c6afd545e996ffd2b910ae49fc7fad531a5efe158d8a1bdf128596e1036ac"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Thermometric-Titration-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Thermometric-Titration-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "d98c6afd545e996ffd2b910ae49fc7fad531a5efe158d8a1bdf128596e1036ac"
    }
  ]
},
{
  "id": "article.h2-chemistry-calorimetry",
  "englishSourcePath": "content/posts/H2-Chemistry-Calorimetry-Practical-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Calorimetry-Practical-Guide",
      "sourcePath": "content/posts/H2-Chemistry-Calorimetry-Practical-Guide.mdx",
      "status": "published",
      "sourceSha256": "f1d6273aacbf184be442a4239896a71f49ad55ac19d55e161b02a7a162753bf1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Calorimetry-Practical-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Calorimetry-Practical-Guide.mdx",
      "status": "draft",
      "sourceSha256": "f1d6273aacbf184be442a4239896a71f49ad55ac19d55e161b02a7a162753bf1"
    }
  ]
},
{
  "id": "article.h2-chemistry-pdo-uncertainty",
  "englishSourcePath": "content/posts/H2-Chemistry-PDO-and-Uncertainty-Masterclass.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-PDO-and-Uncertainty-Masterclass",
      "sourcePath": "content/posts/H2-Chemistry-PDO-and-Uncertainty-Masterclass.mdx",
      "status": "published",
      "sourceSha256": "08a8e61728dcbb2937ea12dff1ccba46193b4838fdc1d1e6227203bedb023e08"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-PDO-and-Uncertainty-Masterclass",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-PDO-and-Uncertainty-Masterclass.mdx",
      "status": "draft",
      "sourceSha256": "08a8e61728dcbb2937ea12dff1ccba46193b4838fdc1d1e6227203bedb023e08"
    }
  ]
},
{
  "id": "article.h2-chemistry-planning-risk",
  "englishSourcePath": "content/posts/H2-Chemistry-Planning-and-Risk-Playbook.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Planning-and-Risk-Playbook",
      "sourcePath": "content/posts/H2-Chemistry-Planning-and-Risk-Playbook.mdx",
      "status": "published",
      "sourceSha256": "95391345f855829b984c03262874d4e80ac33080510795bfd3646fa82298194e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Planning-and-Risk-Playbook",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Planning-and-Risk-Playbook.mdx",
      "status": "draft",
      "sourceSha256": "95391345f855829b984c03262874d4e80ac33080510795bfd3646fa82298194e"
    }
  ]
},
{
  "id": "article.h2-chemistry-ace",
  "englishSourcePath": "content/posts/H2-Chemistry-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-ACE-Qualitative-to-Quantitative-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "6af736827ac086c1b948aee056ccf66b3eead0aa26c01020c7c1623fdfebe1b9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-ACE-Qualitative-to-Quantitative-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "6af736827ac086c1b948aee056ccf66b3eead0aa26c01020c7c1623fdfebe1b9"
    }
  ]
},
{
  "id": "article.h2-chemistry-electrochemistry-instrument",
  "englishSourcePath": "content/posts/H2-Chemistry-Electrochemistry-Instrumental-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Electrochemistry-Instrumental-Guide",
      "sourcePath": "content/posts/H2-Chemistry-Electrochemistry-Instrumental-Guide.mdx",
      "status": "published",
      "sourceSha256": "15b0753370d921a97a0f1d621236e1448e562a0c0b6700fa3f0fb62e8956cb14"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Electrochemistry-Instrumental-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Electrochemistry-Instrumental-Guide.mdx",
      "status": "draft",
      "sourceSha256": "15b0753370d921a97a0f1d621236e1448e562a0c0b6700fa3f0fb62e8956cb14"
    }
  ]
},
{
  "id": "article.h2-chemistry-kinetics-practical",
  "englishSourcePath": "content/posts/H2-Chemistry-Kinetics-Practical-Framework.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Kinetics-Practical-Framework",
      "sourcePath": "content/posts/H2-Chemistry-Kinetics-Practical-Framework.mdx",
      "status": "published",
      "sourceSha256": "8a909b5ca39ce0317f89cf13f29d4ec7f2b5b6609b01eb1d8d992cd60bb77ce4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Kinetics-Practical-Framework",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Kinetics-Practical-Framework.mdx",
      "status": "draft",
      "sourceSha256": "8a909b5ca39ce0317f89cf13f29d4ec7f2b5b6609b01eb1d8d992cd60bb77ce4"
    }
  ]
},
{
  "id": "article.h2-chemistry-organic-functional-tests",
  "englishSourcePath": "content/posts/H2-Chemistry-Organic-Functional-Group-Tests-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Organic-Functional-Group-Tests-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-Organic-Functional-Group-Tests-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "bfc311028b97f0ac3e42fddb146c450a64e3722f821e8e96c4a2de833afc1368"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Organic-Functional-Group-Tests-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Organic-Functional-Group-Tests-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "bfc311028b97f0ac3e42fddb146c450a64e3722f821e8e96c4a2de833afc1368"
    }
  ]
},
{
  "id": "article.h2-chemistry-organic-synthesis",
  "englishSourcePath": "content/posts/H2-Chemistry-Organic-Synthesis-Purification-Labs.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Organic-Synthesis-Purification-Labs",
      "sourcePath": "content/posts/H2-Chemistry-Organic-Synthesis-Purification-Labs.mdx",
      "status": "published",
      "sourceSha256": "e421f2da2c189a562ea2b8d55fae74164d67bcd153004538c8b4897de04bd089"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Organic-Synthesis-Purification-Labs",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Organic-Synthesis-Purification-Labs.mdx",
      "status": "draft",
      "sourceSha256": "e421f2da2c189a562ea2b8d55fae74164d67bcd153004538c8b4897de04bd089"
    }
  ]
},
{
  "id": "article.h2-chemistry-qualitative-analysis",
  "englishSourcePath": "content/posts/H2-Chemistry-Qualitative-Analysis-Workflow.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Qualitative-Analysis-Workflow",
      "sourcePath": "content/posts/H2-Chemistry-Qualitative-Analysis-Workflow.mdx",
      "status": "published",
      "sourceSha256": "fb27523e937b27b12eed79a6a6b4824bce8966fbd70960a0a5bd731c81b89604"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Qualitative-Analysis-Workflow",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Qualitative-Analysis-Workflow.mdx",
      "status": "draft",
      "sourceSha256": "fb27523e937b27b12eed79a6a6b4824bce8966fbd70960a0a5bd731c81b89604"
    }
  ]
},
{
  "id": "article.h2-chemistry-multi-ion-qa",
  "englishSourcePath": "content/posts/H2-Chemistry-QA-Two-Cation-Two-Anion-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-QA-Two-Cation-Two-Anion-Paper-4",
      "sourcePath": "content/posts/H2-Chemistry-QA-Two-Cation-Two-Anion-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "daf80740734fcc18ae074027594341584b373e84d91174f0b7ee9d0d6022eecf"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-QA-Two-Cation-Two-Anion-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-QA-Two-Cation-Two-Anion-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "daf80740734fcc18ae074027594341584b373e84d91174f0b7ee9d0d6022eecf"
    }
  ]
},
{
  "id": "article.h2-chemistry-lab-revision",
  "englishSourcePath": "content/posts/H2-Chemistry-Paper-4-Lab-Revision-Checklist.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Paper-4-Lab-Revision-Checklist",
      "sourcePath": "content/posts/H2-Chemistry-Paper-4-Lab-Revision-Checklist.mdx",
      "status": "published",
      "sourceSha256": "2092a153c75f6ff62e015852cec1641ace1f43afe4342bd356568c2dd1b492b2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Paper-4-Lab-Revision-Checklist",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Paper-4-Lab-Revision-Checklist.mdx",
      "status": "draft",
      "sourceSha256": "2092a153c75f6ff62e015852cec1641ace1f43afe4342bd356568c2dd1b492b2"
    }
  ]
},
{
  "id": "article.h2-chemistry-volumetric",
  "englishSourcePath": "content/posts/H2-Chemistry-Volumetric-Practical-Deep-Dive.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Volumetric-Practical-Deep-Dive",
      "sourcePath": "content/posts/H2-Chemistry-Volumetric-Practical-Deep-Dive.mdx",
      "status": "published",
      "sourceSha256": "a73bb2e9ff2c3c23f4a2250a28961c68b7d89328bbb474831b6accbe4e6c4877"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Volumetric-Practical-Deep-Dive",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Volumetric-Practical-Deep-Dive.mdx",
      "status": "draft",
      "sourceSha256": "a73bb2e9ff2c3c23f4a2250a28961c68b7d89328bbb474831b6accbe4e6c4877"
    }
  ]
},
{
  "id": "article.h2-chemistry-paper1",
  "englishSourcePath": "content/posts/H2-Chemistry-Paper-1-Format.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Paper-1-Format",
      "sourcePath": "content/posts/H2-Chemistry-Paper-1-Format.mdx",
      "status": "published",
      "sourceSha256": "d7bd4943f140204e302671c81014925aec6d924b1a6e8aa0d964138233fc0d8f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Paper-1-Format",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Paper-1-Format.mdx",
      "status": "draft",
      "sourceSha256": "d7bd4943f140204e302671c81014925aec6d924b1a6e8aa0d964138233fc0d8f"
    }
  ]
},
{
  "id": "article.h2-chemistry-paper2",
  "englishSourcePath": "content/posts/H2-Chemistry-Paper-2-Format.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Paper-2-Format",
      "sourcePath": "content/posts/H2-Chemistry-Paper-2-Format.mdx",
      "status": "published",
      "sourceSha256": "f48ec4aca77b68155d7eeed7218f8e37bc6c646e0c73c1fad88d55d3efd98b78"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Paper-2-Format",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Paper-2-Format.mdx",
      "status": "draft",
      "sourceSha256": "f48ec4aca77b68155d7eeed7218f8e37bc6c646e0c73c1fad88d55d3efd98b78"
    }
  ]
},
{
  "id": "article.h2-chemistry-paper3",
  "englishSourcePath": "content/posts/H2-Chemistry-Paper-3-Format.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Paper-3-Format",
      "sourcePath": "content/posts/H2-Chemistry-Paper-3-Format.mdx",
      "status": "published",
      "sourceSha256": "cc1445cc642a486b3f7779e15467d17a13ade76164d2db1a2f19ea029e3b2115"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Paper-3-Format",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Paper-3-Format.mdx",
      "status": "draft",
      "sourceSha256": "cc1445cc642a486b3f7779e15467d17a13ade76164d2db1a2f19ea029e3b2115"
    }
  ]
},
{
  "id": "article.h2-chemistry-paper4",
  "englishSourcePath": "content/posts/H2-Chemistry-Paper-4-Format.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Paper-4-Format",
      "sourcePath": "content/posts/H2-Chemistry-Paper-4-Format.mdx",
      "status": "published",
      "sourceSha256": "70421ad958f3b1f6a608c6ef4b78ebe498a9325de90e809f67f5d3e4591b1ba7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Paper-4-Format",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Paper-4-Format.mdx",
      "status": "draft",
      "sourceSha256": "70421ad958f3b1f6a608c6ef4b78ebe498a9325de90e809f67f5d3e4591b1ba7"
    }
  ]
},
{
  "id": "article.h2-chemistry-paper2-strategy",
  "englishSourcePath": "content/posts/H2-Chemistry-Paper-2-Structured-Question-Strategy.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Paper-2-Structured-Question-Strategy",
      "sourcePath": "content/posts/H2-Chemistry-Paper-2-Structured-Question-Strategy.mdx",
      "status": "published",
      "sourceSha256": "149f63fbc18e5cfd89a24c3ccfe088f3d9182943fc4c737691190b99c3f269a1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Paper-2-Structured-Question-Strategy",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Paper-2-Structured-Question-Strategy.mdx",
      "status": "draft",
      "sourceSha256": "149f63fbc18e5cfd89a24c3ccfe088f3d9182943fc4c737691190b99c3f269a1"
    }
  ]
},
{
  "id": "article.h2-chemistry-formula-sheet",
  "englishSourcePath": "content/posts/H2-Chemistry-Formula-Sheet-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Formula-Sheet-2026",
      "sourcePath": "content/posts/H2-Chemistry-Formula-Sheet-2026.mdx",
      "status": "published",
      "sourceSha256": "d46ada668c739fcf4261a94133e845aeec24c54b7f8ba54de3a0f8b040d2822c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Formula-Sheet-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Formula-Sheet-2026.mdx",
      "status": "draft",
      "sourceSha256": "d46ada668c739fcf4261a94133e845aeec24c54b7f8ba54de3a0f8b040d2822c"
    }
  ]
},
{
  "id": "article.h2-chemistry-data-booklet",
  "englishSourcePath": "content/posts/H2-Chemistry-Data-Booklet-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Data-Booklet-2026",
      "sourcePath": "content/posts/H2-Chemistry-Data-Booklet-2026.mdx",
      "status": "published",
      "sourceSha256": "fffea17c2be7086726f65c9b653138e738c4bbf9ee177c353f5b0c2d56128d2b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Data-Booklet-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Data-Booklet-2026.mdx",
      "status": "draft",
      "sourceSha256": "fffea17c2be7086726f65c9b653138e738c4bbf9ee177c353f5b0c2d56128d2b"
    }
  ]
},
{
  "id": "article.h2-chemistry-syllabus",
  "englishSourcePath": "content/posts/H2-Chemistry-Syllabus-2026-27.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Syllabus-2026-27",
      "sourcePath": "content/posts/H2-Chemistry-Syllabus-2026-27.mdx",
      "status": "published",
      "sourceSha256": "79c14887243f703b3ea2e7dcd65f1f0896293861cd838f7ca331dc9f77a05e22"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Syllabus-2026-27",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Syllabus-2026-27.mdx",
      "status": "draft",
      "sourceSha256": "79c14887243f703b3ea2e7dcd65f1f0896293861cd838f7ca331dc9f77a05e22"
    }
  ]
},
{
  "id": "article.h2-chemistry-atomic-structure",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-1-Atomic-Structure.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-1-Atomic-Structure",
      "sourcePath": "content/posts/H2-Chemistry-Topic-1-Atomic-Structure.mdx",
      "status": "published",
      "sourceSha256": "48dda8d8443693c1125bca6547eac21132aac743bf87cc161a3b5c9824ea5ab8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-1-Atomic-Structure",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-1-Atomic-Structure.mdx",
      "status": "draft",
      "sourceSha256": "48dda8d8443693c1125bca6547eac21132aac743bf87cc161a3b5c9824ea5ab8"
    }
  ]
},
{
  "id": "article.h2-chemistry-chemical-bonding",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-2-Chemical-Bonding.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-2-Chemical-Bonding",
      "sourcePath": "content/posts/H2-Chemistry-Topic-2-Chemical-Bonding.mdx",
      "status": "published",
      "sourceSha256": "2a3fd862f63e49b718bca2157c2bb84ab9bda2a83734423fc6667d358e59459a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-2-Chemical-Bonding",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-2-Chemical-Bonding.mdx",
      "status": "draft",
      "sourceSha256": "2a3fd862f63e49b718bca2157c2bb84ab9bda2a83734423fc6667d358e59459a"
    }
  ]
},
{
  "id": "article.h2-chemistry-gaseous-state",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-3-The-Gaseous-State.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-3-The-Gaseous-State",
      "sourcePath": "content/posts/H2-Chemistry-Topic-3-The-Gaseous-State.mdx",
      "status": "published",
      "sourceSha256": "3894e9ad883500602332b18d0a855c5a6e39648f0527959c0340f1553fabdc30"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-3-The-Gaseous-State",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-3-The-Gaseous-State.mdx",
      "status": "draft",
      "sourceSha256": "3894e9ad883500602332b18d0a855c5a6e39648f0527959c0340f1553fabdc30"
    }
  ]
},
{
  "id": "article.h2-chemistry-acids-bases",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-4-Theories-of-Acids-and-Bases.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-4-Theories-of-Acids-and-Bases",
      "sourcePath": "content/posts/H2-Chemistry-Topic-4-Theories-of-Acids-and-Bases.mdx",
      "status": "published",
      "sourceSha256": "cf3633052932a96d6f59f773fc99ab66903d256a27f7bad7428c01413c42ea8f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-4-Theories-of-Acids-and-Bases",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-4-Theories-of-Acids-and-Bases.mdx",
      "status": "draft",
      "sourceSha256": "cf3633052932a96d6f59f773fc99ab66903d256a27f7bad7428c01413c42ea8f"
    }
  ]
},
{
  "id": "article.h2-chemistry-periodic-table",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-5-The-Periodic-Table.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-5-The-Periodic-Table",
      "sourcePath": "content/posts/H2-Chemistry-Topic-5-The-Periodic-Table.mdx",
      "status": "published",
      "sourceSha256": "a7b1dcdf0d8cd674c1cb0a36c716949e225edbdf319ddd459add216f4b17ff9f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-5-The-Periodic-Table",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-5-The-Periodic-Table.mdx",
      "status": "draft",
      "sourceSha256": "a7b1dcdf0d8cd674c1cb0a36c716949e225edbdf319ddd459add216f4b17ff9f"
    }
  ]
},
{
  "id": "article.h2-chemistry-mole-concept",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-6-The-Mole-Concept-and-Stoichiometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-6-The-Mole-Concept-and-Stoichiometry",
      "sourcePath": "content/posts/H2-Chemistry-Topic-6-The-Mole-Concept-and-Stoichiometry.mdx",
      "status": "published",
      "sourceSha256": "454584899cb0976fb29f4ee33777381c4e460dc6c0b99fb18d3d9e742efbdbad"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-6-The-Mole-Concept-and-Stoichiometry",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-6-The-Mole-Concept-and-Stoichiometry.mdx",
      "status": "draft",
      "sourceSha256": "454584899cb0976fb29f4ee33777381c4e460dc6c0b99fb18d3d9e742efbdbad"
    }
  ]
},
{
  "id": "article.h2-chemistry-energetics",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-7-Chemical-Energetics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-7-Chemical-Energetics",
      "sourcePath": "content/posts/H2-Chemistry-Topic-7-Chemical-Energetics.mdx",
      "status": "published",
      "sourceSha256": "c860e81f38c42313ccd8ef75465d0c58e1cc1ae494a05b10c8fb96fe0facd6ac"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-7-Chemical-Energetics",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-7-Chemical-Energetics.mdx",
      "status": "draft",
      "sourceSha256": "c860e81f38c42313ccd8ef75465d0c58e1cc1ae494a05b10c8fb96fe0facd6ac"
    }
  ]
},
{
  "id": "article.h2-chemistry-kinetics",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-8-Reaction-Kinetics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-8-Reaction-Kinetics",
      "sourcePath": "content/posts/H2-Chemistry-Topic-8-Reaction-Kinetics.mdx",
      "status": "published",
      "sourceSha256": "5b305ca05ff1be03c3530f8f9b8372e2a287632d94e8304647dbb378785e9715"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-8-Reaction-Kinetics",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-8-Reaction-Kinetics.mdx",
      "status": "draft",
      "sourceSha256": "5b305ca05ff1be03c3530f8f9b8372e2a287632d94e8304647dbb378785e9715"
    }
  ]
},
{
  "id": "article.h2-chemistry-equilibria",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-9-Chemical-Equilibria.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-9-Chemical-Equilibria",
      "sourcePath": "content/posts/H2-Chemistry-Topic-9-Chemical-Equilibria.mdx",
      "status": "published",
      "sourceSha256": "67c8c27d2351542e5ef2fef1d7c09c6fe3d3a6d354f507c3f8db2c2bf639b80a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-9-Chemical-Equilibria",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-9-Chemical-Equilibria.mdx",
      "status": "draft",
      "sourceSha256": "67c8c27d2351542e5ef2fef1d7c09c6fe3d3a6d354f507c3f8db2c2bf639b80a"
    }
  ]
},
{
  "id": "article.h2-chemistry-aqueous-solutions",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-10-Chemistry-of-Aqueous-Solutions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-10-Chemistry-of-Aqueous-Solutions",
      "sourcePath": "content/posts/H2-Chemistry-Topic-10-Chemistry-of-Aqueous-Solutions.mdx",
      "status": "published",
      "sourceSha256": "323b20696ca3ffa6dc7c95f1457ed0504f37bdb247c056b145bb751557e5775f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-10-Chemistry-of-Aqueous-Solutions",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-10-Chemistry-of-Aqueous-Solutions.mdx",
      "status": "draft",
      "sourceSha256": "323b20696ca3ffa6dc7c95f1457ed0504f37bdb247c056b145bb751557e5775f"
    }
  ]
},
{
  "id": "article.h2-chemistry-organic",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-11-Organic-Chemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-11-Organic-Chemistry",
      "sourcePath": "content/posts/H2-Chemistry-Topic-11-Organic-Chemistry.mdx",
      "status": "published",
      "sourceSha256": "464ce0455396e39d28dc4ed4dbe98cef23daafdddc8635a53302d2fa97d9639f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-11-Organic-Chemistry",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-11-Organic-Chemistry.mdx",
      "status": "draft",
      "sourceSha256": "464ce0455396e39d28dc4ed4dbe98cef23daafdddc8635a53302d2fa97d9639f"
    }
  ]
},
{
  "id": "article.h2-chemistry-electrochemistry",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-12-Electrochemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-12-Electrochemistry",
      "sourcePath": "content/posts/H2-Chemistry-Topic-12-Electrochemistry.mdx",
      "status": "published",
      "sourceSha256": "45b46134a4fa3861154f1e1cbc7c4a7c50b8befe0afd03e9766a0c9508c74aed"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-12-Electrochemistry",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-12-Electrochemistry.mdx",
      "status": "draft",
      "sourceSha256": "45b46134a4fa3861154f1e1cbc7c4a7c50b8befe0afd03e9766a0c9508c74aed"
    }
  ]
},
{
  "id": "article.h2-chemistry-transition-elements",
  "englishSourcePath": "content/posts/H2-Chemistry-Topic-13-Transition-Elements.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Topic-13-Transition-Elements",
      "sourcePath": "content/posts/H2-Chemistry-Topic-13-Transition-Elements.mdx",
      "status": "published",
      "sourceSha256": "596ce5444b29567fe169f30a81c839ec8bc779d4458bce017ceb4c9de994aeab"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Topic-13-Transition-Elements",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Topic-13-Transition-Elements.mdx",
      "status": "draft",
      "sourceSha256": "596ce5444b29567fe169f30a81c839ec8bc779d4458bce017ceb4c9de994aeab"
    }
  ]
},
{
  "id": "article.h2-chemistry-electrochemistry-notes",
  "englishSourcePath": "content/posts/H2-Chemistry-Electrochemistry-Notes.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Electrochemistry-Notes",
      "sourcePath": "content/posts/H2-Chemistry-Electrochemistry-Notes.mdx",
      "status": "published",
      "sourceSha256": "9ce9ee7f442f9f6cbce1eaae841a6017135fda0f5b84645f8c06b153807317c9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Electrochemistry-Notes",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Electrochemistry-Notes.mdx",
      "status": "draft",
      "sourceSha256": "9ce9ee7f442f9f6cbce1eaae841a6017135fda0f5b84645f8c06b153807317c9"
    }
  ]
},
{
  "id": "article.h2-chemistry-hardest-topics",
  "englishSourcePath": "content/posts/H2-Chemistry-Hardest-Topics-How-to-Master-Them.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Hardest-Topics-How-to-Master-Them",
      "sourcePath": "content/posts/H2-Chemistry-Hardest-Topics-How-to-Master-Them.mdx",
      "status": "published",
      "sourceSha256": "fd6cd7d9234eceb4391300b12bc3a55835f7787a5e7b3f8d1ed40d49f3cc73b7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Hardest-Topics-How-to-Master-Them",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Hardest-Topics-How-to-Master-Them.mdx",
      "status": "draft",
      "sourceSha256": "fd6cd7d9234eceb4391300b12bc3a55835f7787a5e7b3f8d1ed40d49f3cc73b7"
    }
  ]
},
{
  "id": "article.h2-chemistry-organic-summary",
  "englishSourcePath": "content/posts/H2-Chemistry-Organic-Reactions-Summary-Flowchart-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Organic-Reactions-Summary-Flowchart-2026",
      "sourcePath": "content/posts/H2-Chemistry-Organic-Reactions-Summary-Flowchart-2026.mdx",
      "status": "published",
      "sourceSha256": "6171bd0afe4a447f919bbb2451ea8db14ccbab711e02261ea3920b6e170578e5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Organic-Reactions-Summary-Flowchart-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Organic-Reactions-Summary-Flowchart-2026.mdx",
      "status": "draft",
      "sourceSha256": "6171bd0afe4a447f919bbb2451ea8db14ccbab711e02261ea3920b6e170578e5"
    }
  ]
},
{
  "id": "article.h2-chemistry-organic-synthesis-map",
  "englishSourcePath": "content/posts/H2-Chemistry-Organic-Synthesis-Flowchart-Reaction-Map.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-notes/H2-Chemistry-Organic-Synthesis-Flowchart-Reaction-Map",
      "sourcePath": "content/posts/H2-Chemistry-Organic-Synthesis-Flowchart-Reaction-Map.mdx",
      "status": "published",
      "sourceSha256": "e2a4233d05bbc3bb43665dc38946118851ddfa16c16eee5a8f6219d098309ce9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-notes/H2-Chemistry-Organic-Synthesis-Flowchart-Reaction-Map",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Organic-Synthesis-Flowchart-Reaction-Map.mdx",
      "status": "draft",
      "sourceSha256": "e2a4233d05bbc3bb43665dc38946118851ddfa16c16eee5a8f6219d098309ce9"
    }
  ]
},
{
  "id": "article.h2-chemistry-private-candidate",
  "englishSourcePath": "content/posts/H2-Chemistry-Practical-Private-Candidate-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Practical-Private-Candidate-Guide-2026",
      "sourcePath": "content/posts/H2-Chemistry-Practical-Private-Candidate-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "1248366d630b6d6c378d56fde8215e40f657fc963fb0ee46880df3bcc7aa6e86"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Practical-Private-Candidate-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Practical-Private-Candidate-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "1248366d630b6d6c378d56fde8215e40f657fc963fb0ee46880df3bcc7aa6e86"
    }
  ]
},
{
  "id": "article.h2-chemistry-acjc",
  "englishSourcePath": "content/posts/H2-Chemistry-at-ACJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-chemistry-tuition/H2-Chemistry-at-ACJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Chemistry-at-ACJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "7968a8337b6ce85aa47f7bca19f7258464b6235293c17f9cfd254816f491190a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-chemistry-tuition/H2-Chemistry-at-ACJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-at-ACJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "7968a8337b6ce85aa47f7bca19f7258464b6235293c17f9cfd254816f491190a"
    }
  ]
},
{
  "id": "article.h2-chemistry-asrjc",
  "englishSourcePath": "content/posts/H2-Chemistry-at-ASRJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-chemistry-tuition/H2-Chemistry-at-ASRJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Chemistry-at-ASRJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "8785e4ed236b44b5fb2218b8e9b2221fafc32070cf556604d3bd5434e964ce64"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-chemistry-tuition/H2-Chemistry-at-ASRJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-at-ASRJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "8785e4ed236b44b5fb2218b8e9b2221fafc32070cf556604d3bd5434e964ce64"
    }
  ]
},
{
  "id": "article.h2-chemistry-cjc",
  "englishSourcePath": "content/posts/H2-Chemistry-at-CJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-chemistry-tuition/H2-Chemistry-at-CJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Chemistry-at-CJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "4567a2d28f25582d1ab6b87b3255781bd68ab09065d2d2084d2bf184eb138d31"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-chemistry-tuition/H2-Chemistry-at-CJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-at-CJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "4567a2d28f25582d1ab6b87b3255781bd68ab09065d2d2084d2bf184eb138d31"
    }
  ]
},
{
  "id": "article.h2-chemistry-ri",
  "englishSourcePath": "content/posts/H2-Chemistry-at-RI-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-chemistry-tuition/H2-Chemistry-at-RI-What-to-Expect",
      "sourcePath": "content/posts/H2-Chemistry-at-RI-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "0e5d09862c5d181613fd36b7f2f20ab630a6ac76f4bd8c6c01e2bb4784034b2f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-chemistry-tuition/H2-Chemistry-at-RI-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-at-RI-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "0e5d09862c5d181613fd36b7f2f20ab630a6ac76f4bd8c6c01e2bb4784034b2f"
    }
  ]
},
{
  "id": "article.h2-physics-quantities",
  "englishSourcePath": "content/posts/1-Quantities-and-Measurements.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/1-Quantities-and-Measurements",
      "sourcePath": "content/posts/1-Quantities-and-Measurements.mdx",
      "status": "published",
      "sourceSha256": "f927ebb87240e8bc9d9c183c4e7b090f2d017bb12e1ca2253d011ed8e7c7e38b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/1-Quantities-and-Measurements",
      "sourcePath": "content/translations/zh-Hans/1-Quantities-and-Measurements.mdx",
      "status": "draft",
      "sourceSha256": "f927ebb87240e8bc9d9c183c4e7b090f2d017bb12e1ca2253d011ed8e7c7e38b"
    }
  ]
},
{
  "id": "article.h2-physics-forces",
  "englishSourcePath": "content/posts/2-Forces-and-Moments.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/2-Forces-and-Moments",
      "sourcePath": "content/posts/2-Forces-and-Moments.mdx",
      "status": "published",
      "sourceSha256": "f11bdbc377787eddca763d834ca86668ae7c1257e0ab2fef5b783d4e1f180c68"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/2-Forces-and-Moments",
      "sourcePath": "content/translations/zh-Hans/2-Forces-and-Moments.mdx",
      "status": "draft",
      "sourceSha256": "f11bdbc377787eddca763d834ca86668ae7c1257e0ab2fef5b783d4e1f180c68"
    }
  ]
},
{
  "id": "article.h2-physics-motion",
  "englishSourcePath": "content/posts/3-Motion-and-Forces.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/3-Motion-and-Forces",
      "sourcePath": "content/posts/3-Motion-and-Forces.mdx",
      "status": "published",
      "sourceSha256": "9d2094771b00423e28eec8a3088a9f2721ded567d8d7c8d875c0b9a5eb66857c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/3-Motion-and-Forces",
      "sourcePath": "content/translations/zh-Hans/3-Motion-and-Forces.mdx",
      "status": "draft",
      "sourceSha256": "9d2094771b00423e28eec8a3088a9f2721ded567d8d7c8d875c0b9a5eb66857c"
    }
  ]
},
{
  "id": "article.h2-physics-energy",
  "englishSourcePath": "content/posts/4-Energy-and-Fields.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/4-Energy-and-Fields",
      "sourcePath": "content/posts/4-Energy-and-Fields.mdx",
      "status": "published",
      "sourceSha256": "d926e18918fda6dec007d9181613fb0c73447014a010416d688341a88c359052"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/4-Energy-and-Fields",
      "sourcePath": "content/translations/zh-Hans/4-Energy-and-Fields.mdx",
      "status": "draft",
      "sourceSha256": "d926e18918fda6dec007d9181613fb0c73447014a010416d688341a88c359052"
    }
  ]
},
{
  "id": "article.h2-physics-projectile",
  "englishSourcePath": "content/posts/5-Projectile-Motion-and-Energy.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/5-Projectile-Motion-and-Energy",
      "sourcePath": "content/posts/5-Projectile-Motion-and-Energy.mdx",
      "status": "published",
      "sourceSha256": "72147caadb95e82c89f6e373942b85ef92a7cdb979df04748bb553a40bc0c4f2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/5-Projectile-Motion-and-Energy",
      "sourcePath": "content/translations/zh-Hans/5-Projectile-Motion-and-Energy.mdx",
      "status": "draft",
      "sourceSha256": "72147caadb95e82c89f6e373942b85ef92a7cdb979df04748bb553a40bc0c4f2"
    }
  ]
},
{
  "id": "article.h2-physics-collisions",
  "englishSourcePath": "content/posts/6-Collisions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/6-Collisions",
      "sourcePath": "content/posts/6-Collisions.mdx",
      "status": "published",
      "sourceSha256": "ae838167731d78c21acd3927d2174f30212cd194078ceb678fb33eb854b6003f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/6-Collisions",
      "sourcePath": "content/translations/zh-Hans/6-Collisions.mdx",
      "status": "draft",
      "sourceSha256": "ae838167731d78c21acd3927d2174f30212cd194078ceb678fb33eb854b6003f"
    }
  ]
},
{
  "id": "article.h2-physics-circular",
  "englishSourcePath": "content/posts/7-Circular-Motion.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/7-Circular-Motion",
      "sourcePath": "content/posts/7-Circular-Motion.mdx",
      "status": "published",
      "sourceSha256": "2fe8483538a1c79906c99c7364b3247f7af8ab0f626553cd15bec3c4d9fe7199"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/7-Circular-Motion",
      "sourcePath": "content/translations/zh-Hans/7-Circular-Motion.mdx",
      "status": "draft",
      "sourceSha256": "2fe8483538a1c79906c99c7364b3247f7af8ab0f626553cd15bec3c4d9fe7199"
    }
  ]
},
{
  "id": "article.h2-physics-gravity",
  "englishSourcePath": "content/posts/8-Gravitational-Fields.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/8-Gravitational-Fields",
      "sourcePath": "content/posts/8-Gravitational-Fields.mdx",
      "status": "published",
      "sourceSha256": "6e8a8fc8cc9570032cf0492c153479b55a59eacea9a92a51848f6c06a8ffb485"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/8-Gravitational-Fields",
      "sourcePath": "content/translations/zh-Hans/8-Gravitational-Fields.mdx",
      "status": "draft",
      "sourceSha256": "6e8a8fc8cc9570032cf0492c153479b55a59eacea9a92a51848f6c06a8ffb485"
    }
  ]
},
{
  "id": "article.h2-physics-oscillations",
  "englishSourcePath": "content/posts/9-Oscillations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/9-Oscillations",
      "sourcePath": "content/posts/9-Oscillations.mdx",
      "status": "published",
      "sourceSha256": "1ae3475a66b0b4f1c95097dbb007a3a67a3f06d63b4945506e97f8cdce8723e3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/9-Oscillations",
      "sourcePath": "content/translations/zh-Hans/9-Oscillations.mdx",
      "status": "draft",
      "sourceSha256": "1ae3475a66b0b4f1c95097dbb007a3a67a3f06d63b4945506e97f8cdce8723e3"
    }
  ]
},
{
  "id": "article.h2-physics-wave",
  "englishSourcePath": "content/posts/10-Wave-Motion-and-Polarisation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/10-Wave-Motion-and-Polarisation",
      "sourcePath": "content/posts/10-Wave-Motion-and-Polarisation.mdx",
      "status": "published",
      "sourceSha256": "9413ddeeb85e93de70ea5f56847a518175b2421d1192707bf6afebd0132f18a1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/10-Wave-Motion-and-Polarisation",
      "sourcePath": "content/translations/zh-Hans/10-Wave-Motion-and-Polarisation.mdx",
      "status": "draft",
      "sourceSha256": "9413ddeeb85e93de70ea5f56847a518175b2421d1192707bf6afebd0132f18a1"
    }
  ]
},
{
  "id": "article.h2-physics-superposition",
  "englishSourcePath": "content/posts/11-Superposition.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/11-Superposition",
      "sourcePath": "content/posts/11-Superposition.mdx",
      "status": "published",
      "sourceSha256": "552d532b538901bf73e5783f2abb2514368a55f099ac78e2daa339b4c1254135"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/11-Superposition",
      "sourcePath": "content/translations/zh-Hans/11-Superposition.mdx",
      "status": "draft",
      "sourceSha256": "552d532b538901bf73e5783f2abb2514368a55f099ac78e2daa339b4c1254135"
    }
  ]
},
{
  "id": "article.h2-physics-gases",
  "englishSourcePath": "content/posts/12-Temperature-and-Ideal-Gases.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/12-Temperature-and-Ideal-Gases",
      "sourcePath": "content/posts/12-Temperature-and-Ideal-Gases.mdx",
      "status": "published",
      "sourceSha256": "e61d1ab9bc166b4aaf5871ca15b75f847e82736029fdd01ea74dd3ed53829ca5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/12-Temperature-and-Ideal-Gases",
      "sourcePath": "content/translations/zh-Hans/12-Temperature-and-Ideal-Gases.mdx",
      "status": "draft",
      "sourceSha256": "e61d1ab9bc166b4aaf5871ca15b75f847e82736029fdd01ea74dd3ed53829ca5"
    }
  ]
},
{
  "id": "article.h2-physics-thermodynamics",
  "englishSourcePath": "content/posts/13-Thermodynamic-Systems.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/13-Thermodynamic-Systems",
      "sourcePath": "content/posts/13-Thermodynamic-Systems.mdx",
      "status": "published",
      "sourceSha256": "00c3e99cb4ecac0cd8b41505528b6a85d384a4eb6e3f0728ea591176c6971050"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/13-Thermodynamic-Systems",
      "sourcePath": "content/translations/zh-Hans/13-Thermodynamic-Systems.mdx",
      "status": "draft",
      "sourceSha256": "00c3e99cb4ecac0cd8b41505528b6a85d384a4eb6e3f0728ea591176c6971050"
    }
  ]
},
{
  "id": "article.h2-physics-electric",
  "englishSourcePath": "content/posts/14-Electric-Fields.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/14-Electric-Fields",
      "sourcePath": "content/posts/14-Electric-Fields.mdx",
      "status": "published",
      "sourceSha256": "3cc3dd192b14901165b1c376252b3242130894a7a8362f3eef88520eb049d88a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/14-Electric-Fields",
      "sourcePath": "content/translations/zh-Hans/14-Electric-Fields.mdx",
      "status": "draft",
      "sourceSha256": "3cc3dd192b14901165b1c376252b3242130894a7a8362f3eef88520eb049d88a"
    }
  ]
},
{
  "id": "article.h2-physics-currents",
  "englishSourcePath": "content/posts/15-Currents.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/15-Currents",
      "sourcePath": "content/posts/15-Currents.mdx",
      "status": "published",
      "sourceSha256": "41e0a4cf2b54cba3bf6d00d33a2d8cf324ab0c79c69fe0d1f00cc60515b7c623"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/15-Currents",
      "sourcePath": "content/translations/zh-Hans/15-Currents.mdx",
      "status": "draft",
      "sourceSha256": "41e0a4cf2b54cba3bf6d00d33a2d8cf324ab0c79c69fe0d1f00cc60515b7c623"
    }
  ]
},
{
  "id": "article.h2-physics-circuits",
  "englishSourcePath": "content/posts/16-Circuits.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/16-Circuits",
      "sourcePath": "content/posts/16-Circuits.mdx",
      "status": "published",
      "sourceSha256": "e10d5284b9d4d8a594f0b1eee4ec9a9a340fb2a73030f9edaa3866ea6041e3aa"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/16-Circuits",
      "sourcePath": "content/translations/zh-Hans/16-Circuits.mdx",
      "status": "draft",
      "sourceSha256": "e10d5284b9d4d8a594f0b1eee4ec9a9a340fb2a73030f9edaa3866ea6041e3aa"
    }
  ]
},
{
  "id": "article.h2-physics-electromagnetic",
  "englishSourcePath": "content/posts/17-Electromagnetic-Forces.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/17-Electromagnetic-Forces",
      "sourcePath": "content/posts/17-Electromagnetic-Forces.mdx",
      "status": "published",
      "sourceSha256": "42aa30b0fc97f4538e63d95d9919b69b0652355ca175c028a6e114dfc2879aee"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/17-Electromagnetic-Forces",
      "sourcePath": "content/translations/zh-Hans/17-Electromagnetic-Forces.mdx",
      "status": "draft",
      "sourceSha256": "42aa30b0fc97f4538e63d95d9919b69b0652355ca175c028a6e114dfc2879aee"
    }
  ]
},
{
  "id": "article.h2-physics-induction",
  "englishSourcePath": "content/posts/18-Electromagnetic-Induction.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/18-Electromagnetic-Induction",
      "sourcePath": "content/posts/18-Electromagnetic-Induction.mdx",
      "status": "published",
      "sourceSha256": "5c24d82a7ebbbbc330fbc4dea15e4bf3a881f06ff1d05c1012121c71d5d873eb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/18-Electromagnetic-Induction",
      "sourcePath": "content/translations/zh-Hans/18-Electromagnetic-Induction.mdx",
      "status": "draft",
      "sourceSha256": "5c24d82a7ebbbbc330fbc4dea15e4bf3a881f06ff1d05c1012121c71d5d873eb"
    }
  ]
},
{
  "id": "article.h2-physics-quantum",
  "englishSourcePath": "content/posts/19-Quantum-Physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/19-Quantum-Physics",
      "sourcePath": "content/posts/19-Quantum-Physics.mdx",
      "status": "published",
      "sourceSha256": "76547dc92209dd6f2c015f0817dcd58c409c37f928d7cf2f08fc2b8a639a9a5b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/19-Quantum-Physics",
      "sourcePath": "content/translations/zh-Hans/19-Quantum-Physics.mdx",
      "status": "draft",
      "sourceSha256": "76547dc92209dd6f2c015f0817dcd58c409c37f928d7cf2f08fc2b8a639a9a5b"
    }
  ]
},
{
  "id": "article.h2-physics-nuclear",
  "englishSourcePath": "content/posts/20-Nuclear-Physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/20-Nuclear-Physics",
      "sourcePath": "content/posts/20-Nuclear-Physics.mdx",
      "status": "published",
      "sourceSha256": "0c063314ffaf454a4cd9e83131d050073a8cf7e8577c0194b0f85de8c647110f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/20-Nuclear-Physics",
      "sourcePath": "content/translations/zh-Hans/20-Nuclear-Physics.mdx",
      "status": "draft",
      "sourceSha256": "0c063314ffaf454a4cd9e83131d050073a8cf7e8577c0194b0f85de8c647110f"
    }
  ]
},
{
  "id": "article.h2-physics-data-formulae",
  "englishSourcePath": "content/posts/H2-Physics-Data-and-Formulae-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/H2-Physics-Data-and-Formulae-2026",
      "sourcePath": "content/posts/H2-Physics-Data-and-Formulae-2026.mdx",
      "status": "published",
      "sourceSha256": "689d5af5a23a0155b12ce4773b321d595b7d079d686c44c8d36ed2162f5eece9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/H2-Physics-Data-and-Formulae-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Data-and-Formulae-2026.mdx",
      "status": "draft",
      "sourceSha256": "689d5af5a23a0155b12ce4773b321d595b7d079d686c44c8d36ed2162f5eece9"
    }
  ]
},
{
  "id": "article.h2-physics-ace",
  "englishSourcePath": "content/posts/H2-Physics-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-experiments/H2-Physics-ACE-Qualitative-to-Quantitative-Paper-4",
      "sourcePath": "content/posts/H2-Physics-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "725a8a1fdfc972398f86be9b3f3f5b5d9a7de7941d812c52ff23ee552b87cafa"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-experiments/H2-Physics-ACE-Qualitative-to-Quantitative-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-ACE-Qualitative-to-Quantitative-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "725a8a1fdfc972398f86be9b3f3f5b5d9a7de7941d812c52ff23ee552b87cafa"
    }
  ]
},
{
  "id": "article.h2-physics-rc",
  "englishSourcePath": "content/posts/H2-Physics-Capacitor-Charge-Discharge-RC-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-experiments/H2-Physics-Capacitor-Charge-Discharge-RC-Paper-4",
      "sourcePath": "content/posts/H2-Physics-Capacitor-Charge-Discharge-RC-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "324f09ffe51a04b8f13c171f52b0d8aa23a3e3121e2910ed9c760bd47c6971e3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-experiments/H2-Physics-Capacitor-Charge-Discharge-RC-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Capacitor-Charge-Discharge-RC-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "324f09ffe51a04b8f13c171f52b0d8aa23a3e3121e2910ed9c760bd47c6971e3"
    }
  ]
},
{
  "id": "article.h2-physics-moments",
  "englishSourcePath": "content/posts/H2-Physics-Moments-Equilibrium-Practical-Pivot-Torque-Centre-of-Mass.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-experiments/H2-Physics-Moments-Equilibrium-Practical-Pivot-Torque-Centre-of-Mass",
      "sourcePath": "content/posts/H2-Physics-Moments-Equilibrium-Practical-Pivot-Torque-Centre-of-Mass.mdx",
      "status": "published",
      "sourceSha256": "c30358a7bf9d8254d2d5f865304ff0664f5e94a00b4f9a6c580c45affd8a66dc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-experiments/H2-Physics-Moments-Equilibrium-Practical-Pivot-Torque-Centre-of-Mass",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Moments-Equilibrium-Practical-Pivot-Torque-Centre-of-Mass.mdx",
      "status": "draft",
      "sourceSha256": "c30358a7bf9d8254d2d5f865304ff0664f5e94a00b4f9a6c580c45affd8a66dc"
    }
  ]
},
{
  "id": "article.h2-physics-paper3-strategy",
  "englishSourcePath": "content/posts/H2-Physics-Paper-3-Multi-Topic-Strategy.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/H2-Physics-Paper-3-Multi-Topic-Strategy",
      "sourcePath": "content/posts/H2-Physics-Paper-3-Multi-Topic-Strategy.mdx",
      "status": "published",
      "sourceSha256": "45d667e48931904580dbbb218e8d2fdb8cdc96e58519ee99bb691e3f45cb9f76"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/H2-Physics-Paper-3-Multi-Topic-Strategy",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Paper-3-Multi-Topic-Strategy.mdx",
      "status": "draft",
      "sourceSha256": "45d667e48931904580dbbb218e8d2fdb8cdc96e58519ee99bb691e3f45cb9f76"
    }
  ]
},
{
  "id": "article.h2-physics-spreadsheet",
  "englishSourcePath": "content/posts/H2-Physics-Paper-4-Spreadsheet-Skills-9478-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-experiments/H2-Physics-Paper-4-Spreadsheet-Skills-9478-2026",
      "sourcePath": "content/posts/H2-Physics-Paper-4-Spreadsheet-Skills-9478-2026.mdx",
      "status": "published",
      "sourceSha256": "325ed34cb9abec7b3a2f5013ac0ca94d35a64cbafde627ab47cda68b4e64ff2f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-experiments/H2-Physics-Paper-4-Spreadsheet-Skills-9478-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Paper-4-Spreadsheet-Skills-9478-2026.mdx",
      "status": "draft",
      "sourceSha256": "325ed34cb9abec7b3a2f5013ac0ca94d35a64cbafde627ab47cda68b4e64ff2f"
    }
  ]
},
{
  "id": "article.h2-physics-linearisation",
  "englishSourcePath": "content/posts/H2-Physics-Spreadsheet-Linearisation-Time-Constants-Paper-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-experiments/H2-Physics-Spreadsheet-Linearisation-Time-Constants-Paper-4",
      "sourcePath": "content/posts/H2-Physics-Spreadsheet-Linearisation-Time-Constants-Paper-4.mdx",
      "status": "published",
      "sourceSha256": "a5f1107a025966496885b0ef3e5259acc8074ae687aeaa982376c4afae780aa2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-experiments/H2-Physics-Spreadsheet-Linearisation-Time-Constants-Paper-4",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Spreadsheet-Linearisation-Time-Constants-Paper-4.mdx",
      "status": "draft",
      "sourceSha256": "a5f1107a025966496885b0ef3e5259acc8074ae687aeaa982376c4afae780aa2"
    }
  ]
},
{
  "id": "article.h2-physics-private-candidate",
  "englishSourcePath": "content/posts/H2-Physics-Practical-Private-Candidate-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-experiments/H2-Physics-Practical-Private-Candidate-Guide-2026",
      "sourcePath": "content/posts/H2-Physics-Practical-Private-Candidate-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "d5450d830101afeb920de0abe661433ad82d567d19dd141a9b0416232df2adea"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-experiments/H2-Physics-Practical-Private-Candidate-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Practical-Private-Candidate-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "d5450d830101afeb920de0abe661433ad82d567d19dd141a9b0416232df2adea"
    }
  ]
},
{
  "id": "article.h2-physics-lab-mastery",
  "englishSourcePath": "content/posts/H2-Physics-Practical-2026-Lab-Mastery-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-experiments/H2-Physics-Practical-2026-Lab-Mastery-Guide",
      "sourcePath": "content/posts/H2-Physics-Practical-2026-Lab-Mastery-Guide.mdx",
      "status": "published",
      "sourceSha256": "10ef2173435386b1c772ad47b267e9add1f42d23cb778837fd1242ce5f78f566"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-experiments/H2-Physics-Practical-2026-Lab-Mastery-Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Practical-2026-Lab-Mastery-Guide.mdx",
      "status": "draft",
      "sourceSha256": "10ef2173435386b1c772ad47b267e9add1f42d23cb778837fd1242ce5f78f566"
    }
  ]
},
{
  "id": "article.h2-physics-technique-file",
  "englishSourcePath": "content/posts/H2-Physics-Paper-4-Technique-File.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-experiments/H2-Physics-Paper-4-Technique-File",
      "sourcePath": "content/posts/H2-Physics-Paper-4-Technique-File.mdx",
      "status": "published",
      "sourceSha256": "3db1f3e127dadd0753ef97d8f9ffdea2f4100969eda5030e3eceeca0daa48533"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-experiments/H2-Physics-Paper-4-Technique-File",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Paper-4-Technique-File.mdx",
      "status": "draft",
      "sourceSha256": "3db1f3e127dadd0753ef97d8f9ffdea2f4100969eda5030e3eceeca0daa48533"
    }
  ]
},
{
  "id": "article.h2-physics-syllabus-map",
  "englishSourcePath": "content/posts/H2-Physics-Syllabus-2026-27.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/H2-Physics-Syllabus-2026-27",
      "sourcePath": "content/posts/H2-Physics-Syllabus-2026-27.mdx",
      "status": "published",
      "sourceSha256": "39eecea6d3fb2812e18232a80691716d71b4f7ecc3486a53ee6f765663cbfadb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/H2-Physics-Syllabus-2026-27",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-Syllabus-2026-27.mdx",
      "status": "draft",
      "sourceSha256": "39eecea6d3fb2812e18232a80691716d71b4f7ecc3486a53ee6f765663cbfadb"
    }
  ]
},
{
  "id": "article.h2-physics-vjc",
  "englishSourcePath": "content/posts/H2-Physics-at-VJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-physics-tuition/H2-Physics-at-VJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Physics-at-VJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "fe8ee4e36483309fcf911a0314c28b36cd43184ef33dbba3c25c79e2bd1666b7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-physics-tuition/H2-Physics-at-VJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-at-VJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "fe8ee4e36483309fcf911a0314c28b36cd43184ef33dbba3c25c79e2bd1666b7"
    }
  ]
},
{
  "id": "article.h2-physics-sajc",
  "englishSourcePath": "content/posts/H2-Physics-at-SAJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-physics-tuition/H2-Physics-at-SAJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Physics-at-SAJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "4ebd5c8bc0d4e792b8c14459ae65433d2fa517c1c39e2bb60a8f887d87f6c413"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-physics-tuition/H2-Physics-at-SAJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-at-SAJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "4ebd5c8bc0d4e792b8c14459ae65433d2fa517c1c39e2bb60a8f887d87f6c413"
    }
  ]
},
{
  "id": "article.h2-physics-yijc",
  "englishSourcePath": "content/posts/H2-Physics-at-YIJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-physics-tuition/H2-Physics-at-YIJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Physics-at-YIJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "f15de6403b7130404fa6d604ed99afe6299ea360da8341a07dc8bc9408fe745f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-physics-tuition/H2-Physics-at-YIJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-at-YIJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "f15de6403b7130404fa6d604ed99afe6299ea360da8341a07dc8bc9408fe745f"
    }
  ]
},
{
  "id": "article.h2-physics-hci",
  "englishSourcePath": "content/posts/H2-Physics-at-HCI-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-physics-tuition/H2-Physics-at-HCI-What-to-Expect",
      "sourcePath": "content/posts/H2-Physics-at-HCI-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "f4fab0bbfcbd3b04759a4cb125e17e857ef1d689c8a8b5d8ab9db6b92e813d1d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-physics-tuition/H2-Physics-at-HCI-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-at-HCI-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "f4fab0bbfcbd3b04759a4cb125e17e857ef1d689c8a8b5d8ab9db6b92e813d1d"
    }
  ]
},
{
  "id": "article.h2-physics-definitions",
  "englishSourcePath": "content/posts/H2-Physics-in-A-Level-Complete-Definitions-and-Formulae_Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/H2-Physics-in-A-Level-Complete-Definitions-and-Formulae_Guide",
      "sourcePath": "content/posts/H2-Physics-in-A-Level-Complete-Definitions-and-Formulae_Guide.mdx",
      "status": "published",
      "sourceSha256": "27cf95eab31acbc1af9bcd1d1576a6512d60ead42981de7c979b55c226087a8a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/H2-Physics-in-A-Level-Complete-Definitions-and-Formulae_Guide",
      "sourcePath": "content/translations/zh-Hans/H2-Physics-in-A-Level-Complete-Definitions-and-Formulae_Guide.mdx",
      "status": "draft",
      "sourceSha256": "27cf95eab31acbc1af9bcd1d1576a6512d60ead42981de7c979b55c226087a8a"
    }
  ]
},
{
  "id": "article.h2-maths-functions",
  "englishSourcePath": "content/posts/H2-Maths-Notes-1-1-Functions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-1-1-Functions",
      "sourcePath": "content/posts/H2-Maths-Notes-1-1-Functions.mdx",
      "status": "published",
      "sourceSha256": "8a293ca27c1bbe2af927cbb5f88a648e774fdb4d6df5184334916640cff0dc88"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-1-1-Functions",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-1-1-Functions.mdx",
      "status": "draft",
      "sourceSha256": "8a293ca27c1bbe2af927cbb5f88a648e774fdb4d6df5184334916640cff0dc88"
    }
  ]
},
{
  "id": "article.h2-maths-graphs-transformations",
  "englishSourcePath": "content/posts/H2-Maths-Notes-1-2-Graphs-and-Transformations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-1-2-Graphs-and-Transformations",
      "sourcePath": "content/posts/H2-Maths-Notes-1-2-Graphs-and-Transformations.mdx",
      "status": "published",
      "sourceSha256": "d99136d03ca7c78b25a43e481018d4fa2be7cbb4140b6488177fc22444390050"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-1-2-Graphs-and-Transformations",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-1-2-Graphs-and-Transformations.mdx",
      "status": "draft",
      "sourceSha256": "d99136d03ca7c78b25a43e481018d4fa2be7cbb4140b6488177fc22444390050"
    }
  ]
},
{
  "id": "article.h2-maths-equations-inequalities",
  "englishSourcePath": "content/posts/H2-Maths-Notes-1-3-Equations-and-Inequalities.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-1-3-Equations-and-Inequalities",
      "sourcePath": "content/posts/H2-Maths-Notes-1-3-Equations-and-Inequalities.mdx",
      "status": "published",
      "sourceSha256": "62cce7d017b127acdb7ef9fc68bd1812b6584d29368b188efbd1cb1a47bbe907"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-1-3-Equations-and-Inequalities",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-1-3-Equations-and-Inequalities.mdx",
      "status": "draft",
      "sourceSha256": "62cce7d017b127acdb7ef9fc68bd1812b6584d29368b188efbd1cb1a47bbe907"
    }
  ]
},
{
  "id": "article.h2-maths-sequences-series",
  "englishSourcePath": "content/posts/H2-Maths-Notes-2-1-Sequences-and-Series.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-2-1-Sequences-and-Series",
      "sourcePath": "content/posts/H2-Maths-Notes-2-1-Sequences-and-Series.mdx",
      "status": "published",
      "sourceSha256": "a59a389fd88d65514e10fce41936277c12ab4ebda91cbd39726ac8f622e94f23"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-2-1-Sequences-and-Series",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-2-1-Sequences-and-Series.mdx",
      "status": "draft",
      "sourceSha256": "a59a389fd88d65514e10fce41936277c12ab4ebda91cbd39726ac8f622e94f23"
    }
  ]
},
{
  "id": "article.h2-maths-vectors",
  "englishSourcePath": "content/posts/H2-Maths-Notes-3-Vectors.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-3-Vectors",
      "sourcePath": "content/posts/H2-Maths-Notes-3-Vectors.mdx",
      "status": "published",
      "sourceSha256": "aaad20c7523160bbb424c029ecb60004a793e94c86cc48ae8119f231c58bf7c8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-3-Vectors",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-3-Vectors.mdx",
      "status": "draft",
      "sourceSha256": "aaad20c7523160bbb424c029ecb60004a793e94c86cc48ae8119f231c58bf7c8"
    }
  ]
},
{
  "id": "article.h2-maths-complex-numbers",
  "englishSourcePath": "content/posts/H2-Maths-Notes-4-Complex-Numbers.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-4-Complex-Numbers",
      "sourcePath": "content/posts/H2-Maths-Notes-4-Complex-Numbers.mdx",
      "status": "published",
      "sourceSha256": "71ffc71210418dd8914a5043ff4be132cd67a89db70d90eb6b54d720c9a63031"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-4-Complex-Numbers",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-4-Complex-Numbers.mdx",
      "status": "draft",
      "sourceSha256": "71ffc71210418dd8914a5043ff4be132cd67a89db70d90eb6b54d720c9a63031"
    }
  ]
},
{
  "id": "article.h2-maths-argand-diagrams",
  "englishSourcePath": "content/posts/H2-Maths-Notes-4-1-Complex-Numbers-Argand-Diagrams.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-4-1-Complex-Numbers-Argand-Diagrams",
      "sourcePath": "content/posts/H2-Maths-Notes-4-1-Complex-Numbers-Argand-Diagrams.mdx",
      "status": "published",
      "sourceSha256": "63909c67c3ebf176d7d1f3ff15f69a95fd44a323dc3d2c85fe166ad21e199042"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-4-1-Complex-Numbers-Argand-Diagrams",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-4-1-Complex-Numbers-Argand-Diagrams.mdx",
      "status": "draft",
      "sourceSha256": "63909c67c3ebf176d7d1f3ff15f69a95fd44a323dc3d2c85fe166ad21e199042"
    }
  ]
},
{
  "id": "article.h2-maths-calculus",
  "englishSourcePath": "content/posts/H2-Maths-Notes-5-Calculus.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-5-Calculus",
      "sourcePath": "content/posts/H2-Maths-Notes-5-Calculus.mdx",
      "status": "published",
      "sourceSha256": "e84cfc9fcd4a2088c3e74d6124d687abd2b8dcb3784028343386a3f285569788"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-5-Calculus",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-5-Calculus.mdx",
      "status": "draft",
      "sourceSha256": "e84cfc9fcd4a2088c3e74d6124d687abd2b8dcb3784028343386a3f285569788"
    }
  ]
},
{
  "id": "article.h2-maths-differentiation",
  "englishSourcePath": "content/posts/H2-Maths-Notes-5-1-Differentiation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-5-1-Differentiation",
      "sourcePath": "content/posts/H2-Maths-Notes-5-1-Differentiation.mdx",
      "status": "published",
      "sourceSha256": "55fb0d196e2875d8c09e22102933b774b44e7d2a007220d0e1caeb9e0194c93e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-5-1-Differentiation",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-5-1-Differentiation.mdx",
      "status": "draft",
      "sourceSha256": "55fb0d196e2875d8c09e22102933b774b44e7d2a007220d0e1caeb9e0194c93e"
    }
  ]
},
{
  "id": "article.h2-maths-maclaurin-series",
  "englishSourcePath": "content/posts/H2-Maths-Notes-5-2-Maclaurin-Series.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-5-2-Maclaurin-Series",
      "sourcePath": "content/posts/H2-Maths-Notes-5-2-Maclaurin-Series.mdx",
      "status": "published",
      "sourceSha256": "58520f6251776629f63f8e253bf1870444a31209ea8698a5b8f88ff05fb7de0b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-5-2-Maclaurin-Series",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-5-2-Maclaurin-Series.mdx",
      "status": "draft",
      "sourceSha256": "58520f6251776629f63f8e253bf1870444a31209ea8698a5b8f88ff05fb7de0b"
    }
  ]
},
{
  "id": "article.h2-maths-integration-techniques",
  "englishSourcePath": "content/posts/H2-Maths-Notes-5-3-Integration-Techniques.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-5-3-Integration-Techniques",
      "sourcePath": "content/posts/H2-Maths-Notes-5-3-Integration-Techniques.mdx",
      "status": "published",
      "sourceSha256": "f419bb5350fe982236e1f3c75624094940d5de6c39aba4c271c2331b744bbb4b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-5-3-Integration-Techniques",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-5-3-Integration-Techniques.mdx",
      "status": "draft",
      "sourceSha256": "f419bb5350fe982236e1f3c75624094940d5de6c39aba4c271c2331b744bbb4b"
    }
  ]
},
{
  "id": "article.h2-maths-definite-integrals",
  "englishSourcePath": "content/posts/H2-Maths-Notes-5-4-Definite-Integrals.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-5-4-Definite-Integrals",
      "sourcePath": "content/posts/H2-Maths-Notes-5-4-Definite-Integrals.mdx",
      "status": "published",
      "sourceSha256": "d07496c4af4025fca9b25b1569ce90f9e7becfd69292b89f7e09d9fbb6795a73"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-5-4-Definite-Integrals",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-5-4-Definite-Integrals.mdx",
      "status": "draft",
      "sourceSha256": "d07496c4af4025fca9b25b1569ce90f9e7becfd69292b89f7e09d9fbb6795a73"
    }
  ]
},
{
  "id": "article.h2-maths-differential-equations",
  "englishSourcePath": "content/posts/H2-Maths-Notes-5-5-Differential-Equations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-5-5-Differential-Equations",
      "sourcePath": "content/posts/H2-Maths-Notes-5-5-Differential-Equations.mdx",
      "status": "published",
      "sourceSha256": "0363403b4184ed78b7c99b97d88c9617d5ab94d3a1fbef7646128078e152143f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-5-5-Differential-Equations",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-5-5-Differential-Equations.mdx",
      "status": "draft",
      "sourceSha256": "0363403b4184ed78b7c99b97d88c9617d5ab94d3a1fbef7646128078e152143f"
    }
  ]
},
{
  "id": "article.h2-maths-probability",
  "englishSourcePath": "content/posts/H2-Maths-Notes-6-1-Probability.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-6-1-Probability",
      "sourcePath": "content/posts/H2-Maths-Notes-6-1-Probability.mdx",
      "status": "published",
      "sourceSha256": "1504022df108c5543e25bad4f6e43f75665f80e3035c150b71f8e59ab44dc79f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-6-1-Probability",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-6-1-Probability.mdx",
      "status": "draft",
      "sourceSha256": "1504022df108c5543e25bad4f6e43f75665f80e3035c150b71f8e59ab44dc79f"
    }
  ]
},
{
  "id": "article.h2-maths-discrete-rv",
  "englishSourcePath": "content/posts/H2-Maths-Notes-6-2-Discrete-Random-Variables.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-6-2-Discrete-Random-Variables",
      "sourcePath": "content/posts/H2-Maths-Notes-6-2-Discrete-Random-Variables.mdx",
      "status": "published",
      "sourceSha256": "a84e74efcf35f0da1da8c9fb173a7bd757665d6f2136bc93fa56ec0b576f3ceb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-6-2-Discrete-Random-Variables",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-6-2-Discrete-Random-Variables.mdx",
      "status": "draft",
      "sourceSha256": "a84e74efcf35f0da1da8c9fb173a7bd757665d6f2136bc93fa56ec0b576f3ceb"
    }
  ]
},
{
  "id": "article.h2-maths-normal-distribution",
  "englishSourcePath": "content/posts/H2-Maths-Notes-6-3-Normal-Distribution.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-6-3-Normal-Distribution",
      "sourcePath": "content/posts/H2-Maths-Notes-6-3-Normal-Distribution.mdx",
      "status": "published",
      "sourceSha256": "453c129f45b67a3ecc703f71275b9c2621e3230cd734db144134740f8e0500e3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-6-3-Normal-Distribution",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-6-3-Normal-Distribution.mdx",
      "status": "draft",
      "sourceSha256": "453c129f45b67a3ecc703f71275b9c2621e3230cd734db144134740f8e0500e3"
    }
  ]
},
{
  "id": "article.h2-maths-sampling",
  "englishSourcePath": "content/posts/H2-Maths-Notes-6-4-Sampling.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-6-4-Sampling",
      "sourcePath": "content/posts/H2-Maths-Notes-6-4-Sampling.mdx",
      "status": "published",
      "sourceSha256": "97c65bd6b1f15077d7fe7db5c3101fe28a2ec3d23e68ed96d09d5e1ee18f37f4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-6-4-Sampling",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-6-4-Sampling.mdx",
      "status": "draft",
      "sourceSha256": "97c65bd6b1f15077d7fe7db5c3101fe28a2ec3d23e68ed96d09d5e1ee18f37f4"
    }
  ]
},
{
  "id": "article.h2-maths-hypothesis-testing",
  "englishSourcePath": "content/posts/H2-Maths-Notes-6-5-Hypothesis-Testing.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-6-5-Hypothesis-Testing",
      "sourcePath": "content/posts/H2-Maths-Notes-6-5-Hypothesis-Testing.mdx",
      "status": "published",
      "sourceSha256": "2b959eaac1e16e05afa919d28bf9f2910fc83174a265bff606395630c5c7425c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-6-5-Hypothesis-Testing",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-6-5-Hypothesis-Testing.mdx",
      "status": "draft",
      "sourceSha256": "2b959eaac1e16e05afa919d28bf9f2910fc83174a265bff606395630c5c7425c"
    }
  ]
},
{
  "id": "article.h2-maths-correlation-regression",
  "englishSourcePath": "content/posts/H2-Maths-Notes-6-6-Correlation-and-Regression.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-6-6-Correlation-and-Regression",
      "sourcePath": "content/posts/H2-Maths-Notes-6-6-Correlation-and-Regression.mdx",
      "status": "published",
      "sourceSha256": "f3294993167634fc92859e40c3d6afbf05501b445f9ab83b59a5fcfc9fa41292"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-6-6-Correlation-and-Regression",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-6-6-Correlation-and-Regression.mdx",
      "status": "draft",
      "sourceSha256": "f3294993167634fc92859e40c3d6afbf05501b445f9ab83b59a5fcfc9fa41292"
    }
  ]
},
{
  "id": "article.h2-maths-pure-overview",
  "englishSourcePath": "content/posts/H2-Maths-Notes-00A-Section-A-Pure-Mathematics-Overview.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-00A-Section-A-Pure-Mathematics-Overview",
      "sourcePath": "content/posts/H2-Maths-Notes-00A-Section-A-Pure-Mathematics-Overview.mdx",
      "status": "published",
      "sourceSha256": "b685c79d6a6e3aae0ac1975ad1029b856f8e34cfea5586a50ec42e8f53674c54"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-00A-Section-A-Pure-Mathematics-Overview",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-00A-Section-A-Pure-Mathematics-Overview.mdx",
      "status": "draft",
      "sourceSha256": "b685c79d6a6e3aae0ac1975ad1029b856f8e34cfea5586a50ec42e8f53674c54"
    }
  ]
},
{
  "id": "article.h2-maths-stats-overview",
  "englishSourcePath": "content/posts/H2-Maths-Notes-00B-Section-B-Probability-and-Statistics-Overview.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-00B-Section-B-Probability-and-Statistics-Overview",
      "sourcePath": "content/posts/H2-Maths-Notes-00B-Section-B-Probability-and-Statistics-Overview.mdx",
      "status": "published",
      "sourceSha256": "37a4470dcaf0dbf72ab41487ef8e4b9c07c5e502e4f056e575bc600cd9b82c8e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-00B-Section-B-Probability-and-Statistics-Overview",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-00B-Section-B-Probability-and-Statistics-Overview.mdx",
      "status": "draft",
      "sourceSha256": "37a4470dcaf0dbf72ab41487ef8e4b9c07c5e502e4f056e575bc600cd9b82c8e"
    }
  ]
},
{
  "id": "article.h2-maths-functions-graphs",
  "englishSourcePath": "content/posts/H2-Maths-Notes-1-Functions-and-Graphs.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-1-Functions-and-Graphs",
      "sourcePath": "content/posts/H2-Maths-Notes-1-Functions-and-Graphs.mdx",
      "status": "published",
      "sourceSha256": "0ca64d4477ada2ac07b428b10697db3f333a1db61043dbde46f8240706166ecc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-1-Functions-and-Graphs",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-1-Functions-and-Graphs.mdx",
      "status": "draft",
      "sourceSha256": "0ca64d4477ada2ac07b428b10697db3f333a1db61043dbde46f8240706166ecc"
    }
  ]
},
{
  "id": "article.h2-maths-sequences-overview",
  "englishSourcePath": "content/posts/H2-Maths-Notes-2-Sequences-and-Series.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-2-Sequences-and-Series",
      "sourcePath": "content/posts/H2-Maths-Notes-2-Sequences-and-Series.mdx",
      "status": "published",
      "sourceSha256": "8fc421b390ac0b6927d04dd9fdfbd3408b4db870be7bfb0e359a09c09260640a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-2-Sequences-and-Series",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-2-Sequences-and-Series.mdx",
      "status": "draft",
      "sourceSha256": "8fc421b390ac0b6927d04dd9fdfbd3408b4db870be7bfb0e359a09c09260640a"
    }
  ]
},
{
  "id": "article.h2-maths-vector-properties",
  "englishSourcePath": "content/posts/H2-Maths-Notes-3-1-Basic-Vector-Properties.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-3-1-Basic-Vector-Properties",
      "sourcePath": "content/posts/H2-Maths-Notes-3-1-Basic-Vector-Properties.mdx",
      "status": "published",
      "sourceSha256": "a4a46454880ca90a1e970188bae28e92b5a4a9b63643eb1f2dc66dae97796cdf"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-3-1-Basic-Vector-Properties",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-3-1-Basic-Vector-Properties.mdx",
      "status": "draft",
      "sourceSha256": "a4a46454880ca90a1e970188bae28e92b5a4a9b63643eb1f2dc66dae97796cdf"
    }
  ]
},
{
  "id": "article.h2-maths-scalar-vector-products",
  "englishSourcePath": "content/posts/H2-Maths-Notes-3-2-Scalar-and-Vector-Products.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-3-2-Scalar-and-Vector-Products",
      "sourcePath": "content/posts/H2-Maths-Notes-3-2-Scalar-and-Vector-Products.mdx",
      "status": "published",
      "sourceSha256": "2e92948db91ef05fd7435579e72cba77abe0c251283a3854c251b5def344cf61"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-3-2-Scalar-and-Vector-Products",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-3-2-Scalar-and-Vector-Products.mdx",
      "status": "draft",
      "sourceSha256": "2e92948db91ef05fd7435579e72cba77abe0c251283a3854c251b5def344cf61"
    }
  ]
},
{
  "id": "article.h2-maths-vector-geometry",
  "englishSourcePath": "content/posts/H2-Maths-Notes-3-3-Three-Dimensional-Vector-Geometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-3-3-Three-Dimensional-Vector-Geometry",
      "sourcePath": "content/posts/H2-Maths-Notes-3-3-Three-Dimensional-Vector-Geometry.mdx",
      "status": "published",
      "sourceSha256": "7cdea5c215ad760d490cd3c4a00753b4e4f51a08a18001750e921438e7b71227"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-3-3-Three-Dimensional-Vector-Geometry",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-3-3-Three-Dimensional-Vector-Geometry.mdx",
      "status": "draft",
      "sourceSha256": "7cdea5c215ad760d490cd3c4a00753b4e4f51a08a18001750e921438e7b71227"
    }
  ]
},
{
  "id": "article.h2-maths-probability-statistics",
  "englishSourcePath": "content/posts/H2-Maths-Notes-6-Probability-and-Statistics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-Notes-6-Probability-and-Statistics",
      "sourcePath": "content/posts/H2-Maths-Notes-6-Probability-and-Statistics.mdx",
      "status": "published",
      "sourceSha256": "e85eb59a5d0ffe9006cbc036c04b89b3a11100f66d134db38d0a6319443b2f32"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-Notes-6-Probability-and-Statistics",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Notes-6-Probability-and-Statistics.mdx",
      "status": "draft",
      "sourceSha256": "e85eb59a5d0ffe9006cbc036c04b89b3a11100f66d134db38d0a6319443b2f32"
    }
  ]
},
{
  "id": "article.h2-maths-mf27",
  "englishSourcePath": "content/posts/H2-Maths-MF27-Formula-List-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/H2-Maths-MF27-Formula-List-2026",
      "sourcePath": "content/posts/H2-Maths-MF27-Formula-List-2026.mdx",
      "status": "published",
      "sourceSha256": "d7e725453e4b6a4d491feea878bc03a3616a6d3d56ba0849c81134c6a7e744b3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/H2-Maths-MF27-Formula-List-2026",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-MF27-Formula-List-2026.mdx",
      "status": "draft",
      "sourceSha256": "d7e725453e4b6a4d491feea878bc03a3616a6d3d56ba0849c81134c6a7e744b3"
    }
  ]
},
{
  "id": "article.h2-maths-physics-skills",
  "englishSourcePath": "content/posts/H2-Maths-Skills-You-Need-for-H2-Physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-physics-notes/H2-Maths-Skills-You-Need-for-H2-Physics",
      "sourcePath": "content/posts/H2-Maths-Skills-You-Need-for-H2-Physics.mdx",
      "status": "published",
      "sourceSha256": "85f7dc07dccb272f5298bbbe78f452c0729069b0a11e7755294df72fa16b0add"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-physics-notes/H2-Maths-Skills-You-Need-for-H2-Physics",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-Skills-You-Need-for-H2-Physics.mdx",
      "status": "draft",
      "sourceSha256": "85f7dc07dccb272f5298bbbe78f452c0729069b0a11e7755294df72fa16b0add"
    }
  ]
},
{
  "id": "article.h2-maths-ejc",
  "englishSourcePath": "content/posts/H2-Maths-at-EJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-maths-tuition/H2-Maths-at-EJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Maths-at-EJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "5a5b044653a1ba992f85b770ab3a02ef3948830b669bbf1f973db5ca02629aff"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-maths-tuition/H2-Maths-at-EJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-at-EJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "5a5b044653a1ba992f85b770ab3a02ef3948830b669bbf1f973db5ca02629aff"
    }
  ]
},
{
  "id": "article.h2-maths-jpjc",
  "englishSourcePath": "content/posts/H2-Maths-at-JPJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-maths-tuition/H2-Maths-at-JPJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Maths-at-JPJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "54ed962da355d97caeb99a308e1b90106f2bb547b31be13da7130b1c96a2e2e9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-maths-tuition/H2-Maths-at-JPJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-at-JPJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "54ed962da355d97caeb99a308e1b90106f2bb547b31be13da7130b1c96a2e2e9"
    }
  ]
},
{
  "id": "article.h2-maths-nyjc",
  "englishSourcePath": "content/posts/H2-Maths-at-NYJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-maths-tuition/H2-Maths-at-NYJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Maths-at-NYJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "b609e140dbb3cb49ab2adbeaa0a2d8a5a90aac723e1261826ab95c375992dc30"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-maths-tuition/H2-Maths-at-NYJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-at-NYJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "b609e140dbb3cb49ab2adbeaa0a2d8a5a90aac723e1261826ab95c375992dc30"
    }
  ]
},
{
  "id": "article.h2-maths-tmjc",
  "englishSourcePath": "content/posts/H2-Maths-at-TMJC-What-to-Expect.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-maths-tuition/H2-Maths-at-TMJC-What-to-Expect",
      "sourcePath": "content/posts/H2-Maths-at-TMJC-What-to-Expect.mdx",
      "status": "published",
      "sourceSha256": "b261c6ecbfec1eea27fd88e7bee773c73fbf92788f0a93a1893674ad9df28495"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-maths-tuition/H2-Maths-at-TMJC-What-to-Expect",
      "sourcePath": "content/translations/zh-Hans/H2-Maths-at-TMJC-What-to-Expect.mdx",
      "status": "draft",
      "sourceSha256": "b261c6ecbfec1eea27fd88e7bee773c73fbf92788f0a93a1893674ad9df28495"
    }
  ]
},
{
  "id": "article.four-h2-choice",
  "englishSourcePath": "content/posts/4H2-vs-3H2-1H1-Which-Is-Better-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/4H2-vs-3H2-1H1-Which-Is-Better-2026",
      "sourcePath": "content/posts/4H2-vs-3H2-1H1-Which-Is-Better-2026.mdx",
      "status": "published",
      "sourceSha256": "43b3a0ac2e21ba4ac28e8c216a6014a9566e8a846c7db9429c36ed0f9b936cda"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/4H2-vs-3H2-1H1-Which-Is-Better-2026",
      "sourcePath": "content/translations/zh-Hans/4H2-vs-3H2-1H1-Which-Is-Better-2026.mdx",
      "status": "draft",
      "sourceSha256": "43b3a0ac2e21ba4ac28e8c216a6014a9566e8a846c7db9429c36ed0f9b936cda"
    }
  ]
},
{
  "id": "article.h2-maths-syllabus",
  "englishSourcePath": "content/posts/A-Level-Mathematics-Syllabus-2026-27.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/A-Level-Mathematics-Syllabus-2026-27",
      "sourcePath": "content/posts/A-Level-Mathematics-Syllabus-2026-27.mdx",
      "status": "published",
      "sourceSha256": "2c7754d0d90e8afae485fd379a11701b8fc3f81f2b29250bd5c45f40465d7153"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/A-Level-Mathematics-Syllabus-2026-27",
      "sourcePath": "content/translations/zh-Hans/A-Level-Mathematics-Syllabus-2026-27.mdx",
      "status": "draft",
      "sourceSha256": "2c7754d0d90e8afae485fd379a11701b8fc3f81f2b29250bd5c45f40465d7153"
    }
  ]
},
{
  "id": "article.h2-maths-university-decision",
  "englishSourcePath": "content/posts/Do-You-Need-H2-Math-for-University-in-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Do-You-Need-H2-Math-for-University-in-Singapore-2026",
      "sourcePath": "content/posts/Do-You-Need-H2-Math-for-University-in-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "a375780b4f6321c7879236a03293122aff7afca0ffe23ac66e4e3afee3f98cad"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Do-You-Need-H2-Math-for-University-in-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/Do-You-Need-H2-Math-for-University-in-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "a375780b4f6321c7879236a03293122aff7afca0ffe23ac66e4e3afee3f98cad"
    }
  ]
},
{
  "id": "article.university-bridging",
  "englishSourcePath": "content/posts/Bridging-Modules-in-Singapore-Universities-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Bridging-Modules-in-Singapore-Universities-2026",
      "sourcePath": "content/posts/Bridging-Modules-in-Singapore-Universities-2026.mdx",
      "status": "published",
      "sourceSha256": "ac2f5a660868eb56928fd8aa7bb17badba73531ae0914d69979a0af6dfdfb57b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Bridging-Modules-in-Singapore-Universities-2026",
      "sourcePath": "content/translations/zh-Hans/Bridging-Modules-in-Singapore-Universities-2026.mdx",
      "status": "draft",
      "sourceSha256": "ac2f5a660868eb56928fd8aa7bb17badba73531ae0914d69979a0af6dfdfb57b"
    }
  ]
},
{
  "id": "article.university-mtl",
  "englishSourcePath": "content/posts/MTL-Requirement-for-University-Admission-in-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/MTL-Requirement-for-University-Admission-in-Singapore-2026",
      "sourcePath": "content/posts/MTL-Requirement-for-University-Admission-in-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "a0a63d9b29e3d3dbf12d284ef668f6ee307df4e4933eb29afc874cfd4a5f63ed"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/MTL-Requirement-for-University-Admission-in-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/MTL-Requirement-for-University-Admission-in-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "a0a63d9b29e3d3dbf12d284ef668f6ee307df4e4933eb29afc874cfd4a5f63ed"
    }
  ]
},
{
  "id": "article.university-prerequisites",
  "englishSourcePath": "content/posts/Singapore-University-Subject-Prerequisites-and-Subject-Planning-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-University-Subject-Prerequisites-and-Subject-Planning-Guide-2026",
      "sourcePath": "content/posts/Singapore-University-Subject-Prerequisites-and-Subject-Planning-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "8d913836c302e0c38f8025b666420e2aef2061453e5a56c38a85924afa7f2ae7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-University-Subject-Prerequisites-and-Subject-Planning-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Singapore-University-Subject-Prerequisites-and-Subject-Planning-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "8d913836c302e0c38f8025b666420e2aef2061453e5a56c38a85924afa7f2ae7"
    }
  ]
},
{
  "id": "article.university-nus-ma1301",
  "englishSourcePath": "content/posts/NUS-No-H2-Maths-MA1301-and-Proficiency-Test-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/NUS-No-H2-Maths-MA1301-and-Proficiency-Test-Guide-2026",
      "sourcePath": "content/posts/NUS-No-H2-Maths-MA1301-and-Proficiency-Test-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "68b1a812105db165058cdaf3cef3d3c67d3803e1134e29be8f1b3f53d5829e73"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/NUS-No-H2-Maths-MA1301-and-Proficiency-Test-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/NUS-No-H2-Maths-MA1301-and-Proficiency-Test-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "68b1a812105db165058cdaf3cef3d3c67d3803e1134e29be8f1b3f53d5829e73"
    }
  ]
},
{
  "id": "article.university-ib",
  "englishSourcePath": "content/posts/IB-Subject-Planning-for-Singapore-Universities-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/IB-Subject-Planning-for-Singapore-Universities-2026",
      "sourcePath": "content/posts/IB-Subject-Planning-for-Singapore-Universities-2026.mdx",
      "status": "published",
      "sourceSha256": "36597d6252765a0a1ec41cd9a5eee926961495c56eec16e67f7e699c7e179759"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/IB-Subject-Planning-for-Singapore-Universities-2026",
      "sourcePath": "content/translations/zh-Hans/IB-Subject-Planning-for-Singapore-Universities-2026.mdx",
      "status": "draft",
      "sourceSha256": "36597d6252765a0a1ec41cd9a5eee926961495c56eec16e67f7e699c7e179759"
    }
  ]
},
{
  "id": "article.university-polytechnic",
  "englishSourcePath": "content/posts/Polytechnic-to-University-Programme-Prerequisites-and-Planning-Guide-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Polytechnic-to-University-Programme-Prerequisites-and-Planning-Guide-Singapore-2026",
      "sourcePath": "content/posts/Polytechnic-to-University-Programme-Prerequisites-and-Planning-Guide-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "a01743472e29b56e47a1e6fd2ee395efacee9fe21dfef0cd2157e82e7275719a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Polytechnic-to-University-Programme-Prerequisites-and-Planning-Guide-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/Polytechnic-to-University-Programme-Prerequisites-and-Planning-Guide-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "a01743472e29b56e47a1e6fd2ee395efacee9fe21dfef0cd2157e82e7275719a"
    }
  ]
},
{
  "id": "article.university-aba",
  "englishSourcePath": "content/posts/Aptitude-Based-Admissions-ABA-Singapore-Universities-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Aptitude-Based-Admissions-ABA-Singapore-Universities-2026",
      "sourcePath": "content/posts/Aptitude-Based-Admissions-ABA-Singapore-Universities-2026.mdx",
      "status": "published",
      "sourceSha256": "6a8ba489e3467fb67860ad6e61e91055e436abb47e3fe03d8d2ba2bd555b8949"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Aptitude-Based-Admissions-ABA-Singapore-Universities-2026",
      "sourcePath": "content/translations/zh-Hans/Aptitude-Based-Admissions-ABA-Singapore-Universities-2026.mdx",
      "status": "draft",
      "sourceSha256": "6a8ba489e3467fb67860ad6e61e91055e436abb47e3fe03d8d2ba2bd555b8949"
    }
  ]
},
{
  "id": "article.university-computing",
  "englishSourcePath": "content/posts/Computer-Science-Data-Science-and-AI-Singapore-University-Subject-Planning-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Computer-Science-Data-Science-and-AI-Singapore-University-Subject-Planning-Guide-2026",
      "sourcePath": "content/posts/Computer-Science-Data-Science-and-AI-Singapore-University-Subject-Planning-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "3bf5cf0eab35cc8fff8005fbd2143c2c1683c376875279bbd7f02017792b1aca"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Computer-Science-Data-Science-and-AI-Singapore-University-Subject-Planning-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Computer-Science-Data-Science-and-AI-Singapore-University-Subject-Planning-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "3bf5cf0eab35cc8fff8005fbd2143c2c1683c376875279bbd7f02017792b1aca"
    }
  ]
},
{
  "id": "article.university-engineering",
  "englishSourcePath": "content/posts/Engineering-Singapore-University-Subject-Planning-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Engineering-Singapore-University-Subject-Planning-Guide-2026",
      "sourcePath": "content/posts/Engineering-Singapore-University-Subject-Planning-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "a2729b18f60527064400d1ff6db79ae8c68981f70bce0fbdebd0cd7f2a8c9055"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Engineering-Singapore-University-Subject-Planning-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Engineering-Singapore-University-Subject-Planning-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "a2729b18f60527064400d1ff6db79ae8c68981f70bce0fbdebd0cd7f2a8c9055"
    }
  ]
}
,
{
  "id": "article.university-medicine",
  "englishSourcePath": "content/posts/Medicine-and-Health-Degrees-Singapore-University-Subject-Planning-Guide-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Medicine-and-Health-Degrees-Singapore-University-Subject-Planning-Guide-2026",
      "sourcePath": "content/posts/Medicine-and-Health-Degrees-Singapore-University-Subject-Planning-Guide-2026.mdx",
      "status": "published",
      "sourceSha256": "2f1cc152393daf9ff03411cac038fc63401481fa4ed554d83db7bb0523d9d265"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Medicine-and-Health-Degrees-Singapore-University-Subject-Planning-Guide-2026",
      "sourcePath": "content/translations/zh-Hans/Medicine-and-Health-Degrees-Singapore-University-Subject-Planning-Guide-2026.mdx",
      "status": "draft",
      "sourceSha256": "2f1cc152393daf9ff03411cac038fc63401481fa4ed554d83db7bb0523d9d265"
    }
  ]
}
,
{
  "id": "article.university-personal-statement",
  "englishSourcePath": "content/posts/University-Personal-Statement-Mistakes-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/University-Personal-Statement-Mistakes-Singapore-2026",
      "sourcePath": "content/posts/University-Personal-Statement-Mistakes-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "48a024580e470adb9b2a8ceeaf1f885548b68728e0e6aef11720dcc17f2accc2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/University-Personal-Statement-Mistakes-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/University-Personal-Statement-Mistakes-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "48a024580e470adb9b2a8ceeaf1f885548b68728e0e6aef11720dcc17f2accc2"
    }
  ]
}
,
{
  "id": "article.university-appeals",
  "englishSourcePath": "content/posts/How-to-Appeal-University-Rejection-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/How-to-Appeal-University-Rejection-Singapore-2026",
      "sourcePath": "content/posts/How-to-Appeal-University-Rejection-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "d1243a8176c0add3b2751d7ec235dd456d7ad943d27cdd40b4496765da27a61c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/How-to-Appeal-University-Rejection-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/How-to-Appeal-University-Rejection-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "d1243a8176c0add3b2751d7ec235dd456d7ad943d27cdd40b4496765da27a61c"
    }
  ]
}
,
{
  "id": "article.university-interviews",
  "englishSourcePath": "content/posts/NUS-NTU-SMU-University-Interview-Tips-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/NUS-NTU-SMU-University-Interview-Tips-Singapore-2026",
      "sourcePath": "content/posts/NUS-NTU-SMU-University-Interview-Tips-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "b06b6adebc31df8c27746d14c1f623fff6818aeffc4abb71188c893d8d2afbbc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/NUS-NTU-SMU-University-Interview-Tips-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/NUS-NTU-SMU-University-Interview-Tips-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "b06b6adebc31df8c27746d14c1f623fff6818aeffc4abb71188c893d8d2afbbc"
    }
  ]
}
,
{
  "id": "article.university-cca",
  "englishSourcePath": "content/posts/CCA-University-Applications-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/CCA-University-Applications-Singapore-2026",
      "sourcePath": "content/posts/CCA-University-Applications-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "5a557abf7d89a13ed3d46c24fc6750b165780713caa0e8dba5cb696b1b40103e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/CCA-University-Applications-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/CCA-University-Applications-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "5a557abf7d89a13ed3d46c24fc6750b165780713caa0e8dba5cb696b1b40103e"
    }
  ]
}
,
{
  "id": "article.university-ns-timeline",
  "englishSourcePath": "content/posts/NS-University-Application-Timeline-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/NS-University-Application-Timeline-Singapore-2026",
      "sourcePath": "content/posts/NS-University-Application-Timeline-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "411d337855ec30399814ec7c8fbc2a997f01492d651754d0cff387ef28bc0a3b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/NS-University-Application-Timeline-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/NS-University-Application-Timeline-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "411d337855ec30399814ec7c8fbc2a997f01492d651754d0cff387ef28bc0a3b"
    }
  ]
}
,
{
  "id": "article.university-ns-study",
  "englishSourcePath": "content/posts/Staying-Academically-Sharp-During-NS-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Staying-Academically-Sharp-During-NS-Singapore-2026",
      "sourcePath": "content/posts/Staying-Academically-Sharp-During-NS-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "8ded4797e3981a9d608b71c688bd14671231d6ee37eb80ffc0511abbd72e3430"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Staying-Academically-Sharp-During-NS-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/Staying-Academically-Sharp-During-NS-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "8ded4797e3981a9d608b71c688bd14671231d6ee37eb80ffc0511abbd72e3430"
    }
  ]
}
,
{
  "id": "article.university-backward-planning",
  "englishSourcePath": "content/posts/Backward-Planning-JC-Subjects-for-University-Course-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Backward-Planning-JC-Subjects-for-University-Course-Singapore-2026",
      "sourcePath": "content/posts/Backward-Planning-JC-Subjects-for-University-Course-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "23da350b889fbe873b2fd5daf67bd8df7a4c728a403858c4a569f065e9a3c4bf"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Backward-Planning-JC-Subjects-for-University-Course-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/Backward-Planning-JC-Subjects-for-University-Course-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "23da350b889fbe873b2fd5daf67bd8df7a4c728a403858c4a569f065e9a3c4bf"
    }
  ]
}
,
{
  "id": "article.university-polytechnic-gpa",
  "englishSourcePath": "content/posts/Polytechnic-to-University-GPA-Guide-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Polytechnic-to-University-GPA-Guide-Singapore-2026",
      "sourcePath": "content/posts/Polytechnic-to-University-GPA-Guide-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "60be4b0110bbd283eab6214c10da8ce56a132ad96e99b20892afa187bbf19859"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Polytechnic-to-University-GPA-Guide-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/Polytechnic-to-University-GPA-Guide-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "60be4b0110bbd283eab6214c10da8ce56a132ad96e99b20892afa187bbf19859"
    }
  ]
}
,
{
  "id": "article.university-private-degrees",
  "englishSourcePath": "content/posts/Private-University-Degrees-Singapore-SIM-Kaplan-PSB-MDIS-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Private-University-Degrees-Singapore-SIM-Kaplan-PSB-MDIS-2026",
      "sourcePath": "content/posts/Private-University-Degrees-Singapore-SIM-Kaplan-PSB-MDIS-2026.mdx",
      "status": "published",
      "sourceSha256": "be3a4eb5a71c5bc26e1be02d3c83f7d190439e7e5d4c630b72b9cf8812f82422"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Private-University-Degrees-Singapore-SIM-Kaplan-PSB-MDIS-2026",
      "sourcePath": "content/translations/zh-Hans/Private-University-Degrees-Singapore-SIM-Kaplan-PSB-MDIS-2026.mdx",
      "status": "draft",
      "sourceSha256": "be3a4eb5a71c5bc26e1be02d3c83f7d190439e7e5d4c630b72b9cf8812f82422"
    }
  ]
}
,
{
  "id": "article.university-bursary-comparison",
  "englishSourcePath": "content/posts/University-Bursary-Singapore-Comparison-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/bursaries/University-Bursary-Singapore-Comparison-2026",
      "sourcePath": "content/posts/University-Bursary-Singapore-Comparison-2026.mdx",
      "status": "published",
      "sourceSha256": "4edc61ba2f9cc3c586e6188e404c07d0eb709c77d0e1b4c6054c3b14b9f1106c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/bursaries/University-Bursary-Singapore-Comparison-2026",
      "sourcePath": "content/translations/zh-Hans/University-Bursary-Singapore-Comparison-2026.mdx",
      "status": "draft",
      "sourceSha256": "4edc61ba2f9cc3c586e6188e404c07d0eb709c77d0e1b4c6054c3b14b9f1106c"
    }
  ]
}
,
{
  "id": "article.university-bursary-deadlines",
  "englishSourcePath": "content/posts/University-Bursary-Application-Deadlines-Singapore-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/bursaries/University-Bursary-Application-Deadlines-Singapore-2026",
      "sourcePath": "content/posts/University-Bursary-Application-Deadlines-Singapore-2026.mdx",
      "status": "published",
      "sourceSha256": "71aa05030a43b41f91086eafa7f91a2667d0ccc4c661e06b3f68838cf5cd7de4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/bursaries/University-Bursary-Application-Deadlines-Singapore-2026",
      "sourcePath": "content/translations/zh-Hans/University-Bursary-Application-Deadlines-Singapore-2026.mdx",
      "status": "draft",
      "sourceSha256": "71aa05030a43b41f91086eafa7f91a2667d0ccc4c661e06b3f68838cf5cd7de4"
    }
  ]
}
,
{
  "id": "article.lbkm-university-bursary",
  "englishSourcePath": "content/posts/LBKM-University-Bursary-Profile.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/bursaries/LBKM-University-Bursary-Profile",
      "sourcePath": "content/posts/LBKM-University-Bursary-Profile.mdx",
      "status": "published",
      "sourceSha256": "f0463f5c22ae90f336cb8f92f008be1a1fb04a634aa2746e0dfb35cfefd51f2f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/bursaries/LBKM-University-Bursary-Profile",
      "sourcePath": "content/translations/zh-Hans/LBKM-University-Bursary-Profile.mdx",
      "status": "draft",
      "sourceSha256": "f0463f5c22ae90f336cb8f92f008be1a1fb04a634aa2746e0dfb35cfefd51f2f"
    }
  ]
}
,
{
  "id": "article.mtfa-university-bursary",
  "englishSourcePath": "content/posts/MTFA-Bursary-University-Bursary-Profile.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/bursaries/MTFA-Bursary-University-Bursary-Profile",
      "sourcePath": "content/posts/MTFA-Bursary-University-Bursary-Profile.mdx",
      "status": "published",
      "sourceSha256": "6ea7402695f61c049c6ad0aa115aafda3fa8909625afe82acabca021a4f1397d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/bursaries/MTFA-Bursary-University-Bursary-Profile",
      "sourcePath": "content/translations/zh-Hans/MTFA-Bursary-University-Bursary-Profile.mdx",
      "status": "draft",
      "sourceSha256": "6ea7402695f61c049c6ad0aa115aafda3fa8909625afe82acabca021a4f1397d"
    }
  ]
}
,
{
  "id": "article.ntu-usp-scholarship",
  "englishSourcePath": "content/posts/NTU-University-Scholars-Programme-Scholarship-Profile.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/scholarships/NTU-University-Scholars-Programme-Scholarship-Profile",
      "sourcePath": "content/posts/NTU-University-Scholars-Programme-Scholarship-Profile.mdx",
      "status": "published",
      "sourceSha256": "7321795f08f789ce03788dc4cbf1f621e29ae4802ae0c1fbedf9bfe56bc1f8ea"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/scholarships/NTU-University-Scholars-Programme-Scholarship-Profile",
      "sourcePath": "content/translations/zh-Hans/NTU-University-Scholars-Programme-Scholarship-Profile.mdx",
      "status": "draft",
      "sourceSha256": "7321795f08f789ce03788dc4cbf1f621e29ae4802ae0c1fbedf9bfe56bc1f8ea"
    }
  ]
}
,
{
  "id": "article.sec3-ammeter-voltmeter-wiring",
  "englishSourcePath": "content/posts/How-to-Connect-Ammeter-Voltmeter-Sec-3-Physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/How-to-Connect-Ammeter-Voltmeter-Sec-3-Physics",
      "sourcePath": "content/posts/How-to-Connect-Ammeter-Voltmeter-Sec-3-Physics.mdx",
      "status": "published",
      "sourceSha256": "76517cf28a5bb958da1801bc3d19315e7fe2db7380f0fb84b52e06a60eb85062"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/How-to-Connect-Ammeter-Voltmeter-Sec-3-Physics",
      "sourcePath": "content/translations/zh-Hans/How-to-Connect-Ammeter-Voltmeter-Sec-3-Physics.mdx",
      "status": "draft",
      "sourceSha256": "76517cf28a5bb958da1801bc3d19315e7fe2db7380f0fb84b52e06a60eb85062"
    }
  ]
}
,
{
  "id": "article.o-level-ammeter-voltmeter-wiring",
  "englishSourcePath": "content/posts/How-to-Connect-Ammeter-Voltmeter-Circuit-O-Level-Physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/How-to-Connect-Ammeter-Voltmeter-Circuit-O-Level-Physics",
      "sourcePath": "content/posts/How-to-Connect-Ammeter-Voltmeter-Circuit-O-Level-Physics.mdx",
      "status": "published",
      "sourceSha256": "4d713dbb31fbfaac9f01befc0019adba06c308879d2e8cd8f33bd169042bcd75"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/How-to-Connect-Ammeter-Voltmeter-Circuit-O-Level-Physics",
      "sourcePath": "content/translations/zh-Hans/How-to-Connect-Ammeter-Voltmeter-Circuit-O-Level-Physics.mdx",
      "status": "draft",
      "sourceSha256": "4d713dbb31fbfaac9f01befc0019adba06c308879d2e8cd8f33bd169042bcd75"
    }
  ]
}
,
{
  "id": "article.o-level-wire-resistance",
  "englishSourcePath": "content/posts/Resistance-of-Wire-Experiment-O-Level-Physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/Resistance-of-Wire-Experiment-O-Level-Physics",
      "sourcePath": "content/posts/Resistance-of-Wire-Experiment-O-Level-Physics.mdx",
      "status": "published",
      "sourceSha256": "1d614b9a87616cdeea1cd6a53ee8652bce7846814e8b72a367122f1e046e3db4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/Resistance-of-Wire-Experiment-O-Level-Physics",
      "sourcePath": "content/translations/zh-Hans/Resistance-of-Wire-Experiment-O-Level-Physics.mdx",
      "status": "draft",
      "sourceSha256": "1d614b9a87616cdeea1cd6a53ee8652bce7846814e8b72a367122f1e046e3db4"
    }
  ]
}
,
{
  "id": "article.singapore-physics-league",
  "englishSourcePath": "content/posts/Singapore-Physics-League-SPhL.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Singapore-Physics-League-SPhL",
      "sourcePath": "content/posts/Singapore-Physics-League-SPhL.mdx",
      "status": "published",
      "sourceSha256": "a7cde064be3a39e08cb80522b4789948d9313960bdf4a648b9e911c9337e3fe5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Singapore-Physics-League-SPhL",
      "sourcePath": "content/translations/zh-Hans/Singapore-Physics-League-SPhL.mdx",
      "status": "draft",
      "sourceSha256": "a7cde064be3a39e08cb80522b4789948d9313960bdf4a648b9e911c9337e3fe5"
    }
  ]
}
,
{
  "id": "article.regeneron-science-talent-search",
  "englishSourcePath": "content/posts/Regeneron-Science-Talent-Search.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Regeneron-Science-Talent-Search",
      "sourcePath": "content/posts/Regeneron-Science-Talent-Search.mdx",
      "status": "published",
      "sourceSha256": "05551f52198274bee88e056b7c488ea0c1469fa1f5202860461fda2836da72a2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Regeneron-Science-Talent-Search",
      "sourcePath": "content/translations/zh-Hans/Regeneron-Science-Talent-Search.mdx",
      "status": "draft",
      "sourceSha256": "05551f52198274bee88e056b7c488ea0c1469fa1f5202860461fda2836da72a2"
    }
  ]
}
,
{
  "id": "article.sjpo-results-2026",
  "englishSourcePath": "content/posts/SJPO-Results-2026-When-How-to-Check.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/SJPO-Results-2026-When-How-to-Check",
      "sourcePath": "content/posts/SJPO-Results-2026-When-How-to-Check.mdx",
      "status": "published",
      "sourceSha256": "e832064fb61e3ab2b0f64434f61b957788c9faa793b5547148fd6601d61f07fd"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/SJPO-Results-2026-When-How-to-Check",
      "sourcePath": "content/translations/zh-Hans/SJPO-Results-2026-When-How-to-Check.mdx",
      "status": "draft",
      "sourceSha256": "e832064fb61e3ab2b0f64434f61b957788c9faa793b5547148fd6601d61f07fd"
    }
  ]
},
{
  "id": "article.lab-balances",
  "englishSourcePath": "content/posts/Lab-Balances-Mass-Handling.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Balances-Mass-Handling",
      "sourcePath": "content/posts/Lab-Balances-Mass-Handling.mdx",
      "status": "published",
      "sourceSha256": "9bd9616b83a2a0f7ab2301ff60344cc692324d13815382ec333b379106cbeb8b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Balances-Mass-Handling",
      "sourcePath": "content/translations/zh-Hans/Lab-Balances-Mass-Handling.mdx",
      "status": "draft",
      "sourceSha256": "9bd9616b83a2a0f7ab2301ff60344cc692324d13815382ec333b379106cbeb8b"
    }
  ]
},
{
  "id": "article.lab-amylase-starch-solutions",
  "englishSourcePath": "content/posts/Lab-Amylase-Starch-Solutions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Amylase-Starch-Solutions",
      "sourcePath": "content/posts/Lab-Amylase-Starch-Solutions.mdx",
      "status": "published",
      "sourceSha256": "682d7f65594e52d42f261df01f5fab2f737cafcbca2f297714df93b5f565d7b8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Amylase-Starch-Solutions",
      "sourcePath": "content/translations/zh-Hans/Lab-Amylase-Starch-Solutions.mdx",
      "status": "draft",
      "sourceSha256": "682d7f65594e52d42f261df01f5fab2f737cafcbca2f297714df93b5f565d7b8"
    }
  ]
},
{
  "id": "article.lab-aquatic-plants",
  "englishSourcePath": "content/posts/Lab-Aquatic-Plants-Cabomba-Elodea.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Aquatic-Plants-Cabomba-Elodea",
      "sourcePath": "content/posts/Lab-Aquatic-Plants-Cabomba-Elodea.mdx",
      "status": "published",
      "sourceSha256": "e069f58358d29771e79b6eef349d80dffac5ad325e702def8532aae4d7ecd58f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Aquatic-Plants-Cabomba-Elodea",
      "sourcePath": "content/translations/zh-Hans/Lab-Aquatic-Plants-Cabomba-Elodea.mdx",
      "status": "draft",
      "sourceSha256": "e069f58358d29771e79b6eef349d80dffac5ad325e702def8532aae4d7ecd58f"
    }
  ]
},
{
  "id": "article.lab-buffer-solutions",
  "englishSourcePath": "content/posts/Lab-Buffer-Solutions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Buffer-Solutions",
      "sourcePath": "content/posts/Lab-Buffer-Solutions.mdx",
      "status": "published",
      "sourceSha256": "829e63141b98e61aee5c454ab37933afed4245e08aa6502d5007fd6e9c77991e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Buffer-Solutions",
      "sourcePath": "content/translations/zh-Hans/Lab-Buffer-Solutions.mdx",
      "status": "draft",
      "sourceSha256": "829e63141b98e61aee5c454ab37933afed4245e08aa6502d5007fd6e9c77991e"
    }
  ]
},
{
  "id": "article.lab-filtration-materials",
  "englishSourcePath": "content/posts/Lab-Filter-Funnels-Paper-Pouring-Rods.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Filter-Funnels-Paper-Pouring-Rods",
      "sourcePath": "content/posts/Lab-Filter-Funnels-Paper-Pouring-Rods.mdx",
      "status": "published",
      "sourceSha256": "d60f8a100a4ed8ea971da5c10c81fc0aef5653d5c3b27c07d190e9d02835484c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Filter-Funnels-Paper-Pouring-Rods",
      "sourcePath": "content/translations/zh-Hans/Lab-Filter-Funnels-Paper-Pouring-Rods.mdx",
      "status": "draft",
      "sourceSha256": "d60f8a100a4ed8ea971da5c10c81fc0aef5653d5c3b27c07d190e9d02835484c"
    }
  ]
},
{
  "id": "article.lab-condensers",
  "englishSourcePath": "content/posts/Lab-Condensers-Cooling-Connections.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Condensers-Cooling-Connections",
      "sourcePath": "content/posts/Lab-Condensers-Cooling-Connections.mdx",
      "status": "published",
      "sourceSha256": "46d85dd2fdd116c054068c9727e5dc6ac4b9d5db1e57dac483ddcecdd9633f0a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Condensers-Cooling-Connections",
      "sourcePath": "content/translations/zh-Hans/Lab-Condensers-Cooling-Connections.mdx",
      "status": "draft",
      "sourceSha256": "46d85dd2fdd116c054068c9727e5dc6ac4b9d5db1e57dac483ddcecdd9633f0a"
    }
  ]
},
{
  "id": "article.lab-heated-flasks",
  "englishSourcePath": "content/posts/Lab-Flasks-Heat-Sources-Boiling-Granules.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Flasks-Heat-Sources-Boiling-Granules",
      "sourcePath": "content/posts/Lab-Flasks-Heat-Sources-Boiling-Granules.mdx",
      "status": "published",
      "sourceSha256": "6bdb1bab910489650a9aa0dcf78a1fee9fd7b1c99194ea39fd102b7d207a5632"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Flasks-Heat-Sources-Boiling-Granules",
      "sourcePath": "content/translations/zh-Hans/Lab-Flasks-Heat-Sources-Boiling-Granules.mdx",
      "status": "draft",
      "sourceSha256": "6bdb1bab910489650a9aa0dcf78a1fee9fd7b1c99194ea39fd102b7d207a5632"
    }
  ]
},
{
  "id": "article.lab-germinating-seeds",
  "englishSourcePath": "content/posts/Lab-Germinating-Seeds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Germinating-Seeds",
      "sourcePath": "content/posts/Lab-Germinating-Seeds.mdx",
      "status": "published",
      "sourceSha256": "966c6702e7f491f23885dccd9c28971e867e18299fedfdfb131c043c8772ac0b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Germinating-Seeds",
      "sourcePath": "content/translations/zh-Hans/Lab-Germinating-Seeds.mdx",
      "status": "draft",
      "sourceSha256": "966c6702e7f491f23885dccd9c28971e867e18299fedfdfb131c043c8772ac0b"
    }
  ]
},
{
  "id": "article.lab-laminas-plumb-lines",
  "englishSourcePath": "content/posts/Lab-Laminas-Plumb-Lines-Thread.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Laminas-Plumb-Lines-Thread",
      "sourcePath": "content/posts/Lab-Laminas-Plumb-Lines-Thread.mdx",
      "status": "published",
      "sourceSha256": "1c23fe3a8875d2f6dd9e8b433c880f3650bb20adef829214864c9109dfabae06"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Laminas-Plumb-Lines-Thread",
      "sourcePath": "content/translations/zh-Hans/Lab-Laminas-Plumb-Lines-Thread.mdx",
      "status": "draft",
      "sourceSha256": "1c23fe3a8875d2f6dd9e8b433c880f3650bb20adef829214864c9109dfabae06"
    }
  ]
},
{
  "id": "article.lab-rulers-protractors",
  "englishSourcePath": "content/posts/Lab-Rulers-Protractors.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Rulers-Protractors",
      "sourcePath": "content/posts/Lab-Rulers-Protractors.mdx",
      "status": "published",
      "sourceSha256": "3dec4f52c762f62088671a10122475a1ae3d01c4f036bdb2f0f8b6faf75416bf"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Rulers-Protractors",
      "sourcePath": "content/translations/zh-Hans/Lab-Rulers-Protractors.mdx",
      "status": "draft",
      "sourceSha256": "3dec4f52c762f62088671a10122475a1ae3d01c4f036bdb2f0f8b6faf75416bf"
    }
  ]
},
{
  "id": "article.lab-ray-boxes-plane-mirrors",
  "englishSourcePath": "content/posts/Lab-Ray-Boxes-Plane-Mirrors.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Ray-Boxes-Plane-Mirrors",
      "sourcePath": "content/posts/Lab-Ray-Boxes-Plane-Mirrors.mdx",
      "status": "published",
      "sourceSha256": "341218312cf6710a3314cac82bb12e78a70179dc0667e91640b8de68aaf22757"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Ray-Boxes-Plane-Mirrors",
      "sourcePath": "content/translations/zh-Hans/Lab-Ray-Boxes-Plane-Mirrors.mdx",
      "status": "draft",
      "sourceSha256": "341218312cf6710a3314cac82bb12e78a70179dc0667e91640b8de68aaf22757"
    }
  ]
},
{
  "id": "article.lab-spotting-tiles",
  "englishSourcePath": "content/posts/Lab-Spotting-Tiles.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Spotting-Tiles",
      "sourcePath": "content/posts/Lab-Spotting-Tiles.mdx",
      "status": "published",
      "sourceSha256": "f43e8889774052689b5bb532f887f417c70e38ab2bc54614ebfa7839a962d085"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Spotting-Tiles",
      "sourcePath": "content/translations/zh-Hans/Lab-Spotting-Tiles.mdx",
      "status": "draft",
      "sourceSha256": "f43e8889774052689b5bb532f887f417c70e38ab2bc54614ebfa7839a962d085"
    }
  ]
},
{
  "id": "article.lab-test-tubes-racks",
  "englishSourcePath": "content/posts/Lab-Test-Tubes-Racks-Receiving-Vessels.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Test-Tubes-Racks-Receiving-Vessels",
      "sourcePath": "content/posts/Lab-Test-Tubes-Racks-Receiving-Vessels.mdx",
      "status": "published",
      "sourceSha256": "7345af30844085c42344d7b45f3e8c303f9287a1a00b8959025b1f4000012c32"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Test-Tubes-Racks-Receiving-Vessels",
      "sourcePath": "content/translations/zh-Hans/Lab-Test-Tubes-Racks-Receiving-Vessels.mdx",
      "status": "draft",
      "sourceSha256": "7345af30844085c42344d7b45f3e8c303f9287a1a00b8959025b1f4000012c32"
    }
  ]
},
{
  "id": "article.lab-transfer-pipettes",
  "englishSourcePath": "content/posts/Lab-Transfer-Pipettes-Pipette-Aids.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Transfer-Pipettes-Pipette-Aids",
      "sourcePath": "content/posts/Lab-Transfer-Pipettes-Pipette-Aids.mdx",
      "status": "published",
      "sourceSha256": "e5c4973075fd72ceeda60e6b56d4571ceb62cbaf05cac28f4d6ec925a0dd7e72"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Transfer-Pipettes-Pipette-Aids",
      "sourcePath": "content/translations/zh-Hans/Lab-Transfer-Pipettes-Pipette-Aids.mdx",
      "status": "draft",
      "sourceSha256": "e5c4973075fd72ceeda60e6b56d4571ceb62cbaf05cac28f4d6ec925a0dd7e72"
    }
  ]
},
{
  "id": "article.lab-water-baths",
  "englishSourcePath": "content/posts/Lab-Water-Baths-Water-Handling.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Water-Baths-Water-Handling",
      "sourcePath": "content/posts/Lab-Water-Baths-Water-Handling.mdx",
      "status": "published",
      "sourceSha256": "0b1ef600c17bcc4243fa5adc9d8808ec9d965d311d72ef3a2ed8be6d0749e5a3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Water-Baths-Water-Handling",
      "sourcePath": "content/translations/zh-Hans/Lab-Water-Baths-Water-Handling.mdx",
      "status": "draft",
      "sourceSha256": "0b1ef600c17bcc4243fa5adc9d8808ec9d965d311d72ef3a2ed8be6d0749e5a3"
    }
  ]
},
{
  "id": "article.lab-ripple-tanks",
  "englishSourcePath": "content/posts/Lab-Ripple-Tanks.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Ripple-Tanks",
      "sourcePath": "content/posts/Lab-Ripple-Tanks.mdx",
      "status": "published",
      "sourceSha256": "82da206acc75e5fdad1e9dd8be64b87c0d81e1841b9fbf7a482b9960df26c59e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Ripple-Tanks",
      "sourcePath": "content/translations/zh-Hans/Lab-Ripple-Tanks.mdx",
      "status": "draft",
      "sourceSha256": "82da206acc75e5fdad1e9dd8be64b87c0d81e1841b9fbf7a482b9960df26c59e"
    }
  ]
},
{
  "id": "article.lab-yeast-specimens",
  "englishSourcePath": "content/posts/Lab-Yeast-Specimens.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Yeast-Specimens",
      "sourcePath": "content/posts/Lab-Yeast-Specimens.mdx",
      "status": "published",
      "sourceSha256": "1e3853f01f9f41c6c6cd2d5254efbef9101913d1d2b79d1036bd7dd64117c34e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Yeast-Specimens",
      "sourcePath": "content/translations/zh-Hans/Lab-Yeast-Specimens.mdx",
      "status": "draft",
      "sourceSha256": "1e3853f01f9f41c6c6cd2d5254efbef9101913d1d2b79d1036bd7dd64117c34e"
    }
  ]
},
{
  "id": "article.lab-iodine-test",
  "englishSourcePath": "content/posts/Lab-Iodine-Test-Reagent.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Iodine-Test-Reagent",
      "sourcePath": "content/posts/Lab-Iodine-Test-Reagent.mdx",
      "status": "published",
      "sourceSha256": "7b07f901564d4c59bac2b3532733beaf8077bb0cd3953b3f45a3c7bb0cec56fc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Iodine-Test-Reagent",
      "sourcePath": "content/translations/zh-Hans/Lab-Iodine-Test-Reagent.mdx",
      "status": "draft",
      "sourceSha256": "7b07f901564d4c59bac2b3532733beaf8077bb0cd3953b3f45a3c7bb0cec56fc"
    }
  ]
},
{
  "id": "article.lab-temperature-probes",
  "englishSourcePath": "content/posts/Lab-Thermometers-Temperature-Probes.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Thermometers-Temperature-Probes",
      "sourcePath": "content/posts/Lab-Thermometers-Temperature-Probes.mdx",
      "status": "published",
      "sourceSha256": "cf02e86783056a45873cc6e796a77a4714e5ff6ffa3698f0d5bb94a04a461c56"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Thermometers-Temperature-Probes",
      "sourcePath": "content/translations/zh-Hans/Lab-Thermometers-Temperature-Probes.mdx",
      "status": "draft",
      "sourceSha256": "cf02e86783056a45873cc6e796a77a4714e5ff6ffa3698f0d5bb94a04a461c56"
    }
  ]
},
{
  "id": "article.lab-prepared-slides",
  "englishSourcePath": "content/posts/Lab-Prepared-Slides-Plant-Sections.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Prepared-Slides-Plant-Sections",
      "sourcePath": "content/posts/Lab-Prepared-Slides-Plant-Sections.mdx",
      "status": "published",
      "sourceSha256": "3c48e9afb7381a45b560231cdf2e892b2c6146f2cda2a6ed0f3980f97ea47b6d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Prepared-Slides-Plant-Sections",
      "sourcePath": "content/translations/zh-Hans/Lab-Prepared-Slides-Plant-Sections.mdx",
      "status": "draft",
      "sourceSha256": "3c48e9afb7381a45b560231cdf2e892b2c6146f2cda2a6ed0f3980f97ea47b6d"
    }
  ]
},
{
  "id": "article.lab-supports",
  "englishSourcePath": "content/posts/Lab-Stands-Clamps-Supports.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Stands-Clamps-Supports",
      "sourcePath": "content/posts/Lab-Stands-Clamps-Supports.mdx",
      "status": "published",
      "sourceSha256": "78df981a9c8344672fd5d224c4e419404070e7b0c01689fd17f9bb5eff7497f0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Stands-Clamps-Supports",
      "sourcePath": "content/translations/zh-Hans/Lab-Stands-Clamps-Supports.mdx",
      "status": "draft",
      "sourceSha256": "78df981a9c8344672fd5d224c4e419404070e7b0c01689fd17f9bb5eff7497f0"
    }
  ]
},
{
  "id": "article.lab-induction-apparatus",
  "englishSourcePath": "content/posts/Lab-Magnets-Coils-Galvanometers.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Magnets-Coils-Galvanometers",
      "sourcePath": "content/posts/Lab-Magnets-Coils-Galvanometers.mdx",
      "status": "published",
      "sourceSha256": "20ae545d99404470701fefebe0b56478ad53db454fdf750441dd1331cfdd6c0e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Magnets-Coils-Galvanometers",
      "sourcePath": "content/translations/zh-Hans/Lab-Magnets-Coils-Galvanometers.mdx",
      "status": "draft",
      "sourceSha256": "20ae545d99404470701fefebe0b56478ad53db454fdf750441dd1331cfdd6c0e"
    }
  ]
},
{
  "id": "article.lab-masses-beams",
  "englishSourcePath": "content/posts/Lab-Hanging-Masses-Beams-Pivots.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Hanging-Masses-Beams-Pivots",
      "sourcePath": "content/posts/Lab-Hanging-Masses-Beams-Pivots.mdx",
      "status": "published",
      "sourceSha256": "7ac5c875638cbe276ac75729ede2e5a3e510aefef3ef593dcca8ddc25989708f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Hanging-Masses-Beams-Pivots",
      "sourcePath": "content/translations/zh-Hans/Lab-Hanging-Masses-Beams-Pivots.mdx",
      "status": "draft",
      "sourceSha256": "7ac5c875638cbe276ac75729ede2e5a3e510aefef3ef593dcca8ddc25989708f"
    }
  ]
},
{
  "id": "article.lab-insulation",
  "englishSourcePath": "content/posts/Lab-Insulation-Cooling-Practicals.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Insulation-Cooling-Practicals",
      "sourcePath": "content/posts/Lab-Insulation-Cooling-Practicals.mdx",
      "status": "published",
      "sourceSha256": "35e6af296e1e930730eaf00641bba1c563d2ebc2b86d451c8d0ca4602bd92b3d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Insulation-Cooling-Practicals",
      "sourcePath": "content/translations/zh-Hans/Lab-Insulation-Cooling-Practicals.mdx",
      "status": "draft",
      "sourceSha256": "35e6af296e1e930730eaf00641bba1c563d2ebc2b86d451c8d0ca4602bd92b3d"
    }
  ]
},
{
  "id": "article.lab-collision-apparatus",
  "englishSourcePath": "content/posts/Lab-Collision-Carts-Tracks-Light-Gates-Video.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Collision-Carts-Tracks-Light-Gates-Video",
      "sourcePath": "content/posts/Lab-Collision-Carts-Tracks-Light-Gates-Video.mdx",
      "status": "published",
      "sourceSha256": "1125987528131bdbe4c14f74c350819bdf24a840904ad9b49a9080ad91b95d80"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Collision-Carts-Tracks-Light-Gates-Video",
      "sourcePath": "content/translations/zh-Hans/Lab-Collision-Carts-Tracks-Light-Gates-Video.mdx",
      "status": "draft",
      "sourceSha256": "1125987528131bdbe4c14f74c350819bdf24a840904ad9b49a9080ad91b95d80"
    }
  ]
},
{
  "id": "article.lab-safety",
  "englishSourcePath": "content/posts/Lab-Safety-Starts-Before-the-Experiment.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/Lab-Safety-Starts-Before-the-Experiment",
      "sourcePath": "content/posts/Lab-Safety-Starts-Before-the-Experiment.mdx",
      "status": "published",
      "sourceSha256": "a969a026fa0e6d07fce118b8ebdb1df006855725ad64b9fb77448ae97b2d2b4d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/Lab-Safety-Starts-Before-the-Experiment",
      "sourcePath": "content/translations/zh-Hans/Lab-Safety-Starts-Before-the-Experiment.mdx",
      "status": "draft",
      "sourceSha256": "a969a026fa0e6d07fce118b8ebdb1df006855725ad64b9fb77448ae97b2d2b4d"
    }
  ]
},
{
  "id": "article.centre-of-gravity-practical",
  "englishSourcePath": "content/posts/O-Level-Physics-Centre-of-Gravity-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/O-Level-Physics-Centre-of-Gravity-Practical",
      "sourcePath": "content/posts/O-Level-Physics-Centre-of-Gravity-Practical.mdx",
      "status": "published",
      "sourceSha256": "7051edafd73bb370c62ea9d36d6dcff86bb69340ccb2417e612f7a75e2b942d2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/O-Level-Physics-Centre-of-Gravity-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Physics-Centre-of-Gravity-Practical.mdx",
      "status": "draft",
      "sourceSha256": "7051edafd73bb370c62ea9d36d6dcff86bb69340ccb2417e612f7a75e2b942d2"
    }
  ]
},
{
  "id": "article.moments-practical",
  "englishSourcePath": "content/posts/O-Level-Physics-Moments-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/O-Level-Physics-Moments-Practical",
      "sourcePath": "content/posts/O-Level-Physics-Moments-Practical.mdx",
      "status": "published",
      "sourceSha256": "8ace17e45780bdaffa533d3276fbfbf0c96734cd596e98b54cae977497b74344"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/O-Level-Physics-Moments-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Physics-Moments-Practical.mdx",
      "status": "draft",
      "sourceSha256": "8ace17e45780bdaffa533d3276fbfbf0c96734cd596e98b54cae977497b74344"
    }
  ]
},
{
  "id": "article.density-practical",
  "englishSourcePath": "content/posts/O-Level-Physics-Density-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/O-Level-Physics-Density-Practical",
      "sourcePath": "content/posts/O-Level-Physics-Density-Practical.mdx",
      "status": "published",
      "sourceSha256": "3b7af4a069a7ff606ffc4224db4db14ba4ec7c90590b4fcda45327439d00e09f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/O-Level-Physics-Density-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Physics-Density-Practical.mdx",
      "status": "draft",
      "sourceSha256": "3b7af4a069a7ff606ffc4224db4db14ba4ec7c90590b4fcda45327439d00e09f"
    }
  ]
},
{
  "id": "article.induction-practical",
  "englishSourcePath": "content/posts/O-Level-Physics-Electromagnetic-Induction-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/O-Level-Physics-Electromagnetic-Induction-Practical",
      "sourcePath": "content/posts/O-Level-Physics-Electromagnetic-Induction-Practical.mdx",
      "status": "published",
      "sourceSha256": "3837ff479828e5d5250f8c3c1ad2b6e2dd75e2d9a16b64dd52414c6b8a60792d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/O-Level-Physics-Electromagnetic-Induction-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Physics-Electromagnetic-Induction-Practical.mdx",
      "status": "draft",
      "sourceSha256": "3837ff479828e5d5250f8c3c1ad2b6e2dd75e2d9a16b64dd52414c6b8a60792d"
    }
  ]
},
{
  "id": "article.gravity-filtration-practical",
  "englishSourcePath": "content/posts/O-Level-Chemistry-Gravity-Filtration-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-chemistry-experiments/O-Level-Chemistry-Gravity-Filtration-Practical",
      "sourcePath": "content/posts/O-Level-Chemistry-Gravity-Filtration-Practical.mdx",
      "status": "published",
      "sourceSha256": "500d22c2dfb725857354df43ff8099b234294abe43183c63516541081f75911c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-chemistry-experiments/O-Level-Chemistry-Gravity-Filtration-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Chemistry-Gravity-Filtration-Practical.mdx",
      "status": "draft",
      "sourceSha256": "500d22c2dfb725857354df43ff8099b234294abe43183c63516541081f75911c"
    }
  ]
},
{
  "id": "article.cooling-curves-practical",
  "englishSourcePath": "content/posts/O-Level-Physics-Heat-Transfer-Cooling-Curves-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/O-Level-Physics-Heat-Transfer-Cooling-Curves-Practical",
      "sourcePath": "content/posts/O-Level-Physics-Heat-Transfer-Cooling-Curves-Practical.mdx",
      "status": "published",
      "sourceSha256": "fde7a0f2e84b60cfdf874e7a12b1493c9de651f7f2bb551ec51cfa0ba08168fe"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/O-Level-Physics-Heat-Transfer-Cooling-Curves-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Physics-Heat-Transfer-Cooling-Curves-Practical.mdx",
      "status": "draft",
      "sourceSha256": "fde7a0f2e84b60cfdf874e7a12b1493c9de651f7f2bb551ec51cfa0ba08168fe"
    }
  ]
},
{
  "id": "article.wave-speed-practical",
  "englishSourcePath": "content/posts/O-Level-Physics-Wave-Speed-Ripple-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/O-Level-Physics-Wave-Speed-Ripple-Practical",
      "sourcePath": "content/posts/O-Level-Physics-Wave-Speed-Ripple-Practical.mdx",
      "status": "published",
      "sourceSha256": "4a7eb56a4bffbcbb0deb81d331fea41b06cc572556271019f3823d12b3065485"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/O-Level-Physics-Wave-Speed-Ripple-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Physics-Wave-Speed-Ripple-Practical.mdx",
      "status": "draft",
      "sourceSha256": "4a7eb56a4bffbcbb0deb81d331fea41b06cc572556271019f3823d12b3065485"
    }
  ]
},
{
  "id": "article.distillation-practical",
  "englishSourcePath": "content/posts/H2-Chemistry-Distillation-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Distillation-Practical",
      "sourcePath": "content/posts/H2-Chemistry-Distillation-Practical.mdx",
      "status": "published",
      "sourceSha256": "2d19984dff2554777c5c4f026d4199e99ac8c4b99a2f5b5c3d167d67769674e3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Distillation-Practical",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Distillation-Practical.mdx",
      "status": "draft",
      "sourceSha256": "2d19984dff2554777c5c4f026d4199e99ac8c4b99a2f5b5c3d167d67769674e3"
    }
  ]
},
{
  "id": "article.reflux-practical",
  "englishSourcePath": "content/posts/H2-Chemistry-Reflux-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-chemistry-experiments/H2-Chemistry-Reflux-Practical",
      "sourcePath": "content/posts/H2-Chemistry-Reflux-Practical.mdx",
      "status": "published",
      "sourceSha256": "5574bfb9d17a8d539c5e5a38a05fbbe02fd81e7c2a2ae0d8a6b69ae3925b2dfb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-chemistry-experiments/H2-Chemistry-Reflux-Practical",
      "sourcePath": "content/translations/zh-Hans/H2-Chemistry-Reflux-Practical.mdx",
      "status": "draft",
      "sourceSha256": "5574bfb9d17a8d539c5e5a38a05fbbe02fd81e7c2a2ae0d8a6b69ae3925b2dfb"
    }
  ]
},
{
  "id": "article.leaf-stem-microscopy",
  "englishSourcePath": "content/posts/O-Level-Biology-Leaf-Stem-Microscopy-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-biology-experiments/O-Level-Biology-Leaf-Stem-Microscopy-Practical",
      "sourcePath": "content/posts/O-Level-Biology-Leaf-Stem-Microscopy-Practical.mdx",
      "status": "published",
      "sourceSha256": "2ec118ac3f139f75e97545d2d396720a6987cd2a492e91cf734a32aa50929782"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-biology-experiments/O-Level-Biology-Leaf-Stem-Microscopy-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Biology-Leaf-Stem-Microscopy-Practical.mdx",
      "status": "draft",
      "sourceSha256": "2ec118ac3f139f75e97545d2d396720a6987cd2a492e91cf734a32aa50929782"
    }
  ]
}
,
{
  "id": "article.law-of-reflection-practical",
  "englishSourcePath": "content/posts/O-Level-Physics-Law-of-Reflection-Practical.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-physics-experiments/O-Level-Physics-Law-of-Reflection-Practical",
      "sourcePath": "content/posts/O-Level-Physics-Law-of-Reflection-Practical.mdx",
      "status": "published",
      "sourceSha256": "8f5ec9e771d67f859fafe974210c6837f2da4cdc88809d5150f01e776623a5f7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-physics-experiments/O-Level-Physics-Law-of-Reflection-Practical",
      "sourcePath": "content/translations/zh-Hans/O-Level-Physics-Law-of-Reflection-Practical.mdx",
      "status": "draft",
      "sourceSha256": "8f5ec9e771d67f859fafe974210c6837f2da4cdc88809d5150f01e776623a5f7"
    }
  ]
}
,
{
  "id": "article.ip-emaths-algebraic-tools",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-01-Algebraic-Tools.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-01-Algebraic-Tools",
      "sourcePath": "content/posts/IP-EMaths-Notes-01-Algebraic-Tools.mdx",
      "status": "published",
      "sourceSha256": "e116540a34bb49d82cb9c9d13c9e42730e57e57b79ed4218ae363b8348c4625c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-01-Algebraic-Tools",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-01-Algebraic-Tools.mdx",
      "status": "draft",
      "sourceSha256": "e116540a34bb49d82cb9c9d13c9e42730e57e57b79ed4218ae363b8348c4625c"
    }
  ]
}
,
{
  "id": "article.ip-emaths-indices-standard-form",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-02-Indices-and-Standard-Form.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-02-Indices-and-Standard-Form",
      "sourcePath": "content/posts/IP-EMaths-Notes-02-Indices-and-Standard-Form.mdx",
      "status": "published",
      "sourceSha256": "3fea193b77ef01c4db2a3233d8ba5f1b9668b337cffa19a0153f5c30a7b19abc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-02-Indices-and-Standard-Form",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-02-Indices-and-Standard-Form.mdx",
      "status": "draft",
      "sourceSha256": "3fea193b77ef01c4db2a3233d8ba5f1b9668b337cffa19a0153f5c30a7b19abc"
    }
  ]
}
,
{
  "id": "article.ip-emaths-algebraic-fractions-surds",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-03-Algebraic-Fractions-and-Surds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-03-Algebraic-Fractions-and-Surds",
      "sourcePath": "content/posts/IP-EMaths-Notes-03-Algebraic-Fractions-and-Surds.mdx",
      "status": "published",
      "sourceSha256": "d53a6b712997583cef2c3e4f034c9acc4f1f0b93e102c9888b65ac240c1c59a5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-03-Algebraic-Fractions-and-Surds",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-03-Algebraic-Fractions-and-Surds.mdx",
      "status": "draft",
      "sourceSha256": "d53a6b712997583cef2c3e4f034c9acc4f1f0b93e102c9888b65ac240c1c59a5"
    }
  ]
}
,
{
  "id": "article.ip-emaths-linear-equations-inequalities",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-04-Linear-Equations-and-Inequalities.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-04-Linear-Equations-and-Inequalities",
      "sourcePath": "content/posts/IP-EMaths-Notes-04-Linear-Equations-and-Inequalities.mdx",
      "status": "published",
      "sourceSha256": "36dfba8481bc60281efff6f38eddb6d1fc4460ddceb929c0f3db3bfeab184c28"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-04-Linear-Equations-and-Inequalities",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-04-Linear-Equations-and-Inequalities.mdx",
      "status": "draft",
      "sourceSha256": "36dfba8481bc60281efff6f38eddb6d1fc4460ddceb929c0f3db3bfeab184c28"
    }
  ]
}
,
{
  "id": "article.ip-emaths-simultaneous-equations",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-05-Simultaneous-Equations-and-Word-Problems.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-05-Simultaneous-Equations-and-Word-Problems",
      "sourcePath": "content/posts/IP-EMaths-Notes-05-Simultaneous-Equations-and-Word-Problems.mdx",
      "status": "published",
      "sourceSha256": "6fcb04e23ba121c74b39318cc09d5aec45629c1da7fe67c90e91e7a8e2501b36"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-05-Simultaneous-Equations-and-Word-Problems",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-05-Simultaneous-Equations-and-Word-Problems.mdx",
      "status": "draft",
      "sourceSha256": "6fcb04e23ba121c74b39318cc09d5aec45629c1da7fe67c90e91e7a8e2501b36"
    }
  ]
}
,
{
  "id": "article.ip-emaths-quadratic-functions",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-06-Quadratic-Functions-and-Graphs.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-06-Quadratic-Functions-and-Graphs",
      "sourcePath": "content/posts/IP-EMaths-Notes-06-Quadratic-Functions-and-Graphs.mdx",
      "status": "published",
      "sourceSha256": "96e4e63cc2a44d805304c8496e90bf570fb35b31ec9fb8f05cac267b39dcdb8f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-06-Quadratic-Functions-and-Graphs",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-06-Quadratic-Functions-and-Graphs.mdx",
      "status": "draft",
      "sourceSha256": "96e4e63cc2a44d805304c8496e90bf570fb35b31ec9fb8f05cac267b39dcdb8f"
    }
  ]
}
,
{
  "id": "article.ip-emaths-coordinate-geometry",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-07-Coordinate-Geometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-07-Coordinate-Geometry",
      "sourcePath": "content/posts/IP-EMaths-Notes-07-Coordinate-Geometry.mdx",
      "status": "published",
      "sourceSha256": "95d5213af02f8f6c23a9349c3886a190c6875a8c54e758cdbdc14a75bf1a6fa8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-07-Coordinate-Geometry",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-07-Coordinate-Geometry.mdx",
      "status": "draft",
      "sourceSha256": "95d5213af02f8f6c23a9349c3886a190c6875a8c54e758cdbdc14a75bf1a6fa8"
    }
  ]
}
,
{
  "id": "article.ip-emaths-functions-transformations",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-08-Functions-and-Transformations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-08-Functions-and-Transformations",
      "sourcePath": "content/posts/IP-EMaths-Notes-08-Functions-and-Transformations.mdx",
      "status": "published",
      "sourceSha256": "a186fcbbaef7e6b6310745fe2473be9292ac7501aa2f4d43092fdf6c5717d2b0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-08-Functions-and-Transformations",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-08-Functions-and-Transformations.mdx",
      "status": "draft",
      "sourceSha256": "a186fcbbaef7e6b6310745fe2473be9292ac7501aa2f4d43092fdf6c5717d2b0"
    }
  ]
}
,
{
  "id": "article.ip-emaths-right-triangle-trig",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-09-Right-Triangle-Trigonometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-09-Right-Triangle-Trigonometry",
      "sourcePath": "content/posts/IP-EMaths-Notes-09-Right-Triangle-Trigonometry.mdx",
      "status": "published",
      "sourceSha256": "1bab8cf43bcf7d1dca2b796bae4409033cbc6fda136a5c458d5237b5a397e14c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-09-Right-Triangle-Trigonometry",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-09-Right-Triangle-Trigonometry.mdx",
      "status": "draft",
      "sourceSha256": "1bab8cf43bcf7d1dca2b796bae4409033cbc6fda136a5c458d5237b5a397e14c"
    }
  ]
}
,
{
  "id": "article.ip-emaths-trig-applications",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-10-Trigonometric-Applications.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-10-Trigonometric-Applications",
      "sourcePath": "content/posts/IP-EMaths-Notes-10-Trigonometric-Applications.mdx",
      "status": "published",
      "sourceSha256": "c9b776fdb862efa8be7d4f6cf4ef7a3aa010a0982967fabefa90182386b154b6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-10-Trigonometric-Applications",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-10-Trigonometric-Applications.mdx",
      "status": "draft",
      "sourceSha256": "c9b776fdb862efa8be7d4f6cf4ef7a3aa010a0982967fabefa90182386b154b6"
    }
  ]
}
,
{
  "id": "article.ip-emaths-mensuration-3d-geometry",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-11-Mensuration-and-3D-Geometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-11-Mensuration-and-3D-Geometry",
      "sourcePath": "content/posts/IP-EMaths-Notes-11-Mensuration-and-3D-Geometry.mdx",
      "status": "published",
      "sourceSha256": "a1f7899a456be61c8a919b30b62bcf6cac9a7a18119c8abb5d2d0f041c68311f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-11-Mensuration-and-3D-Geometry",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-11-Mensuration-and-3D-Geometry.mdx",
      "status": "draft",
      "sourceSha256": "a1f7899a456be61c8a919b30b62bcf6cac9a7a18119c8abb5d2d0f041c68311f"
    }
  ]
}
,
{
  "id": "article.ip-emaths-similarity-congruency",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-12-Similarity-and-Congruency.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-12-Similarity-and-Congruency",
      "sourcePath": "content/posts/IP-EMaths-Notes-12-Similarity-and-Congruency.mdx",
      "status": "published",
      "sourceSha256": "ae1a51fb3025052906afc17c6ad6cf7dce04a52c1e3cd5453c32cb9e48c68c5f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-12-Similarity-and-Congruency",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-12-Similarity-and-Congruency.mdx",
      "status": "draft",
      "sourceSha256": "ae1a51fb3025052906afc17c6ad6cf7dce04a52c1e3cd5453c32cb9e48c68c5f"
    }
  ]
}
,
{
  "id": "article.ip-emaths-variation-rate",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-13-Variation-and-Rate-of-Change.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-13-Variation-and-Rate-of-Change",
      "sourcePath": "content/posts/IP-EMaths-Notes-13-Variation-and-Rate-of-Change.mdx",
      "status": "published",
      "sourceSha256": "9a71b98e179d9aa6e53258fab32ff47d1f673f02298f3a08811601fdef11940b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-13-Variation-and-Rate-of-Change",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-13-Variation-and-Rate-of-Change.mdx",
      "status": "draft",
      "sourceSha256": "9a71b98e179d9aa6e53258fab32ff47d1f673f02298f3a08811601fdef11940b"
    }
  ]
}
,
{
  "id": "article.ip-emaths-probability",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-14-Probability.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-14-Probability",
      "sourcePath": "content/posts/IP-EMaths-Notes-14-Probability.mdx",
      "status": "published",
      "sourceSha256": "16765efa8ae854f221be6748c4a667c15498467fa8ac0bc0937029560f9b1d94"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-14-Probability",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-14-Probability.mdx",
      "status": "draft",
      "sourceSha256": "16765efa8ae854f221be6748c4a667c15498467fa8ac0bc0937029560f9b1d94"
    }
  ]
}
,
{
  "id": "article.ip-emaths-statistics-data",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-15-Statistics-and-Data-Handling.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-15-Statistics-and-Data-Handling",
      "sourcePath": "content/posts/IP-EMaths-Notes-15-Statistics-and-Data-Handling.mdx",
      "status": "published",
      "sourceSha256": "13ba58b3d0a37a593a29957ffdd0635a49b7e1ba0fd1d4b7835d430a3e3943c4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-15-Statistics-and-Data-Handling",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-15-Statistics-and-Data-Handling.mdx",
      "status": "draft",
      "sourceSha256": "13ba58b3d0a37a593a29957ffdd0635a49b7e1ba0fd1d4b7835d430a3e3943c4"
    }
  ]
}
,
{
  "id": "article.ip-emaths-upper-sec-overview",
  "englishSourcePath": "content/posts/IP-EMaths-Notes-00-Upper-Sec-Overview.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-00-Upper-Sec-Overview",
      "sourcePath": "content/posts/IP-EMaths-Notes-00-Upper-Sec-Overview.mdx",
      "status": "published",
      "sourceSha256": "978a6f99b39331885d2ebccbd3243901f7f5146ed74dad3a78e28cc32236ad50"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-emaths-upper-sec-notes/IP-EMaths-Notes-00-Upper-Sec-Overview",
      "sourcePath": "content/translations/zh-Hans/IP-EMaths-Notes-00-Upper-Sec-Overview.mdx",
      "status": "draft",
      "sourceSha256": "978a6f99b39331885d2ebccbd3243901f7f5146ed74dad3a78e28cc32236ad50"
    }
  ]
}
,
{
  "id": "article.ip-amaths-upper-sec-overview",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-00-Upper-Sec-Overview.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-00-Upper-Sec-Overview",
      "sourcePath": "content/posts/IP-AMaths-Notes-00-Upper-Sec-Overview.mdx",
      "status": "published",
      "sourceSha256": "63ad96acfeefb8bbd3d02db984f0b7bb157902f8005bdb7098059144d4d1e789"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-00-Upper-Sec-Overview",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-00-Upper-Sec-Overview.mdx",
      "status": "draft",
      "sourceSha256": "63ad96acfeefb8bbd3d02db984f0b7bb157902f8005bdb7098059144d4d1e789"
    }
  ]
}
,
{
  "id": "article.ip-amaths-indices-surds",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-01-Indices-and-Surds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-01-Indices-and-Surds",
      "sourcePath": "content/posts/IP-AMaths-Notes-01-Indices-and-Surds.mdx",
      "status": "published",
      "sourceSha256": "935213d16e25e815c1a81ccdda72cabee402238ec264b1be88eda5377263f30f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-01-Indices-and-Surds",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-01-Indices-and-Surds.mdx",
      "status": "draft",
      "sourceSha256": "935213d16e25e815c1a81ccdda72cabee402238ec264b1be88eda5377263f30f"
    }
  ]
}
,
{
  "id": "article.ip-amaths-logarithms-exponentials",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-02-Logarithms-and-Exponentials.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-02-Logarithms-and-Exponentials",
      "sourcePath": "content/posts/IP-AMaths-Notes-02-Logarithms-and-Exponentials.mdx",
      "status": "published",
      "sourceSha256": "bc8c3fbeaada9c12362d8ecb480a92231aa8ed9e7c49f4d3ebce3767117bd417"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-02-Logarithms-and-Exponentials",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-02-Logarithms-and-Exponentials.mdx",
      "status": "draft",
      "sourceSha256": "bc8c3fbeaada9c12362d8ecb480a92231aa8ed9e7c49f4d3ebce3767117bd417"
    }
  ]
}
,
{
  "id": "article.ip-amaths-linear-law",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-03-Linear-Law.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-03-Linear-Law",
      "sourcePath": "content/posts/IP-AMaths-Notes-03-Linear-Law.mdx",
      "status": "published",
      "sourceSha256": "8c1b0433b9a9fc48135d84f0d4a650e8446a1c176b538849219e66bb1b244812"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-03-Linear-Law",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-03-Linear-Law.mdx",
      "status": "draft",
      "sourceSha256": "8c1b0433b9a9fc48135d84f0d4a650e8446a1c176b538849219e66bb1b244812"
    }
  ]
}
,
{
  "id": "article.ip-amaths-simultaneous-equations",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-04-Simultaneous-Equations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-04-Simultaneous-Equations",
      "sourcePath": "content/posts/IP-AMaths-Notes-04-Simultaneous-Equations.mdx",
      "status": "published",
      "sourceSha256": "78e0da33b6dcd5d417488e6b2da35885756528b1128a54645e2b0aff2b2a31f2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-04-Simultaneous-Equations",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-04-Simultaneous-Equations.mdx",
      "status": "draft",
      "sourceSha256": "78e0da33b6dcd5d417488e6b2da35885756528b1128a54645e2b0aff2b2a31f2"
    }
  ]
}
,
{
  "id": "article.ip-amaths-quadratic-functions",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-05-Quadratic-Functions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-05-Quadratic-Functions",
      "sourcePath": "content/posts/IP-AMaths-Notes-05-Quadratic-Functions.mdx",
      "status": "published",
      "sourceSha256": "4dba77d5c7577ac46a7b29298d176ce1857e031a9f287af6c596a0fe261370d0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-05-Quadratic-Functions",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-05-Quadratic-Functions.mdx",
      "status": "draft",
      "sourceSha256": "4dba77d5c7577ac46a7b29298d176ce1857e031a9f287af6c596a0fe261370d0"
    }
  ]
}
,
{
  "id": "article.ip-amaths-coordinate-geometry-lines",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-06-Coordinate-Geometry-Lines.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-06-Coordinate-Geometry-Lines",
      "sourcePath": "content/posts/IP-AMaths-Notes-06-Coordinate-Geometry-Lines.mdx",
      "status": "published",
      "sourceSha256": "e165d8ed64031ae1dfea7c768fd487bc94b5784372d866de99ef9fb685318352"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-06-Coordinate-Geometry-Lines",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-06-Coordinate-Geometry-Lines.mdx",
      "status": "draft",
      "sourceSha256": "e165d8ed64031ae1dfea7c768fd487bc94b5784372d866de99ef9fb685318352"
    }
  ]
}
,
{
  "id": "article.ip-amaths-parabolas-circles",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-07-Parabolas-and-Circles.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-07-Parabolas-and-Circles",
      "sourcePath": "content/posts/IP-AMaths-Notes-07-Parabolas-and-Circles.mdx",
      "status": "published",
      "sourceSha256": "2ffc2eba15a4b308a2627d768a199ad1d105595b7fa8f30770393163d2738b2c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-07-Parabolas-and-Circles",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-07-Parabolas-and-Circles.mdx",
      "status": "draft",
      "sourceSha256": "2ffc2eba15a4b308a2627d768a199ad1d105595b7fa8f30770393163d2738b2c"
    }
  ]
}
,
{
  "id": "article.ip-amaths-plane-geometry",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-08-Plane-Geometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-08-Plane-Geometry",
      "sourcePath": "content/posts/IP-AMaths-Notes-08-Plane-Geometry.mdx",
      "status": "published",
      "sourceSha256": "a58d6a00790a4b7149ae0ed046f78eedb89e85bb4a77331ae5fa7a74faadf4d9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-08-Plane-Geometry",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-08-Plane-Geometry.mdx",
      "status": "draft",
      "sourceSha256": "a58d6a00790a4b7149ae0ed046f78eedb89e85bb4a77331ae5fa7a74faadf4d9"
    }
  ]
}
,
{
  "id": "article.ip-amaths-polynomials",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-09-Polynomials.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-09-Polynomials",
      "sourcePath": "content/posts/IP-AMaths-Notes-09-Polynomials.mdx",
      "status": "published",
      "sourceSha256": "2a81ebe5707e7da0369aa732349d2ee7825e982d5fde067a6e86633f46e454cf"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-09-Polynomials",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-09-Polynomials.mdx",
      "status": "draft",
      "sourceSha256": "2a81ebe5707e7da0369aa732349d2ee7825e982d5fde067a6e86633f46e454cf"
    }
  ]
}
,
{
  "id": "article.ip-amaths-binomial-theorem",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-10-Binomial-Theorem.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-10-Binomial-Theorem",
      "sourcePath": "content/posts/IP-AMaths-Notes-10-Binomial-Theorem.mdx",
      "status": "published",
      "sourceSha256": "a5b2a87f561bd93cfab91f3dfad24dec1d5b60750fe311cdfe7110bac6590724"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-10-Binomial-Theorem",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-10-Binomial-Theorem.mdx",
      "status": "draft",
      "sourceSha256": "a5b2a87f561bd93cfab91f3dfad24dec1d5b60750fe311cdfe7110bac6590724"
    }
  ]
}
,
{
  "id": "article.ip-amaths-modulus-functions",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-11-Modulus-Functions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-11-Modulus-Functions",
      "sourcePath": "content/posts/IP-AMaths-Notes-11-Modulus-Functions.mdx",
      "status": "published",
      "sourceSha256": "3228942aa23e149a31b35bb75b5fbf5d6001729d0c53d999f4e003d0c960c257"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-11-Modulus-Functions",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-11-Modulus-Functions.mdx",
      "status": "draft",
      "sourceSha256": "3228942aa23e149a31b35bb75b5fbf5d6001729d0c53d999f4e003d0c960c257"
    }
  ]
}
,
{
  "id": "article.ip-amaths-trigonometry-one",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-12-Trigonometry-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-12-Trigonometry-1",
      "sourcePath": "content/posts/IP-AMaths-Notes-12-Trigonometry-1.mdx",
      "status": "published",
      "sourceSha256": "fd4a5c601f15b3fafe78c8a4f1fffbf9b34c6d07e4a8f6a9fcb6e7bfab9e9f9e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-12-Trigonometry-1",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-12-Trigonometry-1.mdx",
      "status": "draft",
      "sourceSha256": "fd4a5c601f15b3fafe78c8a4f1fffbf9b34c6d07e4a8f6a9fcb6e7bfab9e9f9e"
    }
  ]
}
,
{
  "id": "article.ip-amaths-trigonometry-two",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-13-Trigonometry-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-13-Trigonometry-2",
      "sourcePath": "content/posts/IP-AMaths-Notes-13-Trigonometry-2.mdx",
      "status": "published",
      "sourceSha256": "ec761896159585e2f5ff4522a443b58d0cecb1a41acdfd95184fed62472eeed1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-13-Trigonometry-2",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-13-Trigonometry-2.mdx",
      "status": "draft",
      "sourceSha256": "ec761896159585e2f5ff4522a443b58d0cecb1a41acdfd95184fed62472eeed1"
    }
  ]
}
,
{
  "id": "article.ip-amaths-differentiation-fundamentals",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-14-Differentiation-Fundamentals.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-14-Differentiation-Fundamentals",
      "sourcePath": "content/posts/IP-AMaths-Notes-14-Differentiation-Fundamentals.mdx",
      "status": "published",
      "sourceSha256": "bf0c01a2b919985980d92f66f72da544f66ccec6153326bcb752a1a1a8e78a3a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-14-Differentiation-Fundamentals",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-14-Differentiation-Fundamentals.mdx",
      "status": "draft",
      "sourceSha256": "bf0c01a2b919985980d92f66f72da544f66ccec6153326bcb752a1a1a8e78a3a"
    }
  ]
}
,
{
  "id": "article.ip-amaths-differentiation-techniques",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-15-Differentiation-Techniques.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-15-Differentiation-Techniques",
      "sourcePath": "content/posts/IP-AMaths-Notes-15-Differentiation-Techniques.mdx",
      "status": "published",
      "sourceSha256": "2046e8a56ad51663e637567cf5e5ca8d42596302a225a959a1efe5adee9904aa"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-15-Differentiation-Techniques",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-15-Differentiation-Techniques.mdx",
      "status": "draft",
      "sourceSha256": "2046e8a56ad51663e637567cf5e5ca8d42596302a225a959a1efe5adee9904aa"
    }
  ]
}
,
{
  "id": "article.ip-amaths-differentiation-applications",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-16-Applications-of-Differentiation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-16-Applications-of-Differentiation",
      "sourcePath": "content/posts/IP-AMaths-Notes-16-Applications-of-Differentiation.mdx",
      "status": "published",
      "sourceSha256": "8695b0d161983f098d060f1762e44a6b751a79695929a4a5d0a786302a189389"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-16-Applications-of-Differentiation",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-16-Applications-of-Differentiation.mdx",
      "status": "draft",
      "sourceSha256": "8695b0d161983f098d060f1762e44a6b751a79695929a4a5d0a786302a189389"
    }
  ]
}
,
{
  "id": "article.ip-amaths-integration-essentials",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-17-Integration-Essentials.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-17-Integration-Essentials",
      "sourcePath": "content/posts/IP-AMaths-Notes-17-Integration-Essentials.mdx",
      "status": "published",
      "sourceSha256": "0896fad3c4006e41d7a161c16f5a6a7b9be8555100df59952e44a3a2ef782c6f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-17-Integration-Essentials",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-17-Integration-Essentials.mdx",
      "status": "draft",
      "sourceSha256": "0896fad3c4006e41d7a161c16f5a6a7b9be8555100df59952e44a3a2ef782c6f"
    }
  ]
}
,
{
  "id": "article.ip-amaths-partial-fractions",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-18-Partial-Fractions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-18-Partial-Fractions",
      "sourcePath": "content/posts/IP-AMaths-Notes-18-Partial-Fractions.mdx",
      "status": "published",
      "sourceSha256": "bb394e72a008ff70941a3c18d2607dc34fed44ede9d8065b289eed2c5c6b42d6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-18-Partial-Fractions",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-18-Partial-Fractions.mdx",
      "status": "draft",
      "sourceSha256": "bb394e72a008ff70941a3c18d2607dc34fed44ede9d8065b289eed2c5c6b42d6"
    }
  ]
}
,
{
  "id": "article.ip-amaths-kinematics",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-19-Kinematics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-19-Kinematics",
      "sourcePath": "content/posts/IP-AMaths-Notes-19-Kinematics.mdx",
      "status": "published",
      "sourceSha256": "4acd0879f15e17274ecd77514296ce64114ec431cc02fcc5dd08d1e3294ca809"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-19-Kinematics",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-19-Kinematics.mdx",
      "status": "draft",
      "sourceSha256": "4acd0879f15e17274ecd77514296ce64114ec431cc02fcc5dd08d1e3294ca809"
    }
  ]
}
,
{
  "id": "article.ip-amaths-standard-deviation",
  "englishSourcePath": "content/posts/IP-AMaths-Notes-20-Standard-Deviation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-20-Standard-Deviation",
      "sourcePath": "content/posts/IP-AMaths-Notes-20-Standard-Deviation.mdx",
      "status": "published",
      "sourceSha256": "1a7d91bbe1c5a15ba2b2e38b02e71573ed6f95658726d3d77d7c9447cd70a9c3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-amaths-upper-sec-notes/IP-AMaths-Notes-20-Standard-Deviation",
      "sourcePath": "content/translations/zh-Hans/IP-AMaths-Notes-20-Standard-Deviation.mdx",
      "status": "draft",
      "sourceSha256": "1a7d91bbe1c5a15ba2b2e38b02e71573ed6f95658726d3d77d7c9447cd70a9c3"
    }
  ]
}
,
{
  "id": "article.h2-chemistry-jc-roadmap",
  "englishSourcePath": "content/posts/JC1-to-JC2-H2-Chemistry-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-chemistry-tuition/JC1-to-JC2-H2-Chemistry-Roadmap-for-Consistent-A-Level-Results-2026",
      "sourcePath": "content/posts/JC1-to-JC2-H2-Chemistry-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
      "status": "published",
      "sourceSha256": "bcd2948616712e54baf3a00bef0bad131569158f28ded59ace7e61300b23df59"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-chemistry-tuition/JC1-to-JC2-H2-Chemistry-Roadmap-for-Consistent-A-Level-Results-2026",
      "sourcePath": "content/translations/zh-Hans/JC1-to-JC2-H2-Chemistry-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
      "status": "draft",
      "sourceSha256": "bcd2948616712e54baf3a00bef0bad131569158f28ded59ace7e61300b23df59"
    }
  ]
},
{
  "id": "article.h2-physics-jc-roadmap",
  "englishSourcePath": "content/posts/JC1-to-JC2-H2-Physics-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/a-level-physics-tuition/JC1-to-JC2-H2-Physics-Roadmap-for-Consistent-A-Level-Results-2026",
      "sourcePath": "content/posts/JC1-to-JC2-H2-Physics-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
      "status": "published",
      "sourceSha256": "8a25ea22b8bb5b9641d0c878b3147b3ed6417074616256e3de7a5c3a3844b150"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/a-level-physics-tuition/JC1-to-JC2-H2-Physics-Roadmap-for-Consistent-A-Level-Results-2026",
      "sourcePath": "content/translations/zh-Hans/JC1-to-JC2-H2-Physics-Roadmap-for-Consistent-A-Level-Results-2026.mdx",
      "status": "draft",
      "sourceSha256": "8a25ea22b8bb5b9641d0c878b3147b3ed6417074616256e3de7a5c3a3844b150"
    }
  ]
}
,
{
  "id": "article.o-level-biology-sec-study-plan",
  "englishSourcePath": "content/posts/Sec-3-to-Sec-4-O-Level-Biology-Paper-3-Study-Plan-2026.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/o-level-biology-tuition/Sec-3-to-Sec-4-O-Level-Biology-Paper-3-Study-Plan-2026",
      "sourcePath": "content/posts/Sec-3-to-Sec-4-O-Level-Biology-Paper-3-Study-Plan-2026.mdx",
      "status": "published",
      "sourceSha256": "01c6cdb83dec4ce53f15599679e308341e7ba83c1f0be598201a32449e1e6868"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/o-level-biology-tuition/Sec-3-to-Sec-4-O-Level-Biology-Paper-3-Study-Plan-2026",
      "sourcePath": "content/translations/zh-Hans/Sec-3-to-Sec-4-O-Level-Biology-Paper-3-Study-Plan-2026.mdx",
      "status": "draft",
      "sourceSha256": "01c6cdb83dec4ce53f15599679e308341e7ba83c1f0be598201a32449e1e6868"
    }
  ]
}
,
{
  "id": "article.igcse-maths-0580-study-plan",
  "englishSourcePath": "content/posts/igcse-maths-0580-study-plan-and-paper-strategy-singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-mathematics-notes/igcse-maths-0580-study-plan-and-paper-strategy-singapore",
      "sourcePath": "content/posts/igcse-maths-0580-study-plan-and-paper-strategy-singapore.mdx",
      "status": "published",
      "sourceSha256": "78d00c16e399f45bdddfd52e67851d806a8eb48c41d2365b1bd30cc3f3758bcc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-mathematics-notes/igcse-maths-0580-study-plan-and-paper-strategy-singapore",
      "sourcePath": "content/translations/zh-Hans/igcse-maths-0580-study-plan-and-paper-strategy-singapore.mdx",
      "status": "draft",
      "sourceSha256": "78d00c16e399f45bdddfd52e67851d806a8eb48c41d2365b1bd30cc3f3758bcc"
    }
  ]
}
,
{
  "id": "article.igcse-chemistry-0620-study-plan",
  "englishSourcePath": "content/posts/igcse-chemistry-0620-study-plan-and-paper-strategy-singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-chemistry-notes/igcse-chemistry-0620-study-plan-and-paper-strategy-singapore",
      "sourcePath": "content/posts/igcse-chemistry-0620-study-plan-and-paper-strategy-singapore.mdx",
      "status": "published",
      "sourceSha256": "2961c5a5aaaabf7e72addb935eee31b6b045264d5d24eef638c6e465a12b4f38"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-chemistry-notes/igcse-chemistry-0620-study-plan-and-paper-strategy-singapore",
      "sourcePath": "content/translations/zh-Hans/igcse-chemistry-0620-study-plan-and-paper-strategy-singapore.mdx",
      "status": "draft",
      "sourceSha256": "2961c5a5aaaabf7e72addb935eee31b6b045264d5d24eef638c6e465a12b4f38"
    }
  ]
}
,
{
  "id": "article.igcse-physics-0625-study-plan",
  "englishSourcePath": "content/posts/igcse-physics-0625-study-plan-and-paper-strategy-singapore.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-physics-notes/igcse-physics-0625-study-plan-and-paper-strategy-singapore",
      "sourcePath": "content/posts/igcse-physics-0625-study-plan-and-paper-strategy-singapore.mdx",
      "status": "published",
      "sourceSha256": "5993f2f06a8ab4eff7e1584533bd9d28078c1492f08bb38a5caf14d6f1ee1025"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-physics-notes/igcse-physics-0625-study-plan-and-paper-strategy-singapore",
      "sourcePath": "content/translations/zh-Hans/igcse-physics-0625-study-plan-and-paper-strategy-singapore.mdx",
      "status": "draft",
      "sourceSha256": "5993f2f06a8ab4eff7e1584533bd9d28078c1492f08bb38a5caf14d6f1ee1025"
    }
  ]
}
,
{
  "id": "article.cambridge-as-environmental-01",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-01-Introduction-to-environmental-management.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-01-Introduction-to-environmental-management",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-01-Introduction-to-environmental-management.mdx",
      "status": "published",
      "sourceSha256": "3f402ac451d8fac41fc352175bfe3c7d5c01473862bf911af108547a20943622"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-01-Introduction-to-environmental-management",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-01-Introduction-to-environmental-management.mdx",
      "status": "draft",
      "sourceSha256": "3f402ac451d8fac41fc352175bfe3c7d5c01473862bf911af108547a20943622"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-02",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-02-Environmental-research-and-data-collection.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-02-Environmental-research-and-data-collection",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-02-Environmental-research-and-data-collection.mdx",
      "status": "published",
      "sourceSha256": "cf16ab0430da9dbb59df1715d3434baac658ee44cf563aa05d3725e214bf0e5d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-02-Environmental-research-and-data-collection",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-02-Environmental-research-and-data-collection.mdx",
      "status": "draft",
      "sourceSha256": "cf16ab0430da9dbb59df1715d3434baac658ee44cf563aa05d3725e214bf0e5d"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-03",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-03-Managing-human-population.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-03-Managing-human-population",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-03-Managing-human-population.mdx",
      "status": "published",
      "sourceSha256": "b5463aa0baed59b7db17228656d52f8375a28b2553a2749ceb8fdcbd27ef25e4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-03-Managing-human-population",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-03-Managing-human-population.mdx",
      "status": "draft",
      "sourceSha256": "b5463aa0baed59b7db17228656d52f8375a28b2553a2749ceb8fdcbd27ef25e4"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-04",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-04-Managing-ecosystems-and-biodiversity.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-04-Managing-ecosystems-and-biodiversity",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-04-Managing-ecosystems-and-biodiversity.mdx",
      "status": "published",
      "sourceSha256": "2b9cf49a46ca5801ea758e5fd6a30c5ec486c5f1334f21e65bd164ceba972a20"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-04-Managing-ecosystems-and-biodiversity",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-04-Managing-ecosystems-and-biodiversity.mdx",
      "status": "draft",
      "sourceSha256": "2b9cf49a46ca5801ea758e5fd6a30c5ec486c5f1334f21e65bd164ceba972a20"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-05",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-05-Managing-resources.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-05-Managing-resources",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-05-Managing-resources.mdx",
      "status": "published",
      "sourceSha256": "991acb1080547c11642f64afb466427efdebeb1f7087830bcade90634b541da7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-05-Managing-resources",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-05-Managing-resources.mdx",
      "status": "draft",
      "sourceSha256": "991acb1080547c11642f64afb466427efdebeb1f7087830bcade90634b541da7"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-06",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-06-Managing-water-supplies.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-06-Managing-water-supplies",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-06-Managing-water-supplies.mdx",
      "status": "published",
      "sourceSha256": "9858cfa1f61d2f42af4b6231cf6136366f6061a86cd84e7fdc45ccb91191f248"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-06-Managing-water-supplies",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-06-Managing-water-supplies.mdx",
      "status": "draft",
      "sourceSha256": "9858cfa1f61d2f42af4b6231cf6136366f6061a86cd84e7fdc45ccb91191f248"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-07",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-07-Managing-the-atmosphere.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-07-Managing-the-atmosphere",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-07-Managing-the-atmosphere.mdx",
      "status": "published",
      "sourceSha256": "a15310d4be6bcb3b0b68dc1d54204cf0c5d8dcdf1f7615b001bdcf7b78e76680"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-07-Managing-the-atmosphere",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-07-Managing-the-atmosphere.mdx",
      "status": "draft",
      "sourceSha256": "a15310d4be6bcb3b0b68dc1d54204cf0c5d8dcdf1f7615b001bdcf7b78e76680"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-08",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-08-Managing-climate-change.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-08-Managing-climate-change",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-08-Managing-climate-change.mdx",
      "status": "published",
      "sourceSha256": "044e81910a45456d20f6e8d266b5da4923f2f60a85ef97dd65d640729f40a761"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-notes/Cambridge-International-AS-Environmental-Management-08-Managing-climate-change",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-08-Managing-climate-change.mdx",
      "status": "draft",
      "sourceSha256": "044e81910a45456d20f6e8d266b5da4923f2f60a85ef97dd65d640729f40a761"
    }
  ]
}
,
{
  "id": "article.cambridge-as-environmental-investigations-01",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-01-Scientific-method-and-research-questions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-01-Scientific-method-and-research-questions",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-01-Scientific-method-and-research-questions.mdx",
      "status": "published",
      "sourceSha256": "7087662a15f8f05a98ea55e2e1fa8d4857a9469bc61188278b1167abf7bcc410"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-01-Scientific-method-and-research-questions",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-Investigations-01-Scientific-method-and-research-questions.mdx",
      "status": "draft",
      "sourceSha256": "7087662a15f8f05a98ea55e2e1fa8d4857a9469bc61188278b1167abf7bcc410"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-investigations-02",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-02-Sampling-and-environmental-data-collection.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-02-Sampling-and-environmental-data-collection",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-02-Sampling-and-environmental-data-collection.mdx",
      "status": "published",
      "sourceSha256": "af8e81980946b6f154cb7bdc305b1aaf0dfdb32e82852b408438d79f92ecba93"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-02-Sampling-and-environmental-data-collection",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-Investigations-02-Sampling-and-environmental-data-collection.mdx",
      "status": "draft",
      "sourceSha256": "af8e81980946b6f154cb7bdc305b1aaf0dfdb32e82852b408438d79f92ecba93"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-investigations-03",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-03-Field-and-laboratory-measurements.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-03-Field-and-laboratory-measurements",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-03-Field-and-laboratory-measurements.mdx",
      "status": "published",
      "sourceSha256": "bc3947443ee6b7784e85f47240f73d8d2c7bc43e7ac1cf9a59d4e8bdb49d15c2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-03-Field-and-laboratory-measurements",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-Investigations-03-Field-and-laboratory-measurements.mdx",
      "status": "draft",
      "sourceSha256": "bc3947443ee6b7784e85f47240f73d8d2c7bc43e7ac1cf9a59d4e8bdb49d15c2"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-investigations-04",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-04-Tables-graphs-maps-and-calculations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-04-Tables-graphs-maps-and-calculations",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-04-Tables-graphs-maps-and-calculations.mdx",
      "status": "published",
      "sourceSha256": "849ff4ab329f54697e9bec6773f53b40ce1c0707bb4fa8a9353d834b04595c89"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-04-Tables-graphs-maps-and-calculations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-Investigations-04-Tables-graphs-maps-and-calculations.mdx",
      "status": "draft",
      "sourceSha256": "849ff4ab329f54697e9bec6773f53b40ce1c0707bb4fa8a9353d834b04595c89"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-investigations-05",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-05-Conclusions-limitations-and-evaluation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-05-Conclusions-limitations-and-evaluation",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-05-Conclusions-limitations-and-evaluation.mdx",
      "status": "published",
      "sourceSha256": "b0375f6e0b6259342b5bb05ca36f98f74c243c708f0983f98673b4d99f4e5bab"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-05-Conclusions-limitations-and-evaluation",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-Investigations-05-Conclusions-limitations-and-evaluation.mdx",
      "status": "draft",
      "sourceSha256": "b0375f6e0b6259342b5bb05ca36f98f74c243c708f0983f98673b4d99f4e5bab"
    }
  ]
},
{
  "id": "article.cambridge-as-environmental-investigations-06",
  "englishSourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-06-Management-in-Context-Paper-2-strategy.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-06-Management-in-Context-Paper-2-strategy",
      "sourcePath": "content/posts/Cambridge-International-AS-Environmental-Management-Investigations-06-Management-in-Context-Paper-2-strategy.mdx",
      "status": "published",
      "sourceSha256": "54542186c5c8a2eddafc337081a23e1923daf205d7f449067c79099d6bf1a88b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-as-environmental-management-investigations/Cambridge-International-AS-Environmental-Management-Investigations-06-Management-in-Context-Paper-2-strategy",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-AS-Environmental-Management-Investigations-06-Management-in-Context-Paper-2-strategy.mdx",
      "status": "draft",
      "sourceSha256": "54542186c5c8a2eddafc337081a23e1923daf205d7f449067c79099d6bf1a88b"
    }
  ]
}
,
{
  "id": "article.ip-maths-year-by-year-roadmap",
  "englishSourcePath": "content/posts/IP-Math-Year-by-Year-Roadmap-and-12-Week-Grade-Jump-Plan.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-maths-tuition/IP-Math-Year-by-Year-Roadmap-and-12-Week-Grade-Jump-Plan",
      "sourcePath": "content/posts/IP-Math-Year-by-Year-Roadmap-and-12-Week-Grade-Jump-Plan.mdx",
      "status": "published",
      "sourceSha256": "d5d5b5db2f2be75312a3ef4cc4fb4c43a567041e39670f0af83654eae2850f70"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-maths-tuition/IP-Math-Year-by-Year-Roadmap-and-12-Week-Grade-Jump-Plan",
      "sourcePath": "content/translations/zh-Hans/IP-Math-Year-by-Year-Roadmap-and-12-Week-Grade-Jump-Plan.mdx",
      "status": "draft",
      "sourceSha256": "d5d5b5db2f2be75312a3ef4cc4fb4c43a567041e39670f0af83654eae2850f70"
    }
  ]
}
,
{
  "id": "article.reducing-careless-mistakes-maths",
  "englishSourcePath": "content/posts/Reducing-Careless-Mistakes-in-Mathematics-for-Integrated-Programme-O-Levels-A-Levels.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-maths-tuition/Reducing-Careless-Mistakes-in-Mathematics-for-Integrated-Programme-O-Levels-A-Levels",
      "sourcePath": "content/posts/Reducing-Careless-Mistakes-in-Mathematics-for-Integrated-Programme-O-Levels-A-Levels.mdx",
      "status": "published",
      "sourceSha256": "efbb4216df4796f382bdabe43a5a5056a4fcd3722a08b2e18a23480ae96a3245"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-maths-tuition/Reducing-Careless-Mistakes-in-Mathematics-for-Integrated-Programme-O-Levels-A-Levels",
      "sourcePath": "content/translations/zh-Hans/Reducing-Careless-Mistakes-in-Mathematics-for-Integrated-Programme-O-Levels-A-Levels.mdx",
      "status": "draft",
      "sourceSha256": "efbb4216df4796f382bdabe43a5a5056a4fcd3722a08b2e18a23480ae96a3245"
    }
  ]
}
,
{
  "id": "article.ip-maths-syllabus-scope-guide",
  "englishSourcePath": "content/posts/IP-Maths-Syllabus-Singapore-2026-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-maths-tuition/IP-Maths-Syllabus-Singapore-2026-Guide",
      "sourcePath": "content/posts/IP-Maths-Syllabus-Singapore-2026-Guide.mdx",
      "status": "published",
      "sourceSha256": "aafe7ecee272d5fc69789e08beef06148bac8badd94a1647282fe6cdb37dd75a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-maths-tuition/IP-Maths-Syllabus-Singapore-2026-Guide",
      "sourcePath": "content/translations/zh-Hans/IP-Maths-Syllabus-Singapore-2026-Guide.mdx",
      "status": "draft",
      "sourceSha256": "aafe7ecee272d5fc69789e08beef06148bac8badd94a1647282fe6cdb37dd75a"
    }
  ]
}
,
{
  "id": "article.mathematics-ten-year-series",
  "englishSourcePath": "content/posts/Mathematics-Ten-Year-Series-(TYS)-for-O-Level-and-A-Level.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/ip-maths-tuition/Mathematics-Ten-Year-Series-(TYS)-for-O-Level-and-A-Level",
      "sourcePath": "content/posts/Mathematics-Ten-Year-Series-(TYS)-for-O-Level-and-A-Level.mdx",
      "status": "published",
      "sourceSha256": "2dcd3177238adb74091edd581c3eee6d1d6fa40606229d2e66d8dd6fa92132ee"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/ip-maths-tuition/Mathematics-Ten-Year-Series-(TYS)-for-O-Level-and-A-Level",
      "sourcePath": "content/translations/zh-Hans/Mathematics-Ten-Year-Series-(TYS)-for-O-Level-and-A-Level.mdx",
      "status": "draft",
      "sourceSha256": "2dcd3177238adb74091edd581c3eee6d1d6fa40606229d2e66d8dd6fa92132ee"
    }
  ]
}
,
{
  "id": "article.h2-gc-techniques",
  "englishSourcePath": "content/posts/Graphing-Calculator-Techniques-H2-Maths-Exam-Guide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/h2-maths-notes/Graphing-Calculator-Techniques-H2-Maths-Exam-Guide",
      "sourcePath": "content/posts/Graphing-Calculator-Techniques-H2-Maths-Exam-Guide.mdx",
      "status": "published",
      "sourceSha256": "f3a203fac6475f2a426f9116570efb35e1408e3d9f65622beabc061e7a8c81d8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/h2-maths-notes/Graphing-Calculator-Techniques-H2-Maths-Exam-Guide",
      "sourcePath": "content/translations/zh-Hans/Graphing-Calculator-Techniques-H2-Maths-Exam-Guide.mdx",
      "status": "draft",
      "sourceSha256": "f3a203fac6475f2a426f9116570efb35e1408e3d9f65622beabc061e7a8c81d8"
    }
  ]
}
,
{
  "id": "article.cambridge-0479-statistics-01",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-01-Data-and-its-collection.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-01-Data-and-its-collection",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-01-Data-and-its-collection.mdx",
      "status": "published",
      "sourceSha256": "293a00f908a2970468fa1d469c3b01a0f69d3e091a7946b28c379729146ca9e4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-01-Data-and-its-collection",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-01-Data-and-its-collection.mdx",
      "status": "draft",
      "sourceSha256": "293a00f908a2970468fa1d469c3b01a0f69d3e091a7946b28c379729146ca9e4"
    }
  ]
}
,
{
  "id": "article.cambridge-0479-statistics-02",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-02-Representation-of-data.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-02-Representation-of-data",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-02-Representation-of-data.mdx",
      "status": "published",
      "sourceSha256": "4352e720711490eb4387c3f3cb02cc78d4b804561669a98dabf66139e8e3d37f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-02-Representation-of-data",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-02-Representation-of-data.mdx",
      "status": "draft",
      "sourceSha256": "4352e720711490eb4387c3f3cb02cc78d4b804561669a98dabf66139e8e3d37f"
    }
  ]
}
,
{
  "id": "article.cambridge-0479-statistics-03",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-03-Frequency-distributions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-03-Frequency-distributions",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-03-Frequency-distributions.mdx",
      "status": "published",
      "sourceSha256": "b2aebf6106fd6e10c091dd566adb796c44dc2eaa77f8fd1f3d85494cb10276a4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-03-Frequency-distributions",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-03-Frequency-distributions.mdx",
      "status": "draft",
      "sourceSha256": "b2aebf6106fd6e10c091dd566adb796c44dc2eaa77f8fd1f3d85494cb10276a4"
    }
  ]
}
,
{
  "id": "article.cambridge-0479-statistics-04",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-04-Measures-of-central-tendency.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-04-Measures-of-central-tendency",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-04-Measures-of-central-tendency.mdx",
      "status": "published",
      "sourceSha256": "a581862df45de052cea12efb259caf75f7d92af8af3b2577e7540906585a4681"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-04-Measures-of-central-tendency",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-04-Measures-of-central-tendency.mdx",
      "status": "draft",
      "sourceSha256": "a581862df45de052cea12efb259caf75f7d92af8af3b2577e7540906585a4681"
    }
  ]
}
,
{
  "id": "article.cambridge-0479-statistics-05",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-05-Quartiles-percentiles-and-measures-of-dispersion.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-05-Quartiles-percentiles-and-measures-of-dispersion",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-05-Quartiles-percentiles-and-measures-of-dispersion.mdx",
      "status": "published",
      "sourceSha256": "e15d37b8795c4739537f121e55afacc9239317b764c0d3f72c209d39700c9f83"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-05-Quartiles-percentiles-and-measures-of-dispersion",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-05-Quartiles-percentiles-and-measures-of-dispersion.mdx",
      "status": "draft",
      "sourceSha256": "e15d37b8795c4739537f121e55afacc9239317b764c0d3f72c209d39700c9f83"
    }
  ]
},
{
  "id": "article.cambridge-0479-statistics-06",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-06-Transformations-of-data-sets.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-06-Transformations-of-data-sets",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-06-Transformations-of-data-sets.mdx",
      "status": "published",
      "sourceSha256": "55047a9f9f541f7e45beacbcd09c713fa8512958c5be501a00eefd6a6a85b8da"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-06-Transformations-of-data-sets",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-06-Transformations-of-data-sets.mdx",
      "status": "draft",
      "sourceSha256": "55047a9f9f541f7e45beacbcd09c713fa8512958c5be501a00eefd6a6a85b8da"
    }
  ]
}
,
{
  "id": "article.cambridge-0479-statistics-07",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-07-Probability.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-07-Probability",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-07-Probability.mdx",
      "status": "published",
      "sourceSha256": "3bbb4aeb39875853a5b66fa8ba72f412d5f5954069ff2a0fc3a1817b2746db8e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-07-Probability",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-07-Probability.mdx",
      "status": "draft",
      "sourceSha256": "3bbb4aeb39875853a5b66fa8ba72f412d5f5954069ff2a0fc3a1817b2746db8e"
    }
  ]
},
{
  "id": "article.cambridge-0479-statistics-08",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-08-Probability-distributions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-08-Probability-distributions",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-08-Probability-distributions.mdx",
      "status": "published",
      "sourceSha256": "c111ffe34c676e66f78c3481ec9643747f860d32c64c996c5d3334c295b50cd2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-08-Probability-distributions",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-08-Probability-distributions.mdx",
      "status": "draft",
      "sourceSha256": "c111ffe34c676e66f78c3481ec9643747f860d32c64c996c5d3334c295b50cd2"
    }
  ]
}
,
{
  "id": "article.cambridge-0479-statistics-09",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-09-Crude-and-standardised-rates.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-09-Crude-and-standardised-rates",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-09-Crude-and-standardised-rates.mdx",
      "status": "published",
      "sourceSha256": "4b4d84f0b9fcc8bc30b1adf78b2cf2651bebc4d1a05034713f40fa2daebb5978"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-09-Crude-and-standardised-rates",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-09-Crude-and-standardised-rates.mdx",
      "status": "draft",
      "sourceSha256": "4b4d84f0b9fcc8bc30b1adf78b2cf2651bebc4d1a05034713f40fa2daebb5978"
    }
  ]
},
{
  "id": "article.cambridge-0479-statistics-10",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-10-Index-numbers.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-10-Index-numbers",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-10-Index-numbers.mdx",
      "status": "published",
      "sourceSha256": "e7a3f4900e5c9e0c2888a747fa892fd3b1946bc2ebf0dda8e1bbbfd213059522"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-10-Index-numbers",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-10-Index-numbers.mdx",
      "status": "draft",
      "sourceSha256": "e7a3f4900e5c9e0c2888a747fa892fd3b1946bc2ebf0dda8e1bbbfd213059522"
    }
  ]
}
,
{
  "id": "article.cambridge-0479-statistics-11",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-11-Bivariate-distributions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-11-Bivariate-distributions",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-11-Bivariate-distributions.mdx",
      "status": "published",
      "sourceSha256": "6e66f9ecb941833bb6c1341c4a5ec1ce2b6ffbe9f883214e84d07e7f3bd2d2dd"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-11-Bivariate-distributions",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-11-Bivariate-distributions.mdx",
      "status": "draft",
      "sourceSha256": "6e66f9ecb941833bb6c1341c4a5ec1ce2b6ffbe9f883214e84d07e7f3bd2d2dd"
    }
  ]
},
{
  "id": "article.cambridge-0479-statistics-12",
  "englishSourcePath": "content/posts/Cambridge-0479-Statistics-12-Time-series.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-statistics-notes/Cambridge-0479-Statistics-12-Time-series",
      "sourcePath": "content/posts/Cambridge-0479-Statistics-12-Time-series.mdx",
      "status": "published",
      "sourceSha256": "27ad9a82d33443bcdd4308591c0910cd67b259cc52f9938295b497c22edf34e8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-statistics-notes/Cambridge-0479-Statistics-12-Time-series",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0479-Statistics-12-Time-series.mdx",
      "status": "draft",
      "sourceSha256": "27ad9a82d33443bcdd4308591c0910cd67b259cc52f9938295b497c22edf34e8"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-01",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-01-Number.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-01-Number",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-01-Number.mdx",
      "status": "published",
      "sourceSha256": "1dffa013b927f11bff86b5b429264a9f8a739f46073c8f24268a3addb05ce22a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-01-Number",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-01-Number.mdx",
      "status": "draft",
      "sourceSha256": "1dffa013b927f11bff86b5b429264a9f8a739f46073c8f24268a3addb05ce22a"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-02",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-02-Algebra.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-02-Algebra",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-02-Algebra.mdx",
      "status": "published",
      "sourceSha256": "c685f434f3ea84a5b306f3bff2dcdb6cdc8167e7665531c141081a748fa2511b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-02-Algebra",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-02-Algebra.mdx",
      "status": "draft",
      "sourceSha256": "c685f434f3ea84a5b306f3bff2dcdb6cdc8167e7665531c141081a748fa2511b"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-03",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-03-Functions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-03-Functions",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-03-Functions.mdx",
      "status": "published",
      "sourceSha256": "c86f49f7a3362aa4cc3b720720c30dc1b6a4ad86d16329f6707b244d5ba08f1e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-03-Functions",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-03-Functions.mdx",
      "status": "draft",
      "sourceSha256": "c86f49f7a3362aa4cc3b720720c30dc1b6a4ad86d16329f6707b244d5ba08f1e"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-04",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-04-Coordinate-geometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-04-Coordinate-geometry",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-04-Coordinate-geometry.mdx",
      "status": "published",
      "sourceSha256": "7fcbd5b94f59cf4f2fd6f3b055194eab63940872380ffe4c1b72d0f7472e4f19"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-04-Coordinate-geometry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-04-Coordinate-geometry.mdx",
      "status": "draft",
      "sourceSha256": "7fcbd5b94f59cf4f2fd6f3b055194eab63940872380ffe4c1b72d0f7472e4f19"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-05",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-05-Geometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-05-Geometry",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-05-Geometry.mdx",
      "status": "published",
      "sourceSha256": "e799a77ff97bee52bf6ddd7cd56860e44779c2c83d5ffb45a8c6db5adf888380"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-05-Geometry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-05-Geometry.mdx",
      "status": "draft",
      "sourceSha256": "e799a77ff97bee52bf6ddd7cd56860e44779c2c83d5ffb45a8c6db5adf888380"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-06",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-06-Mensuration.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-06-Mensuration",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-06-Mensuration.mdx",
      "status": "published",
      "sourceSha256": "61cbd3e6ea1457c48c13582f17a3b9a63e0e89833a1265ba0b9eebc7553253c1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-06-Mensuration",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-06-Mensuration.mdx",
      "status": "draft",
      "sourceSha256": "61cbd3e6ea1457c48c13582f17a3b9a63e0e89833a1265ba0b9eebc7553253c1"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-07",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-07-Trigonometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-07-Trigonometry",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-07-Trigonometry.mdx",
      "status": "published",
      "sourceSha256": "b559c388c346ce94611da70cc85c46a9deebc102a5c2bd90df864e7d0fab6920"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-07-Trigonometry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-07-Trigonometry.mdx",
      "status": "draft",
      "sourceSha256": "b559c388c346ce94611da70cc85c46a9deebc102a5c2bd90df864e7d0fab6920"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-08",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-08-Transformations-and-vectors.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-08-Transformations-and-vectors",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-08-Transformations-and-vectors.mdx",
      "status": "published",
      "sourceSha256": "76a0dc3022a18ef5ebae1f89d3f526a70da24473329e2b0a2bbff19be4ba5ab7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-08-Transformations-and-vectors",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-08-Transformations-and-vectors.mdx",
      "status": "draft",
      "sourceSha256": "76a0dc3022a18ef5ebae1f89d3f526a70da24473329e2b0a2bbff19be4ba5ab7"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-09",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-09-Probability.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-09-Probability",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-09-Probability.mdx",
      "status": "published",
      "sourceSha256": "b920d7e91fa62087032d76afcb886cea09651e89fc5ce2dfaecb17c4ccdb2aaf"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-09-Probability",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-09-Probability.mdx",
      "status": "draft",
      "sourceSha256": "b920d7e91fa62087032d76afcb886cea09651e89fc5ce2dfaecb17c4ccdb2aaf"
    }
  ]
},
{
  "id": "article.cambridge-0607-international-mathematics-10",
  "englishSourcePath": "content/posts/Cambridge-0607-International-Mathematics-10-Statistics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-10-Statistics",
      "sourcePath": "content/posts/Cambridge-0607-International-Mathematics-10-Statistics.mdx",
      "status": "published",
      "sourceSha256": "273e649c16ecb89c1a6f7905bfe47b084f836d2b488d7ca19283870b330679da"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-international-mathematics-notes/Cambridge-0607-International-Mathematics-10-Statistics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0607-International-Mathematics-10-Statistics.mdx",
      "status": "draft",
      "sourceSha256": "273e649c16ecb89c1a6f7905bfe47b084f836d2b488d7ca19283870b330679da"
    }
  ]
},
{
  "id": "article.cambridge-0680-environmental-04",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-04-The-atmosphere-and-human-activities.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-04-The-atmosphere-and-human-activities",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-04-The-atmosphere-and-human-activities.mdx",
      "status": "published",
      "sourceSha256": "f80e5a3718bdf9cb8391018ad5eaab7a1c06ca0cf65383bfe9e81b1dd08876cd"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-04-The-atmosphere-and-human-activities",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-04-The-atmosphere-and-human-activities.mdx",
      "status": "draft",
      "sourceSha256": "f80e5a3718bdf9cb8391018ad5eaab7a1c06ca0cf65383bfe9e81b1dd08876cd"
    }
  ]
},
{
  "id": "article.cambridge-0680-environmental-02",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-02-Land.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-02-Land",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-02-Land.mdx",
      "status": "published",
      "sourceSha256": "f78c39533ca3df8724e55ca35ec4384f622810cd1ed1c3b83d9dca7d5a5c334a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-02-Land",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-02-Land.mdx",
      "status": "draft",
      "sourceSha256": "f78c39533ca3df8724e55ca35ec4384f622810cd1ed1c3b83d9dca7d5a5c334a"
    }
  ]
},
{
  "id": "article.cambridge-0680-environmental-03",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-03-Water.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-03-Water",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-03-Water.mdx",
      "status": "published",
      "sourceSha256": "0e96d61cf20fccb85ea4ce53f7c0b99239b9448212026eb7032016ed4357d337"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-03-Water",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-03-Water.mdx",
      "status": "draft",
      "sourceSha256": "0e96d61cf20fccb85ea4ce53f7c0b99239b9448212026eb7032016ed4357d337"
    }
  ]
},
{
  "id": "article.cambridge-0680-environmental-01",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-01-Natural-resources.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-01-Natural-resources",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-01-Natural-resources.mdx",
      "status": "published",
      "sourceSha256": "e0c926936c6453232adf318aeba663d53fd0ff280108bd6022b363b733a93018"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-01-Natural-resources",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-01-Natural-resources.mdx",
      "status": "draft",
      "sourceSha256": "e0c926936c6453232adf318aeba663d53fd0ff280108bd6022b363b733a93018"
    }
  ]
},
{
  "id": "article.cambridge-0680-environmental-05",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-05-Ecosystems-biodiversity-and-fieldwork.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-05-Ecosystems-biodiversity-and-fieldwork",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-05-Ecosystems-biodiversity-and-fieldwork.mdx",
      "status": "published",
      "sourceSha256": "ddbaca960433f16eb9a27bdb40d0cd9a7898b2219eb704acf31b3714caa09981"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-05-Ecosystems-biodiversity-and-fieldwork",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-05-Ecosystems-biodiversity-and-fieldwork.mdx",
      "status": "draft",
      "sourceSha256": "ddbaca960433f16eb9a27bdb40d0cd9a7898b2219eb704acf31b3714caa09981"
    }
  ]
},
{
  "id": "article.cambridge-0680-environmental-06",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-06-Natural-hazards.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-06-Natural-hazards",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-06-Natural-hazards.mdx",
      "status": "published",
      "sourceSha256": "2a632b17e2de808948529bad80e988d00d2febe72ec52f79108d7621672d066b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-06-Natural-hazards",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-06-Natural-hazards.mdx",
      "status": "draft",
      "sourceSha256": "2a632b17e2de808948529bad80e988d00d2febe72ec52f79108d7621672d066b"
    }
  ]
},
{
  "id": "article.cambridge-0680-environmental-07",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-07-Human-population.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-07-Human-population",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-07-Human-population.mdx",
      "status": "published",
      "sourceSha256": "dab903f0b629c673e1fb2c44ab9d6aec72e8a6971cefcbf35da2ad85a0c62a87"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-notes/Cambridge-0680-Environmental-Management-07-Human-population",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-07-Human-population.mdx",
      "status": "draft",
      "sourceSha256": "dab903f0b629c673e1fb2c44ab9d6aec72e8a6971cefcbf35da2ad85a0c62a87"
    }
  ]
},
{
  "id": "article.cambridge-0680-fieldwork-01",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-01-Fieldwork-planning-and-sampling.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-01-Fieldwork-planning-and-sampling",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-01-Fieldwork-planning-and-sampling.mdx",
      "status": "published",
      "sourceSha256": "3691a48527852eb6367195fd30c5f5557ac1d483a7cc249125440fdd45b4670e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-01-Fieldwork-planning-and-sampling",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-Fieldwork-01-Fieldwork-planning-and-sampling.mdx",
      "status": "draft",
      "sourceSha256": "3691a48527852eb6367195fd30c5f5557ac1d483a7cc249125440fdd45b4670e"
    }
  ]
},
{
  "id": "article.cambridge-0680-fieldwork-02",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-02-Environmental-measurements-and-equipment.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-02-Environmental-measurements-and-equipment",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-02-Environmental-measurements-and-equipment.mdx",
      "status": "published",
      "sourceSha256": "fd5ea660afede2fc6b44e788b9c633bbccecb12d5624b87f062d7169c5875d6a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-02-Environmental-measurements-and-equipment",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-Fieldwork-02-Environmental-measurements-and-equipment.mdx",
      "status": "draft",
      "sourceSha256": "fd5ea660afede2fc6b44e788b9c633bbccecb12d5624b87f062d7169c5875d6a"
    }
  ]
},
{
  "id": "article.cambridge-0680-fieldwork-03",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-03-Risk-ethics-and-habitat-protection.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-03-Risk-ethics-and-habitat-protection",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-03-Risk-ethics-and-habitat-protection.mdx",
      "status": "published",
      "sourceSha256": "683fa1ff1b4a74ccd0414b5153d87b9a19ce3536e61ab0d9074501f3ff0b3a80"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-03-Risk-ethics-and-habitat-protection",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-Fieldwork-03-Risk-ethics-and-habitat-protection.mdx",
      "status": "draft",
      "sourceSha256": "683fa1ff1b4a74ccd0414b5153d87b9a19ce3536e61ab0d9074501f3ff0b3a80"
    }
  ]
},
{
  "id": "article.cambridge-0680-fieldwork-04",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-04-Tables-maps-graphs-and-spatial-data.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-04-Tables-maps-graphs-and-spatial-data",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-04-Tables-maps-graphs-and-spatial-data.mdx",
      "status": "published",
      "sourceSha256": "38e4fdfd4f51163be2d27e63c29c33deaf128bd316dd06a7b2b028f5b8ffc6c6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-04-Tables-maps-graphs-and-spatial-data",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-Fieldwork-04-Tables-maps-graphs-and-spatial-data.mdx",
      "status": "draft",
      "sourceSha256": "38e4fdfd4f51163be2d27e63c29c33deaf128bd316dd06a7b2b028f5b8ffc6c6"
    }
  ]
},
{
  "id": "article.cambridge-0680-fieldwork-05",
  "englishSourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-05-Evidence-based-evaluation-and-management-decisions.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-05-Evidence-based-evaluation-and-management-decisions",
      "sourcePath": "content/posts/Cambridge-0680-Environmental-Management-Fieldwork-05-Evidence-based-evaluation-and-management-decisions.mdx",
      "status": "published",
      "sourceSha256": "b900697c30f49fb1e266f1b34b5157f822625a30b3487a8f930f677cd43659c5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-environmental-management-fieldwork/Cambridge-0680-Environmental-Management-Fieldwork-05-Evidence-based-evaluation-and-management-decisions",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0680-Environmental-Management-Fieldwork-05-Evidence-based-evaluation-and-management-decisions.mdx",
      "status": "draft",
      "sourceSha256": "b900697c30f49fb1e266f1b34b5157f822625a30b3487a8f930f677cd43659c5"
    }
  ]
},
{
  "id": "article.cambridge-0697-marine-02",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-02-Sea-water.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-02-Sea-water",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-02-Sea-water.mdx",
      "status": "published",
      "sourceSha256": "aa1e52e26771b6cb397c8be3e39ade1d7fc7cdc9dcf436a683f4f7679bc3aac5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-02-Sea-water",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-02-Sea-water.mdx",
      "status": "draft",
      "sourceSha256": "aa1e52e26771b6cb397c8be3e39ade1d7fc7cdc9dcf436a683f4f7679bc3aac5"
    }
  ]
},
{
  "id": "article.cambridge-0697-marine-03",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-03-Marine-organisms.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-03-Marine-organisms",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-03-Marine-organisms.mdx",
      "status": "published",
      "sourceSha256": "e88d3b9aa444cc8d3a22b2668bffea302fafb42d3df48b451e785703db17cec1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-03-Marine-organisms",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-03-Marine-organisms.mdx",
      "status": "draft",
      "sourceSha256": "e88d3b9aa444cc8d3a22b2668bffea302fafb42d3df48b451e785703db17cec1"
    }
  ]
},
{
  "id": "article.cambridge-0697-marine-04",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-04-Nutrients-and-energy.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-04-Nutrients-and-energy",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-04-Nutrients-and-energy.mdx",
      "status": "published",
      "sourceSha256": "776531247007d6a84e224eddf602bae1735a860fd1542e87dabec2b461c4e945"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-04-Nutrients-and-energy",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-04-Nutrients-and-energy.mdx",
      "status": "draft",
      "sourceSha256": "776531247007d6a84e224eddf602bae1735a860fd1542e87dabec2b461c4e945"
    }
  ]
},
{
  "id": "article.cambridge-0697-marine-05",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-05-Marine-ecology.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-05-Marine-ecology",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-05-Marine-ecology.mdx",
      "status": "published",
      "sourceSha256": "370bfecf969671917d86c8954825d68976d99439155c19f2c05c3111dc1f7d77"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-05-Marine-ecology",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-05-Marine-ecology.mdx",
      "status": "draft",
      "sourceSha256": "370bfecf969671917d86c8954825d68976d99439155c19f2c05c3111dc1f7d77"
    }
  ]
},
{
  "id": "article.cambridge-0697-marine-06",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-06-Human-influences-on-the-marine-environment.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-06-Human-influences-on-the-marine-environment",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-06-Human-influences-on-the-marine-environment.mdx",
      "status": "published",
      "sourceSha256": "0e3fc4e88a73c1c503280e8eaf38e0c592e2b663143403c8a90259537d8d5fab"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-06-Human-influences-on-the-marine-environment",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-06-Human-influences-on-the-marine-environment.mdx",
      "status": "draft",
      "sourceSha256": "0e3fc4e88a73c1c503280e8eaf38e0c592e2b663143403c8a90259537d8d5fab"
    }
  ]
},
{
  "id": "article.cambridge-0697-practical-01",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-01-Sea-water-pH-salinity-and-dissolved-substances.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-01-Sea-water-pH-salinity-and-dissolved-substances",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-01-Sea-water-pH-salinity-and-dissolved-substances.mdx",
      "status": "published",
      "sourceSha256": "b8342a5a6d3fa3bf04e6a5f7dcf0bbe520403fa1a639f5db1ab13b723d722bbd"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-01-Sea-water-pH-salinity-and-dissolved-substances",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-Practical-Skills-01-Sea-water-pH-salinity-and-dissolved-substances.mdx",
      "status": "draft",
      "sourceSha256": "b8342a5a6d3fa3bf04e6a5f7dcf0bbe520403fa1a639f5db1ab13b723d722bbd"
    }
  ]
},
{
  "id": "article.cambridge-0697-practical-03",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-03-Marine-organism-observation-and-identification.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-03-Marine-organism-observation-and-identification",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-03-Marine-organism-observation-and-identification.mdx",
      "status": "published",
      "sourceSha256": "7cf49e05462079c2801a4f6960fd346267445381427547ab0e288351a7ff1dee"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-03-Marine-organism-observation-and-identification",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-Practical-Skills-03-Marine-organism-observation-and-identification.mdx",
      "status": "draft",
      "sourceSha256": "7cf49e05462079c2801a4f6960fd346267445381427547ab0e288351a7ff1dee"
    }
  ]
},
{
  "id": "article.cambridge-0697-practical-04",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-04-Primary-productivity-and-nutrient-investigations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-04-Primary-productivity-and-nutrient-investigations",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-04-Primary-productivity-and-nutrient-investigations.mdx",
      "status": "published",
      "sourceSha256": "fc6a41f3a594b28d95a2fcc8bf0ce111412408373a1ef9c2822fb631657f6229"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-04-Primary-productivity-and-nutrient-investigations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-Practical-Skills-04-Primary-productivity-and-nutrient-investigations.mdx",
      "status": "draft",
      "sourceSha256": "fc6a41f3a594b28d95a2fcc8bf0ce111412408373a1ef9c2822fb631657f6229"
    }
  ]
},
{
  "id": "article.cambridge-0697-practical-05",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-05-Ecological-sampling-and-biodiversity.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-05-Ecological-sampling-and-biodiversity",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-05-Ecological-sampling-and-biodiversity.mdx",
      "status": "published",
      "sourceSha256": "8fca213a4800c218106b687402cd0b7910e9fcfd4e21f2b7447c60cdac7fa6e6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-05-Ecological-sampling-and-biodiversity",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-Practical-Skills-05-Ecological-sampling-and-biodiversity.mdx",
      "status": "draft",
      "sourceSha256": "8fca213a4800c218106b687402cd0b7910e9fcfd4e21f2b7447c60cdac7fa6e6"
    }
  ]
},
{
  "id": "article.cambridge-0697-practical-06",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-06-Pollution-human-impact-and-data-evaluation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-06-Pollution-human-impact-and-data-evaluation",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-06-Pollution-human-impact-and-data-evaluation.mdx",
      "status": "published",
      "sourceSha256": "41cb498a22c62ab9eb1bc3d087da52e0b322d5d52d1e18c4e102b74246416632"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-06-Pollution-human-impact-and-data-evaluation",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-Practical-Skills-06-Pollution-human-impact-and-data-evaluation.mdx",
      "status": "draft",
      "sourceSha256": "41cb498a22c62ab9eb1bc3d087da52e0b322d5d52d1e18c4e102b74246416632"
    }
  ]
},
{
  "id": "article.cambridge-0697-practical-02",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-02-Ocean-and-coastal-physical-measurements.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-02-Ocean-and-coastal-physical-measurements",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-Practical-Skills-02-Ocean-and-coastal-physical-measurements.mdx",
      "status": "published",
      "sourceSha256": "a62a8be6561f6f7e7648e85991fc01239a2d4d7a9301e37e91dc6c91683a474a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-practicals/Cambridge-0697-Marine-Science-Practical-Skills-02-Ocean-and-coastal-physical-measurements",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-Practical-Skills-02-Ocean-and-coastal-physical-measurements.mdx",
      "status": "draft",
      "sourceSha256": "a62a8be6561f6f7e7648e85991fc01239a2d4d7a9301e37e91dc6c91683a474a"
    }
  ]
},
{
  "id": "article.cambridge-0697-marine-01",
  "englishSourcePath": "content/posts/Cambridge-0697-Marine-Science-01-The-Earth-and-its-oceans.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-01-The-Earth-and-its-oceans",
      "sourcePath": "content/posts/Cambridge-0697-Marine-Science-01-The-Earth-and-its-oceans.mdx",
      "status": "published",
      "sourceSha256": "1a878e880714f5e9082409d3156beffd1c844e5459bb5927fdff89ce2b3d22e6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/igcse-marine-science-notes/Cambridge-0697-Marine-Science-01-The-Earth-and-its-oceans",
      "sourcePath": "content/translations/zh-Hans/Cambridge-0697-Marine-Science-01-The-Earth-and-its-oceans.mdx",
      "status": "draft",
      "sourceSha256": "1a878e880714f5e9082409d3156beffd1c844e5459bb5927fdff89ce2b3d22e6"
    }
  ]
},
{
  "id": "article.cambridge-9709-pure-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-01-Pure-Mathematics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-01-Pure-Mathematics-1",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-01-Pure-Mathematics-1.mdx",
      "status": "published",
      "sourceSha256": "7a87a9555678efd85bdcc3ef8eaa1073db880799b66659c34fdb04ddffa265b6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-01-Pure-Mathematics-1",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Mathematics-01-Pure-Mathematics-1.mdx",
      "status": "draft",
      "sourceSha256": "7a87a9555678efd85bdcc3ef8eaa1073db880799b66659c34fdb04ddffa265b6"
    }
  ]
},
{
  "id": "article.cambridge-9709-pure-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-02-Pure-Mathematics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-02-Pure-Mathematics-2",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-02-Pure-Mathematics-2.mdx",
      "status": "published",
      "sourceSha256": "e04a795da95c6038744ca3395056875f506093f2fba89bf0151f8b748f7bf0b8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-02-Pure-Mathematics-2",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Mathematics-02-Pure-Mathematics-2.mdx",
      "status": "draft",
      "sourceSha256": "e04a795da95c6038744ca3395056875f506093f2fba89bf0151f8b748f7bf0b8"
    }
  ]
},
{
  "id": "article.cambridge-9709-pure-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-03-Pure-Mathematics-3.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-03-Pure-Mathematics-3",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-03-Pure-Mathematics-3.mdx",
      "status": "published",
      "sourceSha256": "7afed4f85ba0027504f6dd2c7cd2efc3e659f2b2f0f543595fe3053dd4da6ec3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-03-Pure-Mathematics-3",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Mathematics-03-Pure-Mathematics-3.mdx",
      "status": "draft",
      "sourceSha256": "7afed4f85ba0027504f6dd2c7cd2efc3e659f2b2f0f543595fe3053dd4da6ec3"
    }
  ]
},
{
  "id": "article.cambridge-9709-mechanics-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-04-Mechanics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-04-Mechanics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-04-Mechanics.mdx",
      "status": "published",
      "sourceSha256": "997242d02730a56f7760f5f95771cc2bfb0b3da5311c87b87915c27fb5f08564"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-04-Mechanics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Mathematics-04-Mechanics.mdx",
      "status": "draft",
      "sourceSha256": "997242d02730a56f7760f5f95771cc2bfb0b3da5311c87b87915c27fb5f08564"
    }
  ]
},
{
  "id": "article.cambridge-9709-statistics-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-05-Probability-and-Statistics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-05-Probability-and-Statistics-1",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-05-Probability-and-Statistics-1.mdx",
      "status": "published",
      "sourceSha256": "d0e667afbc7efa87c1ae4c3e3f49a9e176a70a96f4cfc44fce2161c4549e96c9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-05-Probability-and-Statistics-1",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Mathematics-05-Probability-and-Statistics-1.mdx",
      "status": "draft",
      "sourceSha256": "d0e667afbc7efa87c1ae4c3e3f49a9e176a70a96f4cfc44fce2161c4549e96c9"
    }
  ]
},
{
  "id": "article.cambridge-9709-statistics-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-06-Probability-and-Statistics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-06-Probability-and-Statistics-2",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Mathematics-06-Probability-and-Statistics-2.mdx",
      "status": "published",
      "sourceSha256": "2850e9a4e21ad0b2022f5ebc26fd6aa290fa8e568608cfbc4b8f10a8e2cd52ab"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-mathematics-notes/Cambridge-International-A-Level-Mathematics-06-Probability-and-Statistics-2",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Mathematics-06-Probability-and-Statistics-2.mdx",
      "status": "draft",
      "sourceSha256": "2850e9a4e21ad0b2022f5ebc26fd6aa290fa8e568608cfbc4b8f10a8e2cd52ab"
    }
  ]
},
{
  "id": "article.cambridge-9231-further-pure-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Further-Mathematics-01-Further-Pure-Mathematics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-further-mathematics-notes/Cambridge-International-A-Level-Further-Mathematics-01-Further-Pure-Mathematics-1",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Further-Mathematics-01-Further-Pure-Mathematics-1.mdx",
      "status": "published",
      "sourceSha256": "da20bab9563541fa219ffd989ee83b4128b2b110de611586e345eef20ad4cb56"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-further-mathematics-notes/Cambridge-International-A-Level-Further-Mathematics-01-Further-Pure-Mathematics-1",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Further-Mathematics-01-Further-Pure-Mathematics-1.mdx",
      "status": "draft",
      "sourceSha256": "da20bab9563541fa219ffd989ee83b4128b2b110de611586e345eef20ad4cb56"
    }
  ]
},
{
  "id": "article.cambridge-9231-further-pure-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Further-Mathematics-02-Further-Pure-Mathematics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-further-mathematics-notes/Cambridge-International-A-Level-Further-Mathematics-02-Further-Pure-Mathematics-2",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Further-Mathematics-02-Further-Pure-Mathematics-2.mdx",
      "status": "published",
      "sourceSha256": "b94e947d1c9df8979fedfa24e3929194eff3954c30cf03e0e4c976c55cb1017a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-further-mathematics-notes/Cambridge-International-A-Level-Further-Mathematics-02-Further-Pure-Mathematics-2",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Further-Mathematics-02-Further-Pure-Mathematics-2.mdx",
      "status": "draft",
      "sourceSha256": "b94e947d1c9df8979fedfa24e3929194eff3954c30cf03e0e4c976c55cb1017a"
    }
  ]
},
{
  "id": "article.cambridge-9231-further-mechanics-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Further-Mathematics-03-Further-Mechanics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-further-mathematics-notes/Cambridge-International-A-Level-Further-Mathematics-03-Further-Mechanics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Further-Mathematics-03-Further-Mechanics.mdx",
      "status": "published",
      "sourceSha256": "5d66b33ecd4d6050bfd988011c50967f040467bb32215aaf2f357e1934cf335b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-further-mathematics-notes/Cambridge-International-A-Level-Further-Mathematics-03-Further-Mechanics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Further-Mathematics-03-Further-Mechanics.mdx",
      "status": "draft",
      "sourceSha256": "5d66b33ecd4d6050bfd988011c50967f040467bb32215aaf2f357e1934cf335b"
    }
  ]
},
{
  "id": "article.cambridge-9231-further-statistics-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Further-Mathematics-04-Further-Probability-and-Statistics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-further-mathematics-notes/Cambridge-International-A-Level-Further-Mathematics-04-Further-Probability-and-Statistics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Further-Mathematics-04-Further-Probability-and-Statistics.mdx",
      "status": "published",
      "sourceSha256": "4eacdc1aeffcaa94348f44a898b42657f05ae6b8c722b4d0d3dc119308f88707"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-further-mathematics-notes/Cambridge-International-A-Level-Further-Mathematics-04-Further-Probability-and-Statistics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Further-Mathematics-04-Further-Probability-and-Statistics.mdx",
      "status": "draft",
      "sourceSha256": "4eacdc1aeffcaa94348f44a898b42657f05ae6b8c722b4d0d3dc119308f88707"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-p1-01",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-01-P1-Pure-Mathematics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-01-P1-Pure-Mathematics-1",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-01-P1-Pure-Mathematics-1.mdx",
      "status": "published",
      "sourceSha256": "d1664d307acde5c14790cf53437152d05b81692cf09183b3527ff01b873dc616"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-01-P1-Pure-Mathematics-1",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-01-P1-Pure-Mathematics-1.mdx",
      "status": "draft",
      "sourceSha256": "d1664d307acde5c14790cf53437152d05b81692cf09183b3527ff01b873dc616"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-p2-02",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-02-P2-Pure-Mathematics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-02-P2-Pure-Mathematics-2",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-02-P2-Pure-Mathematics-2.mdx",
      "status": "published",
      "sourceSha256": "f4de9c317f74af1eca06e91476d39db76446cfb6546ac73ca4e8a9fef48c9138"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-02-P2-Pure-Mathematics-2",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-02-P2-Pure-Mathematics-2.mdx",
      "status": "draft",
      "sourceSha256": "f4de9c317f74af1eca06e91476d39db76446cfb6546ac73ca4e8a9fef48c9138"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-p3-03",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-03-P3-Pure-Mathematics-3.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-03-P3-Pure-Mathematics-3",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-03-P3-Pure-Mathematics-3.mdx",
      "status": "published",
      "sourceSha256": "c1899c240f95f112aff96ee5cf1ca07f8e4219b362ba16d0fc71027e3b6f65c1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-03-P3-Pure-Mathematics-3",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-03-P3-Pure-Mathematics-3.mdx",
      "status": "draft",
      "sourceSha256": "c1899c240f95f112aff96ee5cf1ca07f8e4219b362ba16d0fc71027e3b6f65c1"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-p4-04",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-04-P4-Pure-Mathematics-4.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-04-P4-Pure-Mathematics-4",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-04-P4-Pure-Mathematics-4.mdx",
      "status": "published",
      "sourceSha256": "8e80714d0a56ec8c9112c64a6b4ad54a97225cecd85434a41023f153a0535bb8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-04-P4-Pure-Mathematics-4",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-04-P4-Pure-Mathematics-4.mdx",
      "status": "draft",
      "sourceSha256": "8e80714d0a56ec8c9112c64a6b4ad54a97225cecd85434a41023f153a0535bb8"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-m1-05",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-05-M1-Mechanics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-05-M1-Mechanics-1",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-05-M1-Mechanics-1.mdx",
      "status": "published",
      "sourceSha256": "4d9f2f600b5d9ee81df19c2b3446f2423b9fce35d492259e1829c45396f0d1ce"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-05-M1-Mechanics-1",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-05-M1-Mechanics-1.mdx",
      "status": "draft",
      "sourceSha256": "4d9f2f600b5d9ee81df19c2b3446f2423b9fce35d492259e1829c45396f0d1ce"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-m2-06",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-06-M2-Mechanics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-06-M2-Mechanics-2",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-06-M2-Mechanics-2.mdx",
      "status": "published",
      "sourceSha256": "8a4461eac978b3e5c8477ec3a5ae41fae519e494d130dbc49d6e33b2a3fbcf2f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-06-M2-Mechanics-2",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-06-M2-Mechanics-2.mdx",
      "status": "draft",
      "sourceSha256": "8a4461eac978b3e5c8477ec3a5ae41fae519e494d130dbc49d6e33b2a3fbcf2f"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-s1-07",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-07-S1-Statistics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-07-S1-Statistics-1",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-07-S1-Statistics-1.mdx",
      "status": "published",
      "sourceSha256": "31e5f3edf72ac2968eac49e8714a1910e18d680a3ddc5255097415181919a8af"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-07-S1-Statistics-1",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-07-S1-Statistics-1.mdx",
      "status": "draft",
      "sourceSha256": "31e5f3edf72ac2968eac49e8714a1910e18d680a3ddc5255097415181919a8af"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-s2-08",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-08-S2-Statistics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-08-S2-Statistics-2",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-08-S2-Statistics-2.mdx",
      "status": "published",
      "sourceSha256": "06342143bb3370cb995bc74acc8e9e34ae7e212be69d92834215bf238174d0e9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-08-S2-Statistics-2",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-08-S2-Statistics-2.mdx",
      "status": "draft",
      "sourceSha256": "06342143bb3370cb995bc74acc8e9e34ae7e212be69d92834215bf238174d0e9"
    }
  ]
},
{
  "id": "article.pearson-ial-maths-d1-09",
  "englishSourcePath": "content/posts/Pearson-IAL-Mathematics-09-D1-Decision-Mathematics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-09-D1-Decision-Mathematics-1",
      "sourcePath": "content/posts/Pearson-IAL-Mathematics-09-D1-Decision-Mathematics-1.mdx",
      "status": "published",
      "sourceSha256": "4ef556f4032cea5c978b302fab64d4c1ec0c98797186f213176b16b793c6c4db"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-mathematics-notes/Pearson-IAL-Mathematics-09-D1-Decision-Mathematics-1",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Mathematics-09-D1-Decision-Mathematics-1.mdx",
      "status": "draft",
      "sourceSha256": "4ef556f4032cea5c978b302fab64d4c1ec0c98797186f213176b16b793c6c4db"
    }
  ]
},
{
  "id": "article.pearson-ial-further-fp1-01",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-01-FP1-Further-Pure-Mathematics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-01-FP1-Further-Pure-Mathematics-1",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-01-FP1-Further-Pure-Mathematics-1.mdx",
      "status": "published",
      "sourceSha256": "c756448bf03bf2d1dffeca647aca96ad2ef22b3542f9082ba67976397b6afca6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-01-FP1-Further-Pure-Mathematics-1",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-01-FP1-Further-Pure-Mathematics-1.mdx",
      "status": "draft",
      "sourceSha256": "c756448bf03bf2d1dffeca647aca96ad2ef22b3542f9082ba67976397b6afca6"
    }
  ]
},
{
  "id": "article.pearson-ial-further-fp2-02",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-02-FP2-Further-Pure-Mathematics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-02-FP2-Further-Pure-Mathematics-2",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-02-FP2-Further-Pure-Mathematics-2.mdx",
      "status": "published",
      "sourceSha256": "1efb47ce3da1788fd1b600c80981b69251f464355d795e9db7bc3a5cd991ef33"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-02-FP2-Further-Pure-Mathematics-2",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-02-FP2-Further-Pure-Mathematics-2.mdx",
      "status": "draft",
      "sourceSha256": "1efb47ce3da1788fd1b600c80981b69251f464355d795e9db7bc3a5cd991ef33"
    }
  ]
},
{
  "id": "article.pearson-ial-further-fp3-03",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-03-FP3-Further-Pure-Mathematics-3.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-03-FP3-Further-Pure-Mathematics-3",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-03-FP3-Further-Pure-Mathematics-3.mdx",
      "status": "published",
      "sourceSha256": "870e892484718b5e36bf75c8dc474b606a75de262d39902fea76601fff75dcba"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-03-FP3-Further-Pure-Mathematics-3",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-03-FP3-Further-Pure-Mathematics-3.mdx",
      "status": "draft",
      "sourceSha256": "870e892484718b5e36bf75c8dc474b606a75de262d39902fea76601fff75dcba"
    }
  ]
},
{
  "id": "article.pearson-ial-further-m1-04",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-04-M1-Mechanics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-04-M1-Mechanics-1",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-04-M1-Mechanics-1.mdx",
      "status": "published",
      "sourceSha256": "d8bfd69da85e67418ba01ec4d54c7c7f82126a07f5170afee070f46c6d708751"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-04-M1-Mechanics-1",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-04-M1-Mechanics-1.mdx",
      "status": "draft",
      "sourceSha256": "d8bfd69da85e67418ba01ec4d54c7c7f82126a07f5170afee070f46c6d708751"
    }
  ]
},
{
  "id": "article.pearson-ial-further-m2-05",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-05-M2-Mechanics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-05-M2-Mechanics-2",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-05-M2-Mechanics-2.mdx",
      "status": "published",
      "sourceSha256": "ad56b73dd1e29b8423c853cd89960b3f353bd0ef69eb46fc675ad5a771837836"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-05-M2-Mechanics-2",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-05-M2-Mechanics-2.mdx",
      "status": "draft",
      "sourceSha256": "ad56b73dd1e29b8423c853cd89960b3f353bd0ef69eb46fc675ad5a771837836"
    }
  ]
},
{
  "id": "article.pearson-ial-further-m3-06",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-06-M3-Mechanics-3.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-06-M3-Mechanics-3",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-06-M3-Mechanics-3.mdx",
      "status": "published",
      "sourceSha256": "21dbcb85a861e4c518a77fd6f4897bc5b80fecb3b0c4393969bf38ec61bbb360"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-06-M3-Mechanics-3",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-06-M3-Mechanics-3.mdx",
      "status": "draft",
      "sourceSha256": "21dbcb85a861e4c518a77fd6f4897bc5b80fecb3b0c4393969bf38ec61bbb360"
    }
  ]
},
{
  "id": "article.pearson-ial-further-s1-07",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-07-S1-Statistics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-07-S1-Statistics-1",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-07-S1-Statistics-1.mdx",
      "status": "published",
      "sourceSha256": "ab21cfc0e39432c69998399f91acbe7e4394537b13809f386ba941ea2ed412ff"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-07-S1-Statistics-1",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-07-S1-Statistics-1.mdx",
      "status": "draft",
      "sourceSha256": "ab21cfc0e39432c69998399f91acbe7e4394537b13809f386ba941ea2ed412ff"
    }
  ]
},
{
  "id": "article.pearson-ial-further-s2-08",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-08-S2-Statistics-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-08-S2-Statistics-2",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-08-S2-Statistics-2.mdx",
      "status": "published",
      "sourceSha256": "a1c89eee442a261c349a5e8222afa32cb6e0d5a33259f4835b071be32696789a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-08-S2-Statistics-2",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-08-S2-Statistics-2.mdx",
      "status": "draft",
      "sourceSha256": "a1c89eee442a261c349a5e8222afa32cb6e0d5a33259f4835b071be32696789a"
    }
  ]
},
{
  "id": "article.pearson-ial-further-s3-09",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-09-S3-Statistics-3.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-09-S3-Statistics-3",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-09-S3-Statistics-3.mdx",
      "status": "published",
      "sourceSha256": "f663bdf7aab7077e6078a46adbfad26a510b2975becaf8bfe4eb6abf2277897c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-09-S3-Statistics-3",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-09-S3-Statistics-3.mdx",
      "status": "draft",
      "sourceSha256": "f663bdf7aab7077e6078a46adbfad26a510b2975becaf8bfe4eb6abf2277897c"
    }
  ]
},
{
  "id": "article.pearson-ial-further-d1-10",
  "englishSourcePath": "content/posts/Pearson-IAL-Further-Mathematics-10-D1-Decision-Mathematics-1.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-10-D1-Decision-Mathematics-1",
      "sourcePath": "content/posts/Pearson-IAL-Further-Mathematics-10-D1-Decision-Mathematics-1.mdx",
      "status": "published",
      "sourceSha256": "f01544534cdbdaa9749e58a2cc598ab3700579a4b57d3f2a8ed3881ac218b094"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-further-mathematics-notes/Pearson-IAL-Further-Mathematics-10-D1-Decision-Mathematics-1",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Further-Mathematics-10-D1-Decision-Mathematics-1.mdx",
      "status": "draft",
      "sourceSha256": "f01544534cdbdaa9749e58a2cc598ab3700579a4b57d3f2a8ed3881ac218b094"
    }
  ]
},
{
  "id": "article.cambridge-9701-atomic-structure-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-01-Atomic-structure.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-01-Atomic-structure",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-01-Atomic-structure.mdx",
      "status": "published",
      "sourceSha256": "dc201361b565db8770f266757855d886652defa84e48547024c7d135974561e3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-01-Atomic-structure",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-01-Atomic-structure.mdx",
      "status": "draft",
      "sourceSha256": "dc201361b565db8770f266757855d886652defa84e48547024c7d135974561e3"
    }
  ]
},
{
  "id": "article.cambridge-9701-stoichiometry-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-02-Atoms-molecules-and-stoichiometry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-02-Atoms-molecules-and-stoichiometry",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-02-Atoms-molecules-and-stoichiometry.mdx",
      "status": "published",
      "sourceSha256": "b4c83a4a8001007a57f6d8cc6a8b0abebaa6dfe27912eb25cbe3d70d3e52ec15"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-02-Atoms-molecules-and-stoichiometry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-02-Atoms-molecules-and-stoichiometry.mdx",
      "status": "draft",
      "sourceSha256": "b4c83a4a8001007a57f6d8cc6a8b0abebaa6dfe27912eb25cbe3d70d3e52ec15"
    }
  ]
},
{
  "id": "article.cambridge-9701-chemical-bonding-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-03-Chemical-bonding.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-03-Chemical-bonding",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-03-Chemical-bonding.mdx",
      "status": "published",
      "sourceSha256": "b4df2268c5c6910397bd4fb7a26e756cf5f622dc129ca7c78797ceffd21d05c9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-03-Chemical-bonding",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-03-Chemical-bonding.mdx",
      "status": "draft",
      "sourceSha256": "b4df2268c5c6910397bd4fb7a26e756cf5f622dc129ca7c78797ceffd21d05c9"
    }
  ]
},
{
  "id": "article.cambridge-9701-states-of-matter-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-04-States-of-matter.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-04-States-of-matter",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-04-States-of-matter.mdx",
      "status": "published",
      "sourceSha256": "a698d0095d14bf951f9ffd4e39aeffa0b30447b0354059b2cbd22ca780a40fc3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-04-States-of-matter",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-04-States-of-matter.mdx",
      "status": "draft",
      "sourceSha256": "a698d0095d14bf951f9ffd4e39aeffa0b30447b0354059b2cbd22ca780a40fc3"
    }
  ]
},
{
  "id": "article.cambridge-9701-chemical-energetics-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-05-Chemical-energetics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-05-Chemical-energetics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-05-Chemical-energetics.mdx",
      "status": "published",
      "sourceSha256": "7592d17596278f54c17dc568f859f9f2ed8e9e9c11dbf66320c4d2e2c891d8f9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-05-Chemical-energetics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-05-Chemical-energetics.mdx",
      "status": "draft",
      "sourceSha256": "7592d17596278f54c17dc568f859f9f2ed8e9e9c11dbf66320c4d2e2c891d8f9"
    }
  ]
},
{
  "id": "article.cambridge-9701-electrochemistry-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-06-Electrochemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-06-Electrochemistry",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-06-Electrochemistry.mdx",
      "status": "published",
      "sourceSha256": "b1d3531a008d461006f7456dca57b0e454c6b41e98b2d9ed0f899d1cf0b1ea3c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-06-Electrochemistry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-06-Electrochemistry.mdx",
      "status": "draft",
      "sourceSha256": "b1d3531a008d461006f7456dca57b0e454c6b41e98b2d9ed0f899d1cf0b1ea3c"
    }
  ]
},
{
  "id": "article.cambridge-9701-equilibria-07",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-07-Equilibria.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-07-Equilibria",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-07-Equilibria.mdx",
      "status": "published",
      "sourceSha256": "5886f2a7d8bb52a0d267a5812d8945b0ade0ada9b5f5db0afb0945139cd0bcf7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-07-Equilibria",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-07-Equilibria.mdx",
      "status": "draft",
      "sourceSha256": "5886f2a7d8bb52a0d267a5812d8945b0ade0ada9b5f5db0afb0945139cd0bcf7"
    }
  ]
},
{
  "id": "article.cambridge-9701-reaction-kinetics-08",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-08-Reaction-kinetics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-08-Reaction-kinetics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-08-Reaction-kinetics.mdx",
      "status": "published",
      "sourceSha256": "acd76353560a57c8cb52a654a6faae69e63ac12af1acdc6b4b41c91bcb2a76a5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-08-Reaction-kinetics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-08-Reaction-kinetics.mdx",
      "status": "draft",
      "sourceSha256": "acd76353560a57c8cb52a654a6faae69e63ac12af1acdc6b4b41c91bcb2a76a5"
    }
  ]
},
{
  "id": "article.cambridge-9701-periodicity-09",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-09-The-Periodic-Table-chemical-periodicity.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-09-The-Periodic-Table-chemical-periodicity",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-09-The-Periodic-Table-chemical-periodicity.mdx",
      "status": "published",
      "sourceSha256": "ce53792d151e13f2ba5091066664a1d185fbe8267cb18fb7aec8fc7a86ee04ce"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-09-The-Periodic-Table-chemical-periodicity",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-09-The-Periodic-Table-chemical-periodicity.mdx",
      "status": "draft",
      "sourceSha256": "ce53792d151e13f2ba5091066664a1d185fbe8267cb18fb7aec8fc7a86ee04ce"
    }
  ]
},
{
  "id": "article.cambridge-9701-group-2-10",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-10-Group-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-10-Group-2",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-10-Group-2.mdx",
      "status": "published",
      "sourceSha256": "88e8edafffa6ea675db86109533264d270b63e0e91a80a2b9d5c4999e2890079"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-10-Group-2",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-10-Group-2.mdx",
      "status": "draft",
      "sourceSha256": "88e8edafffa6ea675db86109533264d270b63e0e91a80a2b9d5c4999e2890079"
    }
  ]
},
{
  "id": "article.cambridge-9701-group-17-11",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-11-Group-17.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-11-Group-17",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-11-Group-17.mdx",
      "status": "published",
      "sourceSha256": "d690ff51a1d901d6cb53749b56bf6f3ecb09886477f37f696415569245314abd"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-11-Group-17",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-11-Group-17.mdx",
      "status": "draft",
      "sourceSha256": "d690ff51a1d901d6cb53749b56bf6f3ecb09886477f37f696415569245314abd"
    }
  ]
},
{
  "id": "article.cambridge-9701-nitrogen-sulfur-12",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-12-Nitrogen-and-sulfur.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-12-Nitrogen-and-sulfur",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-12-Nitrogen-and-sulfur.mdx",
      "status": "published",
      "sourceSha256": "353a3824e4b976a5b18fdd985baaab739ec7cba80523c87266a9a95790f97d17"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-12-Nitrogen-and-sulfur",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-12-Nitrogen-and-sulfur.mdx",
      "status": "draft",
      "sourceSha256": "353a3824e4b976a5b18fdd985baaab739ec7cba80523c87266a9a95790f97d17"
    }
  ]
},
{
  "id": "article.cambridge-9701-organic-introduction-13",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-13-An-introduction-to-AS-Level-organic-chemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-13-An-introduction-to-AS-Level-organic-chemistry",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-13-An-introduction-to-AS-Level-organic-chemistry.mdx",
      "status": "published",
      "sourceSha256": "b347d2f3a5565c86b683dd76e430ce1ce042a98ba9d139eb2268fc669d989429"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-13-An-introduction-to-AS-Level-organic-chemistry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-13-An-introduction-to-AS-Level-organic-chemistry.mdx",
      "status": "draft",
      "sourceSha256": "b347d2f3a5565c86b683dd76e430ce1ce042a98ba9d139eb2268fc669d989429"
    }
  ]
},
{
  "id": "article.cambridge-9701-hydrocarbons-14",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-14-Hydrocarbons.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-14-Hydrocarbons",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-14-Hydrocarbons.mdx",
      "status": "published",
      "sourceSha256": "1a1976905905c5acbcf795013433d7e69dc10fe570d3bf56094070f54e929d28"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-14-Hydrocarbons",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-14-Hydrocarbons.mdx",
      "status": "draft",
      "sourceSha256": "1a1976905905c5acbcf795013433d7e69dc10fe570d3bf56094070f54e929d28"
    }
  ]
},
{
  "id": "article.cambridge-9701-halogen-compounds-15",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-15-Halogen-compounds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-15-Halogen-compounds",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-15-Halogen-compounds.mdx",
      "status": "published",
      "sourceSha256": "e23b8a28d63369cd93be5a9bd8646d9c3827bc20b02326a87bf899d8a3424125"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-15-Halogen-compounds",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-15-Halogen-compounds.mdx",
      "status": "draft",
      "sourceSha256": "e23b8a28d63369cd93be5a9bd8646d9c3827bc20b02326a87bf899d8a3424125"
    }
  ]
},
{
  "id": "article.cambridge-9701-hydroxy-compounds-16",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-16-Hydroxy-compounds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-16-Hydroxy-compounds",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-16-Hydroxy-compounds.mdx",
      "status": "published",
      "sourceSha256": "d90318b7a573830c76767e5a472936dff5fc242d7af448ec5e52993f50dc65d8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-16-Hydroxy-compounds",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-16-Hydroxy-compounds.mdx",
      "status": "draft",
      "sourceSha256": "d90318b7a573830c76767e5a472936dff5fc242d7af448ec5e52993f50dc65d8"
    }
  ]
},
{
  "id": "article.cambridge-9701-carbonyl-compounds-17",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-17-Carbonyl-compounds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-17-Carbonyl-compounds",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-17-Carbonyl-compounds.mdx",
      "status": "published",
      "sourceSha256": "9c5f3b9c4402bbe8f561268303f61e9ed105f3438bae454dd5b1df12109e8ad7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-17-Carbonyl-compounds",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-17-Carbonyl-compounds.mdx",
      "status": "draft",
      "sourceSha256": "9c5f3b9c4402bbe8f561268303f61e9ed105f3438bae454dd5b1df12109e8ad7"
    }
  ]
},
{
  "id": "article.cambridge-9701-carboxylic-acids-18",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-18-Carboxylic-acids-and-derivatives.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-18-Carboxylic-acids-and-derivatives",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-18-Carboxylic-acids-and-derivatives.mdx",
      "status": "published",
      "sourceSha256": "7f67dec6402a7ad3c82313d0ae09f63bd9ae81eab5973a29184f8ffa3b28d71f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-18-Carboxylic-acids-and-derivatives",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-18-Carboxylic-acids-and-derivatives.mdx",
      "status": "draft",
      "sourceSha256": "7f67dec6402a7ad3c82313d0ae09f63bd9ae81eab5973a29184f8ffa3b28d71f"
    }
  ]
},
{
  "id": "article.cambridge-9701-nitrogen-compounds-19",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-19-Nitrogen-compounds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-19-Nitrogen-compounds",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-19-Nitrogen-compounds.mdx",
      "status": "published",
      "sourceSha256": "56e00ecac5fb6afaf336705fd344369c9f2ea6214d71572dfbff789bb288f549"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-19-Nitrogen-compounds",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-19-Nitrogen-compounds.mdx",
      "status": "draft",
      "sourceSha256": "56e00ecac5fb6afaf336705fd344369c9f2ea6214d71572dfbff789bb288f549"
    }
  ]
},
{
  "id": "article.cambridge-9701-polymerisation-20",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-20-Polymerisation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-20-Polymerisation",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-20-Polymerisation.mdx",
      "status": "published",
      "sourceSha256": "985c2c7a55e6bd421632689e81561b7e1147f5c1549b1e5e5c9ccb24bf00834a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-20-Polymerisation",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-20-Polymerisation.mdx",
      "status": "draft",
      "sourceSha256": "985c2c7a55e6bd421632689e81561b7e1147f5c1549b1e5e5c9ccb24bf00834a"
    }
  ]
},
{
  "id": "article.cambridge-9701-organic-synthesis-21",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-21-Organic-synthesis.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-21-Organic-synthesis",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-21-Organic-synthesis.mdx",
      "status": "published",
      "sourceSha256": "c21f3828dd7a57810e58a92ecc8f088160e71789a14143cb0baea5bfecf0bf07"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-21-Organic-synthesis",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-21-Organic-synthesis.mdx",
      "status": "draft",
      "sourceSha256": "c21f3828dd7a57810e58a92ecc8f088160e71789a14143cb0baea5bfecf0bf07"
    }
  ]
},
{
  "id": "article.cambridge-9701-analytical-techniques-22",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-22-Analytical-techniques.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-22-Analytical-techniques",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-22-Analytical-techniques.mdx",
      "status": "published",
      "sourceSha256": "71da7ba0c5277acb8fd8d0d6e75ee1b296b469524e88ac75d0b37e0c820e960a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-22-Analytical-techniques",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-22-Analytical-techniques.mdx",
      "status": "draft",
      "sourceSha256": "71da7ba0c5277acb8fd8d0d6e75ee1b296b469524e88ac75d0b37e0c820e960a"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-energetics-23",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-23-Chemical-energetics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-23-Chemical-energetics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-23-Chemical-energetics.mdx",
      "status": "published",
      "sourceSha256": "70933aba11d9096a8cd84918448394fca58306daca625b93274eecfc6043b0c6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-23-Chemical-energetics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-23-Chemical-energetics.mdx",
      "status": "draft",
      "sourceSha256": "70933aba11d9096a8cd84918448394fca58306daca625b93274eecfc6043b0c6"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-electrochemistry-24",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-24-Electrochemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-24-Electrochemistry",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-24-Electrochemistry.mdx",
      "status": "published",
      "sourceSha256": "3dde6d536188a21a7917bb0c5faecd55370caac957bcfe295b8d3ac6878ab5b6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-24-Electrochemistry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-24-Electrochemistry.mdx",
      "status": "draft",
      "sourceSha256": "3dde6d536188a21a7917bb0c5faecd55370caac957bcfe295b8d3ac6878ab5b6"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-equilibria-25",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-25-Equilibria.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-25-Equilibria",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-25-Equilibria.mdx",
      "status": "published",
      "sourceSha256": "3ad6be057da52a7933fbbb7cdd804087f20f19bd03224547b677fa20d27df59e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-25-Equilibria",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-25-Equilibria.mdx",
      "status": "draft",
      "sourceSha256": "3ad6be057da52a7933fbbb7cdd804087f20f19bd03224547b677fa20d27df59e"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-kinetics-26",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-26-Reaction-kinetics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-26-Reaction-kinetics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-26-Reaction-kinetics.mdx",
      "status": "published",
      "sourceSha256": "ea432e4af87fbdfb5c3071b70c75b248db466a0b8513670614c1bd3978daea62"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-26-Reaction-kinetics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-26-Reaction-Kinetics.mdx",
      "status": "draft",
      "sourceSha256": "ea432e4af87fbdfb5c3071b70c75b248db466a0b8513670614c1bd3978daea62"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-group-2-27",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-27-Group-2.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-27-Group-2",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-27-Group-2.mdx",
      "status": "published",
      "sourceSha256": "5471e485952d1efca0d9251ccd4669f28fc06e992479b89550df61c4bca5538d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-27-Group-2",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-27-Group-2.mdx",
      "status": "draft",
      "sourceSha256": "5471e485952d1efca0d9251ccd4669f28fc06e992479b89550df61c4bca5538d"
    }
  ]
},
{
  "id": "article.cambridge-9701-transition-elements-28",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-28-Chemistry-of-transition-elements.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-28-Chemistry-of-transition-elements",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-28-Chemistry-of-transition-elements.mdx",
      "status": "published",
      "sourceSha256": "7c3e279e83479f03fb5a0984d51358745823428fb415f49a868da7a29d89bea0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-28-Chemistry-of-transition-elements",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-28-Chemistry-of-transition-elements.mdx",
      "status": "draft",
      "sourceSha256": "7c3e279e83479f03fb5a0984d51358745823428fb415f49a868da7a29d89bea0"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-organic-intro-29",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-29-An-introduction-to-A-Level-organic-chemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-29-An-introduction-to-A-Level-organic-chemistry",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-29-An-introduction-to-A-Level-organic-chemistry.mdx",
      "status": "published",
      "sourceSha256": "25ca6041aff57ad0b699feb86c1587d11185b3e52d26d873428c256860694528"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-29-An-introduction-to-A-Level-organic-chemistry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-29-An-introduction-to-A-Level-organic-chemistry.mdx",
      "status": "draft",
      "sourceSha256": "25ca6041aff57ad0b699feb86c1587d11185b3e52d26d873428c256860694528"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-hydrocarbons-30",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-30-Hydrocarbons.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-30-Hydrocarbons",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-30-Hydrocarbons.mdx",
      "status": "published",
      "sourceSha256": "c728c0281c8d0b8cd1677e599739b21002a4d27a8b66958d4970197236b3e837"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-30-Hydrocarbons",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-30-Hydrocarbons.mdx",
      "status": "draft",
      "sourceSha256": "c728c0281c8d0b8cd1677e599739b21002a4d27a8b66958d4970197236b3e837"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-halogen-31",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-31-Halogen-compounds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-31-Halogen-compounds",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-31-Halogen-compounds.mdx",
      "status": "published",
      "sourceSha256": "a2ea865f50e90eebb8badb6403c2f94c893113b60999fad83e67b9f97214c854"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-31-Halogen-compounds",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-31-Halogen-compounds.mdx",
      "status": "draft",
      "sourceSha256": "a2ea865f50e90eebb8badb6403c2f94c893113b60999fad83e67b9f97214c854"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-hydroxy-32",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-32-Hydroxy-compounds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-32-Hydroxy-compounds",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-32-Hydroxy-compounds.mdx",
      "status": "published",
      "sourceSha256": "48d29d7693278cfe67a766031bd5c6048918e2b77bb84d8b3bedd3b2d2abc387"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-32-Hydroxy-compounds",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-32-Hydroxy-compounds.mdx",
      "status": "draft",
      "sourceSha256": "48d29d7693278cfe67a766031bd5c6048918e2b77bb84d8b3bedd3b2d2abc387"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-carboxylic-33",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-33-Carboxylic-acids-and-derivatives.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-33-Carboxylic-acids-and-derivatives",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-33-Carboxylic-acids-and-derivatives.mdx",
      "status": "published",
      "sourceSha256": "b5dea816b348cfcdfabaa81fb752c3fc04dd7c3532c9ad6c1c253f1cbee376fc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-33-Carboxylic-acids-and-derivatives",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-33-Carboxylic-acids-and-derivatives.mdx",
      "status": "draft",
      "sourceSha256": "b5dea816b348cfcdfabaa81fb752c3fc04dd7c3532c9ad6c1c253f1cbee376fc"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-nitrogen-34",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-34-Nitrogen-compounds.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-34-Nitrogen-compounds",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-34-Nitrogen-compounds.mdx",
      "status": "published",
      "sourceSha256": "abd683b4175fbc23f8f1649d05c4c118a749ea7700259b27bfc2bef954d17e2d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-34-Nitrogen-compounds",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-34-Nitrogen-compounds.mdx",
      "status": "draft",
      "sourceSha256": "abd683b4175fbc23f8f1649d05c4c118a749ea7700259b27bfc2bef954d17e2d"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-polymerisation-35",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-35-Polymerisation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-35-Polymerisation",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-35-Polymerisation.mdx",
      "status": "published",
      "sourceSha256": "e800731e2c3bf561e004aef2951d2813888eca82006311e64171472f69d15ae7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-35-Polymerisation",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-35-Polymerisation.mdx",
      "status": "draft",
      "sourceSha256": "e800731e2c3bf561e004aef2951d2813888eca82006311e64171472f69d15ae7"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-synthesis-36",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-36-Organic-synthesis.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-36-Organic-synthesis",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-36-Organic-synthesis.mdx",
      "status": "published",
      "sourceSha256": "b60d691f27533e660f71874e4a5908b5945c002ea8283ce6df981cbd70a888c2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-36-Organic-synthesis",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-36-Organic-synthesis.mdx",
      "status": "draft",
      "sourceSha256": "b60d691f27533e660f71874e4a5908b5945c002ea8283ce6df981cbd70a888c2"
    }
  ]
},
{
  "id": "article.cambridge-9701-advanced-analytical-37",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-37-Analytical-techniques.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-37-Analytical-techniques",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-37-Analytical-techniques.mdx",
      "status": "published",
      "sourceSha256": "cd668b586ddc5492d92c8d703a0e320a5e83838191a3555c3cb30e93a69e8a03"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-notes/Cambridge-International-A-Level-Chemistry-37-Analytical-techniques",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-37-Analytical-techniques.mdx",
      "status": "draft",
      "sourceSha256": "cd668b586ddc5492d92c8d703a0e320a5e83838191a3555c3cb30e93a69e8a03"
    }
  ]
},
{
  "id": "article.cambridge-9702-quantities-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-01-Physical-quantities-and-units.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-01-Physical-quantities-and-units",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-01-Physical-quantities-and-units.mdx",
      "status": "published",
      "sourceSha256": "931c39c8c780f78fd6c53b99a042474175caa90745b7caa48f0df518d35f7dbc"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-01-Physical-quantities-and-units",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-01-Physical-quantities-and-units.mdx",
      "status": "draft",
      "sourceSha256": "931c39c8c780f78fd6c53b99a042474175caa90745b7caa48f0df518d35f7dbc"
    }
  ]
},
{
  "id": "article.cambridge-9702-kinematics-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-02-Kinematics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-02-Kinematics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-02-Kinematics.mdx",
      "status": "published",
      "sourceSha256": "76ef9fca8950371507176f649cc05e4dff58ea33dab9d7a5b7bcca44f44bc2af"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-02-Kinematics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-02-Kinematics.mdx",
      "status": "draft",
      "sourceSha256": "76ef9fca8950371507176f649cc05e4dff58ea33dab9d7a5b7bcca44f44bc2af"
    }
  ]
},
{
  "id": "article.cambridge-9702-dynamics-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-03-Dynamics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-03-Dynamics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-03-Dynamics.mdx",
      "status": "published",
      "sourceSha256": "45b70a39ba3f1a645505f8e05e6c7158c532c29077c3c5834505aaf9338649fb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-03-Dynamics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-03-Dynamics.mdx",
      "status": "draft",
      "sourceSha256": "45b70a39ba3f1a645505f8e05e6c7158c532c29077c3c5834505aaf9338649fb"
    }
  ]
},
{
  "id": "article.cambridge-9702-forces-fluids-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-04-Forces-density-and-pressure.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-04-Forces-density-and-pressure",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-04-Forces-density-and-pressure.mdx",
      "status": "published",
      "sourceSha256": "9350935d9f12822fa8ea6985946c88a5783f02cc4c2534574736c8271a6f763e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-04-Forces-density-and-pressure",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-04-Forces-density-and-pressure.mdx",
      "status": "draft",
      "sourceSha256": "9350935d9f12822fa8ea6985946c88a5783f02cc4c2534574736c8271a6f763e"
    }
  ]
},
{
  "id": "article.cambridge-9702-work-energy-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-05-Work-energy-and-power.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-05-Work-energy-and-power",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-05-Work-energy-and-power.mdx",
      "status": "published",
      "sourceSha256": "01a5b6a3af118e8c0c5db84bf056f84e919f8e008736c0ccfc790988b4464c7f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-05-Work-energy-and-power",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-05-Work-energy-and-power.mdx",
      "status": "draft",
      "sourceSha256": "01a5b6a3af118e8c0c5db84bf056f84e919f8e008736c0ccfc790988b4464c7f"
    }
  ]
},
{
  "id": "article.cambridge-9702-deformation-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-06-Deformation-of-solids.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-06-Deformation-of-solids",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-06-Deformation-of-solids.mdx",
      "status": "published",
      "sourceSha256": "33ec388353f0eb178ac95bab1cab6e3bf5429b7bfa5a87936e4c0d2ca1cd6174"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-06-Deformation-of-solids",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-06-Deformation-of-solids.mdx",
      "status": "draft",
      "sourceSha256": "33ec388353f0eb178ac95bab1cab6e3bf5429b7bfa5a87936e4c0d2ca1cd6174"
    }
  ]
},
{
  "id": "article.cambridge-9702-waves-07",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-07-Waves.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-07-Waves",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-07-Waves.mdx",
      "status": "published",
      "sourceSha256": "e82e8f76e296edc963bca8e40218a3807dd86e572ae905ce48a996d2754b6d5a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-07-Waves",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-07-Waves.mdx",
      "status": "draft",
      "sourceSha256": "e82e8f76e296edc963bca8e40218a3807dd86e572ae905ce48a996d2754b6d5a"
    }
  ]
},
{
  "id": "article.cambridge-9702-superposition-08",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-08-Superposition.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-08-Superposition",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-08-Superposition.mdx",
      "status": "published",
      "sourceSha256": "c61ace04f6a4bdfac1d03b7e1a120f9afd3d2a0d8f51c0c9f9c98a6797b897f9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-08-Superposition",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-08-Superposition.mdx",
      "status": "draft",
      "sourceSha256": "c61ace04f6a4bdfac1d03b7e1a120f9afd3d2a0d8f51c0c9f9c98a6797b897f9"
    }
  ]
},
{
  "id": "article.cambridge-9702-electricity-09",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-09-Electricity.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-09-Electricity",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-09-Electricity.mdx",
      "status": "published",
      "sourceSha256": "d01c33172c34fdde25a2f07c0bee74dcfd841c10e6d6b8a3f2b9d9813a34d3e6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-09-Electricity",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-09-Electricity.mdx",
      "status": "draft",
      "sourceSha256": "d01c33172c34fdde25a2f07c0bee74dcfd841c10e6d6b8a3f2b9d9813a34d3e6"
    }
  ]
},
{
  "id": "article.cambridge-9702-dc-circuits-10",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-10-D-C-circuits.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-10-D-C-circuits",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-10-D-C-circuits.mdx",
      "status": "published",
      "sourceSha256": "6ac137c43ba6598e51031b35956ebeb4e18f943428b81e42d6f05feb261e7f60"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-10-D-C-circuits",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-10-D-C-circuits.mdx",
      "status": "draft",
      "sourceSha256": "6ac137c43ba6598e51031b35956ebeb4e18f943428b81e42d6f05feb261e7f60"
    }
  ]
},
{
  "id": "article.cambridge-9702-particle-physics-11",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-11-Particle-physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-11-Particle-physics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-11-Particle-physics.mdx",
      "status": "published",
      "sourceSha256": "616a596f3296d942ef96d664c33e892ed123cd80c4ec4e2f4822a4e008127607"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-11-Particle-physics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-11-Particle-physics.mdx",
      "status": "draft",
      "sourceSha256": "616a596f3296d942ef96d664c33e892ed123cd80c4ec4e2f4822a4e008127607"
    }
  ]
},
{
  "id": "article.cambridge-9702-circular-motion-12",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-12-Motion-in-a-circle.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-12-Motion-in-a-circle",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-12-Motion-in-a-circle.mdx",
      "status": "published",
      "sourceSha256": "a1c20ffe7d64f215577e4e186ebcbb80ec2163a211cf727a014dbd578c3a7751"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-12-Motion-in-a-circle",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-12-Motion-in-a-circle.mdx",
      "status": "draft",
      "sourceSha256": "a1c20ffe7d64f215577e4e186ebcbb80ec2163a211cf727a014dbd578c3a7751"
    }
  ]
},
{
  "id": "article.cambridge-9702-gravitational-fields-13",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-13-Gravitational-fields.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-13-Gravitational-fields",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-13-Gravitational-fields.mdx",
      "status": "published",
      "sourceSha256": "28b2ea0d50a24bb7df31a91102cbe5df83bfc4a9f92b8a5c1686c41870ffd427"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-13-Gravitational-fields",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-13-Gravitational-fields.mdx",
      "status": "draft",
      "sourceSha256": "28b2ea0d50a24bb7df31a91102cbe5df83bfc4a9f92b8a5c1686c41870ffd427"
    }
  ]
},
{
  "id": "article.cambridge-9702-temperature-14",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-14-Temperature.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-14-Temperature",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-14-Temperature.mdx",
      "status": "published",
      "sourceSha256": "62b65d973efa5cb371e1501c91900ccf0eea3d3445361364866fe1dc216748e1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-14-Temperature",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-14-Temperature.mdx",
      "status": "draft",
      "sourceSha256": "62b65d973efa5cb371e1501c91900ccf0eea3d3445361364866fe1dc216748e1"
    }
  ]
},
{
  "id": "article.cambridge-9702-ideal-gases-15",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-15-Ideal-gases.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-15-Ideal-gases",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-15-Ideal-gases.mdx",
      "status": "published",
      "sourceSha256": "8297b924af6f9a2083b32cd9cf79ade6a298776e48294facee80bc42a2dc4835"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-15-Ideal-gases",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-15-Ideal-gases.mdx",
      "status": "draft",
      "sourceSha256": "8297b924af6f9a2083b32cd9cf79ade6a298776e48294facee80bc42a2dc4835"
    }
  ]
},
{
  "id": "article.cambridge-9702-thermodynamics-16",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-16-Thermodynamics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-16-Thermodynamics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-16-Thermodynamics.mdx",
      "status": "published",
      "sourceSha256": "1d198db6dd546bd664a7bba99525abbe77684299cd926043a37bc6f2d922f449"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-16-Thermodynamics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-16-Thermodynamics.mdx",
      "status": "draft",
      "sourceSha256": "1d198db6dd546bd664a7bba99525abbe77684299cd926043a37bc6f2d922f449"
    }
  ]
},
{
  "id": "article.cambridge-9702-oscillations-17",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-17-Oscillations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-17-Oscillations",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-17-Oscillations.mdx",
      "status": "published",
      "sourceSha256": "43a3fcc9adf2d79dbe1004fea9b99908e8f99d85639725cd9eaa74497e02a3a8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-17-Oscillations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-17-Oscillations.mdx",
      "status": "draft",
      "sourceSha256": "43a3fcc9adf2d79dbe1004fea9b99908e8f99d85639725cd9eaa74497e02a3a8"
    }
  ]
},
{
  "id": "article.cambridge-9702-electric-fields-18",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-18-Electric-fields.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-18-Electric-fields",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-18-Electric-fields.mdx",
      "status": "published",
      "sourceSha256": "5b5d3e3facb8392e5da144fdf858c693e103cd9b73dc5c3c95865486c5dd1d9a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-18-Electric-fields",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-18-Electric-fields.mdx",
      "status": "draft",
      "sourceSha256": "5b5d3e3facb8392e5da144fdf858c693e103cd9b73dc5c3c95865486c5dd1d9a"
    }
  ]
},
{
  "id": "article.cambridge-9702-capacitance-19",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-19-Capacitance.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-19-Capacitance",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-19-Capacitance.mdx",
      "status": "published",
      "sourceSha256": "fe4dedd15ca305dfa1e26b5531d3cc4c0a5063b829f22e05638e1fd9ac43d185"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-19-Capacitance",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-19-Capacitance.mdx",
      "status": "draft",
      "sourceSha256": "fe4dedd15ca305dfa1e26b5531d3cc4c0a5063b829f22e05638e1fd9ac43d185"
    }
  ]
},
{
  "id": "article.cambridge-9702-magnetic-fields-20",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-20-Magnetic-fields.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-20-Magnetic-fields",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-20-Magnetic-fields.mdx",
      "status": "published",
      "sourceSha256": "69cdf0a9965f65338c32da9556aab4b647590978c43b34b3c080b3fcb3742514"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-20-Magnetic-fields",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-20-Magnetic-fields.mdx",
      "status": "draft",
      "sourceSha256": "69cdf0a9965f65338c32da9556aab4b647590978c43b34b3c080b3fcb3742514"
    }
  ]
},
{
  "id": "article.cambridge-9702-alternating-currents-21",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-21-Alternating-currents.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-21-Alternating-currents",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-21-Alternating-currents.mdx",
      "status": "published",
      "sourceSha256": "777e6b67c2fa23328a52795600d8c3430d6fd4b8b6970ef15522356030345fec"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-21-Alternating-currents",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-21-Alternating-currents.mdx",
      "status": "draft",
      "sourceSha256": "777e6b67c2fa23328a52795600d8c3430d6fd4b8b6970ef15522356030345fec"
    }
  ]
},
{
  "id": "article.cambridge-9702-quantum-physics-22",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-22-Quantum-physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-22-Quantum-physics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-22-Quantum-physics.mdx",
      "status": "published",
      "sourceSha256": "b88587757f05322779a2ab020301a42b3b36530308bfbd391324b1fdbb6e9540"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-22-Quantum-physics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-22-Quantum-physics.mdx",
      "status": "draft",
      "sourceSha256": "b88587757f05322779a2ab020301a42b3b36530308bfbd391324b1fdbb6e9540"
    }
  ]
},
{
  "id": "article.cambridge-9702-nuclear-physics-23",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-23-Nuclear-physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-23-Nuclear-physics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-23-Nuclear-physics.mdx",
      "status": "published",
      "sourceSha256": "18b8f626fd5f30cc366b51e9f7b7bd02308e418340eae16c9b00168d2b3e61f3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-23-Nuclear-physics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-23-Nuclear-physics.mdx",
      "status": "draft",
      "sourceSha256": "18b8f626fd5f30cc366b51e9f7b7bd02308e418340eae16c9b00168d2b3e61f3"
    }
  ]
},
{
  "id": "article.cambridge-9702-medical-physics-24",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-24-Medical-physics.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-24-Medical-physics",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-24-Medical-physics.mdx",
      "status": "published",
      "sourceSha256": "0b1dff36576c5ffbb1ea6e267a2b2a46734d297417e5f6a1eeb1bda53f1c8e50"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-24-Medical-physics",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-24-Medical-physics.mdx",
      "status": "draft",
      "sourceSha256": "0b1dff36576c5ffbb1ea6e267a2b2a46734d297417e5f6a1eeb1bda53f1c8e50"
    }
  ]
},
{
  "id": "article.cambridge-9702-astronomy-cosmology-25",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-25-Astronomy-and-cosmology.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-25-Astronomy-and-cosmology",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-25-Astronomy-and-cosmology.mdx",
      "status": "published",
      "sourceSha256": "c2ad11a6cfdb0ed30c2ccbb7bc57c97b7c3383080d1129b668f6026a26e0be46"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-notes/Cambridge-International-A-Level-Physics-25-Astronomy-and-cosmology",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-25-Astronomy-and-cosmology.mdx",
      "status": "draft",
      "sourceSha256": "c2ad11a6cfdb0ed30c2ccbb7bc57c97b7c3383080d1129b668f6026a26e0be46"
    }
  ]
},
{
  "id": "article.cambridge-9700-cell-structure-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-01-Cell-structure.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-01-Cell-structure",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-01-Cell-structure.mdx",
      "status": "published",
      "sourceSha256": "d4376ed142bdcf700f13c6ad72fbd42c8b61eb8ba0ea4a0aa392d508152d3802"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-01-Cell-structure",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-01-Cell-structure.mdx",
      "status": "draft",
      "sourceSha256": "d4376ed142bdcf700f13c6ad72fbd42c8b61eb8ba0ea4a0aa392d508152d3802"
    }
  ]
},
{
  "id": "article.cambridge-9700-biological-molecules-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-02-Biological-molecules.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-02-Biological-molecules",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-02-Biological-molecules.mdx",
      "status": "published",
      "sourceSha256": "e459149c7fda69fa3d5b97b4d59871f4fb378005d458fd2efb54b2a6117df3cf"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-02-Biological-molecules",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-02-Biological-molecules.mdx",
      "status": "draft",
      "sourceSha256": "e459149c7fda69fa3d5b97b4d59871f4fb378005d458fd2efb54b2a6117df3cf"
    }
  ]
},
{
  "id": "article.cambridge-9700-enzymes-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-03-Enzymes.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-03-Enzymes",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-03-Enzymes.mdx",
      "status": "published",
      "sourceSha256": "1397676936dd9efc987a7992851ce5ad8551fba11ffae23157f3604502f24a4f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-03-Enzymes",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-03-Enzymes.mdx",
      "status": "draft",
      "sourceSha256": "1397676936dd9efc987a7992851ce5ad8551fba11ffae23157f3604502f24a4f"
    }
  ]
},
{
  "id": "article.cambridge-9700-membranes-transport-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-04-Cell-membranes-and-transport.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-04-Cell-membranes-and-transport",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-04-Cell-membranes-and-transport.mdx",
      "status": "published",
      "sourceSha256": "8f02a4b1b0cc2595e5b758d0a36d2220e2023b35a13402e7cef6189c97cfdf84"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-04-Cell-membranes-and-transport",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-04-Cell-membranes-and-transport.mdx",
      "status": "draft",
      "sourceSha256": "8f02a4b1b0cc2595e5b758d0a36d2220e2023b35a13402e7cef6189c97cfdf84"
    }
  ]
},
{
  "id": "article.cambridge-9700-mitotic-cycle-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-05-The-mitotic-cell-cycle.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-05-The-mitotic-cell-cycle",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-05-The-mitotic-cell-cycle.mdx",
      "status": "published",
      "sourceSha256": "631f9293f54e4b57b31b981c3ff182c6ff165609b99f4b87b8771601ad22deb1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-05-The-mitotic-cell-cycle",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-05-The-mitotic-cell-cycle.mdx",
      "status": "draft",
      "sourceSha256": "631f9293f54e4b57b31b981c3ff182c6ff165609b99f4b87b8771601ad22deb1"
    }
  ]
},
{
  "id": "article.cambridge-9700-nucleic-acids-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-06-Nucleic-acids-and-protein-synthesis.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-06-Nucleic-acids-and-protein-synthesis",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-06-Nucleic-acids-and-protein-synthesis.mdx",
      "status": "published",
      "sourceSha256": "ff682c24dfaa716bc5b23aaef597d1590d4c1e2d4fa5489e70f58a712c8853e0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-06-Nucleic-acids-and-protein-synthesis",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-06-Nucleic-acids-and-protein-synthesis.mdx",
      "status": "draft",
      "sourceSha256": "ff682c24dfaa716bc5b23aaef597d1590d4c1e2d4fa5489e70f58a712c8853e0"
    }
  ]
},
{
  "id": "article.cambridge-9700-plant-transport-07",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-07-Transport-in-plants.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-07-Transport-in-plants",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-07-Transport-in-plants.mdx",
      "status": "published",
      "sourceSha256": "6d162cacc0e55ab04f5f390f92086ea667ca21c1b9a3802235ac3d662aa86929"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-07-Transport-in-plants",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-07-Transport-in-plants.mdx",
      "status": "draft",
      "sourceSha256": "6d162cacc0e55ab04f5f390f92086ea667ca21c1b9a3802235ac3d662aa86929"
    }
  ]
},
{
  "id": "article.cambridge-9700-mammalian-transport-08",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-08-Transport-in-mammals.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-08-Transport-in-mammals",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-08-Transport-in-mammals.mdx",
      "status": "published",
      "sourceSha256": "099e0643cfb319fb3c67d335f384bb612ebbe182a10650ffc1ddeda037675258"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-08-Transport-in-mammals",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-08-Transport-in-mammals.mdx",
      "status": "draft",
      "sourceSha256": "099e0643cfb319fb3c67d335f384bb612ebbe182a10650ffc1ddeda037675258"
    }
  ]
}
,
{
  "id": "article.cambridge-9700-gas-exchange-09",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-09-Gas-exchange.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-09-Gas-exchange",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-09-Gas-exchange.mdx",
      "status": "published",
      "sourceSha256": "318a7ec8f8cec08964dd1c9b8205ba91797e1050da24dcb05a646bcd989e61f9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-09-Gas-exchange",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-09-Gas-exchange.mdx",
      "status": "draft",
      "sourceSha256": "318a7ec8f8cec08964dd1c9b8205ba91797e1050da24dcb05a646bcd989e61f9"
    }
  ]
},
{
  "id": "article.cambridge-9700-infectious-diseases-10",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-10-Infectious-diseases.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-10-Infectious-diseases",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-10-Infectious-diseases.mdx",
      "status": "published",
      "sourceSha256": "48b2c90433611fc2589e86d63e1404382ed7d39b4cdba418aa89945c39665de6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-10-Infectious-diseases",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-10-Infectious-diseases.mdx",
      "status": "draft",
      "sourceSha256": "48b2c90433611fc2589e86d63e1404382ed7d39b4cdba418aa89945c39665de6"
    }
  ]
},
{
  "id": "article.cambridge-9700-immunity-11",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-11-Immunity.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-11-Immunity",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-11-Immunity.mdx",
      "status": "published",
      "sourceSha256": "92da79bfb5952e890e87f002c22d1d115ce518296401b4b5b2d455eaf1c60152"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-11-Immunity",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-11-Immunity.mdx",
      "status": "draft",
      "sourceSha256": "92da79bfb5952e890e87f002c22d1d115ce518296401b4b5b2d455eaf1c60152"
    }
  ]
},
{
  "id": "article.cambridge-9700-respiration-12",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-12-Energy-and-respiration.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-12-Energy-and-respiration",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-12-Energy-and-respiration.mdx",
      "status": "published",
      "sourceSha256": "9205f782832820cccd5fd178ef0f6c1bb3b0f69a54d9d1aeb6ce4afff9cc92e7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-12-Energy-and-respiration",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-12-Energy-and-respiration.mdx",
      "status": "draft",
      "sourceSha256": "9205f782832820cccd5fd178ef0f6c1bb3b0f69a54d9d1aeb6ce4afff9cc92e7"
    }
  ]
}
,
{
  "id": "article.cambridge-9700-photosynthesis-13",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-13-Photosynthesis.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-13-Photosynthesis",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-13-Photosynthesis.mdx",
      "status": "published",
      "sourceSha256": "73937511ca6784fdd9c910d65598709caca1d686a1766207f29fc091bdaed892"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-13-Photosynthesis",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-13-Photosynthesis.mdx",
      "status": "draft",
      "sourceSha256": "73937511ca6784fdd9c910d65598709caca1d686a1766207f29fc091bdaed892"
    }
  ]
},
{
  "id": "article.cambridge-9700-homeostasis-14",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-14-Homeostasis.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-14-Homeostasis",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-14-Homeostasis.mdx",
      "status": "published",
      "sourceSha256": "455cc811666da042d42d056a079ed2b585e21bd02bc60c2f655116fe85950741"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-14-Homeostasis",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-14-Homeostasis.mdx",
      "status": "draft",
      "sourceSha256": "455cc811666da042d42d056a079ed2b585e21bd02bc60c2f655116fe85950741"
    }
  ]
},
{
  "id": "article.cambridge-9700-coordination-15",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-15-Control-and-coordination.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-15-Control-and-coordination",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-15-Control-and-coordination.mdx",
      "status": "published",
      "sourceSha256": "838ada1520d559ca635b82a259c983aa7f6bee898fe3a23a9f7022aae2d48368"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-15-Control-and-coordination",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-15-Control-and-coordination.mdx",
      "status": "draft",
      "sourceSha256": "838ada1520d559ca635b82a259c983aa7f6bee898fe3a23a9f7022aae2d48368"
    }
  ]
},
{
  "id": "article.cambridge-9700-inheritance-16",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-16-Inheritance.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-16-Inheritance",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-16-Inheritance.mdx",
      "status": "published",
      "sourceSha256": "57ba65292cad8db3ffffc949ab51f449f7cbfcd769841a50e10f3972b88da240"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-16-Inheritance",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-16-Inheritance.mdx",
      "status": "draft",
      "sourceSha256": "57ba65292cad8db3ffffc949ab51f449f7cbfcd769841a50e10f3972b88da240"
    }
  ]
},
{
  "id": "article.cambridge-9700-selection-evolution-17",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-17-Selection-and-evolution.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-17-Selection-and-evolution",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-17-Selection-and-evolution.mdx",
      "status": "published",
      "sourceSha256": "eea36d98a45dfb585c37b1988c3d546efb8c8bc3d70dfc50c0d7938add3f0912"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-17-Selection-and-evolution",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-17-Selection-and-evolution.mdx",
      "status": "draft",
      "sourceSha256": "eea36d98a45dfb585c37b1988c3d546efb8c8bc3d70dfc50c0d7938add3f0912"
    }
  ]
},
{
  "id": "article.cambridge-9700-biodiversity-18",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-18-Classification-biodiversity-and-conservation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-18-Classification-biodiversity-and-conservation",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-18-Classification-biodiversity-and-conservation.mdx",
      "status": "published",
      "sourceSha256": "869295da16e8447cf03f44454aa6633e3ab11b657804bf935532e7f1dd4a98c2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-18-Classification-biodiversity-and-conservation",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-18-Classification-biodiversity-and-conservation.mdx",
      "status": "draft",
      "sourceSha256": "869295da16e8447cf03f44454aa6633e3ab11b657804bf935532e7f1dd4a98c2"
    }
  ]
},
{
  "id": "article.cambridge-9700-genetic-technology-19",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-19-Genetic-technology.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-19-Genetic-technology",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-19-Genetic-technology.mdx",
      "status": "published",
      "sourceSha256": "6c99edbe6a6a8221f7564bde61cebe4ce1778ee1a365d8c04b03d2c1a3cd7dd3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-notes/Cambridge-International-A-Level-Biology-19-Genetic-technology",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-19-Genetic-technology.mdx",
      "status": "draft",
      "sourceSha256": "6c99edbe6a6a8221f7564bde61cebe4ce1778ee1a365d8c04b03d2c1a3cd7dd3"
    }
  ]
},
{
  "id": "article.cambridge-9700-practical-microscopy-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-01-Microscopy-Biological-Drawings-and-Calibration.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-01-Microscopy-Biological-Drawings-and-Calibration",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-01-Microscopy-Biological-Drawings-and-Calibration.mdx",
      "status": "published",
      "sourceSha256": "1aec304ebc2ccec13233fc6250454734def11da23dc41e06825f1f8fe92bef25"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-01-Microscopy-Biological-Drawings-and-Calibration",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-Practical-01-Microscopy-Biological-Drawings-and-Calibration.mdx",
      "status": "draft",
      "sourceSha256": "1aec304ebc2ccec13233fc6250454734def11da23dc41e06825f1f8fe92bef25"
    }
  ]
},
{
  "id": "article.cambridge-9700-practical-biochemical-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-02-Biochemical-Tests-Dilutions-and-Colorimetry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-02-Biochemical-Tests-Dilutions-and-Colorimetry",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-02-Biochemical-Tests-Dilutions-and-Colorimetry.mdx",
      "status": "published",
      "sourceSha256": "ce15aec2f434f9b29c351e7d028324e7f52aac8d2c905a6324feeeceb29929ef"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-02-Biochemical-Tests-Dilutions-and-Colorimetry",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-Practical-02-Biochemical-Tests-Dilutions-and-Colorimetry.mdx",
      "status": "draft",
      "sourceSha256": "ce15aec2f434f9b29c351e7d028324e7f52aac8d2c905a6324feeeceb29929ef"
    }
  ]
},
{
  "id": "article.cambridge-9700-practical-rates-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-03-Rates-Enzymes-and-Membrane-Investigations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-03-Rates-Enzymes-and-Membrane-Investigations",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-03-Rates-Enzymes-and-Membrane-Investigations.mdx",
      "status": "published",
      "sourceSha256": "55d7bdabca079f73e44d34c9274e6c8187e82a8e56071d31087abe3971a02396"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-03-Rates-Enzymes-and-Membrane-Investigations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-Practical-03-Rates-Enzymes-and-Membrane-Investigations.mdx",
      "status": "draft",
      "sourceSha256": "55d7bdabca079f73e44d34c9274e6c8187e82a8e56071d31087abe3971a02396"
    }
  ]
},
{
  "id": "article.cambridge-9700-practical-plant-water-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-04-Plant-Transport-and-Water-Potential-Investigations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-04-Plant-Transport-and-Water-Potential-Investigations",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-04-Plant-Transport-and-Water-Potential-Investigations.mdx",
      "status": "published",
      "sourceSha256": "7cb164eaad21ca76bd7c60579840b4a57221993d44147d43c3f72cd6d32ccf2d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-04-Plant-Transport-and-Water-Potential-Investigations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-Practical-04-Plant-Transport-and-Water-Potential-Investigations.mdx",
      "status": "draft",
      "sourceSha256": "7cb164eaad21ca76bd7c60579840b4a57221993d44147d43c3f72cd6d32ccf2d"
    }
  ]
},
{
  "id": "article.cambridge-9700-practical-planning-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-05-Planning-Biological-Investigations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-05-Planning-Biological-Investigations",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-05-Planning-Biological-Investigations.mdx",
      "status": "published",
      "sourceSha256": "8fff253daefc448c250f76d399667b732fcef9d530e04f3f34bf596bfaf28cc8"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-05-Planning-Biological-Investigations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-Practical-05-Planning-Biological-Investigations.mdx",
      "status": "draft",
      "sourceSha256": "8fff253daefc448c250f76d399667b732fcef9d530e04f3f34bf596bfaf28cc8"
    }
  ]
},
{
  "id": "article.cambridge-9700-practical-data-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-06-Biological-Data-Analysis-and-Evaluation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-06-Biological-Data-Analysis-and-Evaluation",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Biology-Practical-06-Biological-Data-Analysis-and-Evaluation.mdx",
      "status": "published",
      "sourceSha256": "a850e0a794fcc12c0cc7f0226f9174246a180182569fd2d76b38a3d23f262ad9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-biology-practicals/Cambridge-International-A-Level-Biology-Practical-06-Biological-Data-Analysis-and-Evaluation",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Biology-Practical-06-Biological-Data-Analysis-and-Evaluation.mdx",
      "status": "draft",
      "sourceSha256": "a850e0a794fcc12c0cc7f0226f9174246a180182569fd2d76b38a3d23f262ad9"
    }
  ]
},
{
  "id": "article.cambridge-9701-practical-titration-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-01-Quantitative-Measurement-and-Titration.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-01-Quantitative-Measurement-and-Titration",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-01-Quantitative-Measurement-and-Titration.mdx",
      "status": "published",
      "sourceSha256": "15b1f65f119257174035d47ddb270ec5c52986ec0c35f7d84eb63a6915e41bcb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-01-Quantitative-Measurement-and-Titration",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-Practical-01-Quantitative-Measurement-and-Titration.mdx",
      "status": "draft",
      "sourceSha256": "15b1f65f119257174035d47ddb270ec5c52986ec0c35f7d84eb63a6915e41bcb"
    }
  ]
},
{
  "id": "article.cambridge-9701-practical-kinetics-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-02-Rates-and-Kinetics-Investigations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-02-Rates-and-Kinetics-Investigations",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-02-Rates-and-Kinetics-Investigations.mdx",
      "status": "published",
      "sourceSha256": "99c5363fe095b5e1a9df366ba2e990346329975a442590ae8198904789b6350f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-02-Rates-and-Kinetics-Investigations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-Practical-02-Rates-and-Kinetics-Investigations.mdx",
      "status": "draft",
      "sourceSha256": "99c5363fe095b5e1a9df366ba2e990346329975a442590ae8198904789b6350f"
    }
  ]
},
{
  "id": "article.cambridge-9701-practical-energetics-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-03-Energetics-and-Electrochemistry-Investigations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-03-Energetics-and-Electrochemistry-Investigations",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-03-Energetics-and-Electrochemistry-Investigations.mdx",
      "status": "published",
      "sourceSha256": "d8166ba2515551a65ee2b68c33f8a3e0273a66739e409941e9760696476b8858"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-03-Energetics-and-Electrochemistry-Investigations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-Practical-03-Energetics-and-Electrochemistry-Investigations.mdx",
      "status": "draft",
      "sourceSha256": "d8166ba2515551a65ee2b68c33f8a3e0273a66739e409941e9760696476b8858"
    }
  ]
},
{
  "id": "article.cambridge-9701-practical-qualitative-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-04-Qualitative-Analysis.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-04-Qualitative-Analysis",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-04-Qualitative-Analysis.mdx",
      "status": "published",
      "sourceSha256": "a196c90f942cb59922a3cf8630b6358fd7af5542d967db714724a28be2513b4d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-04-Qualitative-Analysis",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-Practical-04-Qualitative-Analysis.mdx",
      "status": "draft",
      "sourceSha256": "a196c90f942cb59922a3cf8630b6358fd7af5542d967db714724a28be2513b4d"
    }
  ]
},
{
  "id": "article.cambridge-9701-practical-organic-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-05-Organic-Preparation-and-Purification.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-05-Organic-Preparation-and-Purification",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-05-Organic-Preparation-and-Purification.mdx",
      "status": "published",
      "sourceSha256": "b738fd2d0a6f72e97a28788edda68270710c5aa600b3a97e1bf598f869bd46fb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-05-Organic-Preparation-and-Purification",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-Practical-05-Organic-Preparation-and-Purification.mdx",
      "status": "draft",
      "sourceSha256": "b738fd2d0a6f72e97a28788edda68270710c5aa600b3a97e1bf598f869bd46fb"
    }
  ]
},
{
  "id": "article.cambridge-9701-practical-planning-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-06-Planning-Data-Analysis-and-Evaluation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-06-Planning-Data-Analysis-and-Evaluation",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Chemistry-Practical-06-Planning-Data-Analysis-and-Evaluation.mdx",
      "status": "published",
      "sourceSha256": "06cf55caed1ed75c97d88af286a6bd32893b4644495b6f12faee8cdf41863ba3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-chemistry-practicals/Cambridge-International-A-Level-Chemistry-Practical-06-Planning-Data-Analysis-and-Evaluation",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Chemistry-Practical-06-Planning-Data-Analysis-and-Evaluation.mdx",
      "status": "draft",
      "sourceSha256": "06cf55caed1ed75c97d88af286a6bd32893b4644495b6f12faee8cdf41863ba3"
    }
  ]
},
{
  "id": "article.cambridge-9702-practical-measurement-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-01-Measurement-Calibration-and-Uncertainty.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-01-Measurement-Calibration-and-Uncertainty",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-01-Measurement-Calibration-and-Uncertainty.mdx",
      "status": "published",
      "sourceSha256": "fa217800df3e0a383b4e461020f116a99c6fb905eba1299f2740bb9e0a8717c2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-01-Measurement-Calibration-and-Uncertainty",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-Practical-01-Measurement-Calibration-and-Uncertainty.mdx",
      "status": "draft",
      "sourceSha256": "fa217800df3e0a383b4e461020f116a99c6fb905eba1299f2740bb9e0a8717c2"
    }
  ]
},
{
  "id": "article.cambridge-9702-practical-mechanics-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-02-Mechanics-and-Materials-Experiments.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-02-Mechanics-and-Materials-Experiments",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-02-Mechanics-and-Materials-Experiments.mdx",
      "status": "published",
      "sourceSha256": "ec7aa7d913d48bf7443113ee1b8378d7ea7dd087b74747c58a7614235b277eb6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-02-Mechanics-and-Materials-Experiments",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-Practical-02-Mechanics-and-Materials-Experiments.mdx",
      "status": "draft",
      "sourceSha256": "ec7aa7d913d48bf7443113ee1b8378d7ea7dd087b74747c58a7614235b277eb6"
    }
  ]
},
{
  "id": "article.cambridge-9702-practical-circuits-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-03-Electricity-and-Circuit-Experiments.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-03-Electricity-and-Circuit-Experiments",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-03-Electricity-and-Circuit-Experiments.mdx",
      "status": "published",
      "sourceSha256": "d3d3b6363be89bebd19080b6fe0267a78adf885d9877b848850926b6c6562527"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-03-Electricity-and-Circuit-Experiments",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-Practical-03-Electricity-and-Circuit-Experiments.mdx",
      "status": "draft",
      "sourceSha256": "d3d3b6363be89bebd19080b6fe0267a78adf885d9877b848850926b6c6562527"
    }
  ]
},
{
  "id": "article.cambridge-9702-practical-waves-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-04-Waves-and-Oscillation-Experiments.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-04-Waves-and-Oscillation-Experiments",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-04-Waves-and-Oscillation-Experiments.mdx",
      "status": "published",
      "sourceSha256": "8ae101baa7fbb72f37d7dcfb551607193ef43ed858aea98c465bcbc647c35a39"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-04-Waves-and-Oscillation-Experiments",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-Practical-04-Waves-and-Oscillation-Experiments.mdx",
      "status": "draft",
      "sourceSha256": "8ae101baa7fbb72f37d7dcfb551607193ef43ed858aea98c465bcbc647c35a39"
    }
  ]
},
{
  "id": "article.cambridge-9702-practical-planning-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-05-Planning-Physics-Investigations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-05-Planning-Physics-Investigations",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-05-Planning-Physics-Investigations.mdx",
      "status": "published",
      "sourceSha256": "ff0eb8c56c912e5815ab2d5b9e07f677404726cacf2af1e6e294511223b3bd71"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-05-Planning-Physics-Investigations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-Practical-05-Planning-Physics-Investigations.mdx",
      "status": "draft",
      "sourceSha256": "ff0eb8c56c912e5815ab2d5b9e07f677404726cacf2af1e6e294511223b3bd71"
    }
  ]
},
{
  "id": "article.cambridge-9702-practical-data-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-06-Physics-Data-Analysis-and-Evaluation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-06-Physics-Data-Analysis-and-Evaluation",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Physics-Practical-06-Physics-Data-Analysis-and-Evaluation.mdx",
      "status": "published",
      "sourceSha256": "818a524d029358ce402bc78867500e1dd3e7638a4216690a84869bc8ade63e7f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-physics-practicals/Cambridge-International-A-Level-Physics-Practical-06-Physics-Data-Analysis-and-Evaluation",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Physics-Practical-06-Physics-Data-Analysis-and-Evaluation.mdx",
      "status": "draft",
      "sourceSha256": "818a524d029358ce402bc78867500e1dd3e7638a4216690a84869bc8ade63e7f"
    }
  ]
},
{
  "id": "article.cambridge-9693-water-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-01-Water.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-01-Water",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-01-Water.mdx",
      "status": "published",
      "sourceSha256": "c28d12d9092102dd39374b98c97c093057a44019785d58523d0bb310a0f889d4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-01-Water",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-01-Water.mdx",
      "status": "draft",
      "sourceSha256": "c28d12d9092102dd39374b98c97c093057a44019785d58523d0bb310a0f889d4"
    }
  ]
},
{
  "id": "article.cambridge-9693-earth-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-02-Earth-processes.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-02-Earth-processes",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-02-Earth-processes.mdx",
      "status": "published",
      "sourceSha256": "d88fb391b1778deb99ec92eb5d3f06fc6f374a8ec65f72412e016d93d2fa7cb5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-02-Earth-processes",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-02-Earth-processes.mdx",
      "status": "draft",
      "sourceSha256": "d88fb391b1778deb99ec92eb5d3f06fc6f374a8ec65f72412e016d93d2fa7cb5"
    }
  ]
},
{
  "id": "article.cambridge-9693-interactions-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-03-Interactions-in-marine-ecosystems.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-03-Interactions-in-marine-ecosystems",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-03-Interactions-in-marine-ecosystems.mdx",
      "status": "published",
      "sourceSha256": "69d57c052967aad9c8ac60c1364c6a29306fdf9f8b66948ed4619b315adf75eb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-03-Interactions-in-marine-ecosystems",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-03-Interactions-in-marine-ecosystems.mdx",
      "status": "draft",
      "sourceSha256": "69d57c052967aad9c8ac60c1364c6a29306fdf9f8b66948ed4619b315adf75eb"
    }
  ]
},
{
  "id": "article.cambridge-9693-classification-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-04-Classification-and-biodiversity.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-04-Classification-and-biodiversity",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-04-Classification-and-biodiversity.mdx",
      "status": "published",
      "sourceSha256": "8573e08e91c20326a72e15f02d6247748e8b9099971fd1ee2b50da47341f0d39"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-04-Classification-and-biodiversity",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-04-Classification-and-biodiversity.mdx",
      "status": "draft",
      "sourceSha256": "8573e08e91c20326a72e15f02d6247748e8b9099971fd1ee2b50da47341f0d39"
    }
  ]
},
{
  "id": "article.cambridge-9693-ecosystems-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-05-Examples-of-marine-ecosystems.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-05-Examples-of-marine-ecosystems",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-05-Examples-of-marine-ecosystems.mdx",
      "status": "published",
      "sourceSha256": "783237933d9fc17848fbb3cd4e59cac67ed1560baee1dfbcc2140faaa6204a43"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-05-Examples-of-marine-ecosystems",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-05-Examples-of-marine-ecosystems.mdx",
      "status": "draft",
      "sourceSha256": "783237933d9fc17848fbb3cd4e59cac67ed1560baee1dfbcc2140faaa6204a43"
    }
  ]
},
{
  "id": "article.cambridge-9693-physiology-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-06-Physiology-of-marine-organisms.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-06-Physiology-of-marine-organisms",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-06-Physiology-of-marine-organisms.mdx",
      "status": "published",
      "sourceSha256": "194a0bab92925cfa5ed05e14f5ba6c5281e5da94a776c47f24c9c19317390dc1"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-06-Physiology-of-marine-organisms",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-06-Physiology-of-marine-organisms.mdx",
      "status": "draft",
      "sourceSha256": "194a0bab92925cfa5ed05e14f5ba6c5281e5da94a776c47f24c9c19317390dc1"
    }
  ]
},
{
  "id": "article.cambridge-9693-energy-07",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-07-Energy.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-07-Energy",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-07-Energy.mdx",
      "status": "published",
      "sourceSha256": "1cf4a486e4b14f7265ba862c0ef3a82dea720e4f7310130663714e29fe3346c4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-07-Energy",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-07-Energy.mdx",
      "status": "draft",
      "sourceSha256": "1cf4a486e4b14f7265ba862c0ef3a82dea720e4f7310130663714e29fe3346c4"
    }
  ]
},
{
  "id": "article.cambridge-9693-fisheries-08",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-08-Fisheries-for-the-future.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-08-Fisheries-for-the-future",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-08-Fisheries-for-the-future.mdx",
      "status": "published",
      "sourceSha256": "f3d5d5685a1b047e8a4ee971f6ea234986d69690cd48b38f6c4a75398a59038f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-08-Fisheries-for-the-future",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-08-Fisheries-for-the-future.mdx",
      "status": "draft",
      "sourceSha256": "f3d5d5685a1b047e8a4ee971f6ea234986d69690cd48b38f6c4a75398a59038f"
    }
  ]
},
{
  "id": "article.cambridge-9693-human-impacts-09",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-09-Human-impacts-on-marine-ecosystems.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-09-Human-impacts-on-marine-ecosystems",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-09-Human-impacts-on-marine-ecosystems.mdx",
      "status": "published",
      "sourceSha256": "5e49795755e5c1076266f958612ecacb5fe54fde52e54b9b615f0705bd643056"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-notes/Cambridge-International-A-Level-Marine-Science-09-Human-impacts-on-marine-ecosystems",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-09-Human-impacts-on-marine-ecosystems.mdx",
      "status": "draft",
      "sourceSha256": "5e49795755e5c1076266f958612ecacb5fe54fde52e54b9b615f0705bd643056"
    }
  ]
},
{
  "id": "article.cambridge-9693-practical-planning-01",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-01-Planning-investigations-and-variables.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-01-Planning-investigations-and-variables",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-01-Planning-investigations-and-variables.mdx",
      "status": "published",
      "sourceSha256": "207588f63293c719807b99c993ed4993d3cc2fd8c563941962f789fa5b995ca0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-01-Planning-investigations-and-variables",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-Practical-Skills-01-Planning-investigations-and-variables.mdx",
      "status": "draft",
      "sourceSha256": "207588f63293c719807b99c993ed4993d3cc2fd8c563941962f789fa5b995ca0"
    }
  ]
},
{
  "id": "article.cambridge-9693-practical-apparatus-02",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-02-Apparatus-methods-and-risk.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-02-Apparatus-methods-and-risk",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-02-Apparatus-methods-and-risk.mdx",
      "status": "published",
      "sourceSha256": "a256f58660f16ed0f2335f5be4ee06134f46177dc32f337023be415592b82750"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-02-Apparatus-methods-and-risk",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-Practical-Skills-02-Apparatus-methods-and-risk.mdx",
      "status": "draft",
      "sourceSha256": "a256f58660f16ed0f2335f5be4ee06134f46177dc32f337023be415592b82750"
    }
  ]
},
{
  "id": "article.cambridge-9693-practical-recording-03",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-03-Recording-observations-and-raw-data.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-03-Recording-observations-and-raw-data",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-03-Recording-observations-and-raw-data.mdx",
      "status": "published",
      "sourceSha256": "98d311c2afd7f428df4b01d30a0dd6c2a5054ef67b8ff3684ce70405491cc84c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-03-Recording-observations-and-raw-data",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-Practical-Skills-03-Recording-observations-and-raw-data.mdx",
      "status": "draft",
      "sourceSha256": "98d311c2afd7f428df4b01d30a0dd6c2a5054ef67b8ff3684ce70405491cc84c"
    }
  ]
},
{
  "id": "article.cambridge-9693-practical-graphs-04",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-04-Tables-graphs-and-transformations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-04-Tables-graphs-and-transformations",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-04-Tables-graphs-and-transformations.mdx",
      "status": "published",
      "sourceSha256": "abecc9bead76948db68f6161566dd2663c2b1d0c815ef81c71d91f0b3d2a7e00"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-04-Tables-graphs-and-transformations",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-Practical-Skills-04-Tables-graphs-and-transformations.mdx",
      "status": "draft",
      "sourceSha256": "abecc9bead76948db68f6161566dd2663c2b1d0c815ef81c71d91f0b3d2a7e00"
    }
  ]
},
{
  "id": "article.cambridge-9693-practical-uncertainty-05",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-05-Uncertainty-precision-and-significant-figures.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-05-Uncertainty-precision-and-significant-figures",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-05-Uncertainty-precision-and-significant-figures.mdx",
      "status": "published",
      "sourceSha256": "eeafaa70103801b0f3290b6436b850654448603fa8678aee29d9f350a1c2b99e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-05-Uncertainty-precision-and-significant-figures",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-Practical-Skills-05-Uncertainty-precision-and-significant-figures.mdx",
      "status": "draft",
      "sourceSha256": "eeafaa70103801b0f3290b6436b850654448603fa8678aee29d9f350a1c2b99e"
    }
  ]
},
{
  "id": "article.cambridge-9693-practical-statistics-06",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-06-Descriptive-statistics-and-statistical-tests.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-06-Descriptive-statistics-and-statistical-tests",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-06-Descriptive-statistics-and-statistical-tests.mdx",
      "status": "published",
      "sourceSha256": "43fc5d55d34a0863ed5875a514481729a760e9239a0c1322b71afde7faf31f28"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-06-Descriptive-statistics-and-statistical-tests",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-Practical-Skills-06-Descriptive-statistics-and-statistical-tests.mdx",
      "status": "draft",
      "sourceSha256": "43fc5d55d34a0863ed5875a514481729a760e9239a0c1322b71afde7faf31f28"
    }
  ]
},
{
  "id": "article.cambridge-9693-practical-evaluation-07",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-07-Conclusions-limitations-and-improvements.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-07-Conclusions-limitations-and-improvements",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-07-Conclusions-limitations-and-improvements.mdx",
      "status": "published",
      "sourceSha256": "fd92f65744c71dea2c5685cdef27f65daab989c8721b8ee90e262de3777655db"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-07-Conclusions-limitations-and-improvements",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-Practical-Skills-07-Conclusions-limitations-and-improvements.mdx",
      "status": "draft",
      "sourceSha256": "fd92f65744c71dea2c5685cdef27f65daab989c8721b8ee90e262de3777655db"
    }
  ]
},
{
  "id": "article.cambridge-9693-practical-strategy-08",
  "englishSourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-08-Paper-2-and-Paper-4-investigation-strategy.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-08-Paper-2-and-Paper-4-investigation-strategy",
      "sourcePath": "content/posts/Cambridge-International-A-Level-Marine-Science-Practical-Skills-08-Paper-2-and-Paper-4-investigation-strategy.mdx",
      "status": "published",
      "sourceSha256": "71a410c9a139f2b7cfa2734c2b9369eff1cc241b49988cb02dfa6ba4c2ac6b99"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/cambridge-international-a-level-marine-science-practicals/Cambridge-International-A-Level-Marine-Science-Practical-Skills-08-Paper-2-and-Paper-4-investigation-strategy",
      "sourcePath": "content/translations/zh-Hans/Cambridge-International-A-Level-Marine-Science-Practical-Skills-08-Paper-2-and-Paper-4-investigation-strategy.mdx",
      "status": "draft",
      "sourceSha256": "71a410c9a139f2b7cfa2734c2b9369eff1cc241b49988cb02dfa6ba4c2ac6b99"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-unit3-01",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-01-Unit-3-Practical-Skills-I.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-01-Unit-3-Practical-Skills-I",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-01-Unit-3-Practical-Skills-I.mdx",
      "status": "published",
      "sourceSha256": "897aaa1707a73247d3f14ba03588c6d9ae48e26f8512c9ef9f8401e33c6c2a32"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-01-Unit-3-Practical-Skills-I",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-01-Unit-3-Practical-Skills-I.mdx",
      "status": "draft",
      "sourceSha256": "897aaa1707a73247d3f14ba03588c6d9ae48e26f8512c9ef9f8401e33c6c2a32"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-unit6-02",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-02-Unit-6-Practical-Skills-II.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-02-Unit-6-Practical-Skills-II",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-02-Unit-6-Practical-Skills-II.mdx",
      "status": "published",
      "sourceSha256": "15fc98ba9980649c5e53b42d97bdbfcea6584dfae77dc5640ed2bb326e9f71aa"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-02-Unit-6-Practical-Skills-II",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-02-Unit-6-Practical-Skills-II.mdx",
      "status": "draft",
      "sourceSha256": "15fc98ba9980649c5e53b42d97bdbfcea6584dfae77dc5640ed2bb326e9f71aa"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-colour-03",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-03-Core-Practical-1-Estimate-reducing-sugar-and-starch-concentrations-using-colour-standards.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-03-Core-Practical-1-Estimate-reducing-sugar-and-starch-concentrations-using-colour-standards",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-03-Core-Practical-1-Estimate-reducing-sugar-and-starch-concentrations-using-colour-standards.mdx",
      "status": "published",
      "sourceSha256": "34ca856132d73cfc3cc5cc6f1c801ba7c9aad5dea85109e748f90664cd34bf3a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-03-Core-Practical-1-Estimate-reducing-sugar-and-starch-concentrations-using-colour-standards",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-03-Core-Practical-1-Estimate-reducing-sugar-and-starch-concentrations-using-colour-standards.mdx",
      "status": "draft",
      "sourceSha256": "34ca856132d73cfc3cc5cc6f1c801ba7c9aad5dea85109e748f90664cd34bf3a"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-vitamin-c-04",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-04-Core-Practical-2-Investigate-vitamin-C-content-in-food-and-drink.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-04-Core-Practical-2-Investigate-vitamin-C-content-in-food-and-drink",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-04-Core-Practical-2-Investigate-vitamin-C-content-in-food-and-drink.mdx",
      "status": "published",
      "sourceSha256": "5b26450a15c47caf5a6757a5f19ba0bf63d06ee7831ad89aa8e226ee079b6396"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-04-Core-Practical-2-Investigate-vitamin-C-content-in-food-and-drink",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-04-Core-Practical-2-Investigate-vitamin-C-content-in-food-and-drink.mdx",
      "status": "draft",
      "sourceSha256": "5b26450a15c47caf5a6757a5f19ba0bf63d06ee7831ad89aa8e226ee079b6396"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-membrane-05",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-05-Core-Practical-3-Investigate-temperature-and-alcohol-effects-on-membrane-permeability.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-05-Core-Practical-3-Investigate-temperature-and-alcohol-effects-on-membrane-permeability",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-05-Core-Practical-3-Investigate-temperature-and-alcohol-effects-on-membrane-permeability.mdx",
      "status": "published",
      "sourceSha256": "67ea726f70f47c4db25bade6aad7fa98b4d9ff818899b3225dfae856dacffd0d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-05-Core-Practical-3-Investigate-temperature-and-alcohol-effects-on-membrane-permeability",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-05-Core-Practical-3-Investigate-temperature-and-alcohol-effects-on-membrane-permeability.mdx",
      "status": "draft",
      "sourceSha256": "67ea726f70f47c4db25bade6aad7fa98b4d9ff818899b3225dfae856dacffd0d"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-enzyme-06",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-06-Core-Practical-4-Investigate-factors-affecting-initial-enzyme-reaction-rate.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-06-Core-Practical-4-Investigate-factors-affecting-initial-enzyme-reaction-rate",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-06-Core-Practical-4-Investigate-factors-affecting-initial-enzyme-reaction-rate.mdx",
      "status": "published",
      "sourceSha256": "627cc668f64dcc877a8b2cffd5bd1e2a295dc7e8d9e2931602819bd610e7adac"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-06-Core-Practical-4-Investigate-factors-affecting-initial-enzyme-reaction-rate",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-06-Core-Practical-4-Investigate-factors-affecting-initial-enzyme-reaction-rate.mdx",
      "status": "draft",
      "sourceSha256": "627cc668f64dcc877a8b2cffd5bd1e2a295dc7e8d9e2931602819bd610e7adac"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-microscopy-07",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-07-Core-Practical-5-Observe-draw-and-measure-animal-cells-with-a-light-microscope.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-07-Core-Practical-5-Observe-draw-and-measure-animal-cells-with-a-light-microscope",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-07-Core-Practical-5-Observe-draw-and-measure-animal-cells-with-a-light-microscope.mdx",
      "status": "published",
      "sourceSha256": "0bbbad93f36a07f26b798cea2682975a92fa7fccc476ac69bc8cc453f190ce8f"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-07-Core-Practical-5-Observe-draw-and-measure-animal-cells-with-a-light-microscope",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-07-Core-Practical-5-Observe-draw-and-measure-animal-cells-with-a-light-microscope.mdx",
      "status": "draft",
      "sourceSha256": "0bbbad93f36a07f26b798cea2682975a92fa7fccc476ac69bc8cc453f190ce8f"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-root-tip-08",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-08-Core-Practical-6-Prepare-and-stain-a-root-tip-squash-to-observe-mitosis.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-08-Core-Practical-6-Prepare-and-stain-a-root-tip-squash-to-observe-mitosis",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-08-Core-Practical-6-Prepare-and-stain-a-root-tip-squash-to-observe-mitosis.mdx",
      "status": "published",
      "sourceSha256": "757f9558ab7492accbbe89efb5dc5c078d4f5401e47e5c4defa00447899f2c59"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-08-Core-Practical-6-Prepare-and-stain-a-root-tip-squash-to-observe-mitosis",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-08-Core-Practical-6-Prepare-and-stain-a-root-tip-squash-to-observe-mitosis.mdx",
      "status": "draft",
      "sourceSha256": "757f9558ab7492accbbe89efb5dc5c078d4f5401e47e5c4defa00447899f2c59"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-plant-tissue-09",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-09-Core-Practical-7-Observe-and-draw-plant-tissue-sections-and-cells.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-09-Core-Practical-7-Observe-and-draw-plant-tissue-sections-and-cells",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-09-Core-Practical-7-Observe-and-draw-plant-tissue-sections-and-cells.mdx",
      "status": "published",
      "sourceSha256": "ac1e84d60d82a330106c168b66919f2587e9c15a94ab6df37a824bc7cbbdde1a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-09-Core-Practical-7-Observe-and-draw-plant-tissue-sections-and-cells",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-09-Core-Practical-7-Observe-and-draw-plant-tissue-sections-and-cells.mdx",
      "status": "draft",
      "sourceSha256": "ac1e84d60d82a330106c168b66919f2587e9c15a94ab6df37a824bc7cbbdde1a"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-fibre-10",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-10-Core-Practical-8-Determine-the-tensile-strength-of-plant-fibres.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-10-Core-Practical-8-Determine-the-tensile-strength-of-plant-fibres",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-10-Core-Practical-8-Determine-the-tensile-strength-of-plant-fibres.mdx",
      "status": "published",
      "sourceSha256": "274a1b61085795b0652420383786fb5fcb971dec6b0ce172ef44eb69001f9697"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-10-Core-Practical-8-Determine-the-tensile-strength-of-plant-fibres",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-10-Core-Practical-8-Determine-the-tensile-strength-of-plant-fibres.mdx",
      "status": "draft",
      "sourceSha256": "274a1b61085795b0652420383786fb5fcb971dec6b0ce172ef44eb69001f9697"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-antimicrobial-11",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-11-Core-Practical-9-Investigate-antimicrobial-properties-of-plants-using-aseptic-technique.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-11-Core-Practical-9-Investigate-antimicrobial-properties-of-plants-using-aseptic-technique",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-11-Core-Practical-9-Investigate-antimicrobial-properties-of-plants-using-aseptic-technique.mdx",
      "status": "published",
      "sourceSha256": "179e0e944369a740c561f34e5ec29d6d12fb3ff2a0da744248665d32fee031f6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-11-Core-Practical-9-Investigate-antimicrobial-properties-of-plants-using-aseptic-technique",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-11-Core-Practical-9-Investigate-antimicrobial-properties-of-plants-using-aseptic-technique.mdx",
      "status": "draft",
      "sourceSha256": "179e0e944369a740c561f34e5ec29d6d12fb3ff2a0da744248665d32fee031f6"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-photosynthesis-12",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-12-Core-Practical-10-Investigate-factors-affecting-photosynthesis-in-an-aquatic-plant.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-12-Core-Practical-10-Investigate-factors-affecting-photosynthesis-in-an-aquatic-plant",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-12-Core-Practical-10-Investigate-factors-affecting-photosynthesis-in-an-aquatic-plant.mdx",
      "status": "published",
      "sourceSha256": "62c6570031ae3caac4971d9e2f35637d018095d111b4c7c014ad9da0fad247be"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-12-Core-Practical-10-Investigate-factors-affecting-photosynthesis-in-an-aquatic-plant",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-12-Core-Practical-10-Investigate-factors-affecting-photosynthesis-in-an-aquatic-plant.mdx",
      "status": "draft",
      "sourceSha256": "62c6570031ae3caac4971d9e2f35637d018095d111b4c7c014ad9da0fad247be"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-habitat-13",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-13-Core-Practical-11-Study-a-habitat-using-quadrats-transects-and-abiotic-measurements.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-13-Core-Practical-11-Study-a-habitat-using-quadrats-transects-and-abiotic-measurements",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-13-Core-Practical-11-Study-a-habitat-using-quadrats-transects-and-abiotic-measurements.mdx",
      "status": "published",
      "sourceSha256": "959d3912189568ca5cb0b1c6fc491f17d1558acd667d28406ae4408e9bc0803c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-13-Core-Practical-11-Study-a-habitat-using-quadrats-transects-and-abiotic-measurements",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-13-Core-Practical-11-Study-a-habitat-using-quadrats-transects-and-abiotic-measurements.mdx",
      "status": "draft",
      "sourceSha256": "959d3912189568ca5cb0b1c6fc491f17d1558acd667d28406ae4408e9bc0803c"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-development-14",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-14-Core-Practical-12-Investigate-temperature-effects-on-organism-development.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-14-Core-Practical-12-Investigate-temperature-effects-on-organism-development",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-14-Core-Practical-12-Investigate-temperature-effects-on-organism-development.mdx",
      "status": "published",
      "sourceSha256": "bebdb5c3f1c20c00959f35b6951844eede160985af302c0893c77374b5e9db7a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-14-Core-Practical-12-Investigate-temperature-effects-on-organism-development",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-14-Core-Practical-12-Investigate-temperature-effects-on-organism-development.mdx",
      "status": "draft",
      "sourceSha256": "bebdb5c3f1c20c00959f35b6951844eede160985af302c0893c77374b5e9db7a"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-liquid-culture-15",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-15-Core-Practical-13-Investigate-microorganism-growth-in-liquid-culture.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-15-Core-Practical-13-Investigate-microorganism-growth-in-liquid-culture",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-15-Core-Practical-13-Investigate-microorganism-growth-in-liquid-culture.mdx",
      "status": "published",
      "sourceSha256": "f2733f8c25b4dcff52cb576c5ae75bfa9ebd62fc56683015cc63dcd3458ce14b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-15-Core-Practical-13-Investigate-microorganism-growth-in-liquid-culture",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-15-Core-Practical-13-Investigate-microorganism-growth-in-liquid-culture.mdx",
      "status": "draft",
      "sourceSha256": "f2733f8c25b4dcff52cb576c5ae75bfa9ebd62fc56683015cc63dcd3458ce14b"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-antibiotic-16",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-16-Core-Practical-14-Investigate-antibiotic-effects-on-bacteria.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-16-Core-Practical-14-Investigate-antibiotic-effects-on-bacteria",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-16-Core-Practical-14-Investigate-antibiotic-effects-on-bacteria.mdx",
      "status": "published",
      "sourceSha256": "62d50e11b2eb52075ccad0b92589d17e1e7000225bf2bec76dbb2bab354a85ad"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-16-Core-Practical-14-Investigate-antibiotic-effects-on-bacteria",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-16-Core-Practical-14-Investigate-antibiotic-effects-on-bacteria.mdx",
      "status": "draft",
      "sourceSha256": "62d50e11b2eb52075ccad0b92589d17e1e7000225bf2bec76dbb2bab354a85ad"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-redox-17",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-17-Core-Practical-15-Investigate-yeast-respiration-using-a-redox-indicator.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-17-Core-Practical-15-Investigate-yeast-respiration-using-a-redox-indicator",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-17-Core-Practical-15-Investigate-yeast-respiration-using-a-redox-indicator.mdx",
      "status": "published",
      "sourceSha256": "fd7c181b21d3c2213d6bb16a3379833674c64603e690bebcd2330accd79cab51"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-17-Core-Practical-15-Investigate-yeast-respiration-using-a-redox-indicator",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-17-Core-Practical-15-Investigate-yeast-respiration-using-a-redox-indicator.mdx",
      "status": "draft",
      "sourceSha256": "fd7c181b21d3c2213d6bb16a3379833674c64603e690bebcd2330accd79cab51"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-respirometer-18",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-18-Core-Practical-16-Determine-respiration-rate-and-respiratory-quotient-with-a-respirometer.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-18-Core-Practical-16-Determine-respiration-rate-and-respiratory-quotient-with-a-respirometer",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-18-Core-Practical-16-Determine-respiration-rate-and-respiratory-quotient-with-a-respirometer.mdx",
      "status": "published",
      "sourceSha256": "4548f1189b7fe4d28e8a2316c653f32df8f8c1d77d71e363153768723304260c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-18-Core-Practical-16-Determine-respiration-rate-and-respiratory-quotient-with-a-respirometer",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-18-Core-Practical-16-Determine-respiration-rate-and-respiratory-quotient-with-a-respirometer.mdx",
      "status": "draft",
      "sourceSha256": "4548f1189b7fe4d28e8a2316c653f32df8f8c1d77d71e363153768723304260c"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-spirometer-19",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-19-Core-Practical-17-Investigate-exercise-effects-using-spirometer-traces.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-19-Core-Practical-17-Investigate-exercise-effects-using-spirometer-traces",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-19-Core-Practical-17-Investigate-exercise-effects-using-spirometer-traces.mdx",
      "status": "published",
      "sourceSha256": "143a02836304eebb7b94e8457c8843ad7136c5d910ff50e3255cca74bad2a811"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-19-Core-Practical-17-Investigate-exercise-effects-using-spirometer-traces",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-19-Core-Practical-17-Investigate-exercise-effects-using-spirometer-traces.mdx",
      "status": "draft",
      "sourceSha256": "143a02836304eebb7b94e8457c8843ad7136c5d910ff50e3255cca74bad2a811"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-practical-amylase-20",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-Practical-20-Core-Practical-18-Investigate-amylase-production-in-germinating-cereal-grains.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-20-Core-Practical-18-Investigate-amylase-production-in-germinating-cereal-grains",
      "sourcePath": "content/posts/Pearson-IAL-Biology-Practical-20-Core-Practical-18-Investigate-amylase-production-in-germinating-cereal-grains.mdx",
      "status": "published",
      "sourceSha256": "6cc16f4e83a37b856c2078ea927228d693ac6d1d908e1ae109af9a7aa88b3de4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-practicals/Pearson-IAL-Biology-Practical-20-Core-Practical-18-Investigate-amylase-production-in-germinating-cereal-grains",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-Practical-20-Core-Practical-18-Investigate-amylase-production-in-germinating-cereal-grains.mdx",
      "status": "draft",
      "sourceSha256": "6cc16f4e83a37b856c2078ea927228d693ac6d1d908e1ae109af9a7aa88b3de4"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-theory-unit1-01",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-01-Unit-1-Molecules-Diet-Transport-and-Health.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-notes/Pearson-IAL-Biology-01-Unit-1-Molecules-Diet-Transport-and-Health",
      "sourcePath": "content/posts/Pearson-IAL-Biology-01-Unit-1-Molecules-Diet-Transport-and-Health.mdx",
      "status": "published",
      "sourceSha256": "bb42d25080c81a8f25902df4bda7eb37480d122623976da31da7f926b4384303"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-notes/Pearson-IAL-Biology-01-Unit-1-Molecules-Diet-Transport-and-Health",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-01-Unit-1-Molecules-Diet-Transport-and-Health.mdx",
      "status": "draft",
      "sourceSha256": "bb42d25080c81a8f25902df4bda7eb37480d122623976da31da7f926b4384303"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-theory-unit2-02",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-02-Unit-2-Cells-Development-Biodiversity-and-Conservation.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-notes/Pearson-IAL-Biology-02-Unit-2-Cells-Development-Biodiversity-and-Conservation",
      "sourcePath": "content/posts/Pearson-IAL-Biology-02-Unit-2-Cells-Development-Biodiversity-and-Conservation.mdx",
      "status": "published",
      "sourceSha256": "5c6b0255590acdb8ef36190a9c607f0d6bb1d5a8242112d030b3b8499cc270fb"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-notes/Pearson-IAL-Biology-02-Unit-2-Cells-Development-Biodiversity-and-Conservation",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-02-Unit-2-Cells-Development-Biodiversity-and-Conservation.mdx",
      "status": "draft",
      "sourceSha256": "5c6b0255590acdb8ef36190a9c607f0d6bb1d5a8242112d030b3b8499cc270fb"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-theory-unit4-03",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-03-Unit-4-Energy-Environment-Microbiology-and-Immunity.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-notes/Pearson-IAL-Biology-03-Unit-4-Energy-Environment-Microbiology-and-Immunity",
      "sourcePath": "content/posts/Pearson-IAL-Biology-03-Unit-4-Energy-Environment-Microbiology-and-Immunity.mdx",
      "status": "published",
      "sourceSha256": "d0b88175fc220f9c8e0c8ec44e4c93c3d7dc5c0d38707df0931138bed8f54aa6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-notes/Pearson-IAL-Biology-03-Unit-4-Energy-Environment-Microbiology-and-Immunity",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-03-Unit-4-Energy-Environment-Microbiology-and-Immunity.mdx",
      "status": "draft",
      "sourceSha256": "d0b88175fc220f9c8e0c8ec44e4c93c3d7dc5c0d38707df0931138bed8f54aa6"
    }
  ]
},
{
  "id": "article.pearson-ial-biology-theory-unit5-04",
  "englishSourcePath": "content/posts/Pearson-IAL-Biology-04-Unit-5-Respiration-Internal-Environment-Coordination-and-Gene-Technology.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-biology-notes/Pearson-IAL-Biology-04-Unit-5-Respiration-Internal-Environment-Coordination-and-Gene-Technology",
      "sourcePath": "content/posts/Pearson-IAL-Biology-04-Unit-5-Respiration-Internal-Environment-Coordination-and-Gene-Technology.mdx",
      "status": "published",
      "sourceSha256": "09379994ad0899d315204fbfc67e1206c4a09b0a390d5e83f105e9c8ca285e30"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-biology-notes/Pearson-IAL-Biology-04-Unit-5-Respiration-Internal-Environment-Coordination-and-Gene-Technology",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Biology-04-Unit-5-Respiration-Internal-Environment-Coordination-and-Gene-Technology.mdx",
      "status": "draft",
      "sourceSha256": "09379994ad0899d315204fbfc67e1206c4a09b0a390d5e83f105e9c8ca285e30"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-theory-unit1-01",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-01-Unit-1-Structure-Bonding-and-Introduction-to-Organic-Chemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-notes/Pearson-IAL-Chemistry-01-Unit-1-Structure-Bonding-and-Introduction-to-Organic-Chemistry",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-01-Unit-1-Structure-Bonding-and-Introduction-to-Organic-Chemistry.mdx",
      "status": "published",
      "sourceSha256": "d1bdce38703765118851b9af384bae78cbff99f7628e130e4f009ac5cefc1ed2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-notes/Pearson-IAL-Chemistry-01-Unit-1-Structure-Bonding-and-Introduction-to-Organic-Chemistry",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-01-Unit-1-Structure-Bonding-and-Introduction-to-Organic-Chemistry.mdx",
      "status": "draft",
      "sourceSha256": "d1bdce38703765118851b9af384bae78cbff99f7628e130e4f009ac5cefc1ed2"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-theory-unit2-02",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-02-Unit-2-Energetics-Group-Chemistry-Halogenoalkanes-and-Alcohols.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-notes/Pearson-IAL-Chemistry-02-Unit-2-Energetics-Group-Chemistry-Halogenoalkanes-and-Alcohols",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-02-Unit-2-Energetics-Group-Chemistry-Halogenoalkanes-and-Alcohols.mdx",
      "status": "published",
      "sourceSha256": "4f2fc640cc1bd75871bd3ff13fc7899d62c0f3494e5b3e77179f6075fef083d4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-notes/Pearson-IAL-Chemistry-02-Unit-2-Energetics-Group-Chemistry-Halogenoalkanes-and-Alcohols",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-02-Unit-2-Energetics-Group-Chemistry-Halogenoalkanes-and-Alcohols.mdx",
      "status": "draft",
      "sourceSha256": "4f2fc640cc1bd75871bd3ff13fc7899d62c0f3494e5b3e77179f6075fef083d4"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-theory-unit4-03",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-03-Unit-4-Rates-Equilibria-and-Further-Organic-Chemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-notes/Pearson-IAL-Chemistry-03-Unit-4-Rates-Equilibria-and-Further-Organic-Chemistry",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-03-Unit-4-Rates-Equilibria-and-Further-Organic-Chemistry.mdx",
      "status": "published",
      "sourceSha256": "af3ce1e975358b5ab425187d97ec3473055d94a07ddea147f7681b9f8acab34a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-notes/Pearson-IAL-Chemistry-03-Unit-4-Rates-Equilibria-and-Further-Organic-Chemistry",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-03-Unit-4-Rates-Equilibria-and-Further-Organic-Chemistry.mdx",
      "status": "draft",
      "sourceSha256": "af3ce1e975358b5ab425187d97ec3473055d94a07ddea147f7681b9f8acab34a"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-theory-unit5-04",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-04-Unit-5-Transition-Metals-and-Organic-Nitrogen-Chemistry.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-notes/Pearson-IAL-Chemistry-04-Unit-5-Transition-Metals-and-Organic-Nitrogen-Chemistry",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-04-Unit-5-Transition-Metals-and-Organic-Nitrogen-Chemistry.mdx",
      "status": "published",
      "sourceSha256": "6614ed24b66ff7b0e0e1fe55d6d142ee3802bcb50b1190a210765d02a8eb42c9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-notes/Pearson-IAL-Chemistry-04-Unit-5-Transition-Metals-and-Organic-Nitrogen-Chemistry",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-04-Unit-5-Transition-Metals-and-Organic-Nitrogen-Chemistry.mdx",
      "status": "draft",
      "sourceSha256": "6614ed24b66ff7b0e0e1fe55d6d142ee3802bcb50b1190a210765d02a8eb42c9"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-theory-unit1-01",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-01-Unit-1-Mechanics-and-Materials.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-notes/Pearson-IAL-Physics-01-Unit-1-Mechanics-and-Materials",
      "sourcePath": "content/posts/Pearson-IAL-Physics-01-Unit-1-Mechanics-and-Materials.mdx",
      "status": "published",
      "sourceSha256": "2253b4ac80837bb045de05e1c47b4a2095d60712ba5027b608f6beb97d9ad084"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-notes/Pearson-IAL-Physics-01-Unit-1-Mechanics-and-Materials",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-01-Unit-1-Mechanics-and-Materials.mdx",
      "status": "draft",
      "sourceSha256": "2253b4ac80837bb045de05e1c47b4a2095d60712ba5027b608f6beb97d9ad084"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-theory-unit2-02",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-02-Unit-2-Waves-and-Electricity.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-notes/Pearson-IAL-Physics-02-Unit-2-Waves-and-Electricity",
      "sourcePath": "content/posts/Pearson-IAL-Physics-02-Unit-2-Waves-and-Electricity.mdx",
      "status": "published",
      "sourceSha256": "9905a6200e699d945c285c47ed389f63d20888e64eb08c4e0dfd6ad912c3aef6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-notes/Pearson-IAL-Physics-02-Unit-2-Waves-and-Electricity",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-02-Unit-2-Waves-and-Electricity.mdx",
      "status": "draft",
      "sourceSha256": "9905a6200e699d945c285c47ed389f63d20888e64eb08c4e0dfd6ad912c3aef6"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-theory-unit4-03",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-03-Unit-4-Further-Mechanics-Fields-and-Particles.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-notes/Pearson-IAL-Physics-03-Unit-4-Further-Mechanics-Fields-and-Particles",
      "sourcePath": "content/posts/Pearson-IAL-Physics-03-Unit-4-Further-Mechanics-Fields-and-Particles.mdx",
      "status": "published",
      "sourceSha256": "679cc2332a15afd93def74ff7165bc760af070cfb4740024c233a7bd3374eba5"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-notes/Pearson-IAL-Physics-03-Unit-4-Further-Mechanics-Fields-and-Particles",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-03-Unit-4-Further-Mechanics-Fields-and-Particles.mdx",
      "status": "draft",
      "sourceSha256": "679cc2332a15afd93def74ff7165bc760af070cfb4740024c233a7bd3374eba5"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-theory-unit5-04",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-04-Unit-5-Thermodynamics-Radiation-Oscillations-and-Cosmology.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-notes/Pearson-IAL-Physics-04-Unit-5-Thermodynamics-Radiation-Oscillations-and-Cosmology",
      "sourcePath": "content/posts/Pearson-IAL-Physics-04-Unit-5-Thermodynamics-Radiation-Oscillations-and-Cosmology.mdx",
      "status": "published",
      "sourceSha256": "a844fb4fc1fc2543a0382616941fbb85ca7e4d211d4a2feac0f521fa9b3dcb47"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-notes/Pearson-IAL-Physics-04-Unit-5-Thermodynamics-Radiation-Oscillations-and-Cosmology",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-04-Unit-5-Thermodynamics-Radiation-Oscillations-and-Cosmology.mdx",
      "status": "draft",
      "sourceSha256": "a844fb4fc1fc2543a0382616941fbb85ca7e4d211d4a2feac0f521fa9b3dcb47"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-unit3-01",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-01-Unit-3-Practical-Skills-I.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-01-Unit-3-Practical-Skills-I",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-01-Unit-3-Practical-Skills-I.mdx",
      "status": "published",
      "sourceSha256": "ef64f29a4c8187829ac38fa88a10d15ac05352afb0576ed86c08746e4b0c1fa9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-01-Unit-3-Practical-Skills-I",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-01-Unit-3-Practical-Skills-I.mdx",
      "status": "draft",
      "sourceSha256": "ef64f29a4c8187829ac38fa88a10d15ac05352afb0576ed86c08746e4b0c1fa9"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-unit6-02",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-02-Unit-6-Practical-Skills-II.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-02-Unit-6-Practical-Skills-II",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-02-Unit-6-Practical-Skills-II.mdx",
      "status": "published",
      "sourceSha256": "0c23650f2fed8e462da616d456326f54fed3d94356f8f1fa1b3ab05554afcc9a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-02-Unit-6-Practical-Skills-II",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-02-Unit-6-Practical-Skills-II.mdx",
      "status": "draft",
      "sourceSha256": "0c23650f2fed8e462da616d456326f54fed3d94356f8f1fa1b3ab05554afcc9a"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-free-fall-03",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-03-Core-Practical-1-Determine-free-fall-acceleration.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-03-Core-Practical-1-Determine-free-fall-acceleration",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-03-Core-Practical-1-Determine-free-fall-acceleration.mdx",
      "status": "published",
      "sourceSha256": "b28dd6f3b6940a4eb5ecfa4b9069f855bb79d831f06a8bdea52f9711736b63c6"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-03-Core-Practical-1-Determine-free-fall-acceleration",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-03-Core-Practical-1-Determine-free-fall-acceleration.mdx",
      "status": "draft",
      "sourceSha256": "b28dd6f3b6940a4eb5ecfa4b9069f855bb79d831f06a8bdea52f9711736b63c6"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-viscosity-04",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-04-Core-Practical-2-Determine-liquid-viscosity-using-a-falling-ball.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-04-Core-Practical-2-Determine-liquid-viscosity-using-a-falling-ball",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-04-Core-Practical-2-Determine-liquid-viscosity-using-a-falling-ball.mdx",
      "status": "published",
      "sourceSha256": "cbf6f9c22739e13f75387cc4d48311f6e3d6b12ef1c625e61f7d6ba63d19fb1b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-04-Core-Practical-2-Determine-liquid-viscosity-using-a-falling-ball",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-04-Core-Practical-2-Determine-liquid-viscosity-using-a-falling-ball.mdx",
      "status": "draft",
      "sourceSha256": "cbf6f9c22739e13f75387cc4d48311f6e3d6b12ef1c625e61f7d6ba63d19fb1b"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-young-modulus-05",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-05-Core-Practical-3-Determine-the-Young-modulus-of-a-material.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-05-Core-Practical-3-Determine-the-Young-modulus-of-a-material",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-05-Core-Practical-3-Determine-the-Young-modulus-of-a-material.mdx",
      "status": "published",
      "sourceSha256": "6b355404d43f63e725c442e34b92f98a43d24b2cd84c0b6763be85b3f4d8658a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-05-Core-Practical-3-Determine-the-Young-modulus-of-a-material",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-05-Core-Practical-3-Determine-the-Young-modulus-of-a-material.mdx",
      "status": "draft",
      "sourceSha256": "6b355404d43f63e725c442e34b92f98a43d24b2cd84c0b6763be85b3f4d8658a"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-sound-speed-06",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-06-Core-Practical-4-Determine-the-speed-of-sound-using-an-oscilloscope.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-06-Core-Practical-4-Determine-the-speed-of-sound-using-an-oscilloscope",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-06-Core-Practical-4-Determine-the-speed-of-sound-using-an-oscilloscope.mdx",
      "status": "published",
      "sourceSha256": "157cf63702da6ff4dbb2d36a5cbadafdd346e701cecafb40c358a580978af81e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-06-Core-Practical-4-Determine-the-speed-of-sound-using-an-oscilloscope",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-06-Core-Practical-4-Determine-the-speed-of-sound-using-an-oscilloscope.mdx",
      "status": "draft",
      "sourceSha256": "157cf63702da6ff4dbb2d36a5cbadafdd346e701cecafb40c358a580978af81e"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-vibrating-string-07",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-07-Core-Practical-5-Investigate-factors-affecting-a-vibrating-string-s-frequency.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-07-Core-Practical-5-Investigate-factors-affecting-a-vibrating-string-s-frequency",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-07-Core-Practical-5-Investigate-factors-affecting-a-vibrating-string-s-frequency.mdx",
      "status": "published",
      "sourceSha256": "4a6c34082aca88b9fbc5216379b917f3e81e92518820940de052551d6ac19669"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-07-Core-Practical-5-Investigate-factors-affecting-a-vibrating-string-s-frequency",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-07-Core-Practical-5-Investigate-factors-affecting-a-vibrating-string-s-frequency.mdx",
      "status": "draft",
      "sourceSha256": "4a6c34082aca88b9fbc5216379b917f3e81e92518820940de052551d6ac19669"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-diffraction-grating-08",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-08-Core-Practical-6-Determine-light-wavelength-using-a-diffraction-grating.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-08-Core-Practical-6-Determine-light-wavelength-using-a-diffraction-grating",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-08-Core-Practical-6-Determine-light-wavelength-using-a-diffraction-grating.mdx",
      "status": "published",
      "sourceSha256": "0a40382074cc99cc81ee5a8507cef26f974da16e037db1bfbc57711360737634"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-08-Core-Practical-6-Determine-light-wavelength-using-a-diffraction-grating",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-08-Core-Practical-6-Determine-light-wavelength-using-a-diffraction-grating.mdx",
      "status": "draft",
      "sourceSha256": "0a40382074cc99cc81ee5a8507cef26f974da16e037db1bfbc57711360737634"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-resistivity-09",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-09-Core-Practical-7-Determine-the-electrical-resistivity-of-a-material.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-09-Core-Practical-7-Determine-the-electrical-resistivity-of-a-material",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-09-Core-Practical-7-Determine-the-electrical-resistivity-of-a-material.mdx",
      "status": "published",
      "sourceSha256": "392e7224fe5c6671ec9fb504c0c120e0c643a56490d1cc859852f929c90ce2da"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-09-Core-Practical-7-Determine-the-electrical-resistivity-of-a-material",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-09-Core-Practical-7-Determine-the-electrical-resistivity-of-a-material.mdx",
      "status": "draft",
      "sourceSha256": "392e7224fe5c6671ec9fb504c0c120e0c643a56490d1cc859852f929c90ce2da"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-emf-internal-resistance-10",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-10-Core-Practical-8-Determine-a-cell-s-electromotive-force-and-internal-resistance.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-10-Core-Practical-8-Determine-a-cell-s-electromotive-force-and-internal-resistance",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-10-Core-Practical-8-Determine-a-cell-s-electromotive-force-and-internal-resistance.mdx",
      "status": "published",
      "sourceSha256": "4d4512ee1d2640e5e0d4ecd9132ec4d51954d3dfaf314dc2e2d6666c9f455cd3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-10-Core-Practical-8-Determine-a-cell-s-electromotive-force-and-internal-resistance",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-10-Core-Practical-8-Determine-a-cell-s-electromotive-force-and-internal-resistance.mdx",
      "status": "draft",
      "sourceSha256": "4d4512ee1d2640e5e0d4ecd9132ec4d51954d3dfaf314dc2e2d6666c9f455cd3"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-force-momentum-11",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-11-Core-Practical-9-Investigate-force-and-change-of-momentum.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-11-Core-Practical-9-Investigate-force-and-change-of-momentum",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-11-Core-Practical-9-Investigate-force-and-change-of-momentum.mdx",
      "status": "published",
      "sourceSha256": "984f305686d8eb4db80334cf91110a26035ed7b4224336e00ea2109d5514880a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-11-Core-Practical-9-Investigate-force-and-change-of-momentum",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-11-Core-Practical-9-Investigate-force-and-change-of-momentum.mdx",
      "status": "draft",
      "sourceSha256": "984f305686d8eb4db80334cf91110a26035ed7b4224336e00ea2109d5514880a"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-video-collisions-12",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-12-Core-Practical-10-Analyse-collisions-using-digital-video-or-other-ICT.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-12-Core-Practical-10-Analyse-collisions-using-digital-video-or-other-ICT",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-12-Core-Practical-10-Analyse-collisions-using-digital-video-or-other-ICT.mdx",
      "status": "published",
      "sourceSha256": "d4644c1930a5411da032b5e5304244c9a3ddac72ec9b0136284a85cb284249e4"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-12-Core-Practical-10-Analyse-collisions-using-digital-video-or-other-ICT",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-12-Core-Practical-10-Analyse-collisions-using-digital-video-or-other-ICT.mdx",
      "status": "draft",
      "sourceSha256": "d4644c1930a5411da032b5e5304244c9a3ddac72ec9b0136284a85cb284249e4"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-capacitor-13",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-13-Core-Practical-11-Analyse-capacitor-charging-and-discharging.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-13-Core-Practical-11-Analyse-capacitor-charging-and-discharging",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-13-Core-Practical-11-Analyse-capacitor-charging-and-discharging.mdx",
      "status": "published",
      "sourceSha256": "2073c69cce49286752cdc9fd187d9ef6aa2110cb91409cf4c5f805e65dde987b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-13-Core-Practical-11-Analyse-capacitor-charging-and-discharging",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-13-Core-Practical-11-Analyse-capacitor-charging-and-discharging.mdx",
      "status": "draft",
      "sourceSha256": "2073c69cce49286752cdc9fd187d9ef6aa2110cb91409cf4c5f805e65dde987b"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-thermistor-divider-14",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-14-Core-Practical-12-Calibrate-a-thermistor-potential-divider-thermostat.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-14-Core-Practical-12-Calibrate-a-thermistor-potential-divider-thermostat",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-14-Core-Practical-12-Calibrate-a-thermistor-potential-divider-thermostat.mdx",
      "status": "published",
      "sourceSha256": "e2194262305ccb1f9500e7e66c3e198ae5768ad74765797e473a50ec9bc2efa0"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-14-Core-Practical-12-Calibrate-a-thermistor-potential-divider-thermostat",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-14-Core-Practical-12-Calibrate-a-thermistor-potential-divider-thermostat.mdx",
      "status": "draft",
      "sourceSha256": "e2194262305ccb1f9500e7e66c3e198ae5768ad74765797e473a50ec9bc2efa0"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-latent-heat-15",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-15-Core-Practical-13-Determine-specific-latent-heat.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-15-Core-Practical-13-Determine-specific-latent-heat",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-15-Core-Practical-13-Determine-specific-latent-heat.mdx",
      "status": "published",
      "sourceSha256": "7ab12a2ebad1882cdc32de9ac05e72d28f4482a5a66f2923211788febfdb1334"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-15-Core-Practical-13-Determine-specific-latent-heat",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-15-Core-Practical-13-Determine-specific-latent-heat.mdx",
      "status": "draft",
      "sourceSha256": "7ab12a2ebad1882cdc32de9ac05e72d28f4482a5a66f2923211788febfdb1334"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-gas-pressure-volume-16",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-16-Core-Practical-14-Investigate-gas-pressure-and-volume-at-fixed-temperature.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-16-Core-Practical-14-Investigate-gas-pressure-and-volume-at-fixed-temperature",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-16-Core-Practical-14-Investigate-gas-pressure-and-volume-at-fixed-temperature.mdx",
      "status": "published",
      "sourceSha256": "e23cf6396fa71cb961074bd634ef4407d759d0a8c1c9307c943637ed84c8b4b2"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-16-Core-Practical-14-Investigate-gas-pressure-and-volume-at-fixed-temperature",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-16-Core-Practical-14-Investigate-gas-pressure-and-volume-at-fixed-temperature.mdx",
      "status": "draft",
      "sourceSha256": "e23cf6396fa71cb961074bd634ef4407d759d0a8c1c9307c943637ed84c8b4b2"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-gamma-absorption-17",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-17-Core-Practical-15-Investigate-gamma-absorption-by-lead.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-17-Core-Practical-15-Investigate-gamma-absorption-by-lead",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-17-Core-Practical-15-Investigate-gamma-absorption-by-lead.mdx",
      "status": "published",
      "sourceSha256": "c2a8e8c26bace726bcb4d16a55e6b2d8e8f2ccd29c4dc3ed5a343422838eb90b"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-17-Core-Practical-15-Investigate-gamma-absorption-by-lead",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-17-Core-Practical-15-Investigate-gamma-absorption-by-lead.mdx",
      "status": "draft",
      "sourceSha256": "c2a8e8c26bace726bcb4d16a55e6b2d8e8f2ccd29c4dc3ed5a343422838eb90b"
    }
  ]
},
{
  "id": "article.pearson-ial-physics-practical-resonant-mass-18",
  "englishSourcePath": "content/posts/Pearson-IAL-Physics-Practical-18-Core-Practical-16-Determine-an-unknown-mass-using-resonant-frequencies.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-18-Core-Practical-16-Determine-an-unknown-mass-using-resonant-frequencies",
      "sourcePath": "content/posts/Pearson-IAL-Physics-Practical-18-Core-Practical-16-Determine-an-unknown-mass-using-resonant-frequencies.mdx",
      "status": "published",
      "sourceSha256": "9db8eeb06d79f0b667dd34adef919e6ace6b84ab270f7f9a3bbb8db9eb5efa6d"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-physics-practicals/Pearson-IAL-Physics-Practical-18-Core-Practical-16-Determine-an-unknown-mass-using-resonant-frequencies",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Physics-Practical-18-Core-Practical-16-Determine-an-unknown-mass-using-resonant-frequencies.mdx",
      "status": "draft",
      "sourceSha256": "9db8eeb06d79f0b667dd34adef919e6ace6b84ab270f7f9a3bbb8db9eb5efa6d"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-unit3-01",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-01-Unit-3-Practical-Skills-I.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-01-Unit-3-Practical-Skills-I",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-01-Unit-3-Practical-Skills-I.mdx",
      "status": "published",
      "sourceSha256": "0e6f4c4433978f6ac9ca5d1be0aef9748af86fa933a6a47a77a1e92740d1c283"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-01-Unit-3-Practical-Skills-I",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-01-Unit-3-Practical-Skills-I.mdx",
      "status": "draft",
      "sourceSha256": "0e6f4c4433978f6ac9ca5d1be0aef9748af86fa933a6a47a77a1e92740d1c283"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-unit6-02",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-02-Unit-6-Practical-Skills-II.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-02-Unit-6-Practical-Skills-II",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-02-Unit-6-Practical-Skills-II.mdx",
      "status": "published",
      "sourceSha256": "16e80d3ddd9a41ee65b0c27e4d6ef58217ba62aa6181cd4e40796a44202e70f3"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-02-Unit-6-Practical-Skills-II",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-02-Unit-6-Practical-Skills-II.mdx",
      "status": "draft",
      "sourceSha256": "16e80d3ddd9a41ee65b0c27e4d6ef58217ba62aa6181cd4e40796a44202e70f3"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-molar-gas-volume-03",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-03-Core-Practical-1-Measure-the-molar-volume-of-a-gas.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-03-Core-Practical-1-Measure-the-molar-volume-of-a-gas",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-03-Core-Practical-1-Measure-the-molar-volume-of-a-gas.mdx",
      "status": "published",
      "sourceSha256": "8469fe43c20a6d2483cc22bcb41066d8aabc57aa556e04006ab3ae0ad650edab"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-03-Core-Practical-1-Measure-the-molar-volume-of-a-gas",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-03-Core-Practical-1-Measure-the-molar-volume-of-a-gas.mdx",
      "status": "draft",
      "sourceSha256": "8469fe43c20a6d2483cc22bcb41066d8aabc57aa556e04006ab3ae0ad650edab"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-hess-law-04",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-04-Core-Practical-2-Determine-an-enthalpy-change-using-Hess-s-Law.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-04-Core-Practical-2-Determine-an-enthalpy-change-using-Hess-s-Law",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-04-Core-Practical-2-Determine-an-enthalpy-change-using-Hess-s-Law.mdx",
      "status": "published",
      "sourceSha256": "89ba856eb38ea7da9eb7d4fd33b46b94471a67a0818277a3143649a63feb484a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-04-Core-Practical-2-Determine-an-enthalpy-change-using-Hess-s-Law",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-04-Core-Practical-2-Determine-an-enthalpy-change-using-Hess-s-Law.mdx",
      "status": "draft",
      "sourceSha256": "89ba856eb38ea7da9eb7d4fd33b46b94471a67a0818277a3143649a63feb484a"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-hcl-titration-05",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-05-Core-Practical-3-Find-hydrochloric-acid-concentration-by-titration.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-05-Core-Practical-3-Find-hydrochloric-acid-concentration-by-titration",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-05-Core-Practical-3-Find-hydrochloric-acid-concentration-by-titration.mdx",
      "status": "published",
      "sourceSha256": "fffbbec8cccb3048e976ee47b7cca580e358a647026efcf6a6e18fde117e1c07"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-05-Core-Practical-3-Find-hydrochloric-acid-concentration-by-titration",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-05-Core-Practical-3-Find-hydrochloric-acid-concentration-by-titration.mdx",
      "status": "draft",
      "sourceSha256": "fffbbec8cccb3048e976ee47b7cca580e358a647026efcf6a6e18fde117e1c07"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-standardise-naoh-06",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-06-Core-Practical-4-Prepare-a-standard-solution-and-standardise-sodium-hydroxide.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-06-Core-Practical-4-Prepare-a-standard-solution-and-standardise-sodium-hydroxide",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-06-Core-Practical-4-Prepare-a-standard-solution-and-standardise-sodium-hydroxide.mdx",
      "status": "published",
      "sourceSha256": "f876c6cc06a87889fef5c36717821791eb352bc91e17f560cabd1c2c06b98b5e"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-06-Core-Practical-4-Prepare-a-standard-solution-and-standardise-sodium-hydroxide",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-06-Core-Practical-4-Prepare-a-standard-solution-and-standardise-sodium-hydroxide.mdx",
      "status": "draft",
      "sourceSha256": "f876c6cc06a87889fef5c36717821791eb352bc91e17f560cabd1c2c06b98b5e"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-halogenoalkane-hydrolysis-07",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-07-Core-Practical-5-Investigate-rates-of-halogenoalkane-hydrolysis.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-07-Core-Practical-5-Investigate-rates-of-halogenoalkane-hydrolysis",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-07-Core-Practical-5-Investigate-rates-of-halogenoalkane-hydrolysis.mdx",
      "status": "published",
      "sourceSha256": "b9560f11b18195e63b67c2505ad85b1089d517bcc2a581e8d343c5b2074e0777"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-07-Core-Practical-5-Investigate-rates-of-halogenoalkane-hydrolysis",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-07-Core-Practical-5-Investigate-rates-of-halogenoalkane-hydrolysis.mdx",
      "status": "draft",
      "sourceSha256": "b9560f11b18195e63b67c2505ad85b1089d517bcc2a581e8d343c5b2074e0777"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-organic-preparation-08",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-08-Core-Practical-6-Prepare-2-chloro-2-methylpropane-from-an-alcohol.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-08-Core-Practical-6-Prepare-2-chloro-2-methylpropane-from-an-alcohol",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-08-Core-Practical-6-Prepare-2-chloro-2-methylpropane-from-an-alcohol.mdx",
      "status": "published",
      "sourceSha256": "f75bf8060983fd493e9a81278ecbbccf9d6ee9e6aa5fcd3859c6ef3b4c779144"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-08-Core-Practical-6-Prepare-2-chloro-2-methylpropane-from-an-alcohol",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-08-Core-Practical-6-Prepare-2-chloro-2-methylpropane-from-an-alcohol.mdx",
      "status": "draft",
      "sourceSha256": "f75bf8060983fd493e9a81278ecbbccf9d6ee9e6aa5fcd3859c6ef3b4c779144"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-propanol-oxidation-09",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-09-Core-Practical-7-Oxidise-propan-1-ol-to-propanal-and-propanoic-acid.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-09-Core-Practical-7-Oxidise-propan-1-ol-to-propanal-and-propanoic-acid",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-09-Core-Practical-7-Oxidise-propan-1-ol-to-propanal-and-propanoic-acid.mdx",
      "status": "published",
      "sourceSha256": "c7bd972f16104a51961f0acc026edcd88435f14f3e7cede8123561cef271746a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-09-Core-Practical-7-Oxidise-propan-1-ol-to-propanal-and-propanoic-acid",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-09-Core-Practical-7-Oxidise-propan-1-ol-to-propanal-and-propanoic-acid.mdx",
      "status": "draft",
      "sourceSha256": "c7bd972f16104a51961f0acc026edcd88435f14f3e7cede8123561cef271746a"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-unknown-analysis-10",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-10-Core-Practical-8-Analyse-inorganic-and-organic-unknowns.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-10-Core-Practical-8-Analyse-inorganic-and-organic-unknowns",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-10-Core-Practical-8-Analyse-inorganic-and-organic-unknowns.mdx",
      "status": "published",
      "sourceSha256": "a0397688bd3d897663d8bb5bb78e69a4a0284dc7e5c2ef1084dbfa0253370f07"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-10-Core-Practical-8-Analyse-inorganic-and-organic-unknowns",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-10-Core-Practical-8-Analyse-inorganic-and-organic-unknowns.mdx",
      "status": "draft",
      "sourceSha256": "a0397688bd3d897663d8bb5bb78e69a4a0284dc7e5c2ef1084dbfa0253370f07"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-clock-rates-11",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-11-Core-Practical-9-Follow-iodine-propanone-and-clock-reaction-rates.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-11-Core-Practical-9-Follow-iodine-propanone-and-clock-reaction-rates",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-11-Core-Practical-9-Follow-iodine-propanone-and-clock-reaction-rates.mdx",
      "status": "published",
      "sourceSha256": "4d11fe9321f414bfcca4a8c9ed1d931d0bd7dcbc19a62368896e5950ecabde1a"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-11-Core-Practical-9-Follow-iodine-propanone-and-clock-reaction-rates",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-11-Core-Practical-9-Follow-iodine-propanone-and-clock-reaction-rates.mdx",
      "status": "draft",
      "sourceSha256": "4d11fe9321f414bfcca4a8c9ed1d931d0bd7dcbc19a62368896e5950ecabde1a"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-activation-energy-12",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-12-Core-Practical-10-Determine-the-activation-energy-of-a-reaction.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-12-Core-Practical-10-Determine-the-activation-energy-of-a-reaction",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-12-Core-Practical-10-Determine-the-activation-energy-of-a-reaction.mdx",
      "status": "published",
      "sourceSha256": "127eaa28dec3b887506d75c73f1458aaf9ddece218b84f3a5abd333d7aca9744"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-12-Core-Practical-10-Determine-the-activation-energy-of-a-reaction",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-12-Core-Practical-10-Determine-the-activation-energy-of-a-reaction.mdx",
      "status": "draft",
      "sourceSha256": "127eaa28dec3b887506d75c73f1458aaf9ddece218b84f3a5abd333d7aca9744"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-weak-acid-13",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-13-Core-Practical-11-Determine-the-acid-dissociation-constant-of-a-weak-acid.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-13-Core-Practical-11-Determine-the-acid-dissociation-constant-of-a-weak-acid",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-13-Core-Practical-11-Determine-the-acid-dissociation-constant-of-a-weak-acid.mdx",
      "status": "published",
      "sourceSha256": "908c636a6c4fc70820e675e458c240f735d0e0bc777c485ceccffe4223b80cc9"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-13-Core-Practical-11-Determine-the-acid-dissociation-constant-of-a-weak-acid",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-13-Core-Practical-11-Determine-the-acid-dissociation-constant-of-a-weak-acid.mdx",
      "status": "draft",
      "sourceSha256": "908c636a6c4fc70820e675e458c240f735d0e0bc777c485ceccffe4223b80cc9"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-electrochemical-cells-14",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-14-Core-Practical-12-Investigate-electrochemical-cells.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-14-Core-Practical-12-Investigate-electrochemical-cells",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-14-Core-Practical-12-Investigate-electrochemical-cells.mdx",
      "status": "published",
      "sourceSha256": "93d2c8df2a298bee07c6b71722ad5ed15e1d519df8665f6b520043c48f3d5aed"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-14-Core-Practical-12-Investigate-electrochemical-cells",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-14-Core-Practical-12-Investigate-electrochemical-cells.mdx",
      "status": "draft",
      "sourceSha256": "93d2c8df2a298bee07c6b71722ad5ed15e1d519df8665f6b520043c48f3d5aed"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-redox-titrations-15",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-15-Core-Practical-13-Carry-out-manganate-and-iodine-thiosulfate-redox-titrations.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-15-Core-Practical-13-Carry-out-manganate-and-iodine-thiosulfate-redox-titrations",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-15-Core-Practical-13-Carry-out-manganate-and-iodine-thiosulfate-redox-titrations.mdx",
      "status": "published",
      "sourceSha256": "7d20fc67dfba0c70ca4754652f579a32dee5d8b93b3c67758d0faade6974b32c"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-15-Core-Practical-13-Carry-out-manganate-and-iodine-thiosulfate-redox-titrations",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-15-Core-Practical-13-Carry-out-manganate-and-iodine-thiosulfate-redox-titrations.mdx",
      "status": "draft",
      "sourceSha256": "7d20fc67dfba0c70ca4754652f579a32dee5d8b93b3c67758d0faade6974b32c"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-transition-metal-complex-16",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-16-Core-Practical-14-Prepare-a-transition-metal-complex.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-16-Core-Practical-14-Prepare-a-transition-metal-complex",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-16-Core-Practical-14-Prepare-a-transition-metal-complex.mdx",
      "status": "published",
      "sourceSha256": "2cb275409e11855d338189fabcf7411756fd4db94a7b9668ccaf7ae42ee2f8ed"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-16-Core-Practical-14-Prepare-a-transition-metal-complex",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-16-Core-Practical-14-Prepare-a-transition-metal-complex.mdx",
      "status": "draft",
      "sourceSha256": "2cb275409e11855d338189fabcf7411756fd4db94a7b9668ccaf7ae42ee2f8ed"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-advanced-unknown-analysis-17",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-17-Core-Practical-15-Analyse-advanced-inorganic-and-organic-unknowns.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-17-Core-Practical-15-Analyse-advanced-inorganic-and-organic-unknowns",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-17-Core-Practical-15-Analyse-advanced-inorganic-and-organic-unknowns.mdx",
      "status": "published",
      "sourceSha256": "c105500e8a3c7044465c78fbaf3e66c39e9ffb0fe2ecca07dd9ea88e5d8f80c7"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-17-Core-Practical-15-Analyse-advanced-inorganic-and-organic-unknowns",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-17-Core-Practical-15-Analyse-advanced-inorganic-and-organic-unknowns.mdx",
      "status": "draft",
      "sourceSha256": "c105500e8a3c7044465c78fbaf3e66c39e9ffb0fe2ecca07dd9ea88e5d8f80c7"
    }
  ]
},
{
  "id": "article.pearson-ial-chemistry-practical-aspirin-18",
  "englishSourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-18-Core-Practical-16-Prepare-and-purify-aspirin.mdx",
  "versions": [
    {
      "locale": "en",
      "publicPath": "/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-18-Core-Practical-16-Prepare-and-purify-aspirin",
      "sourcePath": "content/posts/Pearson-IAL-Chemistry-Practical-18-Core-Practical-16-Prepare-and-purify-aspirin.mdx",
      "status": "published",
      "sourceSha256": "5e41f67a3e1bc1e76d03ee63a23ddbf3bf1aa019123f6cf5ead7423726181f90"
    },
    {
      "locale": "zh-Hans",
      "publicPath": "/zh/blog/pearson-ial-chemistry-practicals/Pearson-IAL-Chemistry-Practical-18-Core-Practical-16-Prepare-and-purify-aspirin",
      "sourcePath": "content/translations/zh-Hans/Pearson-IAL-Chemistry-Practical-18-Core-Practical-16-Prepare-and-purify-aspirin.mdx",
      "status": "draft",
      "sourceSha256": "5e41f67a3e1bc1e76d03ee63a23ddbf3bf1aa019123f6cf5ead7423726181f90"
    }
  ]
}
];
